import m, { useState as q, useContext as z, useRef as B, useCallback as G, useEffect as Q, useMemo as _, forwardRef as te, createContext as j, useReducer as qg, cloneElement as xu, isValidElement as Yg, version as Xg } from "react";
import Ni, { createPortal as Eu, flushSync as Ge } from "react-dom";
function Ye(...t) {
  return (...e) => {
    for (let n of t) typeof n == "function" && n(...e);
  };
}
const le = typeof document < "u" ? m.useLayoutEffect : () => {
}, Ur = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Cu = /* @__PURE__ */ m.createContext(Ur), Zg = /* @__PURE__ */ m.createContext(!1);
let Jg = !!(typeof window < "u" && window.document && window.document.createElement), kl = /* @__PURE__ */ new WeakMap();
function Qg(t = !1) {
  let e = z(Cu), n = B(null);
  if (n.current === null && !t) {
    let r = (
      // @ts-ignore
      m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current
    );
    if (r) {
      let l = kl.get(r);
      l == null ? kl.set(r, {
        id: e.current,
        state: r.memoizedState
      }) : r.memoizedState !== l.state && (e.current = l.id, kl.delete(r));
    }
    n.current = ++e.current;
  }
  return n.current;
}
function ey(t) {
  let e = z(Cu);
  e === Ur && !Jg && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Qg(!!t), r = e === Ur && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${e.prefix}`;
  return t || `${r}-${n}`;
}
function ty(t) {
  let e = m.useId(), [n] = q(it()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${Ur.prefix}`;
  return t || `${r}-${e}`;
}
const ny = typeof m.useId == "function" ? ty : ey;
function ry() {
  return !1;
}
function ly() {
  return !0;
}
function iy(t) {
  return () => {
  };
}
function it() {
  return typeof m.useSyncExternalStore == "function" ? m.useSyncExternalStore(iy, ry, ly) : z(Zg);
}
function ay(t) {
  let [e, n] = q(t), r = B(e), l = B(null), i = B(() => {
    if (!l.current) return;
    let o = l.current.next();
    if (o.done) {
      l.current = null;
      return;
    }
    r.current === o.value ? i.current() : n(o.value);
  });
  le(() => {
    r.current = e, l.current && i.current();
  });
  let a = G((o) => {
    l.current = o(r.current), i.current();
  }, [
    i
  ]);
  return [
    e,
    a
  ];
}
let oy = !!(typeof window < "u" && window.document && window.document.createElement), Fn = /* @__PURE__ */ new Map(), tr;
typeof FinalizationRegistry < "u" && (tr = new FinalizationRegistry((t) => {
  Fn.delete(t);
}));
function ce(t) {
  let [e, n] = q(t), r = B(null), l = ny(e), i = B(null);
  if (tr && tr.register(i, l), oy) {
    const a = Fn.get(l);
    a && !a.includes(r) ? a.push(r) : Fn.set(l, [
      r
    ]);
  }
  return le(() => {
    let a = l;
    return () => {
      tr && tr.unregister(i), Fn.delete(a);
    };
  }, [
    l
  ]), Q(() => {
    let a = r.current;
    return a && n(a), () => {
      a && (r.current = null);
    };
  }), l;
}
function uy(t, e) {
  if (t === e) return t;
  let n = Fn.get(t);
  if (n)
    return n.forEach((l) => l.current = e), e;
  let r = Fn.get(e);
  return r ? (r.forEach((l) => l.current = t), t) : e;
}
function mt(t = []) {
  let e = ce(), [n, r] = ay(e), l = G(() => {
    r(function* () {
      yield e, yield document.getElementById(e) ? e : void 0;
    });
  }, [
    e,
    r
  ]);
  return le(l, [
    e,
    l,
    ...t
  ]), n;
}
function at(...t) {
  return t.length === 1 && t[0] ? t[0] : (e) => {
    let n = !1;
    const r = t.map((l) => {
      const i = Ua(l, e);
      return n ||= typeof i == "function", i;
    });
    if (n) return () => {
      r.forEach((l, i) => {
        typeof l == "function" ? l() : Ua(t[i], null);
      });
    };
  };
}
function Ua(t, e) {
  if (typeof t == "function") return t(e);
  t != null && (t.current = e);
}
function Du(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var l = t.length;
    for (e = 0; e < l; e++) t[e] && (n = Du(t[e])) && (r && (r += " "), r += n);
  } else for (n in t) t[n] && (r && (r += " "), r += n);
  return r;
}
function sy() {
  for (var t, e, n = 0, r = "", l = arguments.length; n < l; n++) (t = arguments[n]) && (e = Du(t)) && (r && (r += " "), r += e);
  return r;
}
function L(...t) {
  let e = {
    ...t[0]
  };
  for (let n = 1; n < t.length; n++) {
    let r = t[n];
    for (let l in r) {
      let i = e[l], a = r[l];
      typeof i == "function" && typeof a == "function" && // This is a lot faster than a regex.
      l[0] === "o" && l[1] === "n" && l.charCodeAt(2) >= /* 'A' */
      65 && l.charCodeAt(2) <= /* 'Z' */
      90 ? e[l] = Ye(i, a) : (l === "className" || l === "UNSAFE_className") && typeof i == "string" && typeof a == "string" ? e[l] = sy(i, a) : l === "id" && i && a ? e.id = uy(i, a) : l === "ref" && i && a ? e.ref = at(i, a) : e[l] = a !== void 0 ? a : i;
    }
  }
  return e;
}
function ge(t) {
  const e = B(null), n = B(void 0), r = G((l) => {
    if (typeof t == "function") {
      const i = t, a = i(l);
      return () => {
        typeof a == "function" ? a() : i(null);
      };
    } else if (t)
      return t.current = l, () => {
        t.current = null;
      };
  }, [
    t
  ]);
  return _(() => ({
    get current() {
      return e.current;
    },
    set current(l) {
      e.current = l, n.current && (n.current(), n.current = void 0), l != null && (n.current = r(l));
    }
  }), [
    r
  ]);
}
const rt = /* @__PURE__ */ Symbol("default");
function he({ values: t, children: e }) {
  for (let [n, r] of t)
    e = /* @__PURE__ */ m.createElement(n.Provider, {
      value: r
    }, e);
  return e;
}
function re(t) {
  let { className: e, style: n, children: r, defaultClassName: l, defaultChildren: i, defaultStyle: a, values: o, render: u } = t;
  return _(() => {
    let c, s, d;
    return typeof e == "function" ? c = e({
      ...o,
      defaultClassName: l
    }) : c = e, typeof n == "function" ? s = n({
      ...o,
      defaultStyle: a || {}
    }) : s = n, typeof r == "function" ? d = r({
      ...o,
      defaultChildren: i
    }) : r == null ? d = i : d = r, {
      className: c ?? l,
      style: s || a ? {
        ...a,
        ...s
      } : void 0,
      children: d ?? i,
      "data-rac": "",
      render: u ? (f) => u(f, o) : void 0
    };
  }, [
    e,
    n,
    r,
    l,
    i,
    a,
    o,
    u
  ]);
}
function cy(t, e) {
  return (n) => e(typeof t == "function" ? t(n) : t, n);
}
function We(t, e) {
  let n = z(t);
  if (e === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = e || rt;
    if (!n.slots[r]) {
      let l = new Intl.ListFormat().format(Object.keys(n.slots).map((a) => `"${a}"`)), i = e ? `Invalid slot "${e}".` : "A slot prop is required.";
      throw new Error(`${i} Valid slot names are ${l}.`);
    }
    return n.slots[r];
  }
  return n;
}
function ie(t, e, n) {
  let r = We(n, t.slot) || {}, { ref: l, ...i } = r, a = ge(_(() => at(e, l), [
    e,
    l
  ])), o = L(i, t);
  return "style" in i && i.style && "style" in t && t.style && (typeof i.style == "function" || typeof t.style == "function" ? o.style = (u) => {
    let c = typeof i.style == "function" ? i.style(u) : i.style, s = {
      ...u.defaultStyle,
      ...c
    }, d = typeof t.style == "function" ? t.style({
      ...u,
      defaultStyle: s
    }) : t.style;
    return {
      ...s,
      ...d
    };
  } : o.style = {
    ...i.style,
    ...t.style
  }), [
    o,
    a
  ];
}
function Xe(t = !0) {
  let [e, n] = q(t), r = B(!1), l = G((i) => {
    r.current = !0, n(!!i);
  }, []);
  return le(() => {
    r.current || n(!1);
  }, []), [
    l,
    e
  ];
}
function xt(t) {
  const e = /^(data-.*)$/;
  let n = {};
  for (const r in t) e.test(r) || (n[r] = t[r]);
  return n;
}
function dy(t, e, n) {
  let { render: r, ...l } = e, i = B(null), a = _(() => at(n, i), [
    n,
    i
  ]);
  le(() => {
    process.env.NODE_ENV !== "production" && r && (i.current ? i.current.localName !== t && console.warn(`Unexpected DOM element returned by custom \`render\` function. Expected <${t}>, got <${i.current.localName}>. This may break the component behavior and accessibility.`) : console.warn("Ref was not connected to DOM element returned by custom `render` function. Did you forget to pass through or merge the `ref`?"));
  }, [
    t,
    r
  ]);
  let o = {
    ...l,
    ref: a
  };
  return r ? r(o, void 0) : /* @__PURE__ */ m.createElement(t, o);
}
const Ga = {}, X = new Proxy({}, {
  get(t, e) {
    if (typeof e != "string") return;
    let n = Ga[e];
    return n || (n = /* @__PURE__ */ te(dy.bind(null, e)), Ga[e] = n), n;
  }
}), wu = "react-aria-clear-focus", Jl = "react-aria-focus", ue = (t) => t?.ownerDocument ?? document, De = (t) => t && "window" in t && t.window === t ? t : ue(t).defaultView || window;
function fy(t) {
  return t !== null && typeof t == "object" && "nodeType" in t && typeof t.nodeType == "number";
}
function hy(t) {
  return fy(t) && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in t;
}
let py = !1;
function Pt() {
  return py;
}
function ne(t, e) {
  if (!Pt()) return e && t ? t.contains(e) : !1;
  if (!t || !e) return !1;
  let n = e;
  for (; n !== null; ) {
    if (n === t) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : hy(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const oe = (t = document) => {
  if (!Pt()) return t.activeElement;
  let e = t.activeElement;
  for (; e && "shadowRoot" in e && e.shadowRoot?.activeElement; ) e = e.shadowRoot.activeElement;
  return e;
};
function H(t) {
  if (Pt() && t.target instanceof Element && t.target.shadowRoot) {
    if ("composedPath" in t) return t.composedPath()[0] ?? null;
    if ("composedPath" in t.nativeEvent) return t.nativeEvent.composedPath()[0] ?? null;
  }
  return t.target;
}
function Bt(t) {
  if (!t) return !1;
  let e = t.getRootNode(), n = De(t);
  if (!(e instanceof n.Document || e instanceof n.ShadowRoot)) return !1;
  let r = e.activeElement;
  return r != null && t.contains(r);
}
function Mi(t) {
  let e = Pu(ue(t));
  e !== t && (e && Ql(e, t), t && Gr(t, e));
}
function Ql(t, e) {
  t.dispatchEvent(new FocusEvent("blur", {
    relatedTarget: e
  })), t.dispatchEvent(new FocusEvent("focusout", {
    bubbles: !0,
    relatedTarget: e
  }));
}
function Gr(t, e) {
  t.dispatchEvent(new FocusEvent("focus", {
    relatedTarget: e
  })), t.dispatchEvent(new FocusEvent("focusin", {
    bubbles: !0,
    relatedTarget: e
  }));
}
function Pu(t) {
  let e = oe(t), n = e?.getAttribute("aria-activedescendant");
  return n && t.getElementById(n) || e;
}
function Pe(t) {
  if (by()) t.focus({
    preventScroll: !0
  });
  else {
    let e = my(t);
    t.focus(), gy(e);
  }
}
let Ar = null;
function by() {
  if (Ar == null) {
    Ar = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Ar = !0, !0;
        }
      });
    } catch {
    }
  }
  return Ar;
}
function my(t) {
  let e = t.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; e instanceof HTMLElement && e !== r; )
    (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) && n.push({
      element: e,
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft
    }), e = e.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function gy(t) {
  for (let { element: e, scrollTop: n, scrollLeft: r } of t)
    e.scrollTop = n, e.scrollLeft = r;
}
const yy = typeof Element < "u" && "checkVisibility" in Element.prototype;
function $y(t) {
  const e = De(t);
  if (!(t instanceof e.HTMLElement) && !(t instanceof e.SVGElement)) return !1;
  let { display: n, visibility: r } = t.style, l = n !== "none" && r !== "hidden" && r !== "collapse";
  if (l) {
    const { getComputedStyle: i } = De(t);
    let { display: a, visibility: o } = i(t);
    l = a !== "none" && o !== "hidden" && o !== "collapse";
  }
  return l;
}
function vy(t, e) {
  return !t.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !t.hasAttribute("data-react-aria-prevent-focus") && (t.nodeName === "DETAILS" && e && e.nodeName !== "SUMMARY" ? t.hasAttribute("open") : !0);
}
function Li(t, e) {
  return yy ? t.checkVisibility({
    visibilityProperty: !0
  }) && !t.closest("[data-react-aria-prevent-focus]") : t.nodeName !== "#comment" && $y(t) && vy(t, e) && (!t.parentElement || Li(t.parentElement, t));
}
const zi = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])',
  "permission"
], xy = zi.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
zi.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const Ey = zi.join(':not([hidden]):not([tabindex="-1"]),');
function Vi(t, e) {
  return t.matches(xy) && !Su(t) && (e?.skipVisibilityCheck || Li(t));
}
function qr(t) {
  return t.matches(Ey) && Li(t) && !Su(t);
}
function Su(t) {
  let e = t;
  for (; e != null; ) {
    if (e instanceof De(e).HTMLElement && e.inert) return !0;
    e = e.parentElement;
  }
  return !1;
}
function Oi(t) {
  let e = t;
  return e.nativeEvent = t, e.isDefaultPrevented = () => e.defaultPrevented, e.isPropagationStopped = () => e.cancelBubble, e.persist = () => {
  }, e;
}
function ku(t, e) {
  Object.defineProperty(t, "target", {
    value: e
  }), Object.defineProperty(t, "currentTarget", {
    value: e
  });
}
function Bu(t) {
  let e = B({
    isFocused: !1,
    observer: null
  });
  return le(() => {
    const n = e.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []), G((n) => {
    let r = H(n);
    if (r instanceof HTMLButtonElement || r instanceof HTMLInputElement || r instanceof HTMLTextAreaElement || r instanceof HTMLSelectElement) {
      e.current.isFocused = !0;
      let l = r, i = (a) => {
        if (e.current.isFocused = !1, l.disabled) {
          let o = Oi(a);
          t?.(o);
        }
        e.current.observer && (e.current.observer.disconnect(), e.current.observer = null);
      };
      l.addEventListener("focusout", i, {
        once: !0
      }), e.current.observer = new MutationObserver(() => {
        if (e.current.isFocused && l.disabled) {
          e.current.observer?.disconnect();
          let a = l === oe() ? null : oe();
          l.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: a
          })), l.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: a
          }));
        }
      }), e.current.observer.observe(l, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    t
  ]);
}
let Yr = !1;
function qa(t) {
  for (; t && !Vi(t, {
    skipVisibilityCheck: !0
  }); ) t = t.parentElement;
  let e = De(t), n = e.document.activeElement;
  if (!n || n === t) return;
  Yr = !0;
  let r = !1, l = (s) => {
    (H(s) === n || r) && s.stopImmediatePropagation();
  }, i = (s) => {
    (H(s) === n || r) && (s.stopImmediatePropagation(), !t && !r && (r = !0, Pe(n), u()));
  }, a = (s) => {
    (H(s) === t || r) && s.stopImmediatePropagation();
  }, o = (s) => {
    (H(s) === t || r) && (s.stopImmediatePropagation(), r || (r = !0, Pe(n), u()));
  };
  e.addEventListener("blur", l, !0), e.addEventListener("focusout", i, !0), e.addEventListener("focusin", o, !0), e.addEventListener("focus", a, !0);
  let u = () => {
    cancelAnimationFrame(c), e.removeEventListener("blur", l, !0), e.removeEventListener("focusout", i, !0), e.removeEventListener("focusin", o, !0), e.removeEventListener("focus", a, !0), Yr = !1, r = !1;
  }, c = requestAnimationFrame(u);
  return u;
}
function dl(t) {
  if (typeof window > "u" || window.navigator == null) return !1;
  let e = window.navigator.userAgentData?.brands;
  return Array.isArray(e) && e.some((n) => t.test(n.brand)) || t.test(window.navigator.userAgent);
}
function Hi(t) {
  return typeof window < "u" && window.navigator != null ? t.test(window.navigator.userAgentData?.platform || window.navigator.platform) : !1;
}
function Tt(t) {
  if (process.env.NODE_ENV === "test") return t;
  let e = null;
  return () => (e == null && (e = t()), e);
}
const sn = Tt(function() {
  return Hi(/^Mac/i);
}), Fu = Tt(function() {
  return Hi(/^iPhone/i);
}), Tu = Tt(function() {
  return Hi(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  sn() && navigator.maxTouchPoints > 1;
}), yt = Tt(function() {
  return Fu() || Tu();
}), Cy = Tt(function() {
  return sn() || yt();
}), Au = Tt(function() {
  return dl(/AppleWebKit/i) && !Iu();
}), Iu = Tt(function() {
  return dl(/Chrome/i);
}), _t = Tt(function() {
  return dl(/Android/i);
}), Dy = Tt(function() {
  return dl(/Firefox/i);
});
function ei(t) {
  return t.pointerType === "" && t.isTrusted ? !0 : _t() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function wy(t) {
  return !_t() && t.width === 0 && t.height === 0 || t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse";
}
const Ku = /* @__PURE__ */ j({
  isNative: !0,
  open: Py,
  useHref: (t) => t
});
function l6(t) {
  let { children: e, navigate: n, useHref: r } = t, l = _(() => ({
    isNative: !1,
    open: (i, a, o, u) => {
      Nu(i, (c) => {
        Ru(c, a) ? n(o, u) : $t(c, a);
      });
    },
    useHref: r || ((i) => i)
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ m.createElement(Ku.Provider, {
    value: l
  }, e);
}
function Vn() {
  return z(Ku);
}
function Ru(t, e) {
  let n = t.getAttribute("target");
  return (!n || n === "_self") && t.origin === location.origin && !t.hasAttribute("download") && !e.metaKey && // open in new tab (mac)
  !e.ctrlKey && // open in new tab (windows)
  !e.altKey && // download
  !e.shiftKey;
}
function $t(t, e, n = !0) {
  let { metaKey: r, ctrlKey: l, altKey: i, shiftKey: a } = e;
  Dy() && window.event?.type?.startsWith("key") && t.target === "_blank" && (sn() ? r = !0 : l = !0);
  let o = Au() && sn() && !Tu() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: r,
    ctrlKey: l,
    altKey: i,
    shiftKey: a
  }) : new MouseEvent("click", {
    metaKey: r,
    ctrlKey: l,
    altKey: i,
    shiftKey: a,
    detail: 1,
    bubbles: !0,
    cancelable: !0
  });
  $t.isOpening = n, Pe(t), t.dispatchEvent(o), $t.isOpening = !1;
}
$t.isOpening = !1;
function Nu(t, e) {
  if (t instanceof HTMLAnchorElement) e(t);
  else if (t.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = t.getAttribute("data-href"), t.hasAttribute("data-target") && (n.target = t.getAttribute("data-target")), t.hasAttribute("data-rel") && (n.rel = t.getAttribute("data-rel")), t.hasAttribute("data-download") && (n.download = t.getAttribute("data-download")), t.hasAttribute("data-ping") && (n.ping = t.getAttribute("data-ping")), t.hasAttribute("data-referrer-policy") && (n.referrerPolicy = t.getAttribute("data-referrer-policy")), t.appendChild(n), e(n), t.removeChild(n);
  }
}
function Py(t, e) {
  Nu(t, (n) => $t(n, e));
}
function _i(t) {
  const n = Vn().useHref(t.href ?? "");
  return {
    "data-href": t.href ? n : void 0,
    "data-target": t.target,
    "data-rel": t.rel,
    "data-download": t.download,
    "data-ping": t.ping,
    "data-referrer-policy": t.referrerPolicy
  };
}
function fl(t) {
  const n = Vn().useHref(t?.href ?? "");
  let r = {};
  if (t)
    for (let l of [
      "href",
      "target",
      "rel",
      "download",
      "ping",
      "referrerPolicy"
    ]) l in t && (r[l] = l === "href" ? n : t[l]);
  return r;
}
function Mu(t, e, n, r) {
  !e.isNative && t.currentTarget instanceof HTMLAnchorElement && t.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
  !t.isDefaultPrevented() && Ru(t.currentTarget, t) && n && (t.preventDefault(), e.open(t.currentTarget, t, n, r));
}
let Ft = null, On = "keyboard";
const ur = /* @__PURE__ */ new Set();
let ir = /* @__PURE__ */ new Map(), cn = !1, ti = !1;
const Sy = {
  Tab: !0,
  Escape: !0
};
function hl(t, e) {
  for (let n of ur) n(t, e);
}
function ky(t) {
  return !(t.metaKey || !sn() && t.altKey || t.ctrlKey || t.key === "Control" || t.key === "Shift" || t.key === "Meta");
}
function Xr(t) {
  cn = !0, !$t.isOpening && ky(t) && (Ft = "keyboard", On = "keyboard", hl("keyboard", t));
}
function je(t) {
  Ft = "pointer", On = "pointerType" in t ? t.pointerType : "mouse", (t.type === "mousedown" || t.type === "pointerdown") && (cn = !0, hl("pointer", t));
}
function Lu(t) {
  !$t.isOpening && ei(t) && (cn = !0, Ft = "virtual", On = "virtual");
}
function zu(t) {
  let e = De(H(t)), n = ue(H(t));
  H(t) === e || H(t) === n || Yr || !t.isTrusted || (!cn && !ti && (Ft = "virtual", On = "virtual", hl("virtual", t)), cn = !1, ti = !1);
}
function Vu() {
  Yr || (cn = !1, ti = !0);
}
function Zr(t) {
  if (typeof window > "u" || typeof document > "u") return;
  const e = De(t), n = ue(t);
  if (ir.get(e)) return;
  let r = e.HTMLElement.prototype.focus;
  Reflect.defineProperty(e.HTMLElement.prototype, "focus", {
    configurable: !0,
    writable: !0,
    value: function() {
      cn = !0, r.apply(this, arguments);
    }
  }), n.addEventListener("keydown", Xr, !0), n.addEventListener("keyup", Xr, !0), n.addEventListener("click", Lu, !0), e.addEventListener("focus", zu, !0), e.addEventListener("blur", Vu, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", je, !0), n.addEventListener("pointermove", je, !0), n.addEventListener("pointerup", je, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", je, !0), n.addEventListener("mousemove", je, !0), n.addEventListener("mouseup", je, !0)), e.addEventListener("beforeunload", () => {
    Ou(t);
  }, {
    once: !0
  }), ir.set(e, {
    focus: r
  });
}
const Ou = (t, e) => {
  const n = De(t), r = ue(t);
  e && r.removeEventListener("DOMContentLoaded", e), ir.has(n) && (Reflect.defineProperty(n.HTMLElement.prototype, "focus", {
    configurable: !0,
    writable: !0,
    value: ir.get(n).focus
  }), r.removeEventListener("keydown", Xr, !0), r.removeEventListener("keyup", Xr, !0), r.removeEventListener("click", Lu, !0), n.removeEventListener("focus", zu, !0), n.removeEventListener("blur", Vu, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", je, !0), r.removeEventListener("pointermove", je, !0), r.removeEventListener("pointerup", je, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", je, !0), r.removeEventListener("mousemove", je, !0), r.removeEventListener("mouseup", je, !0)), ir.delete(n));
};
function By(t) {
  const e = ue(t);
  let n;
  return e.readyState !== "loading" ? Zr(t) : (n = () => {
    Zr(t);
  }, e.addEventListener("DOMContentLoaded", n)), () => Ou(t, n);
}
typeof document < "u" && By();
function vt() {
  return Ft !== "pointer";
}
function gt() {
  return Ft;
}
function sr(t) {
  Ft = t, On = t === "pointer" ? "mouse" : t, hl(t, null);
}
function Fy() {
  return On;
}
function pl() {
  Zr();
  let [t, e] = q(Ft);
  return Q(() => {
    let n = () => {
      e(Ft);
    };
    return ur.add(n), () => {
      ur.delete(n);
    };
  }, []), it() ? null : t;
}
const Ty = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Ay(t, e, n) {
  let r = n ? H(n) : void 0, l = ue(r), i = De(r);
  const a = typeof i < "u" ? i.HTMLInputElement : HTMLInputElement, o = typeof i < "u" ? i.HTMLTextAreaElement : HTMLTextAreaElement, u = typeof i < "u" ? i.HTMLElement : HTMLElement, c = typeof i < "u" ? i.KeyboardEvent : KeyboardEvent;
  let s = oe(l);
  return t = t || s instanceof a && !Ty.has(s.type) || s instanceof o || s instanceof u && s.isContentEditable, !(t && e === "keyboard" && n instanceof c && !Sy[n.key]);
}
function Iy(t, e, n) {
  Zr(), Q(() => {
    if (n?.enabled === !1) return;
    let r = (l, i) => {
      Ay(!!n?.isTextInput, l, i) && t(vt());
    };
    return ur.add(r), () => {
      ur.delete(r);
    };
  }, e);
}
var Hu = {};
Hu = {
  collectionLabel: "مقترحات"
};
var _u = {};
_u = {
  collectionLabel: "Предложения"
};
var Wu = {};
Wu = {
  collectionLabel: "Návrhy"
};
var ju = {};
ju = {
  collectionLabel: "Forslag"
};
var Uu = {};
Uu = {
  collectionLabel: "Empfehlungen"
};
var Gu = {};
Gu = {
  collectionLabel: "Προτάσεις"
};
var qu = {};
qu = {
  collectionLabel: "Suggestions"
};
var Yu = {};
Yu = {
  collectionLabel: "Sugerencias"
};
var Xu = {};
Xu = {
  collectionLabel: "Soovitused"
};
var Zu = {};
Zu = {
  collectionLabel: "Ehdotukset"
};
var Ju = {};
Ju = {
  collectionLabel: "Suggestions"
};
var Qu = {};
Qu = {
  collectionLabel: "הצעות"
};
var es = {};
es = {
  collectionLabel: "Prijedlozi"
};
var ts = {};
ts = {
  collectionLabel: "Javaslatok"
};
var ns = {};
ns = {
  collectionLabel: "Suggerimenti"
};
var rs = {};
rs = {
  collectionLabel: "候補"
};
var ls = {};
ls = {
  collectionLabel: "제안"
};
var is = {};
is = {
  collectionLabel: "Pasiūlymai"
};
var as = {};
as = {
  collectionLabel: "Ieteikumi"
};
var os = {};
os = {
  collectionLabel: "Forslag"
};
var us = {};
us = {
  collectionLabel: "Suggesties"
};
var ss = {};
ss = {
  collectionLabel: "Sugestie"
};
var cs = {};
cs = {
  collectionLabel: "Sugestões"
};
var ds = {};
ds = {
  collectionLabel: "Sugestões"
};
var fs = {};
fs = {
  collectionLabel: "Sugestii"
};
var hs = {};
hs = {
  collectionLabel: "Предложения"
};
var ps = {};
ps = {
  collectionLabel: "Návrhy"
};
var bs = {};
bs = {
  collectionLabel: "Predlogi"
};
var ms = {};
ms = {
  collectionLabel: "Predlozi"
};
var gs = {};
gs = {
  collectionLabel: "Förslag"
};
var ys = {};
ys = {
  collectionLabel: "Öneriler"
};
var $s = {};
$s = {
  collectionLabel: "Пропозиції"
};
var vs = {};
vs = {
  collectionLabel: "建议"
};
var xs = {};
xs = {
  collectionLabel: "建議"
};
var Es = {};
Es = {
  "ar-AE": Hu,
  "bg-BG": _u,
  "cs-CZ": Wu,
  "da-DK": ju,
  "de-DE": Uu,
  "el-GR": Gu,
  "en-US": qu,
  "es-ES": Yu,
  "et-EE": Xu,
  "fi-FI": Zu,
  "fr-FR": Ju,
  "he-IL": Qu,
  "hr-HR": es,
  "hu-HU": ts,
  "it-IT": ns,
  "ja-JP": rs,
  "ko-KR": ls,
  "lt-LT": is,
  "lv-LV": as,
  "nb-NO": os,
  "nl-NL": us,
  "pl-PL": ss,
  "pt-BR": cs,
  "pt-PT": ds,
  "ro-RO": fs,
  "ru-RU": hs,
  "sk-SK": ps,
  "sl-SI": bs,
  "sr-SP": ms,
  "sv-SE": gs,
  "tr-TR": ys,
  "uk-UA": $s,
  "zh-CN": vs,
  "zh-TW": xs
};
function ln(t) {
  return sn() ? t.metaKey : t.ctrlKey;
}
const Ky = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function ar(t) {
  return t instanceof HTMLInputElement && !Ky.has(t.type) || t instanceof HTMLTextAreaElement || t instanceof HTMLElement && t.isContentEditable;
}
const Ry = m.useInsertionEffect ?? le;
function ye(t) {
  const e = B(null);
  return Ry(() => {
    e.current = t;
  }, [
    t
  ]), G((...n) => {
    const r = e.current;
    return r?.(...n);
  }, []);
}
function Vt(t, e, n, r) {
  let l = ye(n), i = n == null;
  Q(() => {
    if (i || !t.current) return;
    let a = t.current;
    return a.addEventListener(e, l, r), () => {
      a.removeEventListener(e, l, r);
    };
  }, [
    t,
    e,
    r,
    i
  ]);
}
function kt(t, e) {
  let { id: n, "aria-label": r, "aria-labelledby": l } = t;
  return n = ce(n), l && r ? l = [
    .../* @__PURE__ */ new Set([
      n,
      ...l.trim().split(/\s+/)
    ])
  ].join(" ") : l && (l = l.trim().split(/\s+/).join(" ")), !r && !l && e && (r = e), {
    id: n,
    "aria-label": r,
    "aria-labelledby": l
  };
}
const Ny = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), My = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Ly(t) {
  if (Intl.Locale) {
    let n = new Intl.Locale(t).maximize(), r = (
      // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
      typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo
    );
    if (r) return r.direction === "rtl";
    if (n.script) return Ny.has(n.script);
  }
  let e = t.split("-")[0];
  return My.has(e);
}
const Cs = /* @__PURE__ */ Symbol.for("react-aria.i18n.locale");
function Ds() {
  let t = typeof window < "u" && window[Cs] || // @ts-ignore
  typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      t
    ]);
  } catch {
    t = "en-US";
  }
  return {
    locale: t,
    direction: Ly(t) ? "rtl" : "ltr"
  };
}
let ni = Ds(), nr = /* @__PURE__ */ new Set();
function Ya() {
  ni = Ds();
  for (let t of nr) t(ni);
}
function zy() {
  let t = it(), [e, n] = q(ni);
  return Q(() => (nr.size === 0 && window.addEventListener("languagechange", Ya), nr.add(n), () => {
    nr.delete(n), nr.size === 0 && window.removeEventListener("languagechange", Ya);
  }), []), t ? {
    locale: typeof window < "u" && window[Cs] || "en-US",
    direction: "ltr"
  } : e;
}
const Vy = /* @__PURE__ */ m.createContext(null);
function pe() {
  let t = zy();
  return z(Vy) || t;
}
const Oy = /* @__PURE__ */ Symbol.for("react-aria.i18n.locale"), Hy = /* @__PURE__ */ Symbol.for("react-aria.i18n.strings");
let Ir;
class Ht {
  constructor(e, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(e).filter(([, r]) => r)), this.defaultLocale = n;
  }
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(e, n) {
    let l = this.getStringsForLocale(n)[e];
    if (!l) throw new Error(`Could not find intl message ${e} in ${n} locale`);
    return l;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(e) {
    let n = this.strings[e];
    return n || (n = _y(e, this.strings, this.defaultLocale), this.strings[e] = n), n;
  }
  static getGlobalDictionaryForPackage(e) {
    if (typeof window > "u") return null;
    let n = window[Oy];
    if (Ir === void 0) {
      let l = window[Hy];
      if (!l) return null;
      Ir = {};
      for (let i in l) Ir[i] = new Ht({
        [n]: l[i]
      }, n);
    }
    let r = Ir?.[e];
    if (!r) throw new Error(`Strings for package "${e}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
}
function _y(t, e, n = "en-US") {
  if (e[t]) return e[t];
  let r = Wy(t);
  if (e[r]) return e[r];
  for (let l in e)
    if (l.startsWith(r + "-")) return e[l];
  return e[n];
}
function Wy(t) {
  return Intl.Locale ? new Intl.Locale(t).language : t.split("-")[0];
}
const Xa = /* @__PURE__ */ new Map(), Za = /* @__PURE__ */ new Map();
class ws {
  constructor(e, n) {
    this.locale = e, this.strings = n;
  }
  /** Formats a localized string for the given key with the provided variables. */
  format(e, n) {
    let r = this.strings.getStringForLocale(e, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(e, n, r = "cardinal") {
    let l = n["=" + e];
    if (l) return typeof l == "function" ? l() : l;
    let i = this.locale + ":" + r, a = Xa.get(i);
    a || (a = new Intl.PluralRules(this.locale, {
      type: r
    }), Xa.set(i, a));
    let o = a.select(e);
    return l = n[o] || n.other, typeof l == "function" ? l() : l;
  }
  number(e) {
    let n = Za.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), Za.set(this.locale, n)), n.format(e);
  }
  select(e, n) {
    let r = e[n] || e.other;
    return typeof r == "function" ? r() : r;
  }
}
const Ja = /* @__PURE__ */ new WeakMap();
function jy(t) {
  let e = Ja.get(t);
  return e || (e = new Ht(t), Ja.set(t, e)), e;
}
function Uy(t, e) {
  return e && Ht.getGlobalDictionaryForPackage(e) || jy(t);
}
function ke(t, e) {
  let { locale: n } = pe(), r = Uy(t, e);
  return _(() => new ws(n, r), [
    n,
    r
  ]);
}
function Gy(t) {
  return t && t.__esModule ? t.default : t;
}
function qy(t, e) {
  let { inputRef: n, collectionRef: r, filter: l, disableAutoFocusFirst: i = !1, disableVirtualFocus: a = !1 } = t, o = ce(), u = B(void 0), c = B(!1), s = B(null), d = gt() === "virtual" && (yt() || _t()), [f, h] = q(!d && !a), [p, b] = q(!1), [g, y] = q(!1);
  Q(() => () => clearTimeout(u.current), []);
  let $ = ye((U) => {
    !U.isTrusted && f && n.current && oe(ue(n.current)) !== n.current && Fy() !== "touch" && n.current.focus();
    let k = H(U);
    U.isTrusted || !k || s.current === k.id || (clearTimeout(u.current), k !== r.current ? c.current ? (s.current = k.id, u.current = setTimeout(() => {
      e.setFocusedNodeId(k.id);
    }, 500)) : (s.current = k.id, e.setFocusedNodeId(k.id)) : s.current && !document.getElementById(s.current) && (s.current = null, e.setFocusedNodeId(null)), c.current = !1);
  }), [v, E] = q(null), S = G((U) => {
    E(U), U != null ? (U.getAttribute("tabindex") != null && h(!1), b(!0)) : b(!1);
  }, []);
  le(() => (v?.addEventListener("focusin", $), () => {
    v?.removeEventListener("focusin", $);
  }), [
    v
  ]);
  let w = ge(_(() => at(r, S), [
    r,
    S
  ])), C = G(() => {
    if (!r.current) {
      y(!0);
      return;
    }
    c.current = !0, r.current?.dispatchEvent(new CustomEvent(Jl, {
      cancelable: !0,
      bubbles: !0,
      detail: {
        focusStrategy: "first"
      }
    }));
  }, [
    r
  ]), R = G((U) => {
    y(!1), Mi(oe()), s.current = null, e.setFocusedNodeId(null);
    let k = new CustomEvent(wu, {
      cancelable: !0,
      bubbles: !0,
      detail: {
        clearFocusKey: U
      }
    });
    clearTimeout(u.current), c.current = !1, r.current?.dispatchEvent(k);
  }, [
    r,
    e
  ]), I = B("");
  Vt(n, "beforeinput", (U) => {
    let { inputType: k } = U;
    I.current = k;
  });
  let N = (U) => {
    (I.current === "insertText" || // IME composition (e.g. CJK input) reports 'insertCompositionText'/'insertFromComposition'
    // instead of 'insertText'. Treat these as forward typing so the first item gets virtual focus.
    I.current === "insertCompositionText" || I.current === "insertFromComposition") && !i ? C() : I.current && (I.current.includes("insert") || I.current.includes("delete") || I.current.includes("history")) && (R(!0), Pu(document) === n.current && Gr(n.current, null)), e.setInputValue(U);
  }, O = B(null), A = (U) => {
    if (O.current = H(U), U.nativeEvent.isComposing) return;
    let k = s.current;
    switch (k !== null && ue(n.current).getElementById(k) == null && (s.current = null, k = null), U.key) {
      case "a":
        if (ln(U)) return;
        break;
      case "Escape":
        if (U.isDefaultPrevented()) return;
        break;
      case " ":
        return;
      case "Tab":
        "continuePropagation" in U && U.continuePropagation();
        return;
      case "Home":
      case "End":
      case "PageDown":
      case "PageUp":
      case "ArrowUp":
      case "ArrowDown":
      case "ArrowRight":
      case "ArrowLeft": {
        if ((U.key === "Home" || U.key === "End") && k == null && U.shiftKey) return;
        if (U.key === "ArrowRight" || U.key === "ArrowLeft") {
          if (k == null) {
            U.isPropagationStopped() || U.stopPropagation();
            return;
          }
          break;
        }
        U.preventDefault();
        let Z = new CustomEvent(Jl, {
          cancelable: !0,
          bubbles: !0
        });
        r.current?.dispatchEvent(Z);
        break;
      }
    }
    U.isPropagationStopped() || U.stopPropagation();
    let ee = !0;
    if (r.current !== null)
      if (k == null) ee = r.current?.dispatchEvent(new KeyboardEvent(U.nativeEvent.type, U.nativeEvent)) || !1;
      else {
        let Z = document.getElementById(k);
        Z && (ee = Z?.dispatchEvent(new KeyboardEvent(U.nativeEvent.type, U.nativeEvent)) || !1);
      }
    if (ee) switch (U.key) {
      case "ArrowLeft":
      case "ArrowRight":
        R();
        break;
      case "Enter":
        k != null && document.getElementById(k)?.dispatchEvent(new PointerEvent("click", U.nativeEvent));
        break;
    }
    else
      U.preventDefault();
  }, V = ye((U) => {
    if (H(U) === O.current) {
      U.stopImmediatePropagation();
      let k = s.current;
      k == null ? r.current?.dispatchEvent(new KeyboardEvent(U.type, U)) : document.getElementById(k)?.dispatchEvent(new KeyboardEvent(U.type, U));
    }
  });
  Q(() => (document.addEventListener("keyup", V, !0), () => {
    document.removeEventListener("keyup", V, !0);
  }), []);
  let x = ke(Gy(Es), "@react-aria/autocomplete"), K = kt({
    id: o,
    "aria-label": x.format("collectionLabel")
  }), D = G((U, k) => l ? l(U, e.inputValue, k) : !0, [
    e.inputValue,
    l
  ]), F = (U) => {
    if (!U.isTrusted) return;
    let k = s.current ? document.getElementById(s.current) : null;
    k && Ql(k, U.relatedTarget);
  }, M = (U) => {
    if (!U.isTrusted) return;
    if (s.current ? document.getElementById(s.current) : null) {
      let ee = H(U);
      queueMicrotask(() => {
        Ql(ee, r.current), Gr(r.current, ee);
      });
    }
  }, P = (U) => {
    U.button !== 0 || U.pointerType === "touch" || s.current == null || n.current == null || H(U) === n.current && R();
  }, T = {
    value: e.inputValue,
    onChange: N
  }, W = {
    onKeyDown: A,
    "aria-activedescendant": e.focusedNodeId ?? void 0,
    onBlur: F,
    onFocus: M,
    onPointerDown: P
  };
  return T = {
    ...T,
    ...f && p && W,
    enterKeyHint: "go",
    "aria-controls": p ? o : void 0,
    // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
    "aria-autocomplete": "list",
    // This disable's iOS's autocorrect suggestions, since the autocomplete provides its own suggestions.
    autoCorrect: "off",
    // This disable's the macOS Safari spell check auto corrections.
    spellCheck: "false",
    autoComplete: "off"
  }, {
    inputProps: T,
    collectionProps: L(K, {
      shouldUseVirtualFocus: f,
      disallowTypeAhead: f,
      autoFocus: g ? "first" : !1
    }),
    collectionRef: w,
    filter: l != null ? D : void 0
  };
}
const Yy = typeof document < "u" ? m.useInsertionEffect ?? m.useLayoutEffect : () => {
};
function Be(t, e, n) {
  let [r, l] = q(t || e), i = B(r), a = B(t !== void 0), o = t !== void 0;
  Q(() => {
    let d = a.current;
    d !== o && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${d ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}.`), a.current = o;
  }, [
    o
  ]);
  let u = o ? t : r;
  Yy(() => {
    i.current = u;
  });
  let [, c] = qg(() => ({}), {}), s = G((d, ...f) => {
    let h = typeof d == "function" ? d(i.current) : d;
    Object.is(i.current, h) || (i.current = h, l(h), c(), n?.(h, ...f));
  }, [
    n
  ]);
  return [
    u,
    s
  ];
}
function Xy(t) {
  let { onInputChange: e, inputValue: n, defaultInputValue: r = "" } = t, l = (c) => {
    e && e(c);
  }, [i, a] = q(null), [o, u] = Be(n, r, l);
  return {
    inputValue: o,
    setInputValue: u,
    focusedNodeId: i,
    setFocusedNodeId: a
  };
}
const Zy = /* @__PURE__ */ j(null), Jy = /* @__PURE__ */ j(null), dn = /* @__PURE__ */ j(null), vr = /* @__PURE__ */ j(null);
function i6(t) {
  let e = We(Zy, t.slot);
  t = L(e, t);
  let { filter: n, disableAutoFocusFirst: r } = t, l = Xy(t), i = B(null), a = B(null), { inputProps: o, collectionProps: u, collectionRef: c, filter: s } = qy({
    ...xt(t),
    filter: n,
    disableAutoFocusFirst: r,
    inputRef: i,
    collectionRef: a
  }, l);
  return /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Jy,
        l
      ],
      [
        vr,
        {
          ...o,
          ref: i
        }
      ],
      [
        dn,
        {
          ...u,
          filter: s,
          ref: c
        }
      ]
    ]
  }, t.children);
}
class Ze {
  constructor(e) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.colSpan = null, this.colIndex = null, this.type = this.constructor.type, this.key = e;
  }
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let e = new this.constructor(this.key);
    return e.value = this.value, e.level = this.level, e.hasChildNodes = this.hasChildNodes, e.rendered = this.rendered, e.textValue = this.textValue, e["aria-label"] = this["aria-label"], e.index = this.index, e.parentKey = this.parentKey, e.prevKey = this.prevKey, e.nextKey = this.nextKey, e.firstChildKey = this.firstChildKey, e.lastChildKey = this.lastChildKey, e.props = this.props, e.render = this.render, e.colSpan = this.colSpan, e.colIndex = this.colIndex, e;
  }
  filter(e, n, r) {
    let l = this.clone();
    return n.addDescendants(l, e), l;
  }
}
class bl extends Ze {
  filter(e, n, r) {
    let [l, i] = Ss(e, n, this.firstChildKey, r), a = this.clone();
    return a.firstChildKey = l, a.lastChildKey = i, a;
  }
}
const Ba = class Ba extends Ze {
};
Ba.type = "header";
let ri = Ba;
const Fa = class Fa extends Ze {
};
Fa.type = "loader";
let Jr = Fa;
const Ta = class Ta extends bl {
  filter(e, n, r) {
    if (r(this.textValue, this)) {
      let l = this.clone();
      return n.addDescendants(l, e), l;
    }
    return null;
  }
};
Ta.type = "item";
let cr = Ta;
const Aa = class Aa extends bl {
  filter(e, n, r) {
    let l = super.filter(e, n, r);
    if (l && l.lastChildKey !== null) {
      let i = e.getItem(l.lastChildKey);
      if (i && i.type !== "header") return l;
    }
    return null;
  }
};
Aa.type = "section";
let li = Aa;
class Ps {
  get size() {
    return this.itemCount;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let e = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; e; )
      yield e, e = e.nextKey != null ? this.keyMap.get(e.nextKey) : void 0;
  }
  getChildren(e) {
    let n = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let r = n.get(e), l = r?.firstChildKey != null ? n.get(r.firstChildKey) : null;
        for (; l; )
          yield l, l = l.nextKey != null ? n.get(l.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(e) {
    let n = this.keyMap.get(e);
    if (!n) return null;
    if (n.prevKey != null) {
      for (n = this.keyMap.get(n.prevKey); n && n.type !== "item" && n.lastChildKey != null; ) n = this.keyMap.get(n.lastChildKey);
      return n?.key ?? null;
    }
    return n.parentKey;
  }
  getKeyAfter(e) {
    let n = this.keyMap.get(e);
    if (!n) return null;
    if (n.type !== "item" && n.firstChildKey != null) return n.firstChildKey;
    for (; n; ) {
      if (n.nextKey != null) return n.nextKey;
      if (n.parentKey != null) n = this.keyMap.get(n.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let e = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; e?.lastChildKey != null; ) e = this.keyMap.get(e.lastChildKey);
    return e?.key ?? null;
  }
  getItem(e) {
    return this.keyMap.get(e) ?? null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let e = this.constructor, n = new e();
    return n.keyMap = new Map(this.keyMap), n.firstKey = this.firstKey, n.lastKey = this.lastKey, n.itemCount = this.itemCount, n;
  }
  addNode(e) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    e.type === "item" && this.keyMap.get(e.key) == null && this.itemCount++, this.keyMap.set(e.key, e);
  }
  // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
  addDescendants(e, n) {
    this.addNode(e);
    let r = n.getChildren(e.key);
    for (let l of r) this.addDescendants(l, n);
  }
  removeNode(e) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    let n = this.keyMap.get(e);
    n != null && n.type === "item" && this.itemCount--, this.keyMap.delete(e);
  }
  commit(e, n, r = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = e, this.lastKey = n, this.frozen = !r;
  }
  filter(e) {
    let n = new this.constructor(), [r, l] = Ss(this, n, this.firstKey, e);
    return n?.commit(r, l), n;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1, this.itemCount = 0;
  }
}
function Ss(t, e, n, r) {
  if (n == null) return [
    null,
    null
  ];
  let l = null, i = null, a = t.getItem(n);
  for (; a != null; ) {
    let o = a.filter(t, e, r);
    o != null && (o.nextKey = null, i && (o.prevKey = i.key, i.nextKey = o.key), l == null && (l = o), e.addNode(o), i = o), a = a.nextKey != null ? t.getItem(a.nextKey) : null;
  }
  if (i && i.type === "separator") {
    let o = i.prevKey;
    e.removeNode(i.key), o != null ? (i = e.getItem(o), i.nextKey = null) : i = null;
  }
  return [
    l?.key ?? null,
    i?.key ?? null
  ];
}
class ks {
  constructor(e) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this._minInvalidChildIndex = null, this.ownerDocument = e;
  }
  *[Symbol.iterator]() {
    let e = this.firstChild;
    for (; e; )
      yield e, e = e.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(e) {
    this._firstChild = e, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(e) {
    this._lastChild = e, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(e) {
    this._previousSibling = e, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(e) {
    this._nextSibling = e, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(e) {
    this._parentNode = e, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    return this.parentNode?.isConnected || !1;
  }
  invalidateChildIndices(e) {
    (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || e.index < this._minInvalidChildIndex.index) && (this._minInvalidChildIndex = e, this.ownerDocument.markDirty(this));
  }
  updateChildIndices() {
    let e = this._minInvalidChildIndex;
    for (; e; )
      e.index = e.previousSibling ? e.previousSibling.index + 1 : 0, e = e.nextSibling;
    this._minInvalidChildIndex = null;
  }
  appendChild(e) {
    e.parentNode && e.parentNode.removeChild(e), this.firstChild == null && (this.firstChild = e), this.lastChild ? (this.lastChild.nextSibling = e, e.index = this.lastChild.index + 1, e.previousSibling = this.lastChild) : (e.previousSibling = null, e.index = 0), e.parentNode = this, e.nextSibling = null, this.lastChild = e, this.ownerDocument.markDirty(this), this.isConnected && this.ownerDocument.queueUpdate();
  }
  insertBefore(e, n) {
    if (n == null) return this.appendChild(e);
    e.parentNode && e.parentNode.removeChild(e), e.nextSibling = n, e.previousSibling = n.previousSibling, e.index = n.index - 1, this.firstChild === n ? this.firstChild = e : n.previousSibling && (n.previousSibling.nextSibling = e), n.previousSibling = e, e.parentNode = n.parentNode, this.invalidateChildIndices(e), this.isConnected && this.ownerDocument.queueUpdate();
  }
  removeChild(e) {
    e.parentNode === this && (this._minInvalidChildIndex === e && (this._minInvalidChildIndex = null), e.nextSibling && (this.invalidateChildIndices(e.nextSibling), e.nextSibling.previousSibling = e.previousSibling), e.previousSibling && (e.previousSibling.nextSibling = e.nextSibling), this.firstChild === e && (this.firstChild = e.nextSibling), this.lastChild === e && (this.lastChild = e.previousSibling), e.parentNode = null, e.nextSibling = null, e.previousSibling = null, e.index = 0, this.ownerDocument.markDirty(e), this.isConnected && this.ownerDocument.queueUpdate());
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  get previousVisibleSibling() {
    let e = this.previousSibling;
    for (; e && e.isHidden; ) e = e.previousSibling;
    return e;
  }
  get nextVisibleSibling() {
    let e = this.nextSibling;
    for (; e && e.isHidden; ) e = e.nextSibling;
    return e;
  }
  get firstVisibleChild() {
    let e = this.firstChild;
    for (; e && e.isHidden; ) e = e.nextSibling;
    return e;
  }
  get lastVisibleChild() {
    let e = this.lastChild;
    for (; e && e.isHidden; ) e = e.previousSibling;
    return e;
  }
}
class Tn extends ks {
  constructor(e, n) {
    super(n), this.nodeType = 8, this.isMutated = !0, this._index = 0, this.isHidden = !1, this.node = null;
  }
  get index() {
    return this._index;
  }
  set index(e) {
    this._index = e, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof Tn ? this.parentNode.level + (this.parentNode.node?.type === "item" ? 1 : 0) : 0;
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode() {
    return this.node == null ? null : (this.isMutated || (this.node = this.node.clone(), this.isMutated = !0), this.ownerDocument.markDirty(this), this.node);
  }
  updateNode() {
    let e = this.nextVisibleSibling, n = this.getMutableNode();
    if (n != null && (n.index = this.index, n.level = this.level, n.parentKey = this.parentNode instanceof Tn ? this.parentNode.node?.key ?? null : null, n.prevKey = this.previousVisibleSibling?.node?.key ?? null, n.nextKey = e?.node?.key ?? null, n.hasChildNodes = !!this.firstChild, n.firstChildKey = this.firstVisibleChild?.node?.key ?? null, n.lastChildKey = this.lastVisibleChild?.node?.key ?? null, (n.colSpan != null || n.colIndex != null) && e)) {
      let r = (n.colIndex ?? n.index) + (n.colSpan ?? 1);
      if (e.node != null && r !== e.node.colIndex) {
        let l = e.getMutableNode();
        l.colIndex = r;
      }
    }
  }
  setProps(e, n, r, l, i) {
    let a, { value: o, textValue: u, id: c, ...s } = e;
    if (this.node == null ? (a = new r(c ?? `react-aria-${++this.ownerDocument.nodeId}`), this.node = a) : a = this.getMutableNode(), s.ref = n, a.props = s, a.rendered = l, a.render = i, a.value = o, e["aria-label"] && (a["aria-label"] = e["aria-label"]), a.textValue = u || (typeof s.children == "string" ? s.children : "") || e["aria-label"] || "", c != null && c !== a.key) throw new Error("Cannot change the id of an item");
    s.colSpan != null && (a.colSpan = s.colSpan), this.isConnected && this.ownerDocument.queueUpdate();
  }
  get style() {
    let e = this;
    return {
      get display() {
        return e.isHidden ? "none" : "";
      },
      set display(n) {
        let r = n === "none";
        if (e.isHidden !== r) {
          (e.parentNode?.firstVisibleChild === e || e.parentNode?.lastVisibleChild === e) && e.ownerDocument.markDirty(e.parentNode);
          let l = e.previousVisibleSibling, i = e.nextVisibleSibling;
          l && e.ownerDocument.markDirty(l), i && e.ownerDocument.markDirty(i), e.isHidden = r, e.ownerDocument.markDirty(e);
        }
      }
    };
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
}
class Qy extends ks {
  constructor(e) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.nextCollection = null, this.subscriptions = /* @__PURE__ */ new Set(), this.queuedRender = !1, this.inSubscription = !1, this.collection = e, this.nextCollection = e;
  }
  get isConnected() {
    return !0;
  }
  createElement(e) {
    return new Tn(e, this);
  }
  getMutableCollection() {
    return this.nextCollection || (this.nextCollection = this.collection.clone()), this.nextCollection;
  }
  markDirty(e) {
    this.dirtyNodes.add(e);
  }
  addNode(e) {
    if (e.isHidden || e.node == null) return;
    let n = this.getMutableCollection();
    if (!n.getItem(e.node.key)) for (let r of e) this.addNode(r);
    n.addNode(e.node);
  }
  removeNode(e) {
    for (let n of e) this.removeNode(n);
    e.node && this.getMutableCollection().removeNode(e.node.key);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.inSubscription ? this.collection : (this.queuedRender = !1, this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let e of this.dirtyNodes) e instanceof Tn && (!e.isConnected || e.isHidden) ? this.removeNode(e) : e.updateChildIndices();
    for (let e of this.dirtyNodes) e instanceof Tn ? (e.isConnected && !e.isHidden && (e.updateNode(), this.addNode(e)), e.node && this.dirtyNodes.delete(e), e.isMutated = !1) : this.dirtyNodes.delete(e);
    this.nextCollection && (this.nextCollection.commit(this.firstVisibleChild?.node?.key ?? null, this.lastVisibleChild?.node?.key ?? null, this.isSSR), this.isSSR || (this.collection = this.nextCollection, this.nextCollection = null));
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.queuedRender)) {
      this.queuedRender = !0, this.inSubscription = !0, this.isSSR || (this.collection = this.collection.clone());
      for (let e of this.subscriptions) e();
      this.inSubscription = !1;
    }
  }
  subscribe(e) {
    return this.subscriptions.add(e), () => this.subscriptions.delete(e);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
}
function Wi(t) {
  let { children: e, items: n, idScope: r, addIdAndValue: l, dependencies: i = [] } = t, a = _(() => process.env.NODE_ENV !== "production" && typeof e == "function" ? e.toString() : void 0, [
    e
  ]), o = _(() => /* @__PURE__ */ new WeakMap(), [
    ...i,
    a
  ]);
  return _(() => {
    if (n && typeof e == "function") {
      let u = [];
      for (let c of n) {
        let s = e$(c) ? c : null, d = s ? o.get(s) : null;
        if (!d) {
          d = e(c);
          let f = d.props.id ?? c?.key ?? c?.id;
          r != null && d.props.id == null && f != null && (f = r + ":" + f);
          let h = f ?? u.length;
          d = xu(d, l ? {
            key: h,
            id: f,
            value: c
          } : {
            key: h
          }), s && o.set(s, d);
        }
        u.push(d);
      }
      return u;
    } else if (typeof e != "function") return e;
  }, [
    e,
    n,
    o,
    r,
    l
  ]);
}
function e$(t) {
  switch (typeof t) {
    case "object":
      return t != null;
    case "function":
    case "symbol":
      return !0;
    default:
      return !1;
  }
}
let zt = /* @__PURE__ */ new Map(), ii = /* @__PURE__ */ new Set();
function Qa() {
  if (typeof window > "u") return;
  function t(r) {
    return "propertyName" in r;
  }
  let e = (r) => {
    let l = H(r);
    if (!t(r) || !l) return;
    let i = zt.get(l);
    i || (i = /* @__PURE__ */ new Set(), zt.set(l, i), l.addEventListener("transitioncancel", n, {
      once: !0
    })), i.add(r.propertyName);
  }, n = (r) => {
    let l = H(r);
    if (!t(r) || !l) return;
    let i = zt.get(l);
    if (i && (i.delete(r.propertyName), i.size === 0 && (l.removeEventListener("transitioncancel", n), zt.delete(l)), zt.size === 0)) {
      for (let a of ii) a();
      ii.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? Qa() : document.addEventListener("DOMContentLoaded", Qa));
function t$() {
  for (const [t] of zt)
    "isConnected" in t && !t.isConnected && zt.delete(t);
}
function Bs(t) {
  requestAnimationFrame(() => {
    t$(), zt.size === 0 ? t() : ii.add(t);
  });
}
function Ce(t) {
  if (!t.isConnected) return;
  const e = ue(t);
  if (gt() === "virtual") {
    let n = oe(e);
    Bs(() => {
      const r = oe(e);
      (r === n || r === e.body) && t.isConnected && Pe(t);
    });
  } else Pe(t);
}
function In(t) {
  let { isDisabled: e, onFocus: n, onBlur: r, onFocusChange: l } = t;
  const i = G((u) => {
    if (H(u) === u.currentTarget)
      return r && r(u), l && l(!1), !0;
  }, [
    r,
    l
  ]), a = Bu(i), o = G((u) => {
    let c = H(u);
    const s = ue(c), d = s ? oe(s) : oe();
    c === u.currentTarget && c === d && (n && n(u), l && l(!0), a(u));
  }, [
    l,
    n,
    a
  ]);
  return {
    focusProps: {
      onFocus: !e && (n || l || r) ? o : void 0,
      onBlur: !e && (r || l) ? i : void 0
    }
  };
}
function eo(t) {
  if (!t) return;
  let e = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        e && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : e = !0;
      },
      continuePropagation() {
        e = !1, typeof n.continuePropagation == "function" && n.continuePropagation();
      },
      isPropagationStopped() {
        return e;
      }
    };
    t(r), e && n.stopPropagation();
  };
}
function Hn(t) {
  return {
    keyboardProps: t.isDisabled ? {} : {
      onKeyDown: eo(t.onKeyDown),
      onKeyUp: eo(t.onKeyUp)
    }
  };
}
function ji(t, e) {
  le(() => {
    if (t && t.ref && e)
      return t.ref.current = e.current, () => {
        t.ref && (t.ref.current = null);
      };
  });
}
let Qr = /* @__PURE__ */ m.createContext(null);
function n$(t) {
  let e = z(Qr) || {};
  ji(e, t);
  let { ref: n, ...r } = e;
  return r;
}
const r$ = /* @__PURE__ */ m.forwardRef(function(e, n) {
  let { children: r, ...l } = e, i = ge(n), a = {
    ...l,
    ref: i
  };
  return /* @__PURE__ */ m.createElement(Qr.Provider, {
    value: a
  }, r);
});
function Je(t, e) {
  let { focusProps: n } = In(t), { keyboardProps: r } = Hn(t), l = L(n, r), i = n$(e), a = t.isDisabled ? {} : i, o = B(t.autoFocus);
  Q(() => {
    o.current && e.current && Ce(e.current), o.current = !1;
  }, [
    e
  ]);
  let u = t.excludeFromTabOrder ? -1 : 0;
  return t.isDisabled && (u = void 0), {
    focusableProps: L({
      ...l,
      tabIndex: u
    }, a)
  };
}
const a6 = /* @__PURE__ */ te(({ children: t, ...e }, n) => {
  n = ge(n);
  let { focusableProps: r } = Je(e, n), l = m.Children.only(t);
  Q(() => {
    if (process.env.NODE_ENV === "production") return;
    let a = n.current;
    if (!a || !(a instanceof De(a).Element)) {
      console.error("<Focusable> child must forward its ref to a DOM element.");
      return;
    }
    if (!e.isDisabled && !Vi(a)) {
      console.warn("<Focusable> child must be focusable. Please ensure the tabIndex prop is passed through.");
      return;
    }
    if (a.localName !== "button" && a.localName !== "input" && a.localName !== "select" && a.localName !== "textarea" && a.localName !== "a" && a.localName !== "area" && a.localName !== "summary" && a.localName !== "img" && a.localName !== "svg") {
      let o = a.getAttribute("role");
      o ? (
        // https://w3c.github.io/aria/#widget_roles
        o !== "application" && o !== "button" && o !== "checkbox" && o !== "combobox" && o !== "gridcell" && o !== "link" && o !== "menuitem" && o !== "menuitemcheckbox" && o !== "menuitemradio" && o !== "option" && o !== "radio" && o !== "searchbox" && o !== "separator" && o !== "slider" && o !== "spinbutton" && o !== "switch" && o !== "tab" && o !== "tabpanel" && o !== "textbox" && o !== "treeitem" && // aria-describedby is also announced on these roles
        o !== "img" && o !== "meter" && o !== "progressbar" && console.warn(`<Focusable> child must have an interactive ARIA role. Got "${o}".`)
      ) : console.warn("<Focusable> child must have an interactive ARIA role.");
    }
  }, [
    n,
    e.isDisabled
  ]);
  let i = parseInt(m.version, 10) < 19 ? l.ref : l.props.ref;
  return /* @__PURE__ */ m.cloneElement(l, {
    ...L(r, l.props),
    // @ts-ignore
    ref: at(i, n)
  });
});
typeof HTMLTemplateElement < "u" && (Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
  configurable: !0,
  enumerable: !0,
  get: function() {
    return this.content.firstChild;
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "appendChild", {
  configurable: !0,
  enumerable: !0,
  value: function(t) {
    return this.content.appendChild(t);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "removeChild", {
  configurable: !0,
  enumerable: !0,
  value: function(t) {
    return this.content.removeChild(t);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "insertBefore", {
  configurable: !0,
  enumerable: !0,
  value: function(t, e) {
    return this.content.insertBefore(t, e);
  }
}));
const el = /* @__PURE__ */ j(!1);
function l$(t) {
  if (z(el))
    return /* @__PURE__ */ m.createElement(m.Fragment, null, t.children);
  let n = /* @__PURE__ */ m.createElement(el.Provider, {
    value: !0
  }, t.children);
  return /* @__PURE__ */ m.createElement("template", null, n);
}
function Gt(t) {
  let e = (n, r) => z(el) ? null : t(n, r);
  return e.displayName = t.displayName || t.name, te(e);
}
function Fs() {
  return z(el);
}
var Kr = { exports: {} }, Bl = {};
var to;
function i$() {
  if (to) return Bl;
  to = 1;
  var t = m;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, l = t.useEffect, i = t.useLayoutEffect, a = t.useDebugValue;
  function o(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), b = p[0].inst, g = p[1];
    return i(
      function() {
        b.value = h, b.getSnapshot = f, u(b) && g({ inst: b });
      },
      [d, h, f]
    ), l(
      function() {
        return u(b) && g({ inst: b }), d(function() {
          u(b) && g({ inst: b });
        });
      },
      [d]
    ), a(h), h;
  }
  function u(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var s = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : o;
  return Bl.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : s, Bl;
}
var Fl = {};
var no;
function a$() {
  return no || (no = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(h, p) {
      return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
    }
    function e(h, p) {
      s || l.startTransition === void 0 || (s = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var b = p();
      if (!d) {
        var g = p();
        i(b, g) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      g = a({
        inst: { value: b, getSnapshot: p }
      });
      var y = g[0].inst, $ = g[1];
      return u(
        function() {
          y.value = b, y.getSnapshot = p, n(y) && $({ inst: y });
        },
        [h, b, p]
      ), o(
        function() {
          return n(y) && $({ inst: y }), h(function() {
            n(y) && $({ inst: y });
          });
        },
        [h]
      ), c(b), b;
    }
    function n(h) {
      var p = h.getSnapshot;
      h = h.value;
      try {
        var b = p();
        return !i(h, b);
      } catch {
        return !0;
      }
    }
    function r(h, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var l = m, i = typeof Object.is == "function" ? Object.is : t, a = l.useState, o = l.useEffect, u = l.useLayoutEffect, c = l.useDebugValue, s = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : e;
    Fl.useSyncExternalStore = l.useSyncExternalStore !== void 0 ? l.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Fl;
}
var ro;
function o$() {
  return ro || (ro = 1, process.env.NODE_ENV === "production" ? Kr.exports = i$() : Kr.exports = a$()), Kr.exports;
}
var Ui = o$();
const Ts = /* @__PURE__ */ j(!1), dr = /* @__PURE__ */ j(null);
function hn(t) {
  if (z(dr))
    return t.content;
  let { collection: n, document: r } = d$(t.createCollection);
  return /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(l$, null, /* @__PURE__ */ m.createElement(dr.Provider, {
    value: r
  }, t.content)), /* @__PURE__ */ m.createElement(u$, {
    render: t.children,
    collection: n
  }));
}
function u$({ collection: t, render: e }) {
  return e(t);
}
function s$(t, e, n) {
  let r = it(), l = B(r);
  l.current = r;
  let i = G(() => l.current ? n() : e(), [
    e,
    n
  ]);
  return Ui.useSyncExternalStore(t, i);
}
const c$ = typeof m.useSyncExternalStore == "function" ? m.useSyncExternalStore : s$;
function d$(t) {
  let [e] = q(() => new Qy(t?.() || new Ps())), n = G((a) => e.subscribe(a), [
    e
  ]), r = G(() => {
    let a = e.getCollection();
    return e.isSSR && e.resetAfterSSR(), a;
  }, [
    e
  ]), l = G(() => (e.isSSR = !0, e.getCollection()), [
    e
  ]);
  return {
    collection: c$(n, r, l),
    document: e
  };
}
const ai = /* @__PURE__ */ j(null);
function f$(t) {
  var n;
  return n = class extends Ze {
  }, n.type = t, n;
}
function As(t, e, n, r, l, i) {
  typeof t == "string" && (t = f$(t));
  let a = G((u) => {
    u?.setProps(e, n, t, r, i);
  }, [
    e,
    n,
    r,
    i,
    t
  ]), o = z(ai);
  if (o) {
    let u = o.ownerDocument.nodesByProps.get(e);
    return u || (u = o.ownerDocument.createElement(t.type), u.setProps(e, n, t, r, i), o.appendChild(u), o.ownerDocument.updateCollection(), o.ownerDocument.nodesByProps.set(e, u)), l ? /* @__PURE__ */ m.createElement(ai.Provider, {
      value: u
    }, l) : null;
  }
  return /* @__PURE__ */ m.createElement(t.type, {
    ref: a
  }, l);
}
function ot(t, e) {
  let n = ({ node: l }) => e(l.props, l.props.ref, l), r = te((l, i) => {
    let a = z(Qr);
    if (!z(Ts)) {
      if (e.length >= 3) throw new Error(e.name + " cannot be rendered outside a collection.");
      return e(l, i);
    }
    return As(t, l, i, "children" in l ? l.children : null, null, (u) => (
      // Forward FocusableContext to real DOM tree so tooltips work.
      /* @__PURE__ */ m.createElement(Qr.Provider, {
        value: a
      }, /* @__PURE__ */ m.createElement(n, {
        node: u
      }))
    ));
  });
  return r.displayName = e.name, r;
}
function xr(t, e, n = Is) {
  let r = ({ node: i }) => e(i.props, i.props.ref, i), l = te((i, a) => {
    let o = n(i);
    return As(t, i, a, null, o, (u) => /* @__PURE__ */ m.createElement(r, {
      node: u
    })) ?? /* @__PURE__ */ m.createElement(m.Fragment, null);
  });
  return l.displayName = e.name, l;
}
function Is(t) {
  return Wi({
    ...t,
    addIdAndValue: !0
  });
}
const lo = /* @__PURE__ */ j(null);
function At(t) {
  let e = z(lo), n = (e?.dependencies || []).concat(t.dependencies), r = t.idScope ?? e?.idScope, l = Is({
    ...t,
    idScope: r,
    dependencies: n
  });
  return z(dr) && (l = /* @__PURE__ */ m.createElement(h$, null, l)), e = _(
    () => ({
      dependencies: n,
      idScope: r
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      ...n
    ]
  ), /* @__PURE__ */ m.createElement(lo.Provider, {
    value: e
  }, l);
}
function h$({ children: t }) {
  let e = z(dr), n = _(() => /* @__PURE__ */ m.createElement(dr.Provider, {
    value: null
  }, /* @__PURE__ */ m.createElement(Ts.Provider, {
    value: !0
  }, t)), [
    t
  ]);
  return it() ? /* @__PURE__ */ m.createElement(ai.Provider, {
    value: e
  }, n) : /* @__PURE__ */ Eu(n, e);
}
const Ks = /* @__PURE__ */ j(null), Er = {
  CollectionRoot({ collection: t, renderDropIndicator: e }) {
    return io(t, null, e);
  },
  CollectionBranch({ collection: t, parent: e, renderDropIndicator: n }) {
    return io(t, e, n);
  }
};
function io(t, e, n) {
  return Wi({
    items: e ? t.getChildren(e.key) : t,
    dependencies: [
      n
    ],
    children(r) {
      if (r.type === "content") return /* @__PURE__ */ m.createElement(m.Fragment, null);
      let l = r.render(r);
      return !n || r.type !== "item" ? l : /* @__PURE__ */ m.createElement(m.Fragment, null, n({
        type: "item",
        key: r.key,
        dropPosition: "before"
      }), l, Rs(t, r, n));
    }
  });
}
function Rs(t, e, n) {
  let r = e.key, l = t.getKeyAfter(r), i = l != null ? t.getItem(l) : null;
  for (; i != null && i.type !== "item"; )
    l = t.getKeyAfter(i.key), i = l != null ? t.getItem(l) : null;
  let a = e.nextKey != null ? t.getItem(e.nextKey) : null;
  for (; a != null && a.type !== "item"; ) a = a.nextKey != null ? t.getItem(a.nextKey) : null;
  let o = [];
  if (a == null) {
    let u = e;
    for (; u?.type === "item" && (!i || u.parentKey !== i.parentKey && i.level < u.level); ) {
      let c = n({
        type: "item",
        key: u.key,
        dropPosition: "after"
      });
      /* @__PURE__ */ Yg(c) && o.push(/* @__PURE__ */ xu(c, {
        key: `${u.key}-after`
      })), u = u.parentKey != null ? t.getItem(u.parentKey) : null;
    }
  }
  return o;
}
const me = /* @__PURE__ */ j(Er);
function Gi(t) {
  return _(() => t != null ? /* @__PURE__ */ new Set([
    t
  ]) : null, [
    t
  ]);
}
const p$ = /* @__PURE__ */ new Set([
  "id"
]), b$ = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), m$ = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), g$ = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]), ao = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]), y$ = /^(data-.*)$/;
function Y(t, e = {}) {
  let { labelable: n, isLink: r, global: l, events: i = l, propNames: a } = e, o = {};
  for (const u in t) Object.prototype.hasOwnProperty.call(t, u) && (p$.has(u) || n && b$.has(u) || r && m$.has(u) || l && g$.has(u) || i && (ao.has(u) || u.endsWith("Capture") && ao.has(u.slice(0, -7))) || a?.has(u) || y$.test(u)) && (o[u] = t[u]);
  return o;
}
let wn = "default", oi = "", Hr = /* @__PURE__ */ new WeakMap();
function ui(t) {
  if (yt()) {
    if (wn === "default") {
      const e = ue(t);
      oi = e.documentElement.style.webkitUserSelect, e.documentElement.style.webkitUserSelect = "none";
    }
    wn = "disabled";
  } else if (t instanceof HTMLElement || t instanceof SVGElement) {
    let e = "userSelect" in t.style ? "userSelect" : "webkitUserSelect";
    Hr.set(t, t.style[e]), t.style[e] = "none";
  }
}
function _r(t) {
  if (yt()) {
    if (wn !== "disabled") return;
    wn = "restoring", setTimeout(() => {
      Bs(() => {
        if (wn === "restoring") {
          const e = ue(t);
          e.documentElement.style.webkitUserSelect === "none" && (e.documentElement.style.webkitUserSelect = oi || ""), oi = "", wn = "default";
        }
      });
    }, 300);
  } else if ((t instanceof HTMLElement || t instanceof SVGElement) && t && Hr.has(t)) {
    let e = Hr.get(t), n = "userSelect" in t.style ? "userSelect" : "webkitUserSelect";
    t.style[n] === "none" && (t.style[n] = e), t.getAttribute("style") === "" && t.removeAttribute("style"), Hr.delete(t);
  }
}
function oo(t) {
  return t?.defaultView?.__webpack_nonce__ || globalThis.__webpack_nonce__ || void 0;
}
let Tl = /* @__PURE__ */ new WeakMap();
function Ns(t) {
  let e = t ?? (typeof document < "u" ? document : void 0);
  if (!e) return oo(e);
  if (Tl.has(e)) return Tl.get(e);
  let n = e.querySelector('meta[property="csp-nonce"]'), r = n && n instanceof De(n).HTMLMetaElement && (n.nonce || n.content) || oo(e) || void 0;
  return r !== void 0 && Tl.set(e, r), r;
}
const fr = m.createContext({
  register: () => {
  }
});
fr.displayName = "PressResponderContext";
function It() {
  let t = B(/* @__PURE__ */ new Map()), e = G((l, i, a, o) => {
    let u = o?.once ? (...c) => {
      t.current.delete(a), a(...c);
    } : a;
    t.current.set(a, {
      type: i,
      eventTarget: l,
      fn: u,
      options: o
    }), l.addEventListener(i, u, o);
  }, []), n = G((l, i, a, o) => {
    let u = t.current.get(a)?.fn || a;
    l.removeEventListener(i, u, o), t.current.delete(a);
  }, []), r = G(() => {
    t.current.forEach((l, i) => {
      n(l.eventTarget, l.type, i, l.options);
    });
  }, [
    n
  ]);
  return Q(() => r, [
    r
  ]), {
    addGlobalListener: e,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function $$(t) {
  let e = z(fr);
  if (e) {
    let { register: n, ref: r, ...l } = e;
    t = L(l, t), n();
  }
  return ji(e, t.ref), t;
}
class Rr {
  #e;
  constructor(e, n, r, l) {
    this.#e = !0;
    const a = (l?.target ?? r.currentTarget)?.getBoundingClientRect();
    let o, u = 0, c, s = null;
    r.clientX != null && r.clientY != null && (c = r.clientX, s = r.clientY), a && (c != null && s != null ? (o = c - a.left, u = s - a.top) : (o = a.width / 2, u = a.height / 2)), this.type = e, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = o, this.y = u, this.key = r.key;
  }
  continuePropagation() {
    this.#e = !1;
  }
  get shouldStopPropagation() {
    return this.#e;
  }
}
const uo = /* @__PURE__ */ Symbol("linkClicked"), so = "react-aria-pressable-style", co = "data-react-aria-pressable";
function lt(t) {
  let { onPress: e, onPressChange: n, onPressStart: r, onPressEnd: l, onPressUp: i, onClick: a, isDisabled: o, isPressed: u, preventFocusOnPress: c, shouldCancelOnPointerExit: s, allowTextSelectionOnPress: d, ref: f, ...h } = $$(t), [p, b] = q(!1), g = B({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: y, removeAllGlobalListeners: $ } = It(), v = G((x, K) => {
    let D = g.current;
    if (o || D.didFirePressStart) return !1;
    let F = !0;
    if (D.isTriggeringEvent = !0, r) {
      let M = new Rr("pressstart", K, x);
      r(M), F = M.shouldStopPropagation;
    }
    return n && n(!0), D.isTriggeringEvent = !1, D.didFirePressStart = !0, b(!0), F;
  }, [
    o,
    r,
    n
  ]), E = G((x, K, D = !0) => {
    let F = g.current;
    if (!F.didFirePressStart) return !1;
    F.didFirePressStart = !1, F.isTriggeringEvent = !0;
    let M = !0;
    if (l) {
      let P = new Rr("pressend", K, x);
      l(P), M = P.shouldStopPropagation;
    }
    if (n && n(!1), b(!1), e && D && !o) {
      let P = new Rr("press", K, x);
      e(P), M &&= P.shouldStopPropagation;
    }
    return F.isTriggeringEvent = !1, M;
  }, [
    o,
    l,
    n,
    e
  ]), S = ye(E), w = G((x, K) => {
    let D = g.current;
    if (o) return !1;
    if (i) {
      D.isTriggeringEvent = !0;
      let F = new Rr("pressup", K, x);
      return i(F), D.isTriggeringEvent = !1, F.shouldStopPropagation;
    }
    return !0;
  }, [
    o,
    i
  ]), C = ye(w), R = G((x) => {
    let K = g.current;
    if (K.isPressed && K.target) {
      K.didFirePressStart && K.pointerType != null && E(Qt(K.target, x), K.pointerType, !1), K.isPressed = !1, K.isOverTarget = !1, K.activePointerId = null, K.pointerType = null, $(), d || _r(K.target);
      for (let D of K.disposables) D();
      K.disposables = [];
    }
  }, [
    d,
    $,
    E
  ]), I = ye(R);
  Q(() => {
    o && g.current.isPressed && I({
      currentTarget: g.current.target,
      shiftKey: !1,
      ctrlKey: !1,
      metaKey: !1,
      altKey: !1
    });
  }, [
    o
  ]);
  let N = G((x) => {
    s && R(x);
  }, [
    s,
    R
  ]), O = G((x) => {
    o || a?.(x);
  }, [
    o,
    a
  ]), A = G((x, K) => {
    if (!o && a) {
      let D = new MouseEvent("click", x);
      ku(D, K), a(Oi(D));
    }
  }, [
    o,
    a
  ]), V = _(() => {
    let x = g.current, K = {
      onKeyDown(F) {
        if (Al(F.nativeEvent, F.currentTarget) && ne(F.currentTarget, H(F))) {
          po(H(F), F.key) && F.preventDefault();
          let M = !0;
          !x.isPressed && !F.repeat && (x.target = F.currentTarget, x.isPressed = !0, x.pointerType = "keyboard", M = v(F, "keyboard"));
          let P = F.currentTarget, T = (W) => {
            Al(W, P) && !W.repeat && ne(P, H(W)) && x.target && C(Qt(x.target, W), "keyboard");
          };
          y(ue(F.currentTarget), "keyup", Ye(T, D), !0), M && F.stopPropagation(), F.metaKey && sn() && x.metaKeyEvents?.set(F.key, F.nativeEvent);
        } else F.key === "Meta" && (x.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(F) {
        if (!(F && !ne(F.currentTarget, H(F))) && F && F.button === 0 && !x.isTriggeringEvent && !$t.isOpening) {
          let M = !0;
          if (o && F.preventDefault(), !x.ignoreEmulatedMouseEvents && !x.isPressed && (x.pointerType === "virtual" || ei(F.nativeEvent))) {
            let P = v(F, "virtual"), T = C(F, "virtual"), W = S(F, "virtual");
            O(F), M = P && T && W;
          } else if (x.isPressed && x.pointerType !== "keyboard") {
            let P = x.pointerType || F.nativeEvent.pointerType || "virtual", T = C(Qt(F.currentTarget, F), P), W = S(Qt(F.currentTarget, F), P, !0);
            M = T && W, x.isOverTarget = !1, O(F), I(F);
          }
          x.ignoreEmulatedMouseEvents = !1, M && F.stopPropagation();
        }
      }
    }, D = (F) => {
      if (x.isPressed && x.target && Al(F, x.target)) {
        po(H(F), F.key) && F.preventDefault();
        let M = H(F), P = ne(x.target, M);
        S(Qt(x.target, F), "keyboard", P), P && A(F, x.target), $(), F.key !== "Enter" && qi(x.target) && ne(x.target, M) && !F[uo] && (F[uo] = !0, $t(x.target, F, !1)), x.isPressed = !1, x.metaKeyEvents?.delete(F.key);
      } else if (F.key === "Meta" && x.metaKeyEvents?.size) {
        let M = x.metaKeyEvents;
        x.metaKeyEvents = void 0;
        for (let P of M.values()) x.target?.dispatchEvent(new KeyboardEvent("keyup", P));
      }
    };
    if (typeof PointerEvent < "u") {
      K.onPointerDown = (P) => {
        if (P.button !== 0 || !ne(P.currentTarget, H(P))) return;
        if (wy(P.nativeEvent)) {
          x.pointerType = "virtual";
          return;
        }
        x.pointerType = P.pointerType;
        let T = !0;
        if (!x.isPressed) {
          x.isPressed = !0, x.isOverTarget = !0, x.activePointerId = P.pointerId, x.target = P.currentTarget, d || ui(x.target), T = v(P, x.pointerType);
          let W = H(P);
          "releasePointerCapture" in W && ("hasPointerCapture" in W ? W.hasPointerCapture(P.pointerId) && W.releasePointerCapture(P.pointerId) : W.releasePointerCapture(P.pointerId)), y(ue(P.currentTarget), "pointerup", F, !1), y(ue(P.currentTarget), "pointercancel", M, !1);
        }
        T && P.stopPropagation();
      }, K.onMouseDown = (P) => {
        if (ne(P.currentTarget, H(P)) && P.button === 0) {
          if (c) {
            let T = qa(P.target);
            T && x.disposables.push(T);
          }
          P.stopPropagation();
        }
      }, K.onPointerUp = (P) => {
        !ne(P.currentTarget, H(P)) || x.pointerType === "virtual" || P.button === 0 && !x.isPressed && C(P, x.pointerType || P.pointerType);
      }, K.onPointerEnter = (P) => {
        P.pointerId === x.activePointerId && x.target && !x.isOverTarget && x.pointerType != null && (x.isOverTarget = !0, v(Qt(x.target, P), x.pointerType));
      }, K.onPointerLeave = (P) => {
        P.pointerId === x.activePointerId && x.target && x.isOverTarget && x.pointerType != null && (x.isOverTarget = !1, S(Qt(x.target, P), x.pointerType, !1), N(P));
      };
      let F = (P) => {
        if (P.pointerId === x.activePointerId && x.isPressed && P.button === 0 && x.target) {
          if (ne(x.target, H(P)) && x.pointerType != null) {
            let T = !1, W = setTimeout(() => {
              x.isPressed && x.target instanceof HTMLElement && (T ? I(P) : (Pe(x.target), x.target.click()));
            }, 80);
            y(P.currentTarget, "click", () => T = !0, !0), x.disposables.push(() => clearTimeout(W));
          } else
            I(P);
          x.isOverTarget = !1;
        }
      }, M = (P) => {
        I(P);
      };
      K.onDragStart = (P) => {
        ne(P.currentTarget, H(P)) && I(P);
      };
    } else if (process.env.NODE_ENV === "test") {
      K.onMouseDown = (P) => {
        if (P.button !== 0 || !ne(P.currentTarget, H(P))) return;
        if (x.ignoreEmulatedMouseEvents) {
          P.stopPropagation();
          return;
        }
        if (x.isPressed = !0, x.isOverTarget = !0, x.target = P.currentTarget, x.pointerType = ei(P.nativeEvent) ? "virtual" : "mouse", Ge(() => v(P, x.pointerType)) && P.stopPropagation(), c) {
          let W = qa(P.target);
          W && x.disposables.push(W);
        }
        y(ue(P.currentTarget), "mouseup", F, !1);
      }, K.onMouseEnter = (P) => {
        if (!ne(P.currentTarget, H(P))) return;
        let T = !0;
        x.isPressed && !x.ignoreEmulatedMouseEvents && x.pointerType != null && (x.isOverTarget = !0, T = v(P, x.pointerType)), T && P.stopPropagation();
      }, K.onMouseLeave = (P) => {
        if (!ne(P.currentTarget, H(P))) return;
        let T = !0;
        x.isPressed && !x.ignoreEmulatedMouseEvents && x.pointerType != null && (x.isOverTarget = !1, T = S(P, x.pointerType, !1), N(P)), T && P.stopPropagation();
      }, K.onMouseUp = (P) => {
        ne(P.currentTarget, H(P)) && !x.ignoreEmulatedMouseEvents && P.button === 0 && !x.isPressed && C(P, x.pointerType || "mouse");
      };
      let F = (P) => {
        if (P.button === 0) {
          if (x.ignoreEmulatedMouseEvents) {
            x.ignoreEmulatedMouseEvents = !1;
            return;
          }
          x.target && ne(x.target, H(P)) && x.pointerType != null || I(P), x.isOverTarget = !1;
        }
      };
      K.onTouchStart = (P) => {
        if (!ne(P.currentTarget, H(P))) return;
        let T = v$(P.nativeEvent);
        if (!T) return;
        x.activePointerId = T.identifier, x.ignoreEmulatedMouseEvents = !0, x.isOverTarget = !0, x.isPressed = !0, x.target = P.currentTarget, x.pointerType = "touch", d || ui(x.target), v(Nt(x.target, P), x.pointerType) && P.stopPropagation(), y(De(P.currentTarget), "scroll", M, !0);
      }, K.onTouchMove = (P) => {
        if (!ne(P.currentTarget, H(P))) return;
        if (!x.isPressed) {
          P.stopPropagation();
          return;
        }
        let T = fo(P.nativeEvent, x.activePointerId), W = !0;
        T && ho(T, P.currentTarget) ? !x.isOverTarget && x.pointerType != null && (x.isOverTarget = !0, W = v(Nt(x.target, P), x.pointerType)) : x.isOverTarget && x.pointerType != null && (x.isOverTarget = !1, W = S(Nt(x.target, P), x.pointerType, !1), N(Nt(x.target, P))), W && P.stopPropagation();
      }, K.onTouchEnd = (P) => {
        if (!ne(P.currentTarget, H(P))) return;
        if (!x.isPressed) {
          P.stopPropagation();
          return;
        }
        let T = fo(P.nativeEvent, x.activePointerId), W = !0;
        T && ho(T, P.currentTarget) && x.pointerType != null ? (C(Nt(x.target, P), x.pointerType), W = S(Nt(x.target, P), x.pointerType), A(P.nativeEvent, x.target)) : x.isOverTarget && x.pointerType != null && (W = S(Nt(x.target, P), x.pointerType, !1)), W && P.stopPropagation(), x.isPressed = !1, x.activePointerId = null, x.isOverTarget = !1, x.ignoreEmulatedMouseEvents = !0, x.target && !d && _r(x.target), $();
      }, K.onTouchCancel = (P) => {
        ne(P.currentTarget, H(P)) && (P.stopPropagation(), x.isPressed && I(Nt(x.target, P)));
      };
      let M = (P) => {
        x.isPressed && ne(H(P), x.target) && I({
          currentTarget: x.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      K.onDragStart = (P) => {
        ne(P.currentTarget, H(P)) && I(P);
      };
    }
    return K;
  }, [
    y,
    o,
    c,
    $,
    d,
    N,
    v,
    O,
    A
  ]);
  return Q(() => {
    if (!f || process.env.NODE_ENV === "test") return;
    const x = ue(f.current);
    if (!x || !x.head || x.getElementById(so)) return;
    const K = x.createElement("style");
    K.id = so;
    let D = Ns(x);
    D && (K.nonce = D), K.textContent = `
@layer {
  [${co}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), x.head.prepend(K);
  }, [
    f
  ]), Q(() => {
    let x = g.current;
    return () => {
      d || _r(x.target ?? void 0);
      for (let K of x.disposables) K();
      x.disposables = [];
    };
  }, [
    d
  ]), {
    isPressed: u || p,
    pressProps: L(h, V, {
      [co]: !0
    })
  };
}
function qi(t) {
  return t.tagName === "A" && t.hasAttribute("href");
}
function Al(t, e) {
  const { key: n, code: r } = t, l = e, i = l.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(l instanceof De(l).HTMLInputElement && !Ms(l, n) || l instanceof De(l).HTMLTextAreaElement || l.isContentEditable) && // Links should only trigger with Enter key
  !((i === "link" || !i && qi(l)) && n !== "Enter");
}
function v$(t) {
  const { targetTouches: e } = t;
  return e.length > 0 ? e[0] : null;
}
function fo(t, e) {
  const n = t.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const l = n[r];
    if (l.identifier === e) return l;
  }
  return null;
}
function Nt(t, e) {
  let n = 0, r = 0;
  return e.targetTouches && e.targetTouches.length === 1 && (n = e.targetTouches[0].clientX, r = e.targetTouches[0].clientY), {
    currentTarget: t,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: n,
    clientY: r
  };
}
function Qt(t, e) {
  let n = e.clientX, r = e.clientY;
  return {
    currentTarget: t,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: n,
    clientY: r,
    key: e.key
  };
}
function x$(t) {
  let e = 0, n = 0;
  return t.width !== void 0 ? e = t.width / 2 : t.radiusX !== void 0 && (e = t.radiusX), t.height !== void 0 ? n = t.height / 2 : t.radiusY !== void 0 && (n = t.radiusY), {
    top: t.clientY - n,
    right: t.clientX + e,
    bottom: t.clientY + n,
    left: t.clientX - e
  };
}
function E$(t, e) {
  return !(t.left > e.right || e.left > t.right || t.top > e.bottom || e.top > t.bottom);
}
function ho(t, e) {
  let n = e.getBoundingClientRect(), r = x$(t);
  return E$(n, r);
}
function C$(t) {
  return t instanceof HTMLInputElement ? !1 : t instanceof HTMLButtonElement ? t.type !== "submit" && t.type !== "reset" : !qi(t);
}
function po(t, e) {
  return t instanceof HTMLInputElement ? !Ms(t, e) : C$(t);
}
const D$ = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Ms(t, e) {
  return t.type === "checkbox" || t.type === "radio" ? e === " " : D$.has(t.type);
}
function w$(t, e) {
  let { elementType: n = "a", onPress: r, onPressStart: l, onPressEnd: i, onClick: a, isDisabled: o, ...u } = t, c = {};
  n !== "a" && (c = {
    role: "link",
    tabIndex: o ? void 0 : 0
  });
  let { focusableProps: s } = Je(t, e), { pressProps: d, isPressed: f } = lt({
    onPress: r,
    onPressStart: l,
    onPressEnd: i,
    onClick: a,
    isDisabled: o,
    ref: e
  }), h = Y(u, {
    labelable: !0
  }), p = L(s, d), b = Vn(), g = fl(t);
  return {
    isPressed: f,
    linkProps: L(h, g, {
      ...p,
      ...c,
      "aria-disabled": o || void 0,
      "aria-current": t["aria-current"],
      onClick: (y) => {
        d.onClick?.(y), Mu(y, b, t.href, t.routerOptions);
      }
    })
  };
}
function Et(t) {
  let { isDisabled: e, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: l } = t, i = B({
    isFocusWithin: !1
  }), { addGlobalListener: a, removeAllGlobalListeners: o } = It(), u = G((d) => {
    ne(d.currentTarget, H(d)) && i.current.isFocusWithin && !ne(d.currentTarget, d.relatedTarget) && (i.current.isFocusWithin = !1, o(), n && n(d), l && l(!1));
  }, [
    n,
    l,
    i,
    o
  ]), c = Bu(u), s = G((d) => {
    if (!ne(d.currentTarget, H(d))) return;
    let f = H(d);
    const h = ue(f), p = oe(h);
    if (!i.current.isFocusWithin && p === f) {
      r && r(d), l && l(!0), i.current.isFocusWithin = !0, c(d);
      let b = d.currentTarget;
      a(h, "focus", (g) => {
        let y = H(g);
        if (i.current.isFocusWithin && !ne(b, y)) {
          let $ = new h.defaultView.FocusEvent("blur", {
            relatedTarget: y
          });
          ku($, b);
          let v = Oi($);
          u(v);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    l,
    c,
    a,
    u
  ]);
  return e ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: s,
      onBlur: u
    }
  };
}
function $e(t = {}) {
  let { autoFocus: e = !1, isTextInput: n, within: r } = t, l = B({
    isFocused: !1,
    isFocusVisible: e || vt()
  }), [i, a] = q(!1), [o, u] = q(() => l.current.isFocused && l.current.isFocusVisible), c = G(() => u(l.current.isFocused && l.current.isFocusVisible), []), s = G((h) => {
    l.current.isFocused = h, l.current.isFocusVisible = vt(), a(h), c();
  }, [
    c
  ]);
  Iy((h) => {
    l.current.isFocusVisible = h, c();
  }, [
    n,
    i
  ], {
    enabled: i,
    isTextInput: n
  });
  let { focusProps: d } = In({
    isDisabled: r,
    onFocusChange: s
  }), { focusWithinProps: f } = Et({
    isDisabled: !r,
    onFocusWithinChange: s
  });
  return {
    isFocused: i,
    isFocusVisible: o,
    focusProps: r ? f : d
  };
}
let tl = !1, Nr = 0;
function si() {
  tl = !0, setTimeout(() => {
    tl = !1;
  }, 500);
}
function bo(t) {
  t.pointerType === "touch" && si();
}
function P$() {
  let t = ue(null);
  if (!(typeof t > "u"))
    return Nr === 0 && (typeof PointerEvent < "u" ? t.addEventListener("pointerup", bo) : process.env.NODE_ENV === "test" && t.addEventListener("touchend", si)), Nr++, () => {
      Nr--, !(Nr > 0) && (typeof PointerEvent < "u" ? t.removeEventListener("pointerup", bo) : process.env.NODE_ENV === "test" && t.removeEventListener("touchend", si));
    };
}
function ve(t) {
  let { onHoverStart: e, onHoverChange: n, onHoverEnd: r, isDisabled: l } = t, [i, a] = q(!1), o = B({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  Q(P$, []);
  let { addGlobalListener: u, removeAllGlobalListeners: c } = It(), { hoverProps: s, triggerHoverEnd: d } = _(() => {
    let f = (b, g) => {
      if (o.pointerType = g, l || g === "touch" || o.isHovered || !ne(b.currentTarget, H(b))) return;
      o.isHovered = !0;
      let y = b.currentTarget;
      o.target = y, u(ue(H(b)), "pointerover", ($) => {
        o.isHovered && o.target && !ne(o.target, H($)) && h($, $.pointerType);
      }, {
        capture: !0
      }), e && e({
        type: "hoverstart",
        target: y,
        pointerType: g
      }), n && n(!0), a(!0);
    }, h = (b, g) => {
      let y = o.target;
      o.pointerType = "", o.target = null, !(g === "touch" || !o.isHovered || !y) && (o.isHovered = !1, c(), r && r({
        type: "hoverend",
        target: y,
        pointerType: g
      }), n && n(!1), a(!1));
    }, p = {};
    return typeof PointerEvent < "u" ? (p.onPointerEnter = (b) => {
      tl && b.pointerType === "mouse" || f(b, b.pointerType);
    }, p.onPointerLeave = (b) => {
      !l && ne(b.currentTarget, H(b)) && h(b, b.pointerType);
    }) : process.env.NODE_ENV === "test" && (p.onTouchStart = () => {
      o.ignoreEmulatedMouseEvents = !0;
    }, p.onMouseEnter = (b) => {
      !o.ignoreEmulatedMouseEvents && !tl && f(b, "mouse"), o.ignoreEmulatedMouseEvents = !1;
    }, p.onMouseLeave = (b) => {
      !l && ne(b.currentTarget, H(b)) && h(b, "mouse");
    }), {
      hoverProps: p,
      triggerHoverEnd: h
    };
  }, [
    e,
    n,
    r,
    l,
    o,
    u,
    c
  ]);
  return Q(() => {
    l && d({
      currentTarget: o.target
    }, o.pointerType);
  }, [
    l
  ]), {
    hoverProps: s,
    isHovered: i
  };
}
const Ls = /* @__PURE__ */ j(null), o6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, Ls);
  let r = e.href && !e.isDisabled ? "a" : "span", { linkProps: l, isPressed: i } = w$({
    ...e,
    elementType: r
  }, n), a = X[r], { hoverProps: o, isHovered: u } = ve(e), { focusProps: c, isFocused: s, isFocusVisible: d } = $e(), f = re({
    ...e,
    defaultClassName: "react-aria-Link",
    values: {
      isCurrent: !!e["aria-current"],
      isDisabled: e.isDisabled || !1,
      isPressed: i,
      isHovered: u,
      isFocused: s,
      isFocusVisible: d
    }
  }), h = Y(e, {
    global: !0
  });
  return delete h.onClick, /* @__PURE__ */ m.createElement(a, {
    ref: n,
    slot: e.slot || void 0,
    ...L(h, f, l, o, c),
    "data-focused": s || void 0,
    "data-hovered": u || void 0,
    "data-pressed": i || void 0,
    "data-focus-visible": d || void 0,
    "data-current": !!e["aria-current"] || void 0,
    "data-disabled": e.isDisabled || void 0
  }, f.children);
});
var zs = {};
zs = {
  breadcrumbs: "عناصر الواجهة"
};
var Vs = {};
Vs = {
  breadcrumbs: "Трохи хляб"
};
var Os = {};
Os = {
  breadcrumbs: "Popis cesty"
};
var Hs = {};
Hs = {
  breadcrumbs: "Brødkrummer"
};
var _s = {};
_s = {
  breadcrumbs: "Breadcrumbs"
};
var Ws = {};
Ws = {
  breadcrumbs: "Πλοηγήσεις breadcrumb"
};
var js = {};
js = {
  breadcrumbs: "Breadcrumbs"
};
var Us = {};
Us = {
  breadcrumbs: "Migas de pan"
};
var Gs = {};
Gs = {
  breadcrumbs: "Lingiread"
};
var qs = {};
qs = {
  breadcrumbs: "Navigointilinkit"
};
var Ys = {};
Ys = {
  breadcrumbs: "Chemin de navigation"
};
var Xs = {};
Xs = {
  breadcrumbs: "שבילי ניווט"
};
var Zs = {};
Zs = {
  breadcrumbs: "Navigacijski putovi"
};
var Js = {};
Js = {
  breadcrumbs: "Morzsamenü"
};
var Qs = {};
Qs = {
  breadcrumbs: "Breadcrumb"
};
var ec = {};
ec = {
  breadcrumbs: "パンくずリスト"
};
var tc = {};
tc = {
  breadcrumbs: "탐색 표시"
};
var nc = {};
nc = {
  breadcrumbs: "Naršymo kelias"
};
var rc = {};
rc = {
  breadcrumbs: "Atpakaļceļi"
};
var lc = {};
lc = {
  breadcrumbs: "Navigasjonsstier"
};
var ic = {};
ic = {
  breadcrumbs: "Broodkruimels"
};
var ac = {};
ac = {
  breadcrumbs: "Struktura nawigacyjna"
};
var oc = {};
oc = {
  breadcrumbs: "Caminho detalhado"
};
var uc = {};
uc = {
  breadcrumbs: "Categorias"
};
var sc = {};
sc = {
  breadcrumbs: "Miez de pâine"
};
var cc = {};
cc = {
  breadcrumbs: "Навигация"
};
var dc = {};
dc = {
  breadcrumbs: "Navigačné prvky Breadcrumbs"
};
var fc = {};
fc = {
  breadcrumbs: "Drobtine"
};
var hc = {};
hc = {
  breadcrumbs: "Putanje navigacije"
};
var pc = {};
pc = {
  breadcrumbs: "Sökvägar"
};
var bc = {};
bc = {
  breadcrumbs: "İçerik haritaları"
};
var mc = {};
mc = {
  breadcrumbs: "Навігаційна стежка"
};
var gc = {};
gc = {
  breadcrumbs: "导航栏"
};
var yc = {};
yc = {
  breadcrumbs: "導覽列"
};
var $c = {};
$c = {
  "ar-AE": zs,
  "bg-BG": Vs,
  "cs-CZ": Os,
  "da-DK": Hs,
  "de-DE": _s,
  "el-GR": Ws,
  "en-US": js,
  "es-ES": Us,
  "et-EE": Gs,
  "fi-FI": qs,
  "fr-FR": Ys,
  "he-IL": Xs,
  "hr-HR": Zs,
  "hu-HU": Js,
  "it-IT": Qs,
  "ja-JP": ec,
  "ko-KR": tc,
  "lt-LT": nc,
  "lv-LV": rc,
  "nb-NO": lc,
  "nl-NL": ic,
  "pl-PL": ac,
  "pt-BR": oc,
  "pt-PT": uc,
  "ro-RO": sc,
  "ru-RU": cc,
  "sk-SK": dc,
  "sl-SI": fc,
  "sr-SP": hc,
  "sv-SE": pc,
  "tr-TR": bc,
  "uk-UA": mc,
  "zh-CN": gc,
  "zh-TW": yc
};
function S$(t) {
  return t && t.__esModule ? t.default : t;
}
function k$(t) {
  let { "aria-label": e, ...n } = t, r = ke(S$($c), "@react-aria/breadcrumbs");
  return {
    navProps: {
      ...Y(n, {
        labelable: !0
      }),
      "aria-label": e || r.format("breadcrumbs")
    }
  };
}
const ci = /* @__PURE__ */ j(null), u6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, ci);
  let { CollectionRoot: r } = z(me), { navProps: l } = k$(e), i = Y(e, {
    global: !0,
    labelable: !0
  });
  return /* @__PURE__ */ m.createElement(hn, {
    content: /* @__PURE__ */ m.createElement(At, e)
  }, (a) => /* @__PURE__ */ m.createElement(X.ol, {
    render: e.render,
    ref: n,
    ...L(i, l),
    slot: e.slot || void 0,
    style: e.style,
    className: e.className ?? "react-aria-Breadcrumbs"
  }, /* @__PURE__ */ m.createElement(ci.Provider, {
    value: e
  }, /* @__PURE__ */ m.createElement(r, {
    collection: a
  }))));
}), Ia = class Ia extends Ze {
};
Ia.type = "item";
let di = Ia;
const s6 = /* @__PURE__ */ ot(di, function(e, n, r) {
  let l = r.nextKey == null, { isDisabled: i, onAction: a } = We(ci), o = {
    "aria-current": l ? "page" : null,
    isDisabled: i || l,
    onPress: () => a?.(r.key)
  }, u = re({
    ...r.props,
    children: r.rendered,
    values: {
      isDisabled: i || l,
      isCurrent: l
    },
    defaultClassName: "react-aria-Breadcrumb"
  }), c = Y(e, {
    global: !0,
    labelable: !0
  });
  return delete c.id, /* @__PURE__ */ m.createElement(X.li, {
    ...c,
    ...u,
    ref: n,
    "data-disabled": i || l || void 0,
    "data-current": l || void 0
  }, /* @__PURE__ */ m.createElement(Ls.Provider, {
    value: o
  }, u.children));
}), ut = /* @__PURE__ */ j({}), c6 = /* @__PURE__ */ Gt(function(e, n) {
  [e, n] = ie(e, n, ut);
  let { elementType: r = "label", ...l } = e, i = X[r];
  return /* @__PURE__ */ m.createElement(i, {
    className: "react-aria-Label",
    ...l,
    ref: n
  });
});
function Cr(t) {
  let { id: e, label: n, "aria-labelledby": r, "aria-label": l, labelElementType: i = "label" } = t;
  e = ce(e);
  let a = ce(), o = {};
  n ? (r = r ? `${a} ${r}` : a, o = {
    id: a,
    htmlFor: i === "label" ? e : void 0
  }) : !r && !l && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let u = kt({
    id: e,
    "aria-label": l,
    "aria-labelledby": r
  });
  return {
    labelProps: o,
    fieldProps: u
  };
}
let Il = /* @__PURE__ */ new Map(), fi = !1;
try {
  fi = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let nl = !1;
try {
  nl = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const vc = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class Wt {
  constructor(e, n = {}) {
    this.numberFormatter = B$(e, n), this.options = n;
  }
  /**
  * Formats a number value as a string, according to the locale and options provided to the
  * constructor.
  */
  format(e) {
    let n = "";
    if (!fi && this.options.signDisplay != null ? n = F$(this.numberFormatter, this.options.signDisplay, e) : n = this.numberFormatter.format(e), this.options.style === "unit" && !nl) {
      let { unit: r, unitDisplay: l = "short", locale: i } = this.resolvedOptions();
      if (!r) return n;
      let a = vc[r]?.[l];
      n += a[i] || a.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(e) {
    return this.numberFormatter.formatToParts(e);
  }
  /** Formats a number range as a string. */
  formatRange(e, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(e, n);
    if (n < e) throw new RangeError("End date must be >= start date");
    return `${this.format(e)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(e, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(e, n);
    if (n < e) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(e), l = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...l.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let e = this.numberFormatter.resolvedOptions();
    return !fi && this.options.signDisplay != null && (e = {
      ...e,
      signDisplay: this.options.signDisplay
    }), !nl && this.options.style === "unit" && (e = {
      ...e,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), e;
  }
}
function B$(t, e = {}) {
  let { numberingSystem: n } = e;
  if (n && t.includes("-nu-") && (t.includes("-u-") || (t += "-u-"), t += `-nu-${n}`), e.style === "unit" && !nl) {
    let { unit: i, unitDisplay: a = "short" } = e;
    if (!i) throw new Error('unit option must be provided with style: "unit"');
    if (!vc[i]?.[a]) throw new Error(`Unsupported unit ${i} with unitDisplay = ${a}`);
    e = {
      ...e,
      style: "decimal"
    };
  }
  let r = t + (e ? Object.entries(e).sort((i, a) => i[0] < a[0] ? -1 : 1).join() : "");
  if (Il.has(r)) return Il.get(r);
  let l = new Intl.NumberFormat(t, e);
  return Il.set(r, l), l;
}
function F$(t, e, n) {
  if (e === "auto") return t.format(n);
  if (e === "never") return t.format(Math.abs(n));
  {
    let r = !1;
    if (e === "always" ? r = n > 0 || Object.is(n, 0) : e === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let l = t.format(-n), i = t.format(n), a = l.replace(i, "").replace(/\u200e|\u061C/, "");
      return [
        ...a
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), l.replace(i, "!!!").replace(a, "+").replace("!!!", i);
    } else return t.format(n);
  }
}
const T$ = new RegExp("^.*\\(.*\\).*$"), A$ = [
  "latn",
  "arab",
  "hanidec",
  "deva",
  "beng",
  "fullwide"
];
class xc {
  constructor(e, n = {}) {
    this.locale = e, this.options = n;
  }
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(e) {
    return Kl(this.locale, this.options, e).parse(e);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(e, n, r) {
    return Kl(this.locale, this.options, e).isValidPartialNumber(e, n, r);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(e) {
    return Kl(this.locale, this.options, e).options.numberingSystem;
  }
}
const mo = /* @__PURE__ */ new Map();
function Kl(t, e, n) {
  let r = go(t, e);
  if (!t.includes("-nu-") && !r.isValidPartialNumber(n)) {
    for (let l of A$) if (l !== r.options.numberingSystem) {
      let i = go(t + (t.includes("-u-") ? "-nu-" : "-u-nu-") + l, e);
      if (i.isValidPartialNumber(n)) return i;
    }
  }
  return r;
}
function go(t, e) {
  let n = t + (e ? Object.entries(e).sort((l, i) => l[0] < i[0] ? -1 : 1).join() : ""), r = mo.get(n);
  return r || (r = new I$(t, e), mo.set(n, r)), r;
}
class I$ {
  constructor(e, n = {}) {
    this.locale = e, n.roundingIncrement !== 1 && n.roundingIncrement != null && (n.maximumFractionDigits == null && n.minimumFractionDigits == null ? (n.maximumFractionDigits = 0, n.minimumFractionDigits = 0) : n.maximumFractionDigits == null ? n.maximumFractionDigits = n.minimumFractionDigits : n.minimumFractionDigits == null && (n.minimumFractionDigits = n.maximumFractionDigits)), this.formatter = new Intl.NumberFormat(e, n), this.options = this.formatter.resolvedOptions(), this.symbols = K$(e, this.formatter, this.options, n), this.options.style === "percent" && ((this.options.minimumFractionDigits ?? 0) > 18 || (this.options.maximumFractionDigits ?? 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
  parse(e) {
    let n = this.formatter.resolvedOptions().useGrouping, r = this.sanitize(e);
    if (!n && this.symbols.group && r.includes(this.symbols.group)) return NaN;
    if (this.symbols.group && (r = r.replaceAll(this.symbols.group, "")), this.symbols.decimal && (r = r.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (r = r.replace(this.symbols.minusSign, "-")), r = r.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let i = r.indexOf("-");
      r = r.replace("-", ""), r = r.replace("+", "");
      let a = r.indexOf(".");
      a === -1 && (a = r.length), r = r.replace(".", ""), a - 2 === 0 ? r = `0.${r}` : a - 2 === -1 ? r = `0.0${r}` : a - 2 === -2 ? r = "0.00" : r = `${r.slice(0, a - 2)}.${r.slice(a - 2)}`, i > -1 && (r = `-${r}`);
    }
    let l = r ? +r : NaN;
    if (isNaN(l)) return NaN;
    if (this.options.style === "percent") {
      let i = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min((this.options.minimumFractionDigits ?? 0) + 2, 20),
        maximumFractionDigits: Math.min((this.options.maximumFractionDigits ?? 0) + 2, 20)
      };
      return new xc(this.locale, i).parse(new Wt(this.locale, i).format(l));
    }
    return this.options.currencySign === "accounting" && T$.test(e) && (l = -1 * l), l;
  }
  sanitize(e) {
    let n = this.formatter.resolvedOptions().useGrouping;
    return this.symbols.noNumeralUnits.length > 0 && this.symbols.noNumeralUnits.find((r) => r.unit === e) ? this.symbols.noNumeralUnits.find((r) => r.unit === e).value.toString() : (e = e.replace(this.symbols.literals, ""), this.symbols.minusSign && (e = e.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (e = Mt(e, ",", this.symbols.decimal), e = Mt(e, "،", this.symbols.decimal)), this.symbols.group && n && (e = Mt(e, ".", this.symbols.group))), this.symbols.group === "’" && e.includes("'") && n && (e = Mt(e, "'", this.symbols.group)), this.symbols.group === "'" && e.includes("’") && n && (e = Mt(e, "’", this.symbols.group)), this.options.locale === "fr-FR" && this.symbols.group && n && (e = Mt(e, " ", this.symbols.group), e = Mt(e, /\u00A0/g, this.symbols.group)), e);
  }
  isValidPartialNumber(e, n = -1 / 0, r = 1 / 0) {
    let l = this.formatter.resolvedOptions().useGrouping;
    return e = this.sanitize(e), this.symbols.minusSign && e.startsWith(this.symbols.minusSign) && n < 0 ? e = e.slice(this.symbols.minusSign.length) : this.symbols.plusSign && e.startsWith(this.symbols.plusSign) && r > 0 && (e = e.slice(this.symbols.plusSign.length)), this.symbols.decimal && e.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && l && (e = Mt(e, this.symbols.group, "")), e = e.replace(this.symbols.numeral, ""), this.symbols.decimal && (e = e.replace(this.symbols.decimal, "")), e.length === 0);
  }
}
const yo = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), $o = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function K$(t, e, n, r) {
  let l = new Intl.NumberFormat(t, {
    ...n,
    // Resets so we get the full range of symbols
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21,
    roundingIncrement: 1,
    roundingPriority: "auto",
    roundingMode: "halfExpand",
    useGrouping: !0
  }), i = l.formatToParts(-10000.111), a = l.formatToParts(10000.111), o = $o.map((w) => l.formatToParts(w)), u = o.map((w, C) => {
    let R = w.find((I) => I.type === "unit");
    return R && !w.some((I) => I.type === "integer" || I.type === "fraction") ? {
      unit: R.value,
      value: $o[C]
    } : null;
  }).filter((w) => !!w), c = i.find((w) => w.type === "minusSign")?.value ?? "-", s = a.find((w) => w.type === "plusSign")?.value;
  !s && (r?.signDisplay === "exceptZero" || r?.signDisplay === "always") && (s = "+");
  let f = new Intl.NumberFormat(t, {
    ...n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((w) => w.type === "decimal")?.value, h = i.find((w) => w.type === "group")?.value, p = i.filter((w) => !yo.has(w.type)).map((w) => vo(w.value)), b = o.flatMap((w) => w.filter((C) => !yo.has(C.type)).map((C) => vo(C.value))), g = [
    .../* @__PURE__ */ new Set([
      ...p,
      ...b
    ])
  ].sort((w, C) => C.length - w.length), y = g.length === 0 ? new RegExp("\\p{White_Space}|\\p{Cf}", "gu") : new RegExp(`${g.join("|")}|\\p{White_Space}|\\p{Cf}`, "gu"), $ = [
    ...new Intl.NumberFormat(n.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), v = new Map($.map((w, C) => [
    w,
    C
  ])), E = new RegExp(`[${$.join("")}]`, "g");
  return {
    minusSign: c,
    plusSign: s,
    decimal: f,
    group: h,
    literals: y,
    numeral: E,
    numerals: $,
    index: (w) => String(v.get(w)),
    noNumeralUnits: u
  };
}
function Mt(t, e, n) {
  return t.replaceAll ? t.replaceAll(e, n) : t.split(e).join(n);
}
function vo(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function hi(t = {}) {
  let { locale: e } = pe();
  return _(() => new Wt(e, t), [
    e,
    t
  ]);
}
function Re(t, e = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(t, e), n);
}
function Mr(t, e) {
  let n = t, r = 0, l = e.toString(), i = l.toLowerCase().indexOf("e-");
  if (i > 0) r = Math.abs(Math.floor(Math.log10(Math.abs(e)))) + i;
  else {
    let a = l.indexOf(".");
    a >= 0 && (r = l.length - a);
  }
  if (r > 0) {
    let a = Math.pow(10, r);
    n = Math.round(n * a) / a;
  }
  return n;
}
function Ke(t, e, n, r) {
  e = Number(e), n = Number(n);
  let l = (t - (isNaN(e) ? 0 : e)) % r, i = Mr(Math.abs(l) * 2 >= r ? t + Math.sign(l) * (r - Math.abs(l)) : t - l, r);
  return isNaN(e) ? !isNaN(n) && i > n && (i = Math.floor(Mr(n / r, r)) * r) : i < e ? i = e : !isNaN(n) && i > n && (i = e + Math.floor(Mr((n - e) / r, r)) * r), i = Mr(i, r), i;
}
function Ae(t, e, n = 10) {
  const r = Math.pow(n, e);
  return Math.round(t * r) / r;
}
function R$(t) {
  let { value: e = 0, minValue: n = 0, maxValue: r = 100, valueLabel: l, isIndeterminate: i, formatOptions: a = {
    style: "percent"
  } } = t, o = Y(t, {
    labelable: !0
  }), { labelProps: u, fieldProps: c } = Cr({
    ...t,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  e = Re(e, n, r);
  let s = (e - n) / (r - n), d = hi(a);
  if (!i && !l) {
    let f = a.style === "percent" ? s : e;
    l = d.format(f);
  }
  return {
    progressBarProps: L(o, {
      ...c,
      "aria-valuenow": i ? void 0 : e,
      "aria-valuemin": n,
      "aria-valuemax": r,
      "aria-valuetext": i ? void 0 : l,
      role: "progressbar"
    }),
    labelProps: u
  };
}
const Ec = /* @__PURE__ */ j(null), d6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, Ec);
  let { value: r = 0, minValue: l = 0, maxValue: i = 100, isIndeterminate: a = !1 } = e;
  r = Re(r, l, i);
  let [o, u] = Xe(!e["aria-label"] && !e["aria-labelledby"]), { progressBarProps: c, labelProps: s } = R$({
    ...e,
    label: u
  }), d = a ? void 0 : (r - l) / (i - l) * 100, f = re({
    ...e,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: d,
      valueText: c["aria-valuetext"],
      isIndeterminate: a
    }
  }), h = Y(e, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(h, f, c),
    ref: n,
    slot: e.slot || void 0
  }, /* @__PURE__ */ m.createElement(ut.Provider, {
    value: {
      ...s,
      ref: o,
      elementType: "span"
    }
  }, f.children));
}), Cc = 7e3;
let Lt = null;
function Kn(t, e = "assertive", n = Cc) {
  Lt ? Lt.announce(t, e, n) : (Lt = new M$(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? Lt.announce(t, e, n) : setTimeout(() => {
    Lt?.isAttached() && Lt?.announce(t, e, n);
  }, 100));
}
function N$(t) {
  Lt && Lt.clear(t);
}
class M$ {
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
  isAttached() {
    return this.node?.isConnected;
  }
  createLog(e) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", e), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(e, n = "assertive", r = Cc) {
    if (!this.node) return;
    let l = document.createElement("div");
    typeof e == "object" ? (l.setAttribute("role", "img"), l.setAttribute("aria-labelledby", e["aria-labelledby"])) : l.textContent = e, n === "assertive" ? this.assertiveLog?.appendChild(l) : this.politeLog?.appendChild(l), e !== "" && setTimeout(() => {
      l.remove();
    }, r);
  }
  clear(e) {
    this.node && ((!e || e === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!e || e === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
}
function Dc(t, e) {
  let { elementType: n = "button", isDisabled: r, onPress: l, onPressStart: i, onPressEnd: a, onPressUp: o, onPressChange: u, preventFocusOnPress: c, allowFocusWhenDisabled: s, onClick: d, href: f, target: h, rel: p, type: b = "button" } = t, g;
  n === "button" ? g = {
    type: b,
    disabled: r,
    form: t.form,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formMethod: t.formMethod,
    formNoValidate: t.formNoValidate,
    formTarget: t.formTarget,
    name: t.name,
    value: t.value
  } : g = {
    role: "button",
    href: n === "a" && !r ? f : void 0,
    target: n === "a" ? h : void 0,
    type: n === "input" ? b : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? p : void 0
  };
  let { pressProps: y, isPressed: $ } = lt({
    onPressStart: i,
    onPressEnd: a,
    onPressChange: u,
    onPress: l,
    onPressUp: o,
    onClick: d,
    isDisabled: r,
    preventFocusOnPress: c,
    ref: e
  }), { focusableProps: v } = Je(t, e);
  s && (v.tabIndex = r ? -1 : v.tabIndex);
  let E = L(v, y, Y(t, {
    labelable: !0
  }));
  return {
    isPressed: $,
    buttonProps: L(g, E, {
      "aria-haspopup": t["aria-haspopup"],
      "aria-expanded": t["aria-expanded"],
      "aria-controls": t["aria-controls"],
      "aria-pressed": t["aria-pressed"],
      "aria-current": t["aria-current"],
      "aria-disabled": t["aria-disabled"]
    })
  };
}
const st = /* @__PURE__ */ j({}), f6 = /* @__PURE__ */ Gt(function(e, n) {
  [e, n] = ie(e, n, st);
  let r = e, { isPending: l } = r, { buttonProps: i, isPressed: a } = Dc(e, n);
  i = z$(i, l);
  let { focusProps: o, isFocused: u, isFocusVisible: c } = $e(e), { hoverProps: s, isHovered: d } = ve({
    ...e,
    isDisabled: e.isDisabled || l
  }), f = {
    isHovered: d,
    isPressed: (r.isPressed || a) && !l,
    isFocused: u,
    isFocusVisible: c,
    isDisabled: e.isDisabled || !1,
    isPending: l ?? !1
  }, h = re({
    ...e,
    values: f,
    defaultClassName: "react-aria-Button"
  }), p = ce(i.id), b = ce(), g = i["aria-labelledby"];
  l && (g ? g = `${g} ${b}` : i["aria-label"] && (g = `${p} ${b}`));
  let y = B(l);
  Q(() => {
    let v = {
      "aria-labelledby": g || p
    };
    (!y.current && u && l || y.current && u && !l) && Kn(v, "assertive"), y.current = l;
  }, [
    l,
    u,
    g,
    p
  ]);
  let $ = Y(e, {
    global: !0
  });
  return delete $.onClick, /* @__PURE__ */ m.createElement(X.button, {
    ...L($, h, i, o, s),
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    type: i.type === "submit" && l ? "button" : i.type,
    id: p,
    ref: n,
    "aria-labelledby": g,
    slot: e.slot || void 0,
    "aria-disabled": l ? "true" : i["aria-disabled"],
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": f.isPressed || void 0,
    "data-hovered": d || void 0,
    "data-focused": u || void 0,
    "data-pending": l || void 0,
    "data-focus-visible": c || void 0
  }, /* @__PURE__ */ m.createElement(Ec.Provider, {
    value: {
      id: b
    }
  }, h.children));
}), L$ = /Focus|Blur|Hover|Pointer(Enter|Leave|Over|Out)|Mouse(Enter|Leave|Over|Out)/;
function z$(t, e) {
  if (e) {
    for (const n in t) n.startsWith("on") && !L$.test(n) && (t[n] = void 0);
    t.href = void 0, t.target = void 0;
  }
  return t;
}
const wc = /* @__PURE__ */ j({}), h6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, wc);
  let { children: r, level: l = 3, className: i, ...a } = e, o = X[`h${l}`];
  return /* @__PURE__ */ m.createElement(o, {
    ...a,
    ref: n,
    className: i ?? "react-aria-Heading"
  }, r);
}), Qe = /* @__PURE__ */ j({}), V$ = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, Qe);
  let { elementType: r = "span", ...l } = e, i = X[r];
  return /* @__PURE__ */ m.createElement(i, {
    className: "react-aria-Text",
    ...l,
    ref: n
  });
});
function p6(t, e) {
  let n = B(null);
  return t && n.current && e(t, n.current) && (t = n.current), n.current = t, t;
}
function Pc(t, e) {
  const n = B(!0), r = B(null);
  let l = ye(t);
  Q(() => (n.current = !0, () => {
    n.current = !1;
  }), []), Q(() => {
    let i = r.current;
    n.current ? n.current = !1 : (!i || e.some((a, o) => !Object.is(a, i[o]))) && l(), r.current = e;
  }, e);
}
function jt(t, e) {
  if (!t) return !1;
  let n = window.getComputedStyle(t), r = document.scrollingElement || document.documentElement, l = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return t === r && n.overflow !== "hidden" && (l = !0), l && e && (l = t.scrollHeight !== t.clientHeight || t.scrollWidth !== t.clientWidth), l;
}
function Me(t, e) {
  let n = t;
  for (jt(n, e) && (n = n.parentElement); n && !jt(n, e); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function Rl(t, e) {
  let n = [], r = document.scrollingElement || document.documentElement;
  for (; t && (jt(t, e) && n.push(t), t !== r); )
    t = t.parentElement;
  return n;
}
function Wr(t, e, n = {}) {
  let { block: r = "nearest", inline: l = "nearest" } = n;
  if (t === e) return;
  let i = t.scrollTop, a = t.scrollLeft, o = e.getBoundingClientRect(), u = t.getBoundingClientRect(), c = window.getComputedStyle(e), s = window.getComputedStyle(t), d = document.scrollingElement || document.documentElement, f = t === d, h = t === d ? 0 : u.top, p = t === d ? t.clientHeight : u.bottom, b = t === d ? 0 : u.left, g = t === d ? t.clientWidth : u.right, y = parseFloat(c.scrollMarginTop) || 0, $ = parseFloat(c.scrollMarginBottom) || 0, v = parseFloat(c.scrollMarginLeft) || 0, E = parseFloat(c.scrollMarginRight) || 0, S = parseFloat(s.scrollPaddingTop) || 0, w = parseFloat(s.scrollPaddingBottom) || 0, C = parseFloat(s.scrollPaddingLeft) || 0, R = parseFloat(s.scrollPaddingRight) || 0, I = parseFloat(s.borderTopWidth) || 0, N = parseFloat(s.borderBottomWidth) || 0, O = parseFloat(s.borderLeftWidth) || 0, A = parseFloat(s.borderRightWidth) || 0, V = o.top - y, x = o.bottom + $, K = o.left - v, D = o.right + E, F = t === d ? 0 : O + A, M = t === d ? 0 : I + N, P = t === d ? 0 : t.offsetWidth - t.clientWidth - F, T = t === d ? 0 : t.offsetHeight - t.clientHeight - M, W = h + (f ? 0 : I) + S, U = p - (f ? 0 : N) - w - T, k = b + (f ? 0 : O) + C, ee = g - (f ? 0 : A) - R;
  s.direction === "rtl" && !yt() ? k += P : ee -= P;
  let Z = V < W || x > U, de = K < k || D > ee;
  if (Z && r === "start") i += V - W;
  else if (Z && r === "center") i += (V + x) / 2 - (W + U) / 2;
  else if (Z && r === "end") i += x - U;
  else if (Z && r === "nearest") {
    let ae = V - W, se = x - U;
    i += Math.abs(ae) <= Math.abs(se) ? ae : se;
  }
  if (de && l === "start") a += K - k;
  else if (de && l === "center") a += (K + D) / 2 - (k + ee) / 2;
  else if (de && l === "end") a += D - ee;
  else if (de && l === "nearest") {
    let ae = K - k, se = D - ee;
    a += Math.abs(ae) <= Math.abs(se) ? ae : se;
  }
  if (process.env.NODE_ENV === "test") {
    t.scrollLeft = a, t.scrollTop = i;
    return;
  }
  t.scrollTo({
    left: a,
    top: i
  });
}
function Oe(t, e = {}) {
  let { containingElement: n } = e;
  if (t && t.isConnected) {
    let r = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(r).overflow === "hidden") {
      let { left: i, top: a } = t.getBoundingClientRect(), o = Rl(t, !0);
      for (let s of o) Wr(s, t);
      let { left: u, top: c } = t.getBoundingClientRect();
      if (Math.abs(i - u) > 1 || Math.abs(a - c) > 1) {
        o = n ? Rl(n, !0) : [];
        for (let s of o) Wr(s, n, {
          block: "center",
          inline: "center"
        });
        for (let s of Rl(t, !0)) Wr(s, t);
      }
    } else {
      let { left: i, top: a } = t.getBoundingClientRect();
      t?.scrollIntoView?.({
        block: "nearest"
      });
      let { left: o, top: u } = t.getBoundingClientRect();
      (Math.abs(i - o) > 1 || Math.abs(a - u) > 1) && (n?.scrollIntoView?.({
        block: "center",
        inline: "center"
      }), t.scrollIntoView?.({
        block: "nearest"
      }));
    }
  }
}
let O$ = 0;
const Nl = /* @__PURE__ */ new Map();
function _n(t) {
  let [e, n] = q();
  return le(() => {
    if (!t) return;
    let r = Nl.get(t);
    if (r)
      n(r.element.id);
    else {
      let l = `react-aria-description-${O$++}`;
      n(l);
      let i = document.createElement("div");
      i.id = l, i.style.display = "none", i.textContent = t, document.body.appendChild(i), r = {
        refCount: 0,
        element: i
      }, Nl.set(t, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), Nl.delete(t));
    };
  }, [
    t
  ]), {
    "aria-describedby": t ? e : void 0
  };
}
const xo = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function qt(t = {}) {
  let { style: e, isFocusable: n } = t, [r, l] = q(!1), { focusWithinProps: i } = Et({
    isDisabled: !n,
    onFocusWithinChange: (o) => l(o)
  }), a = _(() => r ? e : e ? {
    ...xo,
    ...e
  } : xo, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...i,
      style: a
    }
  };
}
function ml(t) {
  let { children: e, elementType: n = "div", isFocusable: r, style: l, ...i } = t, { visuallyHiddenProps: a } = qt(t);
  return /* @__PURE__ */ m.createElement(n, L(i, a), e);
}
const Yt = /* @__PURE__ */ j(null), b6 = /* @__PURE__ */ te(function(e, n) {
  return z(Yt)?.isInvalid ? /* @__PURE__ */ m.createElement(H$, {
    ...e,
    ref: n
  }) : null;
}), H$ = /* @__PURE__ */ te((t, e) => {
  let n = z(Yt), { elementType: r, ...l } = t, i = Y(l, {
    global: !0
  }), a = re({
    ...l,
    defaultClassName: "react-aria-FieldError",
    defaultChildren: n.validationErrors.length === 0 ? void 0 : n.validationErrors.join(" "),
    values: n
  });
  return a.children == null ? null : /* @__PURE__ */ m.createElement(V$, {
    slot: "errorMessage",
    elementType: r,
    ...i,
    ...a,
    ref: e
  });
}), Sc = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, kc = {
  ...Sc,
  customError: !0,
  valid: !1
}, Dn = {
  isInvalid: !1,
  validationDetails: Sc,
  validationErrors: []
}, _$ = j({}), Rn = "__reactAriaFormValidationState";
function pn(t) {
  if (t[Rn]) {
    let { realtimeValidation: e, displayValidation: n, updateValidation: r, resetValidation: l, commitValidation: i } = t[Rn];
    return {
      realtimeValidation: e,
      displayValidation: n,
      updateValidation: r,
      resetValidation: l,
      commitValidation: i
    };
  }
  return W$(t);
}
function W$(t) {
  let { isInvalid: e, validationState: n, name: r, value: l, builtinValidation: i, validate: a, validationBehavior: o = "aria" } = t;
  n && (e ||= n === "invalid");
  let u = e !== void 0 ? {
    isInvalid: e,
    validationErrors: [],
    validationDetails: kc
  } : null, c = _(() => {
    if (!a || l == null) return null;
    let N = j$(a, l);
    return Eo(N);
  }, [
    a,
    l
  ]);
  i?.validationDetails.valid && (i = void 0);
  let s = z(_$), d = _(() => r ? Array.isArray(r) ? r.flatMap((N) => pi(s[N])) : pi(s[r]) : [], [
    s,
    r
  ]), [f, h] = q(s), [p, b] = q(!1);
  s !== f && (h(s), b(!1));
  let g = _(() => Eo(p ? [] : d), [
    p,
    d
  ]), y = B(Dn), [$, v] = q(Dn), E = B(Dn), S = () => {
    if (!w) return;
    C(!1);
    let N = c || i || y.current;
    Ml(N, E.current) || (E.current = N, v(N));
  }, [w, C] = q(!1);
  return Q(S), {
    realtimeValidation: u || g || c || i || Dn,
    displayValidation: o === "native" ? u || g || $ : u || g || c || i || $,
    updateValidation(N) {
      o === "aria" && !Ml($, N) ? v(N) : y.current = N;
    },
    resetValidation() {
      let N = Dn;
      Ml(N, E.current) || (E.current = N, v(N)), o === "native" && C(!1), b(!0);
    },
    commitValidation() {
      o === "native" && C(!0), b(!0);
    }
  };
}
function pi(t) {
  return t ? Array.isArray(t) ? t : [
    t
  ] : [];
}
function j$(t, e) {
  if (typeof t == "function") {
    let n = t(e);
    if (n && typeof n != "boolean") return pi(n);
  }
  return [];
}
function Eo(t) {
  return t.length ? {
    isInvalid: !0,
    validationErrors: t,
    validationDetails: kc
  } : null;
}
function Ml(t, e) {
  return t === e ? !0 : !!t && !!e && t.isInvalid === e.isInvalid && t.validationErrors.length === e.validationErrors.length && t.validationErrors.every((n, r) => n === e.validationErrors[r]) && Object.entries(t.validationDetails).every(([n, r]) => e.validationDetails[n] === r);
}
const Wn = /* @__PURE__ */ j(null), U$ = /* @__PURE__ */ new WeakMap();
function gl(t) {
  let { description: e, errorMessage: n, isInvalid: r, validationState: l } = t, { labelProps: i, fieldProps: a } = Cr(t), o = mt([
    !!e,
    !!n,
    r,
    l
  ]), u = mt([
    !!e,
    !!n,
    r,
    l
  ]);
  return a = L(a, {
    "aria-describedby": [
      o,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      u,
      t["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: i,
    fieldProps: a,
    descriptionProps: {
      id: o
    },
    errorMessageProps: {
      id: u
    }
  };
}
function Xt(t, e, n) {
  let r = ye((l) => {
    n && !l.defaultPrevented && n(e);
  });
  Q(() => {
    let l = t?.current?.form;
    return l?.addEventListener("reset", r), () => {
      l?.removeEventListener("reset", r);
    };
  }, [
    t
  ]);
}
function yl(t, e, n) {
  let { validationBehavior: r, focus: l } = t;
  le(() => {
    if (r === "native" && n?.current && "setCustomValidity" in n.current && !n.current.disabled) {
      let c = e.realtimeValidation.isInvalid ? e.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(c), n.current.hasAttribute("title") || (n.current.title = ""), e.realtimeValidation.isInvalid || e.updateValidation(q$(n.current));
    }
  });
  let i = B(!1), a = ye(() => {
    i.current || e.resetValidation();
  }), o = ye((c) => {
    e.displayValidation.isInvalid || e.commitValidation();
    let s = n?.current?.form;
    !c.defaultPrevented && n && s && Y$(s) === n.current && (l ? l() : n.current?.focus(), sr("keyboard")), c.preventDefault();
  }), u = ye(() => {
    e.commitValidation();
  });
  Q(() => {
    let c = n?.current;
    if (!c) return;
    let s = c.form, d = s?.reset;
    return s && (s.reset = () => {
      i.current = !window.event || window.event.type === "message" && H(window.event) instanceof MessagePort, d?.call(s), i.current = !1;
    }), c.addEventListener("invalid", o), c.addEventListener("change", u), s?.addEventListener("reset", a), () => {
      c.removeEventListener("invalid", o), c.removeEventListener("change", u), s?.removeEventListener("reset", a), s && (s.reset = d);
    };
  }, [
    n,
    r
  ]);
}
function G$(t) {
  let e = t.validity;
  return {
    badInput: e.badInput,
    customError: e.customError,
    patternMismatch: e.patternMismatch,
    rangeOverflow: e.rangeOverflow,
    rangeUnderflow: e.rangeUnderflow,
    stepMismatch: e.stepMismatch,
    tooLong: e.tooLong,
    tooShort: e.tooShort,
    typeMismatch: e.typeMismatch,
    valueMissing: e.valueMissing,
    valid: e.valid
  };
}
function q$(t) {
  return {
    isInvalid: !t.validity.valid,
    validationDetails: G$(t),
    validationErrors: t.validationMessage ? [
      t.validationMessage
    ] : []
  };
}
function Y$(t) {
  for (let e = 0; e < t.elements.length; e++) {
    let n = t.elements[e];
    if (n.validity?.valid === !1) return n;
  }
  return null;
}
function X$(t = !0) {
  let [e, n] = q(t), r = B(!1), l = G((i) => {
    r.current = !0, n(!!i);
  }, []);
  return le(() => {
    r.current || n(!1);
  }, []), [
    l,
    e
  ];
}
function bi(t = !0) {
  let e = ce(), [n, r] = X$(t);
  return {
    id: r ? e : void 0,
    ref: n
  };
}
function Bc(t, e, n) {
  let { isDisabled: r = !1, isReadOnly: l = !1, value: i, name: a, form: o, children: u, isRequired: c, validationBehavior: s = "aria", "aria-label": d, "aria-labelledby": f, "aria-describedby": h, onPressStart: p, onPressEnd: b, onPressChange: g, onPress: y, onPressUp: $, onClick: v } = t, E = pn({
    ...t,
    value: e.isSelected
  }), { isInvalid: S, validationErrors: w, validationDetails: C } = E.displayValidation;
  yl(t, E, n);
  let R = (W) => {
    W.stopPropagation(), e.setSelected(H(W).checked);
  }, I = u != null, N = d != null || f != null;
  !I && !N && process.env.NODE_ENV !== "production" && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps: O, isPressed: A } = lt({
    onPressStart: p,
    onPressEnd: b,
    onPressChange: g,
    onPress: y,
    onPressUp: $,
    onClick: v,
    isDisabled: r
  }), [V, x] = q(!1), { pressProps: K } = lt({
    onPressStart(W) {
      if (W.pointerType === "keyboard" || W.pointerType === "virtual") {
        W.continuePropagation();
        return;
      }
      p?.(W), g?.(!0), x(!0);
    },
    onPressEnd(W) {
      if (W.pointerType === "keyboard" || W.pointerType === "virtual") {
        W.continuePropagation();
        return;
      }
      b?.(W), g?.(!1), x(!1);
    },
    onPressUp(W) {
      if (W.pointerType === "keyboard" || W.pointerType === "virtual") {
        W.continuePropagation();
        return;
      }
      $?.(W);
    },
    onClick: v,
    onPress(W) {
      if (W.pointerType === "keyboard" || W.pointerType === "virtual") {
        W.continuePropagation();
        return;
      }
      y?.(W), e.toggle(), n.current?.focus();
      let { [Rn]: U } = t, { commitValidation: k } = U || E;
      k();
    },
    isDisabled: r || l
  }), { focusableProps: D } = Je(t, n), F = L(O, D), M = Y(t, {
    labelable: !0
  });
  Xt(n, e.defaultSelected, e.setSelected);
  let P = bi(), T = bi();
  return {
    labelProps: L(K, {
      onClick: (W) => W.preventDefault()
    }),
    inputProps: L(M, {
      checked: e.isSelected,
      "aria-required": c && s === "aria" || void 0,
      required: c && s === "native",
      "aria-invalid": S || t.validationState === "invalid" || void 0,
      "aria-errormessage": t["aria-errormessage"],
      "aria-controls": t["aria-controls"],
      "aria-readonly": l || void 0,
      "aria-describedby": [
        P.id,
        T.id,
        h
      ].filter(Boolean).join(" ") || void 0,
      onChange: R,
      disabled: r,
      ...i == null ? {} : {
        value: i
      },
      name: a,
      form: o,
      type: "checkbox",
      ...F
    }),
    descriptionProps: P,
    errorMessageProps: T,
    isSelected: e.isSelected,
    isPressed: A || V,
    isDisabled: r,
    isReadOnly: l,
    isInvalid: S || t.validationState === "invalid",
    validationErrors: w,
    validationDetails: C
  };
}
function Fc(t, e, n) {
  let { labelProps: r, inputProps: l, descriptionProps: i, errorMessageProps: a, isSelected: o, isPressed: u, isDisabled: c, isReadOnly: s, isInvalid: d, validationErrors: f, validationDetails: h } = Bc(t, e, n), { isIndeterminate: p } = t;
  return Q(() => {
    n.current && (n.current.indeterminate = !!p);
  }), {
    labelProps: L(r, _(() => ({
      // Prevent label from being focused when mouse down on it.
      // Note, this does not prevent the input from being focused in the `click` event.
      onMouseDown: (b) => b.preventDefault()
    }), [])),
    inputProps: l,
    descriptionProps: i,
    errorMessageProps: a,
    isSelected: o,
    isPressed: u,
    isDisabled: c,
    isReadOnly: s,
    isInvalid: d,
    validationErrors: f,
    validationDetails: h
  };
}
function $l(t = {}) {
  let { isReadOnly: e } = t, [n, r] = Be(t.isSelected, t.defaultSelected || !1, t.onChange), [l] = q(n);
  function i(o) {
    e || r(o);
  }
  function a() {
    e || r(!n);
  }
  return {
    isSelected: n,
    defaultSelected: t.defaultSelected ?? l,
    setSelected: i,
    toggle: a
  };
}
function Z$(t, e, n) {
  const r = $l({
    isReadOnly: t.isReadOnly || e.isReadOnly,
    isSelected: e.isSelected(t.value),
    defaultSelected: e.defaultValue.includes(t.value),
    onChange(b) {
      b ? e.addValue(t.value) : e.removeValue(t.value), t.onChange && t.onChange(b);
    }
  });
  let { name: l, form: i, descriptionId: a, errorMessageId: o, validationBehavior: u } = U$.get(e);
  u = t.validationBehavior ?? u;
  let { realtimeValidation: c } = pn({
    ...t,
    value: r.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  }), s = B(Dn), d = () => {
    e.setInvalid(t.value, c.isInvalid ? c : s.current);
  };
  Q(d);
  let f = e.realtimeValidation.isInvalid ? e.realtimeValidation : c, h = u === "native" ? e.displayValidation : f, p = Fc({
    ...t,
    isReadOnly: t.isReadOnly || e.isReadOnly,
    isDisabled: t.isDisabled || e.isDisabled,
    name: t.name || l,
    form: t.form || i,
    isRequired: t.isRequired ?? e.isRequired,
    validationBehavior: u,
    [Rn]: {
      realtimeValidation: f,
      displayValidation: h,
      resetValidation: e.resetValidation,
      commitValidation: e.commitValidation,
      updateValidation(b) {
        s.current = b, d();
      }
    }
  }, r, n);
  return {
    ...p,
    inputProps: {
      ...p.inputProps,
      "aria-describedby": [
        p.inputProps["aria-describedby"],
        e.isInvalid ? o : null,
        a
      ].filter(Boolean).join(" ") || void 0
    }
  };
}
const Yi = /* @__PURE__ */ j(null), Tc = /* @__PURE__ */ j(null), J$ = /* @__PURE__ */ j(null), Ac = /* @__PURE__ */ j(null);
function Q$(t, e) {
  let { validationBehavior: n } = We(Wn) || {}, r = t.validationBehavior ?? n ?? "native", l = z(J$), i = ge(_(() => at(e, t.inputRef !== void 0 ? t.inputRef : null), [
    e,
    t.inputRef
  ])), a = {
    ...xt(t),
    children: typeof t.children == "function" ? !0 : t.children,
    value: t.value,
    validationBehavior: r
  };
  return [
    l ? Z$(a, l, i) : Fc(a, $l(t), i),
    i
  ];
}
const m6 = /* @__PURE__ */ te(function(e, n) {
  let { inputRef: r = null, ...l } = e;
  [e, n] = ie(l, n, Yi);
  let [i, a] = Q$(e, r);
  return /* @__PURE__ */ m.createElement(Ac.Provider, {
    value: {
      ...i,
      inputRef: a,
      defaultClassName: "react-aria-Checkbox",
      isIndeterminate: e.isIndeterminate,
      isRequired: e.isRequired
    }
  }, /* @__PURE__ */ m.createElement(ev, {
    ...e,
    ref: n
  }));
}), ev = /* @__PURE__ */ te(function(e, n) {
  let { labelProps: r, inputProps: l, isSelected: i, isDisabled: a, isReadOnly: o, isPressed: u, isInvalid: c, inputRef: s, defaultClassName: d, isIndeterminate: f, isRequired: h } = z(Ac), { isFocused: p, isFocusVisible: b, focusProps: g } = $e(), y = a || o, { hoverProps: $, isHovered: v } = ve({
    ...e,
    isDisabled: y
  }), E = re({
    ...e,
    defaultClassName: d,
    values: {
      isSelected: i,
      isIndeterminate: f || !1,
      isPressed: u,
      isHovered: v,
      isFocused: p,
      isFocusVisible: b,
      isDisabled: a,
      isReadOnly: o,
      isInvalid: c,
      isRequired: h || !1
    }
  }), S = Y(e, {
    global: !0
  });
  return delete S.id, delete S.onClick, /* @__PURE__ */ m.createElement(X.label, {
    ...L(S, r, $, E),
    ref: n,
    slot: e.slot || void 0,
    "data-selected": i || void 0,
    "data-indeterminate": f || void 0,
    "data-pressed": u || void 0,
    "data-hovered": v || void 0,
    "data-focused": p || void 0,
    "data-focus-visible": b || void 0,
    "data-disabled": a || void 0,
    "data-readonly": o || void 0,
    "data-invalid": c || void 0,
    "data-required": h || void 0
  }, /* @__PURE__ */ m.createElement(ml, {
    elementType: "span"
  }, /* @__PURE__ */ m.createElement("input", {
    ...L(l, g),
    ref: s
  })), E.children);
}), Xi = /* @__PURE__ */ j(null), g6 = /* @__PURE__ */ te(function(e, n) {
  let { state: r, thumbProps: l, inputXRef: i, inputYRef: a, xInputProps: o, yInputProps: u, isDisabled: c = !1 } = z(Xi), { focusProps: s, isFocused: d, isFocusVisible: f } = $e(), { hoverProps: h, isHovered: p } = ve(e), b = re({
    ...e,
    defaultClassName: "react-aria-ColorThumb",
    defaultStyle: {
      ...l.style,
      backgroundColor: r.getDisplayColor().toString()
    },
    values: {
      color: r.getDisplayColor(),
      isHovered: p,
      isDragging: r.isDragging,
      isFocused: d,
      isFocusVisible: f,
      isDisabled: c
    }
  }), g = Y(e, {
    global: !0
  });
  return delete g.id, /* @__PURE__ */ m.createElement(X.div, {
    ...L(l, h, g),
    ...b,
    ref: n,
    "data-hovered": p || void 0,
    "data-dragging": r.isDragging || void 0,
    "data-focused": d || void 0,
    "data-focus-visible": f || void 0,
    "data-disabled": c || void 0
  }, /* @__PURE__ */ m.createElement("input", {
    ref: i,
    ...o,
    ...s
  }), u && /* @__PURE__ */ m.createElement("input", {
    ref: a,
    ...u,
    ...s
  }), b.children);
});
var Ic = {};
Ic = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "أداة انتقاء اللون",
  colorSwatch: "تغيير الألوان",
  transparent: "شفاف",
  twoDimensionalSlider: "مُنزلق 2D"
};
var Kc = {};
Kc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Средство за избиране на цвят",
  colorSwatch: "цветна мостра",
  transparent: "прозрачен",
  twoDimensionalSlider: "2D плъзгач"
};
var Rc = {};
Rc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Výběr barvy",
  colorSwatch: "barevný vzorek",
  transparent: "průhledný",
  twoDimensionalSlider: "2D posuvník"
};
var Nc = {};
Nc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Farvevælger",
  colorSwatch: "farveprøve",
  transparent: "gennemsigtig",
  twoDimensionalSlider: "2D-skyder"
};
var Mc = {};
Mc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Farbwähler",
  colorSwatch: "Farbfeld",
  transparent: "transparent",
  twoDimensionalSlider: "2D-Schieberegler"
};
var Lc = {};
Lc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Επιλογέας χρωμάτων",
  colorSwatch: "χρωματικό δείγμα",
  transparent: "διαφανές",
  twoDimensionalSlider: "Ρυθμιστικό 2D"
};
var zc = {};
zc = {
  colorPicker: "Color picker",
  twoDimensionalSlider: "2D slider",
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorSwatch: "color swatch",
  transparent: "transparent"
};
var Vc = {};
Vc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Selector de color",
  colorSwatch: "muestra de color",
  transparent: "transparente",
  twoDimensionalSlider: "Regulador 2D"
};
var Oc = {};
Oc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Värvivalija",
  colorSwatch: "värvinäidis",
  transparent: "läbipaistev",
  twoDimensionalSlider: "2D-liugur"
};
var Hc = {};
Hc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Värimuokkain",
  colorSwatch: "värimalli",
  transparent: "läpinäkyvä",
  twoDimensionalSlider: "2D-liukusäädin"
};
var _c = {};
_c = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name} : ${t.value}`,
  colorPicker: "Sélecteur de couleurs",
  colorSwatch: "Échantillon de couleurs",
  transparent: "Transparent",
  twoDimensionalSlider: "Curseur 2D"
};
var Wc = {};
Wc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "בוחר הצבעים",
  colorSwatch: "דוגמית צבע",
  transparent: "שקוף",
  twoDimensionalSlider: "מחוון דו מימדי"
};
var jc = {};
jc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Odabir boje",
  colorSwatch: "uzorak boje",
  transparent: "transparentno",
  twoDimensionalSlider: "2D klizač"
};
var Uc = {};
Uc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Színválasztó",
  colorSwatch: "színtár",
  transparent: "átlátszó",
  twoDimensionalSlider: "2D-csúszka"
};
var Gc = {};
Gc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Selettore colore",
  colorSwatch: "campione di colore",
  transparent: "trasparente",
  twoDimensionalSlider: "Cursore 2D"
};
var qc = {};
qc = {
  colorInputLabel: (t) => `${t.label}、${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name} : ${t.value}`,
  colorPicker: "カラーピッカー",
  colorSwatch: "カラースウォッチ",
  transparent: "透明",
  twoDimensionalSlider: "2D スライダー"
};
var Yc = {};
Yc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "색상 피커",
  colorSwatch: "색상 견본",
  transparent: "투명도",
  twoDimensionalSlider: "2D 슬라이더"
};
var Xc = {};
Xc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Spalvų parinkiklis",
  colorSwatch: "spalvų pavyzdys",
  transparent: "skaidrus",
  twoDimensionalSlider: "2D slankiklis"
};
var Zc = {};
Zc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Krāsu atlasītājs",
  colorSwatch: "krāsu paraugs",
  transparent: "caurspīdīgs",
  twoDimensionalSlider: "2D slīdnis"
};
var Jc = {};
Jc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Fargevelger",
  colorSwatch: "fargekart",
  transparent: "gjennomsiktig",
  twoDimensionalSlider: "2D-glidebryter"
};
var Qc = {};
Qc = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Kleurkiezer",
  colorSwatch: "kleurstaal",
  transparent: "transparant",
  twoDimensionalSlider: "2D-schuifregelaar"
};
var ed = {};
ed = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Próbnik kolorów",
  colorSwatch: "próbka koloru",
  transparent: "przezroczysty",
  twoDimensionalSlider: "Suwak 2D"
};
var td = {};
td = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Seletor de cores",
  colorSwatch: "amostra de cores",
  transparent: "transparente",
  twoDimensionalSlider: "Controle deslizante 2D"
};
var nd = {};
nd = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Seletor de cores",
  colorSwatch: "amostra de cor",
  transparent: "transparente",
  twoDimensionalSlider: "Controle deslizante 2D"
};
var rd = {};
rd = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Selector de culori",
  colorSwatch: "specimen de culoare",
  transparent: "transparent",
  twoDimensionalSlider: "Glisor 2D"
};
var ld = {};
ld = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Палитра цветов",
  colorSwatch: "цветовой образец",
  transparent: "прозрачный",
  twoDimensionalSlider: "Ползунок 2D"
};
var id = {};
id = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Výber farieb",
  colorSwatch: "vzorkovník farieb",
  transparent: "transparentný",
  twoDimensionalSlider: "2D jazdec"
};
var ad = {};
ad = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Izbirnik barv",
  colorSwatch: "barvna paleta",
  transparent: "prozorno",
  twoDimensionalSlider: "2D drsnik"
};
var od = {};
od = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Birač boja",
  colorSwatch: "Uzorak boje",
  transparent: "providno",
  twoDimensionalSlider: "2D klizač"
};
var ud = {};
ud = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Färgväljaren",
  colorSwatch: "färgruta",
  transparent: "genomskinlig",
  twoDimensionalSlider: "2D-reglage"
};
var sd = {};
sd = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Renk Seçici",
  colorSwatch: "renk örneği",
  transparent: "saydam",
  twoDimensionalSlider: "2D sürgü"
};
var cd = {};
cd = {
  colorInputLabel: (t) => `${t.label}, ${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}: ${t.value}`,
  colorPicker: "Палітра кольорів",
  colorSwatch: "зразок кольору",
  transparent: "прозорий",
  twoDimensionalSlider: "Повзунок 2D"
};
var dd = {};
dd = {
  colorInputLabel: (t) => `${t.label}、${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}：${t.value}`,
  colorPicker: "拾色器",
  colorSwatch: "颜色色板",
  transparent: "透明",
  twoDimensionalSlider: "2D 滑块"
};
var fd = {};
fd = {
  colorInputLabel: (t) => `${t.label}，${t.channelLabel}`,
  colorNameAndValue: (t) => `${t.name}：${t.value}`,
  colorPicker: "檢色器",
  colorSwatch: "色票",
  transparent: "透明",
  twoDimensionalSlider: "2D 滑桿"
};
var Zi = {};
Zi = {
  "ar-AE": Ic,
  "bg-BG": Kc,
  "cs-CZ": Rc,
  "da-DK": Nc,
  "de-DE": Mc,
  "el-GR": Lc,
  "en-US": zc,
  "es-ES": Vc,
  "et-EE": Oc,
  "fi-FI": Hc,
  "fr-FR": _c,
  "he-IL": Wc,
  "hr-HR": jc,
  "hu-HU": Uc,
  "it-IT": Gc,
  "ja-JP": qc,
  "ko-KR": Yc,
  "lt-LT": Xc,
  "lv-LV": Zc,
  "nb-NO": Jc,
  "nl-NL": Qc,
  "pl-PL": ed,
  "pt-BR": td,
  "pt-PT": nd,
  "ro-RO": rd,
  "ru-RU": ld,
  "sk-SK": id,
  "sl-SI": ad,
  "sr-SP": od,
  "sv-SE": ud,
  "tr-TR": sd,
  "uk-UA": cd,
  "zh-CN": dd,
  "zh-TW": fd
};
var hd = {};
hd = {
  alpha: "ألفا",
  black: "أسود",
  blue: "أزرق",
  "blue purple": "أرجواني مزرق",
  brightness: "السطوع",
  brown: "بني",
  "brown yellow": "أصفر بني",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "سماوي",
  "cyan blue": "أزرق سماوي",
  dark: "داكن",
  gray: "رمادي",
  grayish: "مائل للرمادي",
  green: "أخضر",
  "green cyan": "سماوي مخضر",
  hue: "درجة اللون",
  light: "فاتح",
  lightness: "الإضاءة",
  magenta: "أرجواني",
  "magenta pink": "أرجواني وردي",
  orange: "برتقالي",
  "orange yellow": "أصفر برتقالي",
  pale: "باهت",
  pink: "وردي",
  "pink red": "أحمر وردي",
  purple: "أرجواني",
  "purple magenta": "بنفسجي",
  red: "أحمر",
  "red orange": "برتقالي محمر",
  saturation: "التشبع",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} شفاف`,
  "very dark": "داكن جدًا",
  "very light": "فاتح جدًا",
  vibrant: "ساطع",
  white: "أبيض",
  yellow: "أصفر",
  "yellow green": "أخضر مصفر"
};
var pd = {};
pd = {
  alpha: "Алфа",
  black: "черно",
  blue: "Синьо",
  "blue purple": "синьо лилаво",
  brightness: "Яркост",
  brown: "кафяво",
  "brown yellow": "кафяво жълто",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "циан",
  "cyan blue": "циан синьо",
  dark: "тъмно",
  gray: "сиво",
  grayish: "сивкав",
  green: "Зелено",
  "green cyan": "зелен циан",
  hue: "Оттенък",
  light: "светло",
  lightness: "Лекота",
  magenta: "магента",
  "magenta pink": "магента розово",
  orange: "оранжево",
  "orange yellow": "оранжево жълто",
  pale: "бледо",
  pink: "розово",
  "pink red": "розово червено",
  purple: "лилаво",
  "purple magenta": "лилаво магента",
  red: "Червено",
  "red orange": "червен портокал",
  saturation: "Наситеност",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} прозрачен`,
  "very dark": "много тъмно",
  "very light": "много светло",
  vibrant: " ярко",
  white: "бяло",
  yellow: "жълто",
  "yellow green": "жълто зелен"
};
var bd = {};
bd = {
  alpha: "Alfa",
  black: "černá",
  blue: "Modrá",
  "blue purple": "modrofialová",
  brightness: "Jas",
  brown: "hnědá",
  "brown yellow": "hnědožlutá",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "tyrkysová",
  "cyan blue": "tyrkysovomodrá",
  dark: "tmavá",
  gray: "šedá",
  grayish: "našedlá",
  green: "Zelená",
  "green cyan": "zelenotyrkysová",
  hue: "Odstín",
  light: "světlá",
  lightness: "Světlost",
  magenta: "purpurová",
  "magenta pink": "purpurově růžová",
  orange: "oranžová",
  "orange yellow": "oranžovožlutá",
  pale: "bledá",
  pink: "růžová",
  "pink red": "růžovočervená",
  purple: "fialová",
  "purple magenta": "fialově purpurová",
  red: "Červená",
  "red orange": "červenooranžová",
  saturation: "Sytost",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} průhledné`,
  "very dark": "velmi tmavá",
  "very light": "velmi světlá",
  vibrant: "zářivá",
  white: "bílá",
  yellow: "žlutá",
  "yellow green": "žlutozelená"
};
var md = {};
md = {
  alpha: "Alfa",
  black: "sort",
  blue: "Blå",
  "blue purple": "blålilla",
  brightness: "Lysstyrke",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "cyan",
  "cyan blue": "cyan blå",
  dark: "mørk",
  gray: "grå",
  grayish: "grålig",
  green: "Grøn",
  "green cyan": "grøn cyan",
  hue: "Tone",
  light: "lys",
  lightness: "Lyshed",
  magenta: "magenta",
  "magenta pink": "magenta pink",
  orange: "orange",
  "orange yellow": "orangegul",
  pale: "bleg",
  pink: "lyserød",
  "pink red": "lyserødlig rød",
  purple: "lilla",
  "purple magenta": "lilla magenta",
  red: "Rød",
  "red orange": "rødorange",
  saturation: "Farvemætning",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} gennemsigtig`,
  "very dark": "meget mørk",
  "very light": "meget lys",
  vibrant: "klar",
  white: "hvid",
  yellow: "gul",
  "yellow green": "gulgrøn"
};
var gd = {};
gd = {
  alpha: "Alpha",
  black: "Schwarz",
  blue: "Blau",
  "blue purple": "Blaulila",
  brightness: "Helligkeit",
  brown: "Braun",
  "brown yellow": "Braungelb",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "Cyan",
  "cyan blue": "Cyanblau",
  dark: "dunkles",
  gray: "Grau",
  grayish: "gräuliches",
  green: "Grün",
  "green cyan": "Grüncyan",
  hue: "Farbton",
  light: "helles",
  lightness: "Leuchtkraft",
  magenta: "Magenta",
  "magenta pink": "Magentarosa",
  orange: "Orange",
  "orange yellow": "Orangegelb",
  pale: "blasses",
  pink: "Rosa",
  "pink red": "Rosarot",
  purple: "Lila",
  "purple magenta": "Lilamagenta",
  red: "Rot",
  "red orange": "Rotorange",
  saturation: "Sättigung",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, zu ${t.percentTransparent} transparent`,
  "very dark": "sehr dunkles",
  "very light": "sehr helles",
  vibrant: "lebhaftes",
  white: "Weiß",
  yellow: "Gelb",
  "yellow green": "Gelbgrün"
};
var yd = {};
yd = {
  alpha: "Άλφα",
  black: "μαύρο",
  blue: "Μπλε",
  "blue purple": "μπλε μωβ",
  brightness: "Φωτεινότητα",
  brown: "καφέ",
  "brown yellow": "καφέ κίτρινο",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "κυανό",
  "cyan blue": "κυανό μπλε",
  dark: "σκούρο",
  gray: "γκρι",
  grayish: "γκριζωπό",
  green: "Πράσινο",
  "green cyan": "πράσινο κυανό",
  hue: "Τόνος",
  light: "ανοιχτό",
  lightness: "Φωτεινότητα",
  magenta: "ματζέντα",
  "magenta pink": "ματζέντα ροζ",
  orange: "πορτοκαλί",
  "orange yellow": "πορτοκαλί κίτρινο",
  pale: "ανοιχτό",
  pink: "ροζ",
  "pink red": "ροζ κόκκινο",
  purple: "μωβ",
  "purple magenta": "μωβ ματζέντα",
  red: "Κόκκινο",
  "red orange": "κόκκινο πορτοκαλί",
  saturation: "Κορεσμός",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} διαφανές`,
  "very dark": "πολύ σκούρο",
  "very light": "πολύ ανοιχτό",
  vibrant: "έντονο",
  white: "λευκό",
  yellow: "κίτρινο",
  "yellow green": "κίτρινο πράσινο"
};
var $d = {};
$d = {
  hue: "Hue",
  saturation: "Saturation",
  lightness: "Lightness",
  brightness: "Brightness",
  red: "Red",
  green: "Green",
  blue: "Blue",
  alpha: "Alpha",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} transparent`,
  "very dark": "very dark",
  dark: "dark",
  light: "light",
  "very light": "very light",
  pale: "pale",
  grayish: "grayish",
  vibrant: "vibrant",
  black: "black",
  white: "white",
  gray: "gray",
  pink: "pink",
  "pink red": "pink red",
  "red orange": "red orange",
  brown: "brown",
  orange: "orange",
  "orange yellow": "orange yellow",
  "brown yellow": "brown yellow",
  yellow: "yellow",
  "yellow green": "yellow green",
  "green cyan": "green cyan",
  cyan: "cyan",
  "cyan blue": "cyan blue",
  "blue purple": "blue purple",
  purple: "purple",
  "purple magenta": "purple magenta",
  magenta: "magenta",
  "magenta pink": "magenta pink"
};
var vd = {};
vd = {
  alpha: "Alpha",
  black: "negro",
  blue: "Azul",
  "blue purple": "púrpura azulado",
  brightness: "Brillo",
  brown: "marrón",
  "brown yellow": "amarillo amarronado",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "cian",
  "cyan blue": "azul cian",
  dark: "oscuro",
  gray: "gris",
  grayish: "grisáceo",
  green: "Verde",
  "green cyan": "cian verdoso",
  hue: "Tono",
  light: "claro",
  lightness: "Luminosidad",
  magenta: "magenta",
  "magenta pink": "rosa magenta",
  orange: "naranja",
  "orange yellow": "amarillo anaranjado",
  pale: "pálido",
  pink: "rosa",
  "pink red": "rojo rosado",
  purple: "morado",
  "purple magenta": "magenta violáceo",
  red: "Rojo",
  "red orange": "naranja rojizo",
  saturation: "Saturación",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} transparente`,
  "very dark": "muy oscuro",
  "very light": "muy claro",
  vibrant: "intenso",
  white: "blanco",
  yellow: "amarillo",
  "yellow green": "verde amarillento"
};
var xd = {};
xd = {
  alpha: "Alfa",
  black: "must",
  blue: "Sinine",
  "blue purple": "sinakaslilla",
  brightness: "Heledus",
  brown: "pruun",
  "brown yellow": "pruunikaskollane",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "tsüaan",
  "cyan blue": "tsüaansinine",
  dark: "tume",
  gray: "hall",
  grayish: "hallikas",
  green: "Roheline",
  "green cyan": "tsüaanroheline",
  hue: "Värv",
  light: "valgus",
  lightness: "Valgus",
  magenta: "magentapunane",
  "magenta pink": "magentaroosa",
  orange: "oranž",
  "orange yellow": "oranžikaskollane",
  pale: "kahvatu",
  pink: "roosa",
  "pink red": "vaarikapunane",
  purple: "lilla",
  "purple magenta": "purpurne magenta",
  red: "Punane",
  "red orange": "punakasoranž",
  saturation: "Küllastus",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} läbipaistev`,
  "very dark": "väga tume",
  "very light": "väga hele",
  vibrant: "ere",
  white: "valge",
  yellow: "kollane",
  "yellow green": "kollakasroheline"
};
var Ed = {};
Ed = {
  alpha: "Alpha",
  black: "musta",
  blue: "Sininen",
  "blue purple": "sinivioletti",
  brightness: "Kirkkaus",
  brown: "ruskea",
  "brown yellow": "ruskeankeltainen",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "syaani",
  "cyan blue": "syaaninsininen",
  dark: "tumma",
  gray: "harmaa",
  grayish: "harmahtava",
  green: "Vihreä",
  "green cyan": "vihreänsyaani",
  hue: "Sävy",
  light: "vaalea",
  lightness: "Valomäärä",
  magenta: "magenta",
  "magenta pink": "magentapinkki",
  orange: "oranssi",
  "orange yellow": "oranssinkeltainen",
  pale: "vaalea",
  pink: "pinkki",
  "pink red": "vaaleanpunainen",
  purple: "violetti",
  "purple magenta": "violettimagenta",
  red: "Punainen",
  "red orange": "punaoranssi",
  saturation: "Värikylläisyys",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} läpinäkyvä`,
  "very dark": "hyvin tumma",
  "very light": "erittäin vaalea",
  vibrant: "eloisa",
  white: "valkea",
  yellow: "keltainen",
  "yellow green": "keltavihreä"
};
var Cd = {};
Cd = {
  alpha: "Alpha",
  black: "Noir",
  blue: "Bleu",
  "blue purple": "Violet bleu",
  brightness: "Luminosité",
  brown: "Brun",
  "brown yellow": "Jaune brun",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "Cyan",
  "cyan blue": "Bleu cyan",
  dark: "Sombre",
  gray: "Gris",
  grayish: "Grisâtre",
  green: "Vert",
  "green cyan": "Cyan vert",
  hue: "Teinte",
  light: "Clair",
  lightness: "Luminosité",
  magenta: "Magenta",
  "magenta pink": "Rose magenta",
  orange: "Orange",
  "orange yellow": "Jaune orangé",
  pale: "Pâle",
  pink: "Rose",
  "pink red": "Rouge rosé",
  purple: "Violet",
  "purple magenta": "Magenta violet",
  red: "Rouge",
  "red orange": "Orange rouge",
  saturation: "Saturation",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} transparent`,
  "very dark": "Très sombre",
  "very light": "Très clair",
  vibrant: "Vif",
  white: "Blanc",
  yellow: "Jaune",
  "yellow green": "Vert jaune"
};
var Dd = {};
Dd = {
  alpha: "אלפא",
  black: "שחור",
  blue: "כחול",
  "blue purple": "כחול סגול",
  brightness: "בהירות",
  brown: "חום",
  "brown yellow": "חום צהוב",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "טורקיז",
  "cyan blue": "כחול ציאן",
  dark: "כהה",
  gray: "אפור",
  grayish: "אפרפר",
  green: "ירוק",
  "green cyan": "ציאן ירוק",
  hue: "גוון",
  light: "אור",
  lightness: "כמות אור",
  magenta: "מג'נטה",
  "magenta pink": "ורוד מג'נטה",
  orange: "כתום",
  "orange yellow": "כתום צהוב",
  pale: "חיוור",
  pink: "ורוד",
  "pink red": "ורוד אדום",
  purple: "סגול",
  "purple magenta": "מג'נטה סגול",
  red: "אדום",
  "red orange": "כתום אדום",
  saturation: "רוויה",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} שקוף`,
  "very dark": "כהה מאוד",
  "very light": "בהיר מאוד",
  vibrant: "תוסס",
  white: "לבן",
  yellow: "צהוב",
  "yellow green": "צהוב ירוק"
};
var wd = {};
wd = {
  alpha: "Alfa",
  black: "crno",
  blue: "Plava",
  "blue purple": "plavo ljubičasta",
  brightness: "Svjetlina",
  brown: "smeđa",
  "brown yellow": "smeđe žuta",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "cijan",
  "cyan blue": "cijan plava",
  dark: "tamno",
  gray: "siva",
  grayish: "sivkasto",
  green: "Zelena",
  "green cyan": "zelena cijan",
  hue: "Nijansa",
  light: "svjetlo",
  lightness: "Osvijetljenost",
  magenta: "magenta",
  "magenta pink": "magentno ružičasta",
  orange: "narančasta",
  "orange yellow": "narančasto žuta",
  pale: "blijeda",
  pink: "ružičasta",
  "pink red": "ružičasto crvena",
  purple: "ljubičasta",
  "purple magenta": "ljubičasta magenta",
  red: "Crvena",
  "red orange": "crveno narančasta",
  saturation: "Zasićenost",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} prozirnosti`,
  "very dark": "jako tamna",
  "very light": "vrlo svijetlo",
  vibrant: "vibrantna",
  white: "bijela",
  yellow: "žuto",
  "yellow green": "žuto zelena"
};
var Pd = {};
Pd = {
  alpha: "Alfa",
  black: "fekete",
  blue: "Kék",
  "blue purple": "kék lila",
  brightness: "Fényesség",
  brown: "barna",
  "brown yellow": "barna sárga",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "ciánkék",
  "cyan blue": "ciánkék",
  dark: "sötét",
  gray: "szürke",
  grayish: "szürkés",
  green: "Zöld",
  "green cyan": "zöld ciánkék",
  hue: "Színárnyalat",
  light: "világos",
  lightness: "Világosság",
  magenta: "bíbor",
  "magenta pink": "bíbor rózsaszín",
  orange: "narancs",
  "orange yellow": "narancssárga",
  pale: "halvány",
  pink: "rózsaszín",
  "pink red": "rózsaszín piros",
  purple: "lila",
  "purple magenta": "lila bíbor",
  red: "Piros",
  "red orange": "piros narancs",
  saturation: "Telítettség",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} átlátszó`,
  "very dark": "nagyon sötét",
  "very light": "nagyon világos",
  vibrant: "élénk",
  white: "fehér",
  yellow: "sárga",
  "yellow green": "sárga zöld"
};
var Sd = {};
Sd = {
  alpha: "Alfa",
  black: "nero",
  blue: "Blu",
  "blue purple": "blu viola",
  brightness: "Luminosità",
  brown: "marrone",
  "brown yellow": "giallo bruno",
  colorName: (t) => `${t.hue} ${t.chroma} ${t.lightness}`,
  cyan: "ciano",
  "cyan blue": "blu ciano",
  dark: "scuro",
  gray: "grigio",
  grayish: "grigiastro",
  green: "Verde",
  "green cyan": "verde ciano",
  hue: "Tonalità",
  light: "chiaro",
  lightness: "Luminosità",
  magenta: "magenta",
  "magenta pink": "rosa magenta",
  orange: "arancio",
  "orange yellow": "giallo arancio",
  pale: "tenue",
  pink: "rosa",
  "pink red": "rosa rosso",
  purple: "viola",
  "purple magenta": "viola magenta",
  red: "Rosso",
  "red orange": "rosso arancio",
  saturation: "Saturazione",
  transparentColorName: (t) => `${t.hue} ${t.chroma} ${t.lightness}, trasparenza ${t.percentTransparent}`,
  "very dark": "molto scuro",
  "very light": "molto chiaro",
  vibrant: "vivace",
  white: "bianco",
  yellow: "giallo",
  "yellow green": "giallo verde"
};
var kd = {};
kd = {
  alpha: "アルファ",
  black: "ブラック",
  blue: "青",
  "blue purple": "ブルーパープル",
  brightness: "明るさ",
  brown: "ブラウン",
  "brown yellow": "ブラウンイエロー",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "シアン",
  "cyan blue": "シアンブルー",
  dark: "ダーク",
  gray: "グレー",
  grayish: "グレイッシュ",
  green: "緑",
  "green cyan": "グリーンシアン",
  hue: "色相",
  light: "ライト",
  lightness: "明度",
  magenta: "マゼンタ",
  "magenta pink": "マゼンタピンク",
  orange: "オレンジ",
  "orange yellow": "オレンジイエロー",
  pale: "ペール",
  pink: "ピンク",
  "pink red": "ピンクレッド",
  purple: "パープル",
  "purple magenta": "パープルマゼンタ",
  red: "赤",
  "red orange": "レッドオレンジ",
  saturation: "彩度",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} 透明`,
  "very dark": "最も暗い",
  "very light": "ベリーライト",
  vibrant: "鮮やか",
  white: "ホワイト",
  yellow: "イエロー",
  "yellow green": "イエローグリーン"
};
var Bd = {};
Bd = {
  alpha: "알파",
  black: "검은색",
  blue: "파랑",
  "blue purple": "청자색",
  brightness: "명도",
  brown: "갈색",
  "brown yellow": "황갈색",
  colorName: (t) => `${t.lightness}, ${t.chroma}, ${t.hue}`,
  cyan: "청록색",
  "cyan blue": "청록색",
  dark: "다크",
  gray: "회색",
  grayish: "회갈색",
  green: "초록",
  "green cyan": "청록색",
  hue: "색조",
  light: "라이트",
  lightness: "밝기",
  magenta: "자홍색",
  "magenta pink": "마젠타 핑크",
  orange: "주황색",
  "orange yellow": "불그스름한 노랑",
  pale: "흙색",
  pink: "분홍색",
  "pink red": "핑크 레드",
  purple: "자주색",
  "purple magenta": "보라빛 자홍색",
  red: "빨강",
  "red orange": "붉은 주황색",
  saturation: "채도",
  transparentColorName: (t) => `${t.lightness}, ${t.chroma}, ${t.hue}, ${t.percentTransparent} 투명도`,
  "very dark": "매우 어두운",
  "very light": "매우 연함",
  vibrant: "강렬한",
  white: "흰색",
  yellow: "노란색",
  "yellow green": "연두색"
};
var Fd = {};
Fd = {
  alpha: "Alfa",
  black: "juoda",
  blue: "Mėlyna",
  "blue purple": "melsvai violetinė",
  brightness: "Ryškumas",
  brown: "ruda",
  "brown yellow": "rusvai geltona",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "žalsvai mėlyna",
  "cyan blue": "žalsvai mėlyna",
  dark: "tamsi",
  gray: "pilka",
  grayish: "pilkšva",
  green: "Žalia",
  "green cyan": "žalsvai mėlyna",
  hue: "Atspalvis",
  light: "šviesi",
  lightness: "Šviesumas",
  magenta: "rausvai raudona",
  "magenta pink": "purpurinė",
  orange: "oranžinė",
  "orange yellow": "oranžinio atspalvio geltona",
  pale: "blyški",
  pink: "rožinė",
  "pink red": "rožinė raudona",
  purple: "violetinė",
  "purple magenta": "purpurinė rausvai raudona",
  red: "Raudona",
  "red orange": "rausvai oranžinė",
  saturation: "Įsotinimas",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} skaidri`,
  "very dark": "labai tamsi",
  "very light": "labai šviesi",
  vibrant: "ryški",
  white: "balta",
  yellow: "geltona",
  "yellow green": "gelsvai žalia"
};
var Td = {};
Td = {
  alpha: "Alfa",
  black: "melns",
  blue: "Zila",
  "blue purple": "zili violets",
  brightness: "Spilgtums",
  brown: "brūns",
  "brown yellow": "brūni dzeltens",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "ciāns",
  "cyan blue": "ciāna zils",
  dark: "tumšs",
  gray: "pelēks",
  grayish: "pelēcīgs",
  green: "Zaļa",
  "green cyan": "zaļš ciāns",
  hue: "Nokrāsa",
  light: "gaišs",
  lightness: "Gaišums",
  magenta: "fuksiju",
  "magenta pink": "fuksiju rozā",
  orange: "oranžs",
  "orange yellow": "oranži dzeltens",
  pale: "bāls",
  pink: "rozā",
  "pink red": "rozīgi sarkans",
  purple: "violets",
  "purple magenta": "violets fuksiju",
  red: "Sarkana",
  "red orange": "sarkanīgi oranžs",
  saturation: "Piesātinājums",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} caurspīdīgs`,
  "very dark": "ļoti tumšs",
  "very light": "ļoti gaišs",
  vibrant: "košs",
  white: "balts",
  yellow: "dzeltens",
  "yellow green": "dzelteni zaļš"
};
var Ad = {};
Ad = {
  alpha: "Alfa",
  black: "svart",
  blue: "Blå",
  "blue purple": "blålilla",
  brightness: "Lysstyrke",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "cyan",
  "cyan blue": "cyanblå",
  dark: "mørk",
  gray: "grå",
  grayish: "gråaktig",
  green: "Grønn",
  "green cyan": "grønncyan",
  hue: "Fargetone",
  light: "lys",
  lightness: "Lyshet",
  magenta: "magenta",
  "magenta pink": "magentarosa",
  orange: "oransje",
  "orange yellow": "oransjegul",
  pale: "blek",
  pink: "rosa",
  "pink red": "rosarød",
  purple: "lilla",
  "purple magenta": "lillamagenta",
  red: "Rød",
  "red orange": "rødoransje",
  saturation: "Metning",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} gjennomsiktig`,
  "very dark": "svært mørk",
  "very light": "svært lys",
  vibrant: "levende",
  white: "hvit",
  yellow: "gul",
  "yellow green": "gulgrønn"
};
var Id = {};
Id = {
  alpha: "Alfa",
  black: "zwart",
  blue: "Blauw",
  "blue purple": "paarsblauw",
  brightness: "Helderheid",
  brown: "bruin",
  "brown yellow": "bruingeel",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "cyaan",
  "cyan blue": "cyaanblauw",
  dark: "donker",
  gray: "grijs",
  grayish: "grijsachtig",
  green: "Groen",
  "green cyan": "cyaangroen",
  hue: "Kleurtoon",
  light: "licht",
  lightness: "Lichtsterkte",
  magenta: "magenta",
  "magenta pink": "magentaroze",
  orange: "oranje",
  "orange yellow": "oranjegeel",
  pale: "bleek",
  pink: "roze",
  "pink red": "rozerood",
  purple: "paars",
  "purple magenta": "magentapaars",
  red: "Rood",
  "red orange": "roodoranje",
  saturation: "Verzadiging",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} transparant`,
  "very dark": "heel donker",
  "very light": "heel licht",
  vibrant: "levendig",
  white: "wit",
  yellow: "geel",
  "yellow green": "geelgroen"
};
var Kd = {};
Kd = {
  alpha: "Alfa",
  black: "czarny",
  blue: "Niebieski",
  "blue purple": "niebiesko-fioletowy",
  brightness: "Jasność",
  brown: "brązowy",
  "brown yellow": "brązowo-żółty",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "cyjanowy",
  "cyan blue": "cyjanowo-niebieski",
  dark: "ciemny",
  gray: "szary",
  grayish: "szarawy",
  green: "Zielony",
  "green cyan": "zielono-cyjanowy",
  hue: "Odcień",
  light: "jasny",
  lightness: "Jaskrawość",
  magenta: "purpurowy",
  "magenta pink": "purpurowo-różowy",
  orange: "pomarańczowy",
  "orange yellow": "pomarańczowo-żółty",
  pale: "blady",
  pink: "różowy",
  "pink red": "różowo-czerwony",
  purple: "fioletowy",
  "purple magenta": "fioletowo-purpurowy",
  red: "Czerwony",
  "red orange": "czerwono-pomarańczowy",
  saturation: "Nasycenie",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} przezroczystości`,
  "very dark": "bardzo ciemny",
  "very light": "bardzo jasny",
  vibrant: "intensywny",
  white: "biały",
  yellow: "żółty",
  "yellow green": "żółto-zielony"
};
var Rd = {};
Rd = {
  alpha: "Alfa",
  black: "preto",
  blue: "Azul",
  "blue purple": "roxo azulado",
  brightness: "Brilho",
  brown: "marrom",
  "brown yellow": "marrom amarelado",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "ciano",
  "cyan blue": "azul-ciano",
  dark: "escuro",
  gray: "cinza",
  grayish: "acinzentado",
  green: "Verde",
  "green cyan": "verde-ciano",
  hue: "Matiz",
  light: "claro",
  lightness: "Luminosidade",
  magenta: "magenta",
  "magenta pink": "rosa-magenta",
  orange: "laranja",
  "orange yellow": "amarelo alaranjado",
  pale: "pálido",
  pink: "rosa",
  "pink red": "rosa avermelhado",
  purple: "roxo",
  "purple magenta": "roxo-magenta",
  red: "Vermelho",
  "red orange": "laranja avermelhado",
  saturation: "Saturação",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} transparente`,
  "very dark": "muito escuro",
  "very light": "muito claro",
  vibrant: "vibrante",
  white: "branco",
  yellow: "amarelo",
  "yellow green": "verde amarelado"
};
var Nd = {};
Nd = {
  alpha: "Alfa",
  black: "preto",
  blue: "Azul",
  "blue purple": "azul-púrpura",
  brightness: "Luminosidade",
  brown: "castanho",
  "brown yellow": "amarelo-castanho",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "ciano",
  "cyan blue": "azul-ciano",
  dark: "escuro",
  gray: "cinzento",
  grayish: "acinzentado",
  green: "Verde",
  "green cyan": "verde-ciano",
  hue: "Tonalidade",
  light: "claro",
  lightness: "Claridade",
  magenta: "magenta",
  "magenta pink": "rosa-magenta",
  orange: "laranja",
  "orange yellow": "amarelo-laranja",
  pale: "pálido",
  pink: "cor-de-rosa",
  "pink red": "vermelho-rosa",
  purple: "púrpura",
  "purple magenta": "púrpura-magenta",
  red: "Vermelho",
  "red orange": "laranja-vermelho",
  saturation: "Saturação",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} transparente`,
  "very dark": "muito escuro",
  "very light": "muito claro",
  vibrant: "vibrante",
  white: "branco",
  yellow: "amarelo",
  "yellow green": "verde-amarelo"
};
var Md = {};
Md = {
  alpha: "Alfa",
  black: "negru",
  blue: "Albastru",
  "blue purple": "albastru-violet",
  brightness: "Luminozitate",
  brown: "maro",
  "brown yellow": "galben maro",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "bleu",
  "cyan blue": "albastru-bleu",
  dark: "închis",
  gray: "gri",
  grayish: "cenușiu",
  green: "Verde",
  "green cyan": "verde bleu",
  hue: "Nuanță",
  light: "deschis",
  lightness: "Luminozitate",
  magenta: "fucsia",
  "magenta pink": "roz-fucsia",
  orange: "portocaliu",
  "orange yellow": "galben-portocaliu",
  pale: "pal",
  pink: "roz",
  "pink red": "roz-roșu",
  purple: "violet",
  "purple magenta": "violet-fucsia",
  red: "Roșu",
  "red orange": "portocaliu-roșu",
  saturation: "Saturație",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} transparent`,
  "very dark": "foarte închis",
  "very light": "foarte deschis",
  vibrant: "plin de viață",
  white: "alb",
  yellow: "galben",
  "yellow green": "galben-verde"
};
var Ld = {};
Ld = {
  alpha: "Альфа",
  black: "черный",
  blue: "Синий",
  "blue purple": "сине-фиолетовый",
  brightness: "Яркость",
  brown: "коричневый",
  "brown yellow": "коричнево-желтый",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "голубой",
  "cyan blue": "цвет морской волны",
  dark: "темный",
  gray: "серый",
  grayish: "сероватый",
  green: "Зеленый",
  "green cyan": "сине-зеленый",
  hue: "Оттенок",
  light: "светлый",
  lightness: "Освещенность",
  magenta: "пурпурный",
  "magenta pink": "пурпурно-розовый",
  orange: "оранжевый",
  "orange yellow": "оранжево-желтый",
  pale: "бледный",
  pink: "розовый",
  "pink red": "розово-красный",
  purple: "фиолетовый",
  "purple magenta": "фиолетово-пурпурный",
  red: "Красный",
  "red orange": "красно-оранжевый",
  saturation: "Насыщенность",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, прозрачный на ${t.percentTransparent}`,
  "very dark": "очень темный",
  "very light": "очень светлый",
  vibrant: "яркий",
  white: "белый",
  yellow: "желтый",
  "yellow green": "желто-зеленый"
};
var zd = {};
zd = {
  alpha: "Alfa",
  black: "čierna",
  blue: "Modrá",
  "blue purple": "modrofialová",
  brightness: "Jas",
  brown: "hnedá",
  "brown yellow": "hnedožltá",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "azúrová",
  "cyan blue": "azúrová modrá",
  dark: "tmavá",
  gray: "sivá",
  grayish: "sivastá",
  green: "Zelená",
  "green cyan": "zelená azúrová",
  hue: "Odtieň",
  light: "svetlá",
  lightness: "Svetlosť",
  magenta: "purpurová",
  "magenta pink": "ružová purpurová",
  orange: "oranžová",
  "orange yellow": "oranžovožltá",
  pale: "bledá",
  pink: "ružová",
  "pink red": "ružovočervená",
  purple: "fialová",
  "purple magenta": "fialová purpurová",
  red: "Červená",
  "red orange": "červenooranžová",
  saturation: "Sýtosť",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} priehľadná`,
  "very dark": "veľmi tmavá",
  "very light": "veľmi svetlá",
  vibrant: "energická",
  white: "biela",
  yellow: "žltá",
  "yellow green": "žltozelená"
};
var Vd = {};
Vd = {
  alpha: "Alfa",
  black: "črna",
  blue: "Modra",
  "blue purple": "modro vijolična",
  brightness: "Svetlost",
  brown: "rjava",
  "brown yellow": "rjavo rumena",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "cian",
  "cyan blue": "cian modra",
  dark: "temna",
  gray: "siva",
  grayish: "sivkasta",
  green: "Zelena",
  "green cyan": "zelena cian",
  hue: "Barva",
  light: "svetla",
  lightness: "Lahkost",
  magenta: "škrlatna",
  "magenta pink": "škrlatno roza",
  orange: "oranžna",
  "orange yellow": "oranžno rumena",
  pale: "bleda",
  pink: "roza",
  "pink red": "roza rdeča",
  purple: "vijolična",
  "purple magenta": "vijolično škrlatna",
  red: "Rdeča",
  "red orange": "rdeče oranžna",
  saturation: "Nasičenost",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} prozorna`,
  "very dark": "zelo temna",
  "very light": "zelo svetla",
  vibrant: "živahna",
  white: "bela",
  yellow: "rumena",
  "yellow green": "rumeno zelena"
};
var Od = {};
Od = {
  alpha: "Alfa",
  black: "crno",
  blue: "Plava",
  "blue purple": "plavoljubičasta",
  brightness: "Osvetljenost",
  brown: "smeđa",
  "brown yellow": "smeđežuta",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "cijan",
  "cyan blue": "cijan plava",
  dark: "tamno",
  gray: "siva",
  grayish: "sivkasta",
  green: "Zelena",
  "green cyan": "zeleno cijan",
  hue: "Nijansa",
  light: "svetla",
  lightness: "Osvetljenje",
  magenta: "purpurnocrvena",
  "magenta pink": "magenta ružičasta",
  orange: "narandžasta",
  "orange yellow": "narandžastožuta",
  pale: "bledo",
  pink: "ružičasta",
  "pink red": "ružičastocrvena",
  purple: "ljubičasta",
  "purple magenta": "ljubičasta magenta",
  red: "Crvena",
  "red orange": "crvenonarandžasta",
  saturation: "Zasićenje",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} prozirna`,
  "very dark": "veoma tamno",
  "very light": "vrlo svetlo",
  vibrant: "živopisna",
  white: "bela",
  yellow: "žuto",
  "yellow green": "žutozelena"
};
var Hd = {};
Hd = {
  alpha: "Alfa",
  black: "svart",
  blue: "Blått",
  "blue purple": "blålila",
  brightness: "Ljusstyrka",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "cyan",
  "cyan blue": "cyanblå",
  dark: "mörk",
  gray: "grå",
  grayish: "gråaktig",
  green: "Grönt",
  "green cyan": "grön cyan",
  hue: "Nyans",
  light: "ljus",
  lightness: "Ljushet",
  magenta: "magenta",
  "magenta pink": "magentarosa",
  orange: "orange",
  "orange yellow": "orangegul",
  pale: "blek",
  pink: "rosa",
  "pink red": "rosaröd",
  purple: "lila",
  "purple magenta": "lila magenta",
  red: "Rött",
  "red orange": "rödorange",
  saturation: "Mättnad",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} genomskinlig`,
  "very dark": "mycket mörk",
  "very light": "mycket ljus",
  vibrant: "livfull",
  white: "vit",
  yellow: "gul",
  "yellow green": "gulgrön"
};
var _d = {};
_d = {
  alpha: "Alfa",
  black: "siyah",
  blue: "Mavi",
  "blue purple": "mavi mor",
  brightness: "Parlaklık",
  brown: "kahverengi",
  "brown yellow": "kahverengi sarı",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "camgöbeği",
  "cyan blue": "camgöbeği mavi",
  dark: "koyu",
  gray: "gri",
  grayish: "grimsi",
  green: "Yeşil",
  "green cyan": "yeşil camgöbeği",
  hue: "Ton",
  light: "açık",
  lightness: "Canlılık",
  magenta: "eflatun",
  "magenta pink": "eflatun pembe",
  orange: "turuncu",
  "orange yellow": "turuncu sarı",
  pale: "solgun",
  pink: "pembe",
  "pink red": "pembe kırmızı",
  purple: "mor",
  "purple magenta": "mor eflatun",
  red: "Kırmızı",
  "red orange": "kırmızı portakal",
  saturation: "Doygunluk",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} saydam`,
  "very dark": "çok koyu",
  "very light": "çok açık",
  vibrant: "canlı",
  white: "beyaz",
  yellow: "sarı",
  "yellow green": "sarı yeşil"
};
var Wd = {};
Wd = {
  alpha: "Альфа",
  black: "чорний",
  blue: "Синій",
  "blue purple": "синьо-фіолетовий",
  brightness: "Яскравість",
  brown: "коричневий",
  "brown yellow": "коричнево-жовтий",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "блакитний",
  "cyan blue": "синьо-блакитний",
  dark: "темний",
  gray: "сірий",
  grayish: "сіруватий",
  green: "Зелений",
  "green cyan": "зелено-блакитний",
  hue: "Тон",
  light: "світлий",
  lightness: "Освітленість",
  magenta: "пурпуровий",
  "magenta pink": "пурпурово-рожевий",
  orange: "помаранчевий",
  "orange yellow": "помаранчево-жовтий",
  pale: "блідий",
  pink: "рожевий",
  "pink red": "рожево-червоний",
  purple: "фіолетовий",
  "purple magenta": "фіолетово-пурпуровий",
  red: "Червоний",
  "red orange": "червоно-помаранчевий",
  saturation: "Насиченість",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, прозорий на ${t.percentTransparent}`,
  "very dark": "дуже темний",
  "very light": "дуже світлий",
  vibrant: "яскравий",
  white: "білий",
  yellow: "жовтий",
  "yellow green": "жовто-зелений"
};
var jd = {};
jd = {
  alpha: "Alpha",
  black: "黑色",
  blue: "蓝色",
  "blue purple": "蓝紫色",
  brightness: "亮度",
  brown: "棕色的",
  "brown yellow": "棕黄色",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "蓝绿色",
  "cyan blue": "青蓝色",
  dark: "深色",
  gray: "灰色",
  grayish: "浅灰色的",
  green: "绿色",
  "green cyan": "绿青色",
  hue: "色相",
  light: "浅色",
  lightness: "明亮度",
  magenta: "紫红色",
  "magenta pink": "紫粉色",
  orange: "橙色",
  "orange yellow": "橙黄色",
  pale: "苍白的",
  pink: "粉色",
  "pink red": "粉红色",
  purple: "紫色",
  "purple magenta": "紫洋红色",
  red: "红色",
  "red orange": "红橙色",
  saturation: "饱和度",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} 透明`,
  "very dark": "很暗",
  "very light": "很浅",
  vibrant: "生机勃勃",
  white: "白色",
  yellow: "黄色",
  "yellow green": "黄色/绿色"
};
var Ud = {};
Ud = {
  alpha: "Alpha",
  black: "黑",
  blue: "藍色",
  "blue purple": "藍紫",
  brightness: "亮度",
  brown: "棕",
  "brown yellow": "棕黃",
  colorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}`,
  cyan: "青",
  "cyan blue": "青藍",
  dark: "暗",
  gray: "灰",
  grayish: "偏灰",
  green: "綠色",
  "green cyan": "青綠",
  hue: "色相",
  light: "淺",
  lightness: "明亮",
  magenta: "洋紅",
  "magenta pink": "淺洋紅",
  orange: "橙",
  "orange yellow": "橙黃",
  pale: "淡",
  pink: "粉紅",
  "pink red": "粉紅",
  purple: "紫",
  "purple magenta": "紫洋紅",
  red: "紅色",
  "red orange": "橙紅",
  saturation: "飽和度",
  transparentColorName: (t) => `${t.lightness} ${t.chroma} ${t.hue}, ${t.percentTransparent} 透明`,
  "very dark": "很暗",
  "very light": "很淺",
  vibrant: "鮮豔",
  white: "白",
  yellow: "黃",
  "yellow green": "黃綠"
};
var Gd = {};
Gd = {
  "ar-AE": hd,
  "bg-BG": pd,
  "cs-CZ": bd,
  "da-DK": md,
  "de-DE": gd,
  "el-GR": yd,
  "en-US": $d,
  "es-ES": vd,
  "et-EE": xd,
  "fi-FI": Ed,
  "fr-FR": Cd,
  "he-IL": Dd,
  "hr-HR": wd,
  "hu-HU": Pd,
  "it-IT": Sd,
  "ja-JP": kd,
  "ko-KR": Bd,
  "lt-LT": Fd,
  "lv-LV": Td,
  "nb-NO": Ad,
  "nl-NL": Id,
  "pl-PL": Kd,
  "pt-BR": Rd,
  "pt-PT": Nd,
  "ro-RO": Md,
  "ru-RU": Ld,
  "sk-SK": zd,
  "sl-SI": Vd,
  "sr-SP": Od,
  "sv-SE": Hd,
  "tr-TR": _d,
  "uk-UA": Wd,
  "zh-CN": jd,
  "zh-TW": Ud
};
function tv(t) {
  return t && t.__esModule ? t.default : t;
}
let Ll = new Ht(tv(Gd));
function _e(t) {
  let e = hr.parse(t) || pr.parse(t) || br.parse(t);
  if (e) return e;
  throw new Error("Invalid color value: " + t);
}
function An(t) {
  return typeof t == "string" ? _e(t) : t;
}
function qd(t) {
  return t === 360 ? t : (t % 360 + 360) % 360;
}
const Co = 0.68, nv = 0.85, Do = 0.55, wo = 1e-3, zl = [
  [
    0,
    "pink"
  ],
  [
    15,
    "red"
  ],
  [
    48,
    "orange"
  ],
  [
    94,
    "yellow"
  ],
  [
    135,
    "green"
  ],
  [
    175,
    "cyan"
  ],
  [
    264,
    "blue"
  ],
  [
    284,
    "purple"
  ],
  [
    320,
    "magenta"
  ],
  [
    349,
    "pink"
  ]
];
class Ji {
  toHexInt() {
    return this.toFormat("rgb").toHexInt();
  }
  getChannelValue(e) {
    if (e in this) return this[e];
    throw new Error("Unsupported color channel: " + e);
  }
  withChannelValue(e, n) {
    if (e in this) {
      let r = this.clone();
      return r[e] = n, r;
    }
    throw new Error("Unsupported color channel: " + e);
  }
  getChannelName(e, n) {
    return (Ht.getGlobalDictionaryForPackage("@react-stately/color") || Ll).getStringForLocale(e, n);
  }
  getColorSpaceAxes(e) {
    let { xChannel: n, yChannel: r } = e, l = n || this.getColorChannels().find((o) => o !== r), i = r || this.getColorChannels().find((o) => o !== l), a = this.getColorChannels().find((o) => o !== l && o !== i);
    return {
      xChannel: l,
      yChannel: i,
      zChannel: a
    };
  }
  getColorName(e) {
    let [n, r, l] = Po(this), i = Ht.getGlobalDictionaryForPackage("@react-stately/color") || Ll;
    if (n > 0.999) return i.getStringForLocale("white", e);
    if (n < 1e-3) return i.getStringForLocale("black", e);
    let a;
    [a, n] = this.getOklchHue(n, r, l, e);
    let o = "", u = "";
    r <= 0.1 && r >= wo ? n >= 0.7 ? u = "pale" : u = "grayish" : r >= 0.15 && (u = "vibrant"), n < 0.3 ? o = "very dark" : n < Do ? o = "dark" : n < 0.7 || (n < 0.85 ? o = "light" : o = "very light"), u && (u = i.getStringForLocale(u, e)), o && (o = i.getStringForLocale(o, e));
    let c = this.getChannelValue("alpha"), s = new ws(e, i);
    if (c < 1) {
      let d = new Wt(e, {
        style: "percent"
      }).format(1 - c);
      return s.format("transparentColorName", {
        lightness: o,
        chroma: u,
        hue: a,
        percentTransparent: d
      }).replace(/\s+/g, " ").trim();
    } else return s.format("colorName", {
      lightness: o,
      chroma: u,
      hue: a
    }).replace(/\s+/g, " ").trim();
  }
  getOklchHue(e, n, r, l) {
    let i = Ht.getGlobalDictionaryForPackage("@react-stately/color") || Ll;
    if (n < wo) return [
      i.getStringForLocale("gray", l),
      e
    ];
    for (let a = 0; a < zl.length; a++) {
      let [o, u] = zl[a], [c, s] = zl[a + 1] || [
        360,
        "pink"
      ];
      if (r >= o && r < c)
        return u === "orange" && (e < Co ? u = "brown" : e = e - Co + Do), r > o + (c - o) / 2 && u !== s ? u = `${u} ${s}` : u === "yellow" && e < nv && (u = "yellow green"), [
          i.getStringForLocale(u, l).toLocaleLowerCase(l),
          e
        ];
    }
    throw new Error("Unexpected hue");
  }
  getHueName(e) {
    let [n, r, l] = Po(this), [i] = this.getOklchHue(n, r, l, e);
    return i;
  }
}
const Sn = class Sn extends Ji {
  constructor(e, n, r, l) {
    super(), this.red = e, this.green = n, this.blue = r, this.alpha = l;
  }
  static parse(e) {
    let n = [];
    if (/^#[\da-f]+$/i.test(e) && [
      4,
      5,
      7,
      9
    ].includes(e.length)) {
      const l = (e.length < 6 ? e.replace(/[^#]/gi, "$&$&") : e).slice(1).split("");
      for (; l.length > 0; ) n.push(parseInt(l.splice(0, 2).join(""), 16));
      n[3] = n[3] !== void 0 ? n[3] / 255 : void 0;
    }
    const r = e.match(/^rgba?\((.*)\)$/);
    if (r?.[1] && (n = r[1].split(",").map((l) => Number(l.trim())), n = n.map((l, i) => Re(l ?? 0, 0, i < 3 ? 255 : 1))), !(n[0] === void 0 || n[1] === void 0 || n[2] === void 0))
      return n.length < 3 ? void 0 : new Sn(n[0], n[1], n[2], n[3] ?? 1);
  }
  toString(e = "css") {
    switch (e) {
      case "hex":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0")).toUpperCase();
      case "hexa":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0") + Math.round(this.alpha * 255).toString(16).padStart(2, "0")).toUpperCase();
      case "rgb":
        return `rgb(${this.red}, ${this.green}, ${this.blue})`;
      case "css":
      case "rgba":
        return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
      default:
        return this.toFormat(e).toString(e);
    }
  }
  toFormat(e) {
    switch (e) {
      case "hex":
      case "hexa":
      case "rgb":
      case "rgba":
        return this;
      case "hsb":
      case "hsba":
        return this.toHSB();
      case "hsl":
      case "hsla":
        return this.toHSL();
      default:
        throw new Error("Unsupported color conversion: rgb -> " + e);
    }
  }
  toHexInt() {
    return this.red << 16 | this.green << 8 | this.blue;
  }
  /**
  * Converts an RGB color value to HSB.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
  *
  * @returns An HSBColor object.
  */
  toHSB() {
    const e = this.red / 255, n = this.green / 255, r = this.blue / 255, l = Math.min(e, n, r), i = Math.max(e, n, r), a = i - l, o = i === 0 ? 0 : a / i;
    let u = 0;
    if (a !== 0) {
      switch (i) {
        case e:
          u = (n - r) / a + (n < r ? 6 : 0);
          break;
        case n:
          u = (r - e) / a + 2;
          break;
        case r:
          u = (e - n) / a + 4;
          break;
      }
      u /= 6;
    }
    return new pr(Ae(u * 360, 2), Ae(o * 100, 2), Ae(i * 100, 2), this.alpha);
  }
  /**
  * Converts an RGB color value to HSL.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
  *
  * @returns An HSLColor object.
  */
  toHSL() {
    const e = this.red / 255, n = this.green / 255, r = this.blue / 255, l = Math.min(e, n, r), i = Math.max(e, n, r), a = (i + l) / 2, o = i - l;
    let u, c;
    if (o === 0) u = c = 0;
    else {
      switch (c = o / (a < 0.5 ? i + l : 2 - i - l), i) {
        case e:
          u = (n - r) / o + (n < r ? 6 : 0);
          break;
        case n:
          u = (r - e) / o + 2;
          break;
        case r:
        default:
          u = (e - n) / o + 4;
          break;
      }
      u /= 6;
    }
    return new br(Ae(u * 360, 2), Ae(c * 100, 2), Ae(a * 100, 2), this.alpha);
  }
  clone() {
    return new Sn(this.red, this.green, this.blue, this.alpha);
  }
  getChannelRange(e) {
    switch (e) {
      case "red":
      case "green":
      case "blue":
        return {
          minValue: 0,
          maxValue: 255,
          step: 1,
          pageSize: 17
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + e);
    }
  }
  getChannelFormatOptions(e) {
    switch (e) {
      case "red":
      case "green":
      case "blue":
        return {
          style: "decimal"
        };
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + e);
    }
  }
  formatChannelValue(e, n) {
    let r = this.getChannelFormatOptions(e), l = this.getChannelValue(e);
    return new Wt(n, r).format(l);
  }
  getColorSpace() {
    return "rgb";
  }
  getColorChannels() {
    return Sn.colorChannels;
  }
};
Sn.colorChannels = [
  "red",
  "green",
  "blue"
];
let hr = Sn;
const rv = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/, kn = class kn extends Ji {
  constructor(e, n, r, l) {
    super(), this.hue = e, this.saturation = n, this.brightness = r, this.alpha = l;
  }
  static parse(e) {
    let n;
    if (n = e.match(rv)) {
      const [r, l, i, a] = (n[1] ?? n[2]).split(",").map((o) => Number(o.trim().replace("%", "")));
      return new kn(qd(r), Re(l, 0, 100), Re(i, 0, 100), Re(a ?? 1, 0, 1));
    }
  }
  toString(e = "css") {
    switch (e) {
      case "css":
        return this.toHSL().toString("css");
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsb":
        return `hsb(${this.hue}, ${Ae(this.saturation, 2)}%, ${Ae(this.brightness, 2)}%)`;
      case "hsba":
        return `hsba(${this.hue}, ${Ae(this.saturation, 2)}%, ${Ae(this.brightness, 2)}%, ${this.alpha})`;
      default:
        return this.toFormat(e).toString(e);
    }
  }
  toFormat(e) {
    switch (e) {
      case "hsb":
      case "hsba":
        return this;
      case "hsl":
      case "hsla":
        return this.toHSL();
      case "rgb":
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsb -> " + e);
    }
  }
  /**
  * Converts a HSB color to HSL.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_HSL.
  *
  * @returns An HSLColor object.
  */
  toHSL() {
    let e = this.saturation / 100, n = this.brightness / 100, r = n * (1 - e / 2);
    return e = r === 0 || r === 1 ? 0 : (n - r) / Math.min(r, 1 - r), new br(Ae(this.hue, 2), Ae(e * 100, 2), Ae(r * 100, 2), this.alpha);
  }
  /**
  * Converts a HSV color value to RGB. Conversion formula adapted from
  * https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_RGB_alternative.
  *
  * @returns An RGBColor object.
  */
  toRGB() {
    let e = this.hue, n = this.saturation / 100, r = this.brightness / 100, l = (i, a = (i + e / 60) % 6) => r - n * r * Math.max(Math.min(a, 4 - a, 1), 0);
    return new hr(Math.round(l(5) * 255), Math.round(l(3) * 255), Math.round(l(1) * 255), this.alpha);
  }
  clone() {
    return new kn(this.hue, this.saturation, this.brightness, this.alpha);
  }
  getChannelRange(e) {
    switch (e) {
      case "hue":
        return {
          minValue: 0,
          maxValue: 360,
          step: 1,
          pageSize: 15
        };
      case "saturation":
      case "brightness":
        return {
          minValue: 0,
          maxValue: 100,
          step: 1,
          pageSize: 10
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + e);
    }
  }
  getChannelFormatOptions(e) {
    switch (e) {
      case "hue":
        return {
          style: "unit",
          unit: "degree",
          unitDisplay: "narrow"
        };
      case "saturation":
      case "brightness":
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + e);
    }
  }
  formatChannelValue(e, n) {
    let r = this.getChannelFormatOptions(e), l = this.getChannelValue(e);
    return (e === "saturation" || e === "brightness") && (l /= 100), new Wt(n, r).format(l);
  }
  getColorSpace() {
    return "hsb";
  }
  getColorChannels() {
    return kn.colorChannels;
  }
};
kn.colorChannels = [
  "hue",
  "saturation",
  "brightness"
];
let pr = kn;
const lv = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/, Bn = class Bn extends Ji {
  constructor(e, n, r, l) {
    super(), this.hue = e, this.saturation = n, this.lightness = r, this.alpha = l;
  }
  static parse(e) {
    let n;
    if (n = e.match(lv)) {
      const [r, l, i, a] = (n[1] ?? n[2]).split(",").map((o) => Number(o.trim().replace("%", "")));
      return new Bn(qd(r), Re(l, 0, 100), Re(i, 0, 100), Re(a ?? 1, 0, 1));
    }
  }
  toString(e = "css") {
    switch (e) {
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsl":
        return `hsl(${this.hue}, ${Ae(this.saturation, 2)}%, ${Ae(this.lightness, 2)}%)`;
      case "css":
      case "hsla":
        return `hsla(${this.hue}, ${Ae(this.saturation, 2)}%, ${Ae(this.lightness, 2)}%, ${this.alpha})`;
      default:
        return this.toFormat(e).toString(e);
    }
  }
  toFormat(e) {
    switch (e) {
      case "hsl":
      case "hsla":
        return this;
      case "hsb":
      case "hsba":
        return this.toHSB();
      case "rgb":
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsl -> " + e);
    }
  }
  /**
  * Converts a HSL color to HSB.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_HSV.
  *
  * @returns An HSBColor object.
  */
  toHSB() {
    let e = this.saturation / 100, n = this.lightness / 100, r = n + e * Math.min(n, 1 - n);
    return e = r === 0 ? 0 : 2 * (1 - n / r), new pr(Ae(this.hue, 2), Ae(e * 100, 2), Ae(r * 100, 2), this.alpha);
  }
  /**
  * Converts a HSL color to RGB. Conversion formula adapted from
  * https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative.
  *
  * @returns An RGBColor object.
  */
  toRGB() {
    let e = this.hue, n = this.saturation / 100, r = this.lightness / 100, l = n * Math.min(r, 1 - r), i = (a, o = (a + e / 30) % 12) => r - l * Math.max(Math.min(o - 3, 9 - o, 1), -1);
    return new hr(Math.round(i(0) * 255), Math.round(i(8) * 255), Math.round(i(4) * 255), this.alpha);
  }
  clone() {
    return new Bn(this.hue, this.saturation, this.lightness, this.alpha);
  }
  getChannelRange(e) {
    switch (e) {
      case "hue":
        return {
          minValue: 0,
          maxValue: 360,
          step: 1,
          pageSize: 15
        };
      case "saturation":
      case "lightness":
        return {
          minValue: 0,
          maxValue: 100,
          step: 1,
          pageSize: 10
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + e);
    }
  }
  getChannelFormatOptions(e) {
    switch (e) {
      case "hue":
        return {
          style: "unit",
          unit: "degree",
          unitDisplay: "narrow"
        };
      case "saturation":
      case "lightness":
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + e);
    }
  }
  formatChannelValue(e, n) {
    let r = this.getChannelFormatOptions(e), l = this.getChannelValue(e);
    return (e === "saturation" || e === "lightness") && (l /= 100), new Wt(n, r).format(l);
  }
  getColorSpace() {
    return "hsl";
  }
  getColorChannels() {
    return Bn.colorChannels;
  }
};
Bn.colorChannels = [
  "hue",
  "saturation",
  "lightness"
];
let br = Bn;
function Po(t) {
  let e = t.toFormat("rgb"), n = e.getChannelValue("red") / 255, r = e.getChannelValue("green") / 255, l = e.getChannelValue("blue") / 255;
  [n, r, l] = av(n, r, l);
  let [i, a, o] = ov(n, r, l), [u, c, s] = uv(i, a, o);
  return iv(u, c, s);
}
function iv(t, e, n) {
  var r = Math.atan2(n, e) * 180 / Math.PI;
  return [
    t,
    Math.sqrt(e ** 2 + n ** 2),
    r >= 0 ? r : r + 360
    // Hue, in degrees [0 to 360)
  ];
}
function av(t, e, n) {
  return [
    Vl(t),
    Vl(e),
    Vl(n)
  ];
}
function Vl(t) {
  let e = t < 0 ? -1 : 1, n = Math.abs(t);
  return n <= 0.04045 ? t / 12.92 : e * Math.pow((n + 0.055) / 1.055, 2.4);
}
function ov(t, e, n) {
  return mi([
    0.4123907992659595,
    0.35758433938387796,
    0.1804807884018343,
    0.21263900587151036,
    0.7151686787677559,
    0.07219231536073371,
    0.01933081871559185,
    0.11919477979462599,
    0.9505321522496606
  ], t, e, n);
}
function uv(t, e, n) {
  const r = [
    0.819022437996703,
    0.3619062600528904,
    -0.1288737815209879,
    0.0329836539323885,
    0.9292868615863434,
    0.0361446663506424,
    0.0481771893596242,
    0.2642395317527308,
    0.6335478284694309
  ], l = [
    0.210454268309314,
    0.7936177747023054,
    -0.0040720430116193,
    1.9779985324311684,
    -2.42859224204858,
    0.450593709617411,
    0.0259040424655478,
    0.7827717124575296,
    -0.8086757549230774
  ];
  let [i, a, o] = mi(r, t, e, n);
  return mi(l, Math.cbrt(i), Math.cbrt(a), Math.cbrt(o));
}
function mi(t, e, n, r) {
  let l = t[0] * e + t[1] * n + t[2] * r, i = t[3] * e + t[4] * n + t[5] * r, a = t[6] * e + t[7] * n + t[8] * r;
  return [
    l,
    i,
    a
  ];
}
const Yd = (t) => [
  0,
  60,
  120,
  180,
  240,
  300,
  360
].map((e) => t.withChannelValue("hue", e).toString("css")).join(", "), Xd = (t) => `${t.withChannelValue("saturation", 0)}, transparent`, sv = {
  hue: Yd,
  saturation: Xd,
  lightness: () => "black, transparent, white"
}, cv = {
  hue: Yd,
  saturation: Xd,
  brightness: () => "black, transparent"
};
function dv({ direction: t, state: e, zChannel: n, xChannel: r, yChannel: l }) {
  return _(() => {
    let a = t === "rtl" ? "left" : "right", o = {}, u = e.value.getChannelValue(n);
    switch (e.value.getColorSpace()) {
      case "rgb": {
        let f = _e("rgb(0, 0, 0)");
        o = {
          background: [
            // The screen blend mode multiplies the inverse of each channel, e.g. 1 - (1 - a) * (1 - b).
            // Create a layer for each channel, with the other channels as 0. After blending, this should
            // result in the gradients being combined channel by channel.
            `linear-gradient(to ${a}, ${f.withChannelValue(r, 0)}, ${f.withChannelValue(r, 255)})`,
            `linear-gradient(to top, ${f.withChannelValue(l, 0)}, ${f.withChannelValue(l, 255)})`,
            f.withChannelValue(n, u)
          ].join(","),
          backgroundBlendMode: "screen"
        };
        break;
      }
      case "hsl": {
        let f = e.value.getColorChannels(), h = _e("hsl(0, 100%, 50%)").withChannelValue(n, u), p = f.filter((b) => b !== n).map((b) => `linear-gradient(to ${b === r ? a : "top"}, ${sv[b](h)})`).reverse();
        n === "hue" && p.push(h.toString("css")), o = {
          background: p.join(", ")
        };
        break;
      }
      case "hsb": {
        let f = e.value.getColorChannels(), h = _e("hsb(0, 100%, 100%)").withChannelValue(n, u), p = f.filter((b) => b !== n).map((b) => `linear-gradient(to ${b === r ? a : "top"}, ${cv[b](h)})`).reverse();
        n === "hue" && p.push(h.toString("css")), o = {
          background: p.join(", ")
        };
        break;
      }
    }
    let { x: c, y: s } = e.getThumbPosition();
    t === "rtl" && (c = 1 - c);
    let d = {
      forcedColorAdjust: "none"
    };
    return {
      colorAreaStyleProps: {
        style: {
          position: "relative",
          touchAction: "none",
          ...d,
          ...o
        }
      },
      thumbStyleProps: {
        style: {
          position: "absolute",
          left: `${c * 100}%`,
          top: `${s * 100}%`,
          transform: "translate(-50%, -50%)",
          touchAction: "none",
          ...d
        }
      }
    };
  }, [
    t,
    e,
    n,
    r,
    l
  ]);
}
function mr(t) {
  let { onMoveStart: e, onMove: n, onMoveEnd: r } = t, l = B({
    didMove: !1,
    lastPosition: null,
    id: null
  }), { addGlobalListener: i, removeGlobalListener: a } = It(), o = G((f, h, p, b) => {
    p === 0 && b === 0 || (l.current.didMove || (l.current.didMove = !0, e?.({
      type: "movestart",
      pointerType: h,
      shiftKey: f.shiftKey,
      metaKey: f.metaKey,
      ctrlKey: f.ctrlKey,
      altKey: f.altKey
    })), n?.({
      type: "move",
      pointerType: h,
      deltaX: p,
      deltaY: b,
      shiftKey: f.shiftKey,
      metaKey: f.metaKey,
      ctrlKey: f.ctrlKey,
      altKey: f.altKey
    }));
  }, [
    e,
    n,
    l
  ]), u = ye(o), c = G((f, h) => {
    _r(), l.current.didMove && r?.({
      type: "moveend",
      pointerType: h,
      shiftKey: f.shiftKey,
      metaKey: f.metaKey,
      ctrlKey: f.ctrlKey,
      altKey: f.altKey
    });
  }, [
    r,
    l
  ]), s = ye(c);
  return {
    moveProps: _(() => {
      let f = {}, h = () => {
        ui(), l.current.didMove = !1;
      };
      if (typeof PointerEvent > "u" && process.env.NODE_ENV === "test") {
        let b = (v) => {
          v.button === 0 && (u(v, "mouse", v.pageX - (l.current.lastPosition?.pageX ?? 0), v.pageY - (l.current.lastPosition?.pageY ?? 0)), l.current.lastPosition = {
            pageX: v.pageX,
            pageY: v.pageY
          });
        }, g = (v) => {
          if (v.button === 0) {
            s(v, "mouse");
            let E = De(H(v));
            a(E, "mousemove", b, !1), a(E, "mouseup", g, !1);
          }
        };
        f.onMouseDown = (v) => {
          if (v.button === 0) {
            h(), v.stopPropagation(), v.preventDefault(), l.current.lastPosition = {
              pageX: v.pageX,
              pageY: v.pageY
            };
            let E = De(H(v));
            i(E, "mousemove", b, !1), i(E, "mouseup", g, !1);
          }
        };
        let y = (v) => {
          let E = [
            ...v.changedTouches
          ].findIndex(({ identifier: S }) => S === l.current.id);
          if (E >= 0) {
            let { pageX: S, pageY: w } = v.changedTouches[E];
            u(v, "touch", S - (l.current.lastPosition?.pageX ?? 0), w - (l.current.lastPosition?.pageY ?? 0)), l.current.lastPosition = {
              pageX: S,
              pageY: w
            };
          }
        }, $ = (v) => {
          if ([
            ...v.changedTouches
          ].findIndex(({ identifier: S }) => S === l.current.id) >= 0) {
            s(v, "touch"), l.current.id = null;
            let S = De(H(v));
            a(S, "touchmove", y), a(S, "touchend", $), a(S, "touchcancel", $);
          }
        };
        f.onTouchStart = (v) => {
          if (v.changedTouches.length === 0 || l.current.id != null) return;
          let { pageX: E, pageY: S, identifier: w } = v.changedTouches[0];
          h(), v.stopPropagation(), v.preventDefault(), l.current.lastPosition = {
            pageX: E,
            pageY: S
          }, l.current.id = w;
          let C = De(H(v));
          i(C, "touchmove", y, !1), i(C, "touchend", $, !1), i(C, "touchcancel", $, !1);
        };
      } else {
        let b = (y) => {
          if (y.pointerId === l.current.id) {
            let $ = y.pointerType || "mouse";
            u(y, $, y.pageX - (l.current.lastPosition?.pageX ?? 0), y.pageY - (l.current.lastPosition?.pageY ?? 0)), l.current.lastPosition = {
              pageX: y.pageX,
              pageY: y.pageY
            };
          }
        }, g = (y) => {
          if (y.pointerId === l.current.id) {
            let $ = y.pointerType || "mouse";
            s(y, $), l.current.id = null;
            let v = De(H(y));
            a(v, "pointermove", b, !1), a(v, "pointerup", g, !1), a(v, "pointercancel", g, !1);
          }
        };
        f.onPointerDown = (y) => {
          if (y.button === 0 && l.current.id == null) {
            h(), y.stopPropagation(), y.preventDefault(), l.current.lastPosition = {
              pageX: y.pageX,
              pageY: y.pageY
            }, l.current.id = y.pointerId;
            let $ = De(H(y));
            i($, "pointermove", b, !1), i($, "pointerup", g, !1), i($, "pointercancel", g, !1);
          }
        };
      }
      let p = (b, g, y) => {
        h(), u(b, "keyboard", g, y), s(b, "keyboard");
      };
      return f.onKeyDown = (b) => {
        switch (b.key) {
          case "Left":
          case "ArrowLeft":
            b.preventDefault(), b.stopPropagation(), p(b, -1, 0);
            break;
          case "Right":
          case "ArrowRight":
            b.preventDefault(), b.stopPropagation(), p(b, 1, 0);
            break;
          case "Up":
          case "ArrowUp":
            b.preventDefault(), b.stopPropagation(), p(b, 0, -1);
            break;
          case "Down":
          case "ArrowDown":
            b.preventDefault(), b.stopPropagation(), p(b, 0, 1);
            break;
        }
      }, f;
    }, [
      i,
      a,
      l
    ])
  };
}
function fv(t) {
  return t && t.__esModule ? t.default : t;
}
function hv(t, e) {
  let { isDisabled: n, inputXRef: r, inputYRef: l, containerRef: i, "aria-label": a, xName: o, yName: u, form: c } = t, s = ke(fv(Zi), "@react-aria/color"), { addGlobalListener: d, removeGlobalListener: f } = It(), { direction: h, locale: p } = pe(), [b, g] = q(null), y = G((J = r) => {
    J.current && Pe(J.current);
  }, [
    r
  ]);
  Xt(r, e.defaultValue, e.setValue);
  let [$, v] = q(!1), [E, S] = q(!1), { xChannel: w, yChannel: C, zChannel: R } = e.channels, I = e.xChannelStep, N = e.yChannelStep, O = B(null), { keyboardProps: A } = Hn({
    onKeyDown(J) {
      if (!/^(PageUp|PageDown|Home|End)$/.test(J.key)) {
        J.continuePropagation();
        return;
      }
      J.preventDefault(), e.setDragging(!0), v(!0);
      let xe;
      switch (J.key) {
        case "PageUp":
          e.incrementY(e.yChannelPageStep), xe = "y";
          break;
        case "PageDown":
          e.decrementY(e.yChannelPageStep), xe = "y";
          break;
        case "Home":
          h === "rtl" ? e.incrementX(e.xChannelPageStep) : e.decrementX(e.xChannelPageStep), xe = "x";
          break;
        case "End":
          h === "rtl" ? e.decrementX(e.xChannelPageStep) : e.incrementX(e.xChannelPageStep), xe = "x";
          break;
      }
      e.setDragging(!1), xe && (y(xe === "x" ? r : l), g(xe));
    }
  }), V = {
    onMoveStart() {
      O.current = null, e.setDragging(!0);
    },
    onMove({ deltaX: J, deltaY: xe, pointerType: Zt, shiftKey: vn }) {
      let { incrementX: Jt, decrementX: Xn, incrementY: xn, decrementY: dt, xChannelPageStep: ft, xChannelStep: ht, yChannelPageStep: Zn, yChannelStep: Jn, getThumbPosition: Pl, setColorFromPoint: Sl } = e;
      O.current == null && (O.current = Pl());
      let { width: we, height: En } = i.current?.getBoundingClientRect() || {
        width: 0,
        height: 0
      }, _a = J !== 0 || xe !== 0;
      if (Zt === "keyboard") {
        let Wa = vn && ft > ht ? ft : ht, ja = vn && Zn > Jn ? Zn : Jn;
        J > 0 && h === "ltr" || J < 0 && h === "rtl" ? Jt(Wa) : J < 0 && h === "ltr" || J > 0 && h === "rtl" ? Xn(Wa) : xe > 0 ? dt(ja) : xe < 0 && xn(ja), v(_a), b = _a && Math.abs(xe) > Math.abs(J) ? "y" : "x", g(b);
      } else
        O.current.x += (h === "rtl" ? -1 : 1) * J / we, O.current.y += xe / En, Sl(O.current.x, O.current.y);
    },
    onMoveEnd() {
      F.current = !1, e.setDragging(!1), y(b === "x" ? r : l);
    }
  }, { moveProps: x } = mr(V), { focusWithinProps: K } = Et({
    onFocusWithinChange: (J) => {
      J || (v(!1), S(!1));
    }
  }), D = B(void 0), F = B(!1), { moveProps: M } = mr({
    onMoveStart() {
      F.current && V.onMoveStart();
    },
    onMove(J) {
      F.current && V.onMove(J);
    },
    onMoveEnd() {
      F.current && V.onMoveEnd();
    }
  }), P = (J) => {
    e.isDragging || (D.current = J, v(!1), y(), e.setDragging(!0), typeof PointerEvent < "u" ? d(window, "pointerup", T, !1) : (d(window, "mouseup", T, !1), d(window, "touchend", T, !1)));
  }, T = (J) => {
    (J.pointerId ?? J.changedTouches?.[0].identifier) === D.current && (v(!1), y(), e.setDragging(!1), D.current = void 0, F.current = !1, typeof PointerEvent < "u" ? f(window, "pointerup", T, !1) : (f(window, "mouseup", T, !1), f(window, "touchend", T, !1)));
  }, W = (J, xe, Zt, vn) => {
    let Jt = J.getBoundingClientRect(), { width: Xn, height: xn } = Jt, dt = (Zt - Jt.x) / Xn, ft = (vn - Jt.y) / xn;
    h === "rtl" && (dt = 1 - dt), dt >= 0 && dt <= 1 && ft >= 0 && ft <= 1 && !e.isDragging && D.current === void 0 && (F.current = !0, v(!1), D.current = xe, e.setColorFromPoint(dt, ft), y(), e.setDragging(!0), typeof PointerEvent < "u" ? d(window, "pointerup", U, !1) : (d(window, "mouseup", U, !1), d(window, "touchend", U, !1)));
  }, U = (J) => {
    let xe = J.pointerId ?? J.changedTouches?.[0].identifier;
    F.current && xe === D.current && (F.current = !1, v(!1), D.current = void 0, e.setDragging(!1), y(), typeof PointerEvent < "u" ? f(window, "pointerup", U, !1) : (f(window, "mouseup", U, !1), f(window, "touchend", U, !1)));
  }, k = n ? {} : L({
    ...typeof PointerEvent < "u" ? {
      onPointerDown: (J) => {
        J.pointerType === "mouse" && (J.button !== 0 || J.altKey || J.ctrlKey || J.metaKey) || W(J.currentTarget, J.pointerId, J.clientX, J.clientY);
      }
    } : {
      onMouseDown: (J) => {
        J.button !== 0 || J.altKey || J.ctrlKey || J.metaKey || W(J.currentTarget, void 0, J.clientX, J.clientY);
      },
      onTouchStart: (J) => {
        W(J.currentTarget, J.changedTouches[0].identifier, J.changedTouches[0].clientX, J.changedTouches[0].clientY);
      }
    }
  }, M), ee = n ? {} : L({
    ...typeof PointerEvent < "u" ? {
      onPointerDown: (J) => {
        J.pointerType === "mouse" && (J.button !== 0 || J.altKey || J.ctrlKey || J.metaKey) || P(J.pointerId);
      }
    } : {
      onMouseDown: (J) => {
        J.button !== 0 || J.altKey || J.ctrlKey || J.metaKey || P(void 0);
      },
      onTouchStart: (J) => {
        P(J.changedTouches[0].identifier);
      }
    }
  }, K, A, x), { focusProps: Z } = In({
    onFocus: () => {
      g("x");
    }
  }), { focusProps: de } = In({
    onFocus: () => {
      g("y");
    }
  });
  const ae = (J) => {
    const { target: xe } = J;
    S(!0), xe === r.current ? e.setXValue(parseFloat(xe.value)) : xe === l.current && e.setYValue(parseFloat(xe.value));
  };
  let se = yt() || _t(), Se = e.getDisplayColor();
  const Yn = G((J) => `${E || $ ? s.format("colorNameAndValue", {
    name: Se.getChannelName(J, p),
    value: Se.formatChannelValue(J, p)
  }) : [
    s.format("colorNameAndValue", {
      name: Se.getChannelName(J, p),
      value: Se.formatChannelValue(J, p)
    }),
    s.format("colorNameAndValue", {
      name: Se.getChannelName(J === C ? w : C, p),
      value: Se.formatChannelValue(J === C ? w : C, p)
    }),
    s.format("colorNameAndValue", {
      name: Se.getChannelName(R, p),
      value: Se.formatChannelValue(R, p)
    })
  ].join(", ")}, ${Se.getColorName(p)}`, [
    p,
    Se,
    s,
    E,
    $,
    w,
    C,
    R
  ]);
  let et = s.format("colorPicker"), gn = kt({
    ...t,
    "aria-label": a ? s.format("colorInputLabel", {
      label: a,
      channelLabel: et
    }) : et
  }), wt = kt({
    ...t,
    "aria-label": a ? s.format("colorInputLabel", {
      label: a,
      channelLabel: et
    }) : et
  }), yn = kt({
    ...t,
    "aria-label": a ? `${a}, ${et}` : void 0
  }, se ? et : void 0), $n = s.format("twoDimensionalSlider"), { visuallyHiddenProps: fe } = qt({
    style: {
      opacity: "0.0001",
      width: "100%",
      height: "100%",
      pointerEvents: "none"
    }
  }), { colorAreaStyleProps: Rt, thumbStyleProps: Tr } = dv({
    direction: h,
    state: e,
    xChannel: w,
    yChannel: C,
    zChannel: R
  });
  return {
    colorAreaProps: {
      ...yn,
      ...k,
      ...Rt,
      role: "group"
    },
    thumbProps: {
      ...ee,
      ...Tr,
      role: "presentation"
    },
    xInputProps: {
      ...gn,
      ...fe,
      ...Z,
      type: "range",
      min: e.value.getChannelRange(w).minValue,
      max: e.value.getChannelRange(w).maxValue,
      step: I,
      "aria-roledescription": $n,
      "aria-valuetext": Yn(w),
      "aria-orientation": "horizontal",
      "aria-describedby": t["aria-describedby"],
      "aria-details": t["aria-details"],
      disabled: n,
      value: e.value.getChannelValue(w),
      name: o,
      form: c,
      tabIndex: se || !b || b === "x" ? void 0 : -1,
      /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused control when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */
      "aria-hidden": se || !b || b === "x" || $ ? void 0 : "true",
      onChange: ae
    },
    yInputProps: {
      ...wt,
      ...fe,
      ...de,
      type: "range",
      min: e.value.getChannelRange(C).minValue,
      max: e.value.getChannelRange(C).maxValue,
      step: N,
      "aria-roledescription": $n,
      "aria-valuetext": Yn(C),
      "aria-orientation": "vertical",
      "aria-describedby": t["aria-describedby"],
      "aria-details": t["aria-details"],
      disabled: n,
      value: e.value.getChannelValue(C),
      name: u,
      form: c,
      tabIndex: se || b === "y" ? void 0 : -1,
      /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused input when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */
      "aria-hidden": se || b === "y" || $ ? void 0 : "true",
      onChange: ae
    }
  };
}
const pv = _e("#ffffff");
function bv(t) {
  let { value: e, defaultValue: n, colorSpace: r, xChannel: l, yChannel: i, onChange: a, onChangeEnd: o } = t;
  !e && !n && (n = pv), e && (e = An(e)), n && (n = An(n));
  let [u, c] = Be(e, n, a), [s] = q(u), d = _(() => r && u ? u.toFormat(r) : u, [
    u,
    r
  ]), f = B(d), h = (D) => {
    f.current = D, c(D);
  }, p = _(() => d.getColorSpaceAxes({
    xChannel: l,
    yChannel: i
  }), [
    d,
    l,
    i
  ]), b = d.getChannelRange(p.xChannel), g = d.getChannelRange(p.yChannel), { minValue: y, maxValue: $, step: v, pageSize: E } = b, { minValue: S, maxValue: w, step: C, pageSize: R } = g, [I, N] = q(!1), O = B(!1), A = d.getChannelValue(p.xChannel), V = d.getChannelValue(p.yChannel), x = (D) => {
    if (D === A) return;
    let F = d.withChannelValue(p.xChannel, D);
    h(F);
  }, K = (D) => {
    if (D === V) return;
    let F = d.withChannelValue(p.yChannel, D);
    h(F);
  };
  return {
    channels: p,
    xChannelStep: v,
    yChannelStep: C,
    xChannelPageStep: E,
    yChannelPageStep: R,
    value: d,
    defaultValue: e !== void 0 ? s : n,
    setValue(D) {
      h(An(D));
    },
    xValue: A,
    setXValue: x,
    yValue: V,
    setYValue: K,
    setColorFromPoint(D, F) {
      let M = y + Re(D, 0, 1) * ($ - y), P = S + (1 - Re(F, 0, 1)) * (w - S), T;
      M !== A && (M = Ke(M, y, $, v), T = d.withChannelValue(p.xChannel, M)), P !== V && (P = Ke(P, S, w, C), T = (T || d).withChannelValue(p.yChannel, P)), T && h(T);
    },
    getThumbPosition() {
      let D = (A - y) / ($ - y), F = 1 - (V - S) / (w - S);
      return {
        x: D,
        y: F
      };
    },
    incrementX(D = 1) {
      x(A + D > $ ? $ : Ke(A + D, y, $, v));
    },
    incrementY(D = 1) {
      K(V + D > w ? w : Ke(V + D, S, w, C));
    },
    decrementX(D = 1) {
      x(Ke(A - D, y, $, v));
    },
    decrementY(D = 1) {
      K(Ke(V - D, S, w, C));
    },
    setDragging(D) {
      let F = O.current;
      O.current = D, o && !D && F && o(f.current), N(D);
    },
    isDragging: I,
    getDisplayColor() {
      return d.withChannelValue("alpha", 1);
    }
  };
}
const Zd = /* @__PURE__ */ j(null), mv = /* @__PURE__ */ j(null), y6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, Zd);
  let r = B(null), l = B(null), i = bv(e), { colorAreaProps: a, xInputProps: o, yInputProps: u, thumbProps: c } = hv({
    ...e,
    inputXRef: r,
    inputYRef: l,
    containerRef: n
  }, i), s = re({
    ...e,
    defaultClassName: "react-aria-ColorArea",
    defaultStyle: a.style,
    values: {
      state: i,
      isDisabled: e.isDisabled || !1
    }
  }), d = Y(e, {
    global: !0
  });
  return delete d.id, /* @__PURE__ */ m.createElement(X.div, {
    ref: n,
    ...L(d, a, s),
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        mv,
        i
      ],
      [
        Xi,
        {
          state: i,
          thumbProps: c,
          inputXRef: r,
          xInputProps: o,
          inputYRef: l,
          yInputProps: u,
          isDisabled: e.isDisabled
        }
      ]
    ]
  }, s.children));
}), Dr = /* @__PURE__ */ j({}), $6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, Dr);
  let { isDisabled: r, isInvalid: l, isReadOnly: i, onHoverStart: a, onHoverChange: o, onHoverEnd: u, ...c } = e;
  r ??= !!e["aria-disabled"] && e["aria-disabled"] !== "false", l ??= !!e["aria-invalid"] && e["aria-invalid"] !== "false";
  let { hoverProps: s, isHovered: d } = ve({
    onHoverStart: a,
    onHoverChange: o,
    onHoverEnd: u,
    isDisabled: r
  }), { isFocused: f, isFocusVisible: h, focusProps: p } = $e({
    within: !0
  }), b = re({
    ...e,
    values: {
      isHovered: d,
      isFocusWithin: f,
      isFocusVisible: h,
      isDisabled: r,
      isInvalid: l
    },
    defaultClassName: "react-aria-Group"
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(c, p, s),
    ...b,
    ref: n,
    role: e.role ?? "group",
    slot: e.slot ?? void 0,
    "data-focus-within": f || void 0,
    "data-hovered": d || void 0,
    "data-focus-visible": h || void 0,
    "data-disabled": r || void 0,
    "data-invalid": l || void 0,
    "data-readonly": i || void 0
  }, b.children);
}), wr = /* @__PURE__ */ j({});
let gv = (t) => {
  let { onHoverStart: e, onHoverChange: n, onHoverEnd: r, ...l } = t;
  return l;
};
const v6 = /* @__PURE__ */ Gt(function(e, n) {
  [e, n] = ie(e, n, wr);
  let { hoverProps: r, isHovered: l } = ve({
    ...e,
    isDisabled: e.disabled
  }), { isFocused: i, isFocusVisible: a, focusProps: o } = $e({
    isTextInput: !0,
    autoFocus: e.autoFocus
  }), u = !!e["aria-invalid"] && e["aria-invalid"] !== "false", c = re({
    ...e,
    values: {
      isHovered: l,
      isFocused: i,
      isFocusVisible: a,
      isDisabled: e.disabled || !1,
      isInvalid: u
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ m.createElement(X.input, {
    ...L(gv(e), o, r),
    ...c,
    ref: n,
    "data-focused": i || void 0,
    "data-disabled": e.disabled || void 0,
    "data-hovered": l || void 0,
    "data-focus-visible": a || void 0,
    "data-invalid": u || void 0
  });
});
function Qi(t, e) {
  let { inputElementType: n = "input", isDisabled: r = !1, isRequired: l = !1, isReadOnly: i = !1, type: a = "text", validationBehavior: o = "aria" } = t, [u, c] = Be(t.value, t.defaultValue || "", t.onChange), { focusableProps: s } = Je(t, e), d = pn({
    ...t,
    value: u
  }), { isInvalid: f, validationErrors: h, validationDetails: p } = d.displayValidation, { labelProps: b, fieldProps: g, descriptionProps: y, errorMessageProps: $ } = gl({
    ...t,
    isInvalid: f,
    errorMessage: t.errorMessage || h
  }), v = Y(t, {
    labelable: !0
  });
  const E = {
    type: a,
    pattern: t.pattern
  };
  let [S] = q(u);
  return Xt(e, t.defaultValue ?? S, c), yl(t, d, e), {
    labelProps: b,
    inputProps: L(v, n === "input" ? E : void 0, {
      disabled: r,
      readOnly: i,
      required: l && o === "native",
      "aria-required": l && o === "aria" || void 0,
      "aria-invalid": f || void 0,
      "aria-errormessage": t["aria-errormessage"],
      "aria-activedescendant": t["aria-activedescendant"],
      "aria-autocomplete": t["aria-autocomplete"],
      "aria-haspopup": t["aria-haspopup"],
      "aria-controls": t["aria-controls"],
      value: u,
      onChange: (w) => c(H(w).value),
      autoComplete: t.autoComplete,
      autoCapitalize: t.autoCapitalize,
      maxLength: t.maxLength,
      minLength: t.minLength,
      name: t.name,
      form: t.form,
      placeholder: t.placeholder,
      inputMode: t.inputMode,
      autoCorrect: t.autoCorrect,
      spellCheck: t.spellCheck,
      [parseInt(m.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: t.enterKeyHint,
      // Clipboard events
      onCopy: t.onCopy,
      onCut: t.onCut,
      onPaste: t.onPaste,
      // Composition events
      onCompositionEnd: t.onCompositionEnd,
      onCompositionStart: t.onCompositionStart,
      onCompositionUpdate: t.onCompositionUpdate,
      // Selection events
      onSelect: t.onSelect,
      // Input events
      onBeforeInput: t.onBeforeInput,
      onInput: t.onInput,
      ...s,
      ...g
    }),
    descriptionProps: y,
    errorMessageProps: $,
    isInvalid: f,
    validationErrors: h,
    validationDetails: p
  };
}
function So() {
  return typeof window < "u" && window.InputEvent && typeof InputEvent.prototype.getTargetRanges == "function";
}
function Jd(t, e, n) {
  let r = ye((d) => {
    let f = n.current;
    if (!f) return;
    let h = null;
    switch (d.inputType) {
      case "historyUndo":
      case "historyRedo":
        return;
      case "insertLineBreak":
        return;
      case "deleteContent":
      case "deleteByCut":
      case "deleteByDrag":
        h = f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteContentForward":
        h = f.selectionEnd === f.selectionStart ? f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd + 1) : f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteContentBackward":
        h = f.selectionEnd === f.selectionStart ? f.value.slice(0, f.selectionStart - 1) + f.value.slice(f.selectionStart) : f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteSoftLineBackward":
      case "deleteHardLineBackward":
        h = f.value.slice(f.selectionStart);
        break;
      default:
        d.data != null && (h = f.value.slice(0, f.selectionStart) + d.data + f.value.slice(f.selectionEnd));
        break;
    }
    (h == null || !e.validate(h)) && d.preventDefault();
  });
  Q(() => {
    if (!So() || !n.current) return;
    let d = n.current;
    return d.addEventListener("beforeinput", r, !1), () => {
      d.removeEventListener("beforeinput", r, !1);
    };
  }, [
    n
  ]);
  let l = So() ? null : (d) => {
    let f = H(d).value.slice(0, H(d).selectionStart) + d.data + H(d).value.slice(H(d).selectionEnd);
    e.validate(f) || d.preventDefault();
  }, { labelProps: i, inputProps: a, descriptionProps: o, errorMessageProps: u, ...c } = Qi(t, n), s = B(null);
  return {
    inputProps: L(a, {
      onBeforeInput: l,
      onCompositionStart() {
        let { value: d, selectionStart: f, selectionEnd: h } = n.current;
        s.current = {
          value: d,
          selectionStart: f,
          selectionEnd: h
        };
      },
      onCompositionEnd() {
        if (n.current && !e.validate(n.current.value)) {
          let { value: d, selectionStart: f, selectionEnd: h } = s.current;
          n.current.value = d, n.current.setSelectionRange(f, h), e.setInputValue(d);
        }
      }
    }),
    labelProps: i,
    descriptionProps: o,
    errorMessageProps: u,
    ...c
  };
}
function Qd(t, e) {
  let { onScroll: n, isDisabled: r } = t, l = G((i) => {
    i.ctrlKey || (i.preventDefault(), i.stopPropagation(), n && n({
      deltaX: i.deltaX,
      deltaY: i.deltaY
    }));
  }, [
    n
  ]);
  Vt(e, "wheel", r ? void 0 : l);
}
var ef = {};
ef = {
  Empty: "فارغ"
};
var tf = {};
tf = {
  Empty: "Изпразни"
};
var nf = {};
nf = {
  Empty: "Prázdné"
};
var rf = {};
rf = {
  Empty: "Tom"
};
var lf = {};
lf = {
  Empty: "Leer"
};
var af = {};
af = {
  Empty: "Άδειο"
};
var of = {};
of = {
  Empty: "Empty"
};
var uf = {};
uf = {
  Empty: "Vacío"
};
var sf = {};
sf = {
  Empty: "Tühjenda"
};
var cf = {};
cf = {
  Empty: "Tyhjä"
};
var df = {};
df = {
  Empty: "Vide"
};
var ff = {};
ff = {
  Empty: "ריק"
};
var hf = {};
hf = {
  Empty: "Prazno"
};
var pf = {};
pf = {
  Empty: "Üres"
};
var bf = {};
bf = {
  Empty: "Vuoto"
};
var mf = {};
mf = {
  Empty: "空"
};
var gf = {};
gf = {
  Empty: "비어 있음"
};
var yf = {};
yf = {
  Empty: "Tuščias"
};
var $f = {};
$f = {
  Empty: "Tukšs"
};
var vf = {};
vf = {
  Empty: "Tom"
};
var xf = {};
xf = {
  Empty: "Leeg"
};
var Ef = {};
Ef = {
  Empty: "Pusty"
};
var Cf = {};
Cf = {
  Empty: "Vazio"
};
var Df = {};
Df = {
  Empty: "Vazio"
};
var wf = {};
wf = {
  Empty: "Gol"
};
var Pf = {};
Pf = {
  Empty: "Не заполнено"
};
var Sf = {};
Sf = {
  Empty: "Prázdne"
};
var kf = {};
kf = {
  Empty: "Prazen"
};
var Bf = {};
Bf = {
  Empty: "Prazno"
};
var Ff = {};
Ff = {
  Empty: "Tomt"
};
var Tf = {};
Tf = {
  Empty: "Boş"
};
var Af = {};
Af = {
  Empty: "Пусто"
};
var If = {};
If = {
  Empty: "空"
};
var Kf = {};
Kf = {
  Empty: "空白"
};
var Rf = {};
Rf = {
  "ar-AE": ef,
  "bg-BG": tf,
  "cs-CZ": nf,
  "da-DK": rf,
  "de-DE": lf,
  "el-GR": af,
  "en-US": of,
  "es-ES": uf,
  "et-EE": sf,
  "fi-FI": cf,
  "fr-FR": df,
  "he-IL": ff,
  "hr-HR": hf,
  "hu-HU": pf,
  "it-IT": bf,
  "ja-JP": mf,
  "ko-KR": gf,
  "lt-LT": yf,
  "lv-LV": $f,
  "nb-NO": vf,
  "nl-NL": xf,
  "pl-PL": Ef,
  "pt-BR": Cf,
  "pt-PT": Df,
  "ro-RO": wf,
  "ru-RU": Pf,
  "sk-SK": Sf,
  "sl-SI": kf,
  "sr-SP": Bf,
  "sv-SE": Ff,
  "tr-TR": Tf,
  "uk-UA": Af,
  "zh-CN": If,
  "zh-TW": Kf
};
function yv(t) {
  return t && t.__esModule ? t.default : t;
}
const ko = () => {
};
function Nf(t) {
  const e = B(void 0);
  let { value: n, textValue: r, minValue: l, maxValue: i, isDisabled: a, isReadOnly: o, isRequired: u, onIncrement: c, onIncrementPage: s, onDecrement: d, onDecrementPage: f, onDecrementToMin: h, onIncrementToMax: p } = t;
  const b = ke(yv(Rf), "@react-aria/spinbutton");
  let g = B(!1);
  const y = G(() => {
    clearTimeout(e.current), g.current = !1;
  }, []), $ = ye(() => {
    y();
  });
  Q(() => () => $(), []);
  let v = (k) => {
    if (!(k.ctrlKey || k.metaKey || k.shiftKey || k.altKey || o || k.nativeEvent.isComposing))
      switch (k.key) {
        case "PageUp":
          if (s) {
            k.preventDefault(), s?.();
            break;
          }
        // fallthrough!
        case "ArrowUp":
        case "Up":
          c && (k.preventDefault(), c?.());
          break;
        case "PageDown":
          if (f) {
            k.preventDefault(), f?.();
            break;
          }
        // fallthrough
        case "ArrowDown":
        case "Down":
          d && (k.preventDefault(), d?.());
          break;
        case "Home":
          h && (k.preventDefault(), h?.());
          break;
        case "End":
          p && (k.preventDefault(), p?.());
          break;
      }
  }, E = B(!1), S = () => {
    E.current = !0;
  }, w = () => {
    E.current = !1;
  }, C = r === "" ? b.format("Empty") : (r || `${n}`).replace("-", "−");
  Q(() => {
    E.current && (N$("assertive"), Kn(C, "assertive"));
  }, [
    C
  ]);
  let R = G(() => {
    y();
  }, [
    y
  ]);
  const I = ye(c ?? ko), N = ye(d ?? ko), O = ye(() => {
    (i === void 0 || isNaN(i) || n === void 0 || isNaN(n) || n < i) && (I(), A(60));
  }), A = ye((k) => {
    $(), g.current = !0, e.current = window.setTimeout(O, k);
  }), V = ye(() => {
    (l === void 0 || isNaN(l) || n === void 0 || isNaN(n) || n > l) && (N(), x(60));
  }), x = ye((k) => {
    $(), g.current = !0, e.current = window.setTimeout(V, k);
  });
  let K = (k) => {
    k.preventDefault();
  }, { addGlobalListener: D, removeAllGlobalListeners: F } = It(), M = B(!1), [P, T] = q(null);
  Q(() => {
    P === "touch" ? A(600) : P ? A(400) : P || $();
  }, [
    P
  ]);
  let [W, U] = q(null);
  return Q(() => {
    W === "touch" ? x(600) : W ? x(400) : W || $();
  }, [
    W
  ]), {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": n !== void 0 && !isNaN(n) ? n : void 0,
      "aria-valuetext": C,
      "aria-valuemin": l,
      "aria-valuemax": i,
      "aria-disabled": a || void 0,
      "aria-readonly": o || void 0,
      "aria-required": u || void 0,
      onKeyDown: v,
      onFocus: S,
      onBlur: w
    },
    incrementButtonProps: {
      onPressStart: (k) => {
        y(), k.pointerType !== "touch" ? (c?.(), T("mouse")) : (D(window, "pointercancel", R, {
          capture: !0
        }), M.current = !1, T("touch")), D(window, "contextmenu", K);
      },
      onPressUp: (k) => {
        y(), k.pointerType === "touch" && (M.current = !0), F(), T(null);
      },
      onPressEnd: (k) => {
        y(), k.pointerType === "touch" && !g.current && M.current && c?.(), M.current = !1, T(null);
      },
      onFocus: S,
      onBlur: w
    },
    decrementButtonProps: {
      onPressStart: (k) => {
        y(), k.pointerType !== "touch" ? (d?.(), U("mouse")) : (D(window, "pointercancel", R, {
          capture: !0
        }), M.current = !1, U("touch"));
      },
      onPressUp: (k) => {
        y(), k.pointerType === "touch" && (M.current = !0), F(), U(null);
      },
      onPressEnd: (k) => {
        y(), k.pointerType === "touch" && !g.current && M.current && d?.(), M.current = !1, U(null);
      },
      onFocus: S,
      onBlur: w
    }
  };
}
function $v(t, e, n) {
  let { isDisabled: r, isReadOnly: l, isRequired: i, isWheelDisabled: a, validationBehavior: o = "aria" } = t, { colorValue: u, inputValue: c, increment: s, decrement: d, incrementToMax: f, decrementToMin: h, commit: p } = e, b = ce(), { spinButtonProps: g } = Nf({
    isDisabled: r,
    isReadOnly: l,
    isRequired: i,
    maxValue: 16777215,
    minValue: 0,
    onIncrement: s,
    onIncrementToMax: f,
    onDecrement: d,
    onDecrementToMin: h,
    value: u ? u.toHexInt() : void 0,
    textValue: u ? u.toString("hex") : void 0
  }), [y, $] = q(!1), { focusWithinProps: v } = Et({
    isDisabled: r,
    onFocusWithinChange: $
  }), E = G((I) => {
    Math.abs(I.deltaY) <= Math.abs(I.deltaX) || (I.deltaY > 0 ? s() : I.deltaY < 0 && d());
  }, [
    d,
    s
  ]);
  Qd({
    onScroll: E,
    isDisabled: a || r || l || !y
  }, n);
  let w = (I) => {
    e.validate(I) && e.setInputValue(I);
  }, { inputProps: C, ...R } = Jd({
    ...t,
    id: b,
    value: c,
    // Intentionally invalid value that will be ignored by onChange during form reset
    // This is handled separately below.
    defaultValue: "!",
    validate: void 0,
    [Rn]: e,
    type: "text",
    autoComplete: "off",
    onChange: w
  }, e, n);
  return Xt(n, e.defaultColorValue, e.setColorValue), C = L(C, g, v, {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false",
    onBlur: p
  }), o === "native" && (C["aria-required"] = void 0), {
    inputProps: C,
    ...R
  };
}
var Mf = {};
Mf = {
  decrease: (t) => `خفض ${t.fieldLabel}`,
  increase: (t) => `زيادة ${t.fieldLabel}`,
  numberField: "حقل رقمي"
};
var Lf = {};
Lf = {
  decrease: (t) => `Намаляване ${t.fieldLabel}`,
  increase: (t) => `Усилване ${t.fieldLabel}`,
  numberField: "Номер на полето"
};
var zf = {};
zf = {
  decrease: (t) => `Snížit ${t.fieldLabel}`,
  increase: (t) => `Zvýšit ${t.fieldLabel}`,
  numberField: "Číselné pole"
};
var Vf = {};
Vf = {
  decrease: (t) => `Reducer ${t.fieldLabel}`,
  increase: (t) => `Øg ${t.fieldLabel}`,
  numberField: "Talfelt"
};
var Of = {};
Of = {
  decrease: (t) => `${t.fieldLabel} verringern`,
  increase: (t) => `${t.fieldLabel} erhöhen`,
  numberField: "Nummernfeld"
};
var Hf = {};
Hf = {
  decrease: (t) => `Μείωση ${t.fieldLabel}`,
  increase: (t) => `Αύξηση ${t.fieldLabel}`,
  numberField: "Πεδίο αριθμού"
};
var _f = {};
_f = {
  decrease: (t) => `Decrease ${t.fieldLabel}`,
  increase: (t) => `Increase ${t.fieldLabel}`,
  numberField: "Number field"
};
var Wf = {};
Wf = {
  decrease: (t) => `Reducir ${t.fieldLabel}`,
  increase: (t) => `Aumentar ${t.fieldLabel}`,
  numberField: "Campo de número"
};
var jf = {};
jf = {
  decrease: (t) => `Vähenda ${t.fieldLabel}`,
  increase: (t) => `Suurenda ${t.fieldLabel}`,
  numberField: "Numbri väli"
};
var Uf = {};
Uf = {
  decrease: (t) => `Vähennä ${t.fieldLabel}`,
  increase: (t) => `Lisää ${t.fieldLabel}`,
  numberField: "Numerokenttä"
};
var Gf = {};
Gf = {
  decrease: (t) => `Diminuer ${t.fieldLabel}`,
  increase: (t) => `Augmenter ${t.fieldLabel}`,
  numberField: "Champ de nombre"
};
var qf = {};
qf = {
  decrease: (t) => `הקטן ${t.fieldLabel}`,
  increase: (t) => `הגדל ${t.fieldLabel}`,
  numberField: "שדה מספר"
};
var Yf = {};
Yf = {
  decrease: (t) => `Smanji ${t.fieldLabel}`,
  increase: (t) => `Povećaj ${t.fieldLabel}`,
  numberField: "Polje broja"
};
var Xf = {};
Xf = {
  decrease: (t) => `${t.fieldLabel} csökkentése`,
  increase: (t) => `${t.fieldLabel} növelése`,
  numberField: "Számmező"
};
var Zf = {};
Zf = {
  decrease: (t) => `Riduci ${t.fieldLabel}`,
  increase: (t) => `Aumenta ${t.fieldLabel}`,
  numberField: "Campo numero"
};
var Jf = {};
Jf = {
  decrease: (t) => `${t.fieldLabel}を縮小`,
  increase: (t) => `${t.fieldLabel}を拡大`,
  numberField: "数値フィールド"
};
var Qf = {};
Qf = {
  decrease: (t) => `${t.fieldLabel} 감소`,
  increase: (t) => `${t.fieldLabel} 증가`,
  numberField: "번호 필드"
};
var eh = {};
eh = {
  decrease: (t) => `Sumažinti ${t.fieldLabel}`,
  increase: (t) => `Padidinti ${t.fieldLabel}`,
  numberField: "Numerio laukas"
};
var th = {};
th = {
  decrease: (t) => `Samazināšana ${t.fieldLabel}`,
  increase: (t) => `Palielināšana ${t.fieldLabel}`,
  numberField: "Skaitļu lauks"
};
var nh = {};
nh = {
  decrease: (t) => `Reduser ${t.fieldLabel}`,
  increase: (t) => `Øk ${t.fieldLabel}`,
  numberField: "Tallfelt"
};
var rh = {};
rh = {
  decrease: (t) => `${t.fieldLabel} verlagen`,
  increase: (t) => `${t.fieldLabel} verhogen`,
  numberField: "Getalveld"
};
var lh = {};
lh = {
  decrease: (t) => `Zmniejsz ${t.fieldLabel}`,
  increase: (t) => `Zwiększ ${t.fieldLabel}`,
  numberField: "Pole numeru"
};
var ih = {};
ih = {
  decrease: (t) => `Diminuir ${t.fieldLabel}`,
  increase: (t) => `Aumentar ${t.fieldLabel}`,
  numberField: "Campo de número"
};
var ah = {};
ah = {
  decrease: (t) => `Diminuir ${t.fieldLabel}`,
  increase: (t) => `Aumentar ${t.fieldLabel}`,
  numberField: "Campo numérico"
};
var oh = {};
oh = {
  decrease: (t) => `Scădere ${t.fieldLabel}`,
  increase: (t) => `Creștere ${t.fieldLabel}`,
  numberField: "Câmp numeric"
};
var uh = {};
uh = {
  decrease: (t) => `Уменьшение ${t.fieldLabel}`,
  increase: (t) => `Увеличение ${t.fieldLabel}`,
  numberField: "Числовое поле"
};
var sh = {};
sh = {
  decrease: (t) => `Znížiť ${t.fieldLabel}`,
  increase: (t) => `Zvýšiť ${t.fieldLabel}`,
  numberField: "Číselné pole"
};
var ch = {};
ch = {
  decrease: (t) => `Upadati ${t.fieldLabel}`,
  increase: (t) => `Povečajte ${t.fieldLabel}`,
  numberField: "Številčno polje"
};
var dh = {};
dh = {
  decrease: (t) => `Smanji ${t.fieldLabel}`,
  increase: (t) => `Povećaj ${t.fieldLabel}`,
  numberField: "Polje broja"
};
var fh = {};
fh = {
  decrease: (t) => `Minska ${t.fieldLabel}`,
  increase: (t) => `Öka ${t.fieldLabel}`,
  numberField: "Nummerfält"
};
var hh = {};
hh = {
  decrease: (t) => `${t.fieldLabel} azalt`,
  increase: (t) => `${t.fieldLabel} arttır`,
  numberField: "Sayı alanı"
};
var ph = {};
ph = {
  decrease: (t) => `Зменшити ${t.fieldLabel}`,
  increase: (t) => `Збільшити ${t.fieldLabel}`,
  numberField: "Поле номера"
};
var bh = {};
bh = {
  decrease: (t) => `降低 ${t.fieldLabel}`,
  increase: (t) => `提高 ${t.fieldLabel}`,
  numberField: "数字字段"
};
var mh = {};
mh = {
  decrease: (t) => `縮小 ${t.fieldLabel}`,
  increase: (t) => `放大 ${t.fieldLabel}`,
  numberField: "數字欄位"
};
var gh = {};
gh = {
  "ar-AE": Mf,
  "bg-BG": Lf,
  "cs-CZ": zf,
  "da-DK": Vf,
  "de-DE": Of,
  "el-GR": Hf,
  "en-US": _f,
  "es-ES": Wf,
  "et-EE": jf,
  "fi-FI": Uf,
  "fr-FR": Gf,
  "he-IL": qf,
  "hr-HR": Yf,
  "hu-HU": Xf,
  "it-IT": Zf,
  "ja-JP": Jf,
  "ko-KR": Qf,
  "lt-LT": eh,
  "lv-LV": th,
  "nb-NO": nh,
  "nl-NL": rh,
  "pl-PL": lh,
  "pt-BR": ih,
  "pt-PT": ah,
  "ro-RO": oh,
  "ru-RU": uh,
  "sk-SK": sh,
  "sl-SI": ch,
  "sr-SP": dh,
  "sv-SE": fh,
  "tr-TR": hh,
  "uk-UA": ph,
  "zh-CN": bh,
  "zh-TW": mh
};
function vv(t) {
  return t && t.__esModule ? t.default : t;
}
function yh(t, e, n) {
  let { id: r, decrementAriaLabel: l, incrementAriaLabel: i, isDisabled: a, isReadOnly: o, isRequired: u, minValue: c, maxValue: s, autoFocus: d, label: f, formatOptions: h, onBlur: p = () => {
  }, onFocus: b, onFocusChange: g, onKeyDown: y, onKeyUp: $, description: v, errorMessage: E, isWheelDisabled: S, ...w } = t, { increment: C, incrementToMax: R, decrement: I, decrementToMin: N, numberValue: O, inputValue: A, commit: V, commitValidation: x } = e;
  const K = ke(vv(gh), "@react-aria/numberfield");
  let D = G(() => {
    let we = n.current?.value ?? "";
    Ge(() => {
      V();
    }), n.current?.value !== we && Kn(n.current?.value ?? "", "assertive");
  }, [
    V,
    n
  ]), F = ce(r), { focusProps: M } = In({
    onBlur() {
      D();
    }
  }), P = hi(h), T = _(() => P.resolvedOptions(), [
    P
  ]), W = hi({
    ...h,
    currencySign: void 0
  }), U = _(() => isNaN(O) ? "" : W.format(O), [
    W,
    O
  ]), { spinButtonProps: k, incrementButtonProps: ee, decrementButtonProps: Z } = Nf({
    isDisabled: a,
    isReadOnly: o,
    isRequired: u,
    maxValue: s,
    minValue: c,
    onIncrement: C,
    onIncrementToMax: R,
    onDecrement: I,
    onDecrementToMin: N,
    value: O,
    textValue: U
  }), [de, ae] = q(!1), { focusWithinProps: se } = Et({
    isDisabled: a,
    onFocusWithinChange: ae
  }), Se = G((we) => {
    Math.abs(we.deltaY) <= Math.abs(we.deltaX) || (we.deltaY > 0 ? C() : we.deltaY < 0 && I());
  }, [
    I,
    C
  ]);
  Qd({
    onScroll: Se,
    isDisabled: S || a || o || !de
  }, n);
  let et = (T.maximumFractionDigits ?? 0) > 0, gn = e.minValue === void 0 || isNaN(e.minValue) || e.minValue < 0, wt = "numeric";
  Fu() ? gn ? wt = "text" : et && (wt = "decimal") : _t() && (gn ? wt = "numeric" : et && (wt = "decimal"));
  let yn = (we) => {
    e.validate(we) && e.setInputValue(we);
  }, $n = (we) => {
    t.onPaste?.(we);
    let En = H(we);
    En && (En.selectionEnd ?? -1) - (En.selectionStart ?? 0) === En.value.length && (we.preventDefault(), V(we.clipboardData?.getData?.("text/plain")?.trim() ?? ""));
  }, fe = Y(t), Rt = G((we) => {
    we.nativeEvent.isComposing || (we.key === "Enter" ? (Ge(() => {
      V();
    }), x()) : we.continuePropagation());
  }, [
    V,
    x
  ]), { isInvalid: Tr, validationErrors: J, validationDetails: xe } = e.displayValidation, { labelProps: Zt, inputProps: vn, descriptionProps: Jt, errorMessageProps: Xn } = Jd({
    ...w,
    ...fe,
    // These props are added to a hidden input rather than the formatted textfield.
    name: void 0,
    form: void 0,
    label: f,
    autoFocus: d,
    isDisabled: a,
    isReadOnly: o,
    isRequired: u,
    validate: void 0,
    [Rn]: e,
    value: A,
    defaultValue: "!",
    autoComplete: "off",
    "aria-label": t["aria-label"] || void 0,
    "aria-labelledby": t["aria-labelledby"] || void 0,
    id: F,
    type: "text",
    inputMode: wt,
    onChange: yn,
    onBlur: p,
    onFocus: b,
    onFocusChange: g,
    onKeyDown: _(() => Ye(Rt, y), [
      Rt,
      y
    ]),
    onKeyUp: $,
    onPaste: $n,
    description: v,
    errorMessage: E
  }, e, n);
  Xt(n, e.defaultNumberValue, e.setNumberValue), xv(e, t.validationBehavior, t.commitBehavior, n, e.minValue, e.maxValue, t.step, e.numberValue);
  let xn = L(k, M, vn, {
    // override the spinbutton role, we can't focus a spin button with VO
    role: null,
    // ignore aria-roledescription on iOS so that required state will announce when it is present
    "aria-roledescription": yt() ? null : K.format("numberField"),
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false"
  });
  t.validationBehavior === "native" && (xn["aria-required"] = void 0);
  let dt = (we) => {
    oe() !== n.current && (we.pointerType === "mouse" ? n.current?.focus() : we.target.focus());
  }, ft = t["aria-label"] || (typeof t.label == "string" ? t.label : ""), ht;
  ft || (ht = t.label != null ? Zt.id : t["aria-labelledby"]);
  let Zn = ce(), Jn = ce(), Pl = L(ee, {
    "aria-label": i || K.format("increase", {
      fieldLabel: ft
    }).trim(),
    id: ht && !i ? Zn : null,
    "aria-labelledby": ht && !i ? `${Zn} ${ht}` : null,
    "aria-controls": F,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !e.canIncrement,
    onPressStart: dt
  }), Sl = L(Z, {
    "aria-label": l || K.format("decrease", {
      fieldLabel: ft
    }).trim(),
    id: ht && !l ? Jn : null,
    "aria-labelledby": ht && !l ? `${Jn} ${ht}` : null,
    "aria-controls": F,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !e.canDecrement,
    onPressStart: dt
  });
  return {
    groupProps: {
      ...se,
      role: "group",
      "aria-disabled": a,
      "aria-invalid": Tr ? "true" : void 0
    },
    labelProps: Zt,
    inputProps: xn,
    incrementButtonProps: Pl,
    decrementButtonProps: Sl,
    errorMessageProps: Xn,
    descriptionProps: Jt,
    isInvalid: Tr,
    validationErrors: J,
    validationDetails: xe
  };
}
let Ne = null;
function xv(t, e, n, r, l, i, a, o) {
  le(() => {
    let u = r.current;
    if (n !== "validate" || t.realtimeValidation.isInvalid || !u || u.disabled || (!Ne && typeof document < "u" && (Ne = document.createElement("input"), Ne.type = "number"), !Ne))
      return;
    Ne.min = l != null && !isNaN(l) ? String(l) : "", Ne.max = i != null && !isNaN(i) ? String(i) : "", Ne.step = a != null && !isNaN(a) ? String(a) : "", Ne.value = o != null && !isNaN(o) ? String(o) : "";
    let c = u.validity.valid && Ne.validity.valid, s = u.validationMessage || Ne.validationMessage, d = {
      isInvalid: !c,
      validationErrors: s ? [
        s
      ] : [],
      validationDetails: {
        badInput: u.validity.badInput,
        customError: u.validity.customError,
        patternMismatch: u.validity.patternMismatch,
        rangeOverflow: Ne.validity.rangeOverflow,
        rangeUnderflow: Ne.validity.rangeUnderflow,
        stepMismatch: Ne.validity.stepMismatch,
        tooLong: u.validity.tooLong,
        tooShort: u.validity.tooShort,
        typeMismatch: u.validity.typeMismatch,
        valueMissing: u.validity.valueMissing,
        valid: c
      }
    };
    t.updateValidation(d), e === "native" && !Ne.validity.valid && u.setCustomValidity(Ne.validationMessage);
  });
}
function Ev(t, e, n) {
  let { locale: r } = pe();
  return yh({
    ...t,
    value: void 0,
    defaultValue: void 0,
    onChange: void 0,
    validate: void 0,
    // Provide a default aria-label if no other label is provided.
    "aria-label": t["aria-label"] || (t.label || t["aria-labelledby"] ? void 0 : e.colorValue.getChannelName(t.channel, r))
  }, e, n);
}
function fn(t) {
  return _(() => {
    if (typeof t == "string") try {
      return _e(t);
    } catch {
      return;
    }
    return t;
  }, [
    t
  ]);
}
const rl = _e("#000000"), $h = _e("#FFFFFF"), Cv = rl.toHexInt(), Dv = $h.toHexInt();
function wv(t) {
  let { value: e, defaultValue: n, onChange: r } = t, { step: l } = rl.getChannelRange("red"), i = fn(n), [a, o] = Be(fn(e), i, r), [u] = q(a), [c, s] = q(() => (e || n) && a ? a.toString("hex") : ""), d = pn({
    ...t,
    value: a
  }), f = (w) => {
    if (!a || !w) {
      o(w);
      return;
    }
    if (w.toHexInt() !== a.toHexInt()) {
      o(w);
      return;
    }
  }, [h, p] = q(a);
  h !== a && (s(a ? a.toString("hex") : ""), p(a));
  let b = _(() => {
    let w;
    try {
      w = _e(c.startsWith("#") ? c : `#${c}`);
    } catch {
      w = null;
    }
    return w;
  }, [
    c
  ]);
  return {
    ...d,
    validate: (w) => w === "" || !!w.match(/^#?[0-9a-f]{0,6}$/i)?.[0],
    colorValue: a,
    defaultColorValue: i ?? u,
    setColorValue: o,
    inputValue: c,
    setInputValue: s,
    commit: () => {
      if (!c.length) {
        f(null), s(e === void 0 || a === null ? "" : a.toString("hex"));
        return;
      }
      if (b == null) {
        s(a ? a.toString("hex") : "");
        return;
      }
      f(b);
      let w = "";
      a && (w = a.toString("hex")), s(w), d.commitValidation();
    },
    increment: () => {
      let w = Bo(b, l);
      w === a && s(w.toString("hex")), f(w), d.commitValidation();
    },
    incrementToMax: () => f($h),
    decrement: () => {
      let w = Bo(b, -l);
      w === a && s(w.toString("hex")), f(w), d.commitValidation();
    },
    decrementToMin: () => f(rl)
  };
}
function Bo(t, e) {
  let n = t || rl, r = n.toHexInt(), l = Math.min(Math.max(r + e, Cv), Dv);
  if (l !== r) {
    let i = `#${l.toString(16).padStart(6, "0").toUpperCase()}`;
    n = _e(i);
  }
  return n;
}
function vh(t) {
  let { minValue: e, maxValue: n, step: r, formatOptions: l, value: i, defaultValue: a = NaN, onChange: o, locale: u, isDisabled: c, isReadOnly: s, commitBehavior: d = "snap" } = t;
  i === null && (i = NaN);
  let f = G((Z) => r === void 0 || isNaN(r) ? Re(Z, e, n) : Ke(Z, e, n, r), [
    r,
    e,
    n
  ]);
  i !== void 0 && !isNaN(i) && d === "snap" && (i = f(i)), !isNaN(a) && d === "snap" && (a = f(a));
  let [h, p] = Be(i, isNaN(a) ? NaN : a, o), [b] = q(h), [g, y] = q(() => isNaN(h) ? "" : new Wt(u, l).format(h)), $ = _(() => new xc(u, l), [
    u,
    l
  ]), v = _(() => $.getNumberingSystem(g), [
    $,
    g
  ]), E = _(() => new Wt(u, {
    ...l,
    numberingSystem: v
  }), [
    u,
    l,
    v
  ]), S = _(() => E.resolvedOptions(), [
    E
  ]), w = G((Z) => isNaN(Z) || Z === null ? "" : E.format(Z), [
    E
  ]), C = pn({
    ...t,
    value: h
  }), R = r !== void 0 && !isNaN(r) ? r : 1;
  S.style === "percent" && (r === void 0 || isNaN(r)) && (R = 0.01);
  let [I, N] = q(h), [O, A] = q(u), [V, x] = q(l);
  (!Object.is(h, I) || u !== O || !Pv(l, V)) && (y(w(h)), N(h), A(u), x(l));
  let K = _(() => $.parse(g), [
    $,
    g
  ]), D = (Z) => {
    let de = Z === void 0 ? g : Z, ae = K;
    if (Z !== void 0 && (ae = $.parse(de)), !de.length) {
      p(NaN), y(i === void 0 ? "" : w(h));
      return;
    }
    if (isNaN(ae)) {
      y(w(h));
      return;
    }
    let se = d === "snap" ? f(ae) : ae;
    se = $.parse(w(se));
    let Se = se !== h;
    p(se), y(w(i === void 0 ? se : h)), Se && C.commitValidation();
  }, F = (Z, de = 0) => {
    let ae = K;
    if (isNaN(ae)) {
      let se = isNaN(de) ? 0 : de;
      return Ke(se, e, n, R);
    } else {
      let se = Ke(ae, e, n, R);
      return Z === "+" && se > ae || Z === "-" && se < ae ? se : Ke(Ol(Z, ae, R), e, n, R);
    }
  }, M = () => {
    let Z = F("+", e);
    Z === h && y(w(Z)), p(Z), C.commitValidation();
  }, P = () => {
    let Z = F("-", n);
    Z === h && y(w(Z)), p(Z), C.commitValidation();
  }, T = () => {
    n != null && (p(Ke(n, e, n, R)), C.commitValidation());
  }, W = () => {
    e != null && (p(e), C.commitValidation());
  }, U = _(() => !c && !s && (isNaN(K) || n === void 0 || isNaN(n) || Ke(K, e, n, R) > K || Ol("+", K, R) <= n), [
    c,
    s,
    e,
    n,
    R,
    K
  ]), k = _(() => !c && !s && (isNaN(K) || e === void 0 || isNaN(e) || Ke(K, e, n, R) < K || Ol("-", K, R) >= e), [
    c,
    s,
    e,
    n,
    R,
    K
  ]);
  return {
    ...C,
    validate: (Z) => $.isValidPartialNumber(Z, e, n),
    increment: M,
    incrementToMax: T,
    decrement: P,
    decrementToMin: W,
    canIncrement: U,
    canDecrement: k,
    minValue: e,
    maxValue: n,
    numberValue: K,
    defaultNumberValue: isNaN(a) ? b : a,
    setNumberValue: p,
    setInputValue: y,
    inputValue: g,
    commit: D
  };
}
function Pv(t, e) {
  if (t === e) return !0;
  if (!t || !e) return !1;
  let n = Object.keys(t), r = Object.keys(e);
  if (n.length !== r.length) return !1;
  for (let l of n)
    if (e[l] !== t[l]) return !1;
  return !0;
}
function Ol(t, e, n) {
  let r = t === "+" ? e + n : e - n;
  if (e % 1 !== 0 || n % 1 !== 0) {
    const l = e.toString().split("."), i = n.toString().split("."), a = l[1] && l[1].length || 0, o = i[1] && i[1].length || 0, u = Math.pow(10, Math.max(a, o));
    e = Math.round(e * u), n = Math.round(n * u), r = t === "+" ? e + n : e - n, r /= u;
  }
  return r;
}
function Sv(t) {
  let { channel: e, colorSpace: n, locale: r } = t, l = fn(t.value), i = fn(t.defaultValue), [a, o] = Be(l, i ?? null, t.onChange), u = Fo(a, n), [c] = q(a), s = i ?? c, d = Fo(s, n), f = u.getChannelValue(e), h = u.getChannelRange(e), p = _(() => u.getChannelFormatOptions(e), [
    u,
    e
  ]), b = p.style === "percent" && h.maxValue === 100 ? 100 : 1;
  return {
    ...vh({
      locale: r,
      value: a === null ? NaN : f / b,
      defaultValue: s === null ? NaN : d.getChannelValue(e) / b,
      onChange: (y) => {
        Number.isNaN(y) ? o(null) : o(u.withChannelValue(e, y * b));
      },
      minValue: h.minValue / b,
      maxValue: h.maxValue / b,
      step: h.step / b,
      formatOptions: p
    }),
    colorValue: u,
    defaultColorValue: s,
    setColorValue: o
  };
}
function Fo(t, e) {
  let n = fn("#000");
  return _(() => {
    let r = t || n;
    return e && r ? r.toFormat(e) : r;
  }, [
    n,
    t,
    e
  ]);
}
const xh = /* @__PURE__ */ j(null), kv = /* @__PURE__ */ j(null), x6 = /* @__PURE__ */ te(function(e, n) {
  return [e, n] = ie(e, n, xh), e.channel ? /* @__PURE__ */ m.createElement(Bv, {
    ...e,
    channel: e.channel,
    forwardedRef: n
  }) : /* @__PURE__ */ m.createElement(Fv, {
    ...e,
    forwardedRef: n
  });
});
function Bv(t) {
  let { locale: e } = pe(), n = Sv({
    ...t,
    locale: e
  }), r = B(null), [l, i] = Xe(!t["aria-label"] && !t["aria-labelledby"]), { labelProps: a, inputProps: o, descriptionProps: u, errorMessageProps: c, ...s } = Ev({
    ...xt(t),
    label: i,
    validationBehavior: t.validationBehavior ?? "native"
  }, n, r);
  return /* @__PURE__ */ m.createElement(m.Fragment, null, Eh(t, n, t.forwardedRef, o, r, a, l, u, c, s), t.name && /* @__PURE__ */ m.createElement("input", {
    type: "hidden",
    name: t.name,
    form: t.form,
    value: isNaN(n.numberValue) ? "" : n.numberValue
  }));
}
function Fv(t) {
  let e = wv({
    ...t,
    validationBehavior: t.validationBehavior ?? "native"
  }), n = B(null), [r, l] = Xe(!t["aria-label"] && !t["aria-labelledby"]), { labelProps: i, inputProps: a, descriptionProps: o, errorMessageProps: u, ...c } = $v({
    ...xt(t),
    label: l,
    validationBehavior: t.validationBehavior ?? "native"
  }, e, n);
  return Eh(t, e, t.forwardedRef, a, n, i, r, o, u, c);
}
function Eh(t, e, n, r, l, i, a, o, u, c) {
  let s = re({
    ...t,
    values: {
      state: e,
      channel: t.channel || "hex",
      isDisabled: t.isDisabled || !1,
      isInvalid: c.isInvalid || !1,
      isReadOnly: t.isReadOnly || !1,
      isRequired: t.isRequired || !1
    },
    defaultClassName: "react-aria-ColorField"
  }), d = Y(t, {
    global: !0
  });
  return delete d.id, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        kv,
        e
      ],
      [
        wr,
        {
          ...r,
          ref: l
        }
      ],
      [
        ut,
        {
          ...i,
          ref: a
        }
      ],
      [
        Dr,
        {
          role: "presentation",
          isInvalid: c.isInvalid,
          isDisabled: t.isDisabled || !1
        }
      ],
      [
        Qe,
        {
          slots: {
            description: o,
            errorMessage: u
          }
        }
      ],
      [
        Yt,
        c
      ]
    ]
  }, /* @__PURE__ */ m.createElement(X.div, {
    ...d,
    ...s,
    ref: n,
    slot: t.slot || void 0,
    "data-channel": t.channel || "hex",
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": c.isInvalid || void 0,
    "data-readonly": t.isReadOnly || void 0,
    "data-required": t.isRequired || void 0
  }));
}
const ea = /* @__PURE__ */ new WeakMap();
function gi(t, e) {
  let n = ea.get(t);
  if (!n) throw new Error("Unknown slider state");
  return `${n.id}-${e}`;
}
function Tv(t, e, n) {
  let { labelProps: r, fieldProps: l } = Cr(t), i = t.orientation === "vertical";
  ea.set(e, {
    id: r.id ?? l.id,
    "aria-describedby": t["aria-describedby"],
    "aria-details": t["aria-details"]
  });
  let { direction: a } = pe(), { addGlobalListener: o, removeGlobalListener: u } = It();
  const c = B(null), s = a === "rtl", d = B(null), { moveProps: f } = mr({
    onMoveStart() {
      d.current = null;
    },
    onMove({ deltaX: g, deltaY: y }) {
      if (!n.current) return;
      let { height: $, width: v } = n.current.getBoundingClientRect(), E = i ? $ : v;
      d.current == null && c.current != null && (d.current = e.getThumbPercent(c.current) * E);
      let S = i ? y : g;
      if ((i || s) && (S = -S), d.current += S, c.current != null && n.current) {
        const w = Re(d.current / E, 0, 1);
        e.setThumbPercent(c.current, w);
      }
    },
    onMoveEnd() {
      c.current != null && (e.setThumbDragging(c.current, !1), c.current = null);
    }
  });
  let h = B(void 0), p = (g, y, $, v) => {
    if (n.current && !t.isDisabled && e.values.every((E, S) => !e.isThumbDragging(S))) {
      let { height: E, width: S, top: w, left: C } = n.current.getBoundingClientRect(), R = i ? E : S, A = ((i ? v : $) - (i ? w : C)) / R;
      (a === "rtl" || i) && (A = 1 - A);
      let V = e.getPercentValue(A), x, K = e.values.findIndex((D) => V - D < 0);
      if (K === 0)
        x = K;
      else if (K === -1)
        x = e.values.length - 1;
      else {
        let D = e.values[K - 1], F = e.values[K];
        Math.abs(D - V) < Math.abs(F - V) ? x = K - 1 : x = K;
      }
      x >= 0 && e.isThumbEditable(x) ? (g.preventDefault(), c.current = x, e.setFocusedThumb(x), h.current = y, e.setThumbDragging(c.current, !0), e.setThumbValue(x, V), o(window, "mouseup", b, !1), o(window, "touchend", b, !1), o(window, "pointerup", b, !1)) : c.current = null;
    }
  }, b = (g) => {
    (g.pointerId ?? g.changedTouches?.[0].identifier) === h.current && (c.current != null && (e.setThumbDragging(c.current, !1), c.current = null), u(window, "mouseup", b, !1), u(window, "touchend", b, !1), u(window, "pointerup", b, !1));
  };
  return "htmlFor" in r && r.htmlFor && (delete r.htmlFor, r.onClick = () => {
    document.getElementById(gi(e, 0))?.focus(), sr("keyboard");
  }), {
    labelProps: r,
    // The root element of the Slider will have role="group" to group together
    // all the thumb inputs in the Slider.  The label of the Slider will
    // be used to label the group.
    groupProps: {
      role: "group",
      ...l
    },
    trackProps: L({
      onMouseDown(g) {
        g.button !== 0 || g.altKey || g.ctrlKey || g.metaKey || p(g, void 0, g.clientX, g.clientY);
      },
      onPointerDown(g) {
        g.pointerType === "mouse" && (g.button !== 0 || g.altKey || g.ctrlKey || g.metaKey) || p(g, g.pointerId, g.clientX, g.clientY);
      },
      onTouchStart(g) {
        p(g, g.changedTouches[0].identifier, g.changedTouches[0].clientX, g.changedTouches[0].clientY);
      },
      style: {
        position: "relative",
        touchAction: "none"
      }
    }, f),
    outputProps: {
      htmlFor: e.values.map((g, y) => gi(e, y)).join(" "),
      "aria-live": "off"
    }
  };
}
function Av(t, e) {
  let { index: n = 0, isRequired: r, validationState: l, isInvalid: i, trackRef: a, inputRef: o, orientation: u = e.orientation, name: c, form: s } = t, d = t.isDisabled || e.isDisabled, f = u === "vertical", { direction: h } = pe(), { addGlobalListener: p, removeGlobalListener: b } = It(), g = ea.get(e);
  const { labelProps: y, fieldProps: $ } = Cr({
    ...t,
    id: gi(e, n),
    "aria-labelledby": `${g.id} ${t["aria-labelledby"] ?? ""}`.trim()
  }), v = e.values[n], E = G(() => {
    o.current && Pe(o.current);
  }, [
    o
  ]), S = e.focusedThumb === n;
  Q(() => {
    S && E();
  }, [
    S,
    E
  ]);
  let w = h === "rtl", C = B(null), { keyboardProps: R } = Hn({
    onKeyDown(D) {
      let { getThumbMaxValue: F, getThumbMinValue: M, decrementThumb: P, incrementThumb: T, setThumbValue: W, setThumbDragging: U, pageSize: k } = e;
      if (!/^(PageUp|PageDown|Home|End)$/.test(D.key)) {
        D.continuePropagation();
        return;
      }
      switch (D.preventDefault(), U(n, !0), D.key) {
        case "PageUp":
          T(n, k);
          break;
        case "PageDown":
          P(n, k);
          break;
        case "Home":
          W(n, M(n));
          break;
        case "End":
          W(n, F(n));
          break;
      }
      U(n, !1);
    }
  }), { moveProps: I } = mr({
    onMoveStart() {
      C.current = null, e.setThumbDragging(n, !0);
    },
    onMove({ deltaX: D, deltaY: F, pointerType: M, shiftKey: P }) {
      const { getThumbPercent: T, setThumbPercent: W, decrementThumb: U, incrementThumb: k, step: ee, pageSize: Z } = e;
      if (!a.current) return;
      let { width: de, height: ae } = a.current.getBoundingClientRect(), se = f ? ae : de;
      if (C.current == null && (C.current = T(n) * se), M === "keyboard")
        D > 0 && w || D < 0 && !w || F > 0 ? U(n, P ? Z : ee) : k(n, P ? Z : ee);
      else {
        let Se = f ? F : D;
        (f || w) && (Se = -Se), C.current += Se, W(n, Re(C.current / se, 0, 1));
      }
    },
    onMoveEnd() {
      e.setThumbDragging(n, !1);
    }
  });
  e.setThumbEditable(n, !d);
  const { focusableProps: N } = Je(L(t, {
    onFocus: () => e.setFocusedThumb(n),
    onBlur: () => e.setFocusedThumb(void 0)
  }), o);
  let O = B(void 0), A = (D) => {
    E(), O.current = D, e.setThumbDragging(n, !0), p(window, "mouseup", V, !1), p(window, "touchend", V, !1), p(window, "pointerup", V, !1);
  }, V = (D) => {
    (D.pointerId ?? D.changedTouches?.[0].identifier) === O.current && (E(), e.setThumbDragging(n, !1), b(window, "mouseup", V, !1), b(window, "touchend", V, !1), b(window, "pointerup", V, !1));
  }, x = e.getThumbPercent(n);
  (f || h === "rtl") && (x = 1 - x);
  let K = d ? {} : L(R, I, {
    onMouseDown: (D) => {
      D.button !== 0 || D.altKey || D.ctrlKey || D.metaKey || A();
    },
    onPointerDown: (D) => {
      D.button !== 0 || D.altKey || D.ctrlKey || D.metaKey || A(D.pointerId);
    },
    onTouchStart: (D) => {
      A(D.changedTouches[0].identifier);
    }
  });
  return Xt(o, e.defaultValues[n], (D) => {
    e.setThumbValue(n, D);
  }), {
    inputProps: L(N, $, {
      type: "range",
      tabIndex: d ? void 0 : 0,
      min: e.getThumbMinValue(n),
      max: e.getThumbMaxValue(n),
      step: e.step,
      value: v,
      name: c,
      form: s,
      disabled: d,
      "aria-orientation": u,
      "aria-valuetext": e.getThumbValueLabel(n),
      "aria-required": r || void 0,
      "aria-invalid": i || l === "invalid" || void 0,
      "aria-errormessage": t["aria-errormessage"],
      "aria-describedby": [
        g["aria-describedby"],
        t["aria-describedby"]
      ].filter(Boolean).join(" "),
      "aria-details": [
        g["aria-details"],
        t["aria-details"]
      ].filter(Boolean).join(" "),
      onChange: (D) => {
        e.setThumbValue(n, parseFloat(H(D).value));
      }
    }),
    thumbProps: {
      ...K,
      style: {
        position: "absolute",
        [f ? "top" : "left"]: `${x * 100}%`,
        transform: "translate(-50%, -50%)",
        touchAction: "none"
      }
    },
    labelProps: y,
    isDragging: e.isThumbDragging(n),
    isDisabled: d,
    isFocused: S
  };
}
const Iv = 0, Kv = 100, Rv = 1;
function Nv(t) {
  const { isDisabled: e = !1, minValue: n = Iv, maxValue: r = Kv, numberFormatter: l, step: i = Rv, orientation: a = "horizontal" } = t;
  let o = _(() => {
    let k = (r - n) / 10;
    return k = Ke(k, 0, k + i, i), Math.max(k, i);
  }, [
    i,
    r,
    n
  ]), u = G((k) => k?.map((ee, Z) => {
    let de = Z === 0 ? n : k[Z - 1], ae = Z === k.length - 1 ? r : k[Z + 1];
    return Ke(ee, de, ae, i);
  }), [
    n,
    r,
    i
  ]), c = _(() => u(Ao(t.value)), [
    t.value,
    u
  ]), s = _(() => u(Ao(t.defaultValue) ?? [
    n
  ]), [
    t.defaultValue,
    n,
    u
  ]), d = Io(t.value, t.defaultValue, t.onChange), f = Io(t.value, t.defaultValue, t.onChangeEnd);
  const [h, p] = Be(c, s, d);
  let [b] = q(h);
  const [g, y] = q(new Array(h.length).fill(!1)), $ = B(new Array(h.length).fill(!0)), [v, E] = q(void 0), S = B(h), w = B(g);
  let C = (k) => {
    S.current = k, p(k);
  }, R = (k) => {
    w.current = k, y(k);
  };
  function I(k) {
    return (k - n) / (r - n);
  }
  function N(k) {
    return k === 0 ? n : h[k - 1];
  }
  function O(k) {
    return k === h.length - 1 ? r : h[k + 1];
  }
  function A(k) {
    return $.current[k];
  }
  function V(k, ee) {
    $.current[k] = ee;
  }
  function x(k, ee) {
    if (e || !A(k)) return;
    const Z = N(k), de = O(k);
    ee = Ke(ee, Z, de, i);
    let ae = To(S.current, k, ee);
    C(ae);
  }
  function K(k, ee) {
    if (e || !A(k)) return;
    ee && (S.current = h);
    const Z = w.current[k];
    w.current = To(w.current, k, ee), R(w.current), f && Z && !w.current.some(Boolean) && f(S.current);
  }
  let D = B(null);
  function F(k = h) {
    switch (typeof k == "number" && (k = [
      k
    ]), k.length) {
      case 0:
        return "";
      case 1:
        return l.format(k[0]);
      case 2:
        return l.formatRange(k[0], k[1]);
      default: {
        let ee = k.map((de) => l.format(de)), Z = D.current;
        return (!Z || Z.resolvedOptions().locale !== l.resolvedOptions().locale) && (Z = D.current = new Intl.ListFormat(l.resolvedOptions().locale, {
          type: "unit"
        })), Z.format(ee);
      }
    }
  }
  function M(k, ee) {
    x(k, T(ee));
  }
  function P(k) {
    return Math.round((k - n) / i) * i + n;
  }
  function T(k) {
    const ee = k * (r - n) + n;
    return Re(P(ee), n, r);
  }
  function W(k, ee = 1) {
    let Z = Math.max(ee, i);
    x(k, Ke(h[k] + Z, n, r, i));
  }
  function U(k, ee = 1) {
    let Z = Math.max(ee, i);
    x(k, Ke(h[k] - Z, n, r, i));
  }
  return {
    values: h,
    defaultValues: t.defaultValue !== void 0 ? s : b,
    getThumbValue: (k) => h[k],
    setThumbValue: x,
    setThumbPercent: M,
    isThumbDragging: (k) => g[k],
    setThumbDragging: K,
    focusedThumb: v,
    setFocusedThumb: E,
    getThumbPercent: (k) => I(h[k]),
    getValuePercent: I,
    getThumbValueLabel: (k) => F(h[k]),
    getFormattedValue: F,
    getThumbMinValue: N,
    getThumbMaxValue: O,
    getPercentValue: T,
    isThumbEditable: A,
    setThumbEditable: V,
    incrementThumb: W,
    decrementThumb: U,
    step: i,
    pageSize: o,
    orientation: a,
    isDisabled: e
  };
}
function To(t, e, n) {
  return t[e] === n ? t : [
    ...t.slice(0, e),
    n,
    ...t.slice(e + 1)
  ];
}
function Ao(t) {
  if (t != null)
    return Array.isArray(t) ? t : [
      t
    ];
}
function Io(t, e, n) {
  return (r) => {
    n?.(typeof t == "number" || typeof e == "number" ? r[0] : r);
  };
}
const Ch = /* @__PURE__ */ j(null), Dh = /* @__PURE__ */ j(null), Mv = /* @__PURE__ */ j(null), E6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, Dh);
  let r = z(Ch), { onHoverStart: l, onHoverEnd: i, onHoverChange: a, ...o } = e, { hoverProps: u, isHovered: c } = ve({
    onHoverStart: l,
    onHoverEnd: i,
    onHoverChange: a
  }), s = re({
    ...e,
    defaultClassName: "react-aria-SliderTrack",
    values: {
      orientation: r.orientation,
      isDisabled: r.isDisabled,
      isHovered: c,
      state: r
    }
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(o, u),
    ...s,
    ref: n,
    "data-hovered": c || void 0,
    "data-orientation": r.orientation || void 0,
    "data-disabled": r.isDisabled || void 0
  });
});
function Lv(t, e) {
  let { trackRef: n, inputRef: r, orientation: l, channel: i, "aria-label": a, name: o, form: u } = t, { locale: c, direction: s } = pe();
  !t.label && !a && !t["aria-labelledby"] && (a = e.value.getChannelName(i, c));
  let { groupProps: d, trackProps: f, labelProps: h, outputProps: p } = Tv(
    // @ts-ignore - ignore unused incompatible props
    {
      ...t,
      "aria-label": a
    },
    e,
    n
  ), { inputProps: b, thumbProps: g } = Av({
    index: 0,
    orientation: l,
    isDisabled: t.isDisabled,
    name: o,
    form: u,
    trackRef: n,
    inputRef: r
  }, e), y = e.getDisplayColor(), $ = () => {
    let S;
    switch (l === "vertical" ? S = "top" : s === "ltr" ? S = "right" : S = "left", i) {
      case "hue": {
        let w = [
          0,
          60,
          120,
          180,
          240,
          300,
          360
        ].map((C) => y.withChannelValue("hue", C).toString("css")).join(", ");
        return `linear-gradient(to ${S}, ${w})`;
      }
      case "lightness": {
        let w = e.getThumbMinValue(0), C = e.getThumbMaxValue(0), R = y.withChannelValue(i, w).toString("css"), I = y.withChannelValue(i, (C - w) / 2).toString("css"), N = y.withChannelValue(i, C).toString("css");
        return `linear-gradient(to ${S}, ${R}, ${I}, ${N})`;
      }
      case "saturation":
      case "brightness":
      case "red":
      case "green":
      case "blue":
      case "alpha": {
        let w = y.withChannelValue(i, e.getThumbMinValue(0)).toString("css"), C = y.withChannelValue(i, e.getThumbMaxValue(0)).toString("css");
        return `linear-gradient(to ${S}, ${w}, ${C})`;
      }
      default:
        throw new Error("Unknown color channel: " + i);
    }
  }, v = {
    forcedColorAdjust: "none"
  };
  i === "hue" ? b["aria-valuetext"] += `, ${y.getHueName(c)}` : i !== "alpha" && (b["aria-valuetext"] += `, ${y.getColorName(c)}`);
  let { visuallyHiddenProps: E } = qt({
    style: {
      opacity: "0.0001",
      width: "100%",
      height: "100%",
      pointerEvents: "none"
    }
  });
  return {
    trackProps: {
      ...L(d, f),
      style: {
        ...f.style,
        ...v,
        background: $()
      }
    },
    inputProps: {
      ...b,
      style: {
        ...b.style,
        ...E.style
      }
    },
    thumbProps: {
      ...g,
      style: {
        ...g.style,
        ...v
      }
    },
    labelProps: h,
    outputProps: p
  };
}
function zv(t) {
  let { channel: e, colorSpace: n, value: r, defaultValue: l, onChange: i, locale: a, ...o } = t;
  if (r == null && l == null) throw new Error("useColorSliderState requires a value or defaultValue");
  r && (r = An(r)), l && (l = An(l));
  let [u, c] = Be(r, l, i), s = _(() => n && u ? u.toFormat(n) : u, [
    u,
    n
  ]), [d] = q(u), f = l ?? d, h = _(() => n && f ? f.toFormat(n) : f, [
    f,
    n
  ]), p = _(() => new Intl.NumberFormat(), []), b = Nv({
    ...s.getChannelRange(e),
    ...o,
    numberFormatter: p,
    value: s.getChannelValue(e),
    defaultValue: h.getChannelValue(e),
    onChange($) {
      c(s.withChannelValue(e, $));
    },
    onChangeEnd($) {
      t.onChangeEnd && t.onChangeEnd(s.withChannelValue(e, $));
    }
  }), { step: g, pageSize: y } = s.getChannelRange(e);
  return {
    ...b,
    value: s,
    setValue($) {
      c(An($));
    },
    getDisplayColor() {
      switch (e) {
        case "hue":
          return _e(`hsl(${s.getChannelValue("hue")}, 100%, 50%)`);
        case "lightness":
        case "brightness":
        case "saturation":
        case "red":
        case "green":
        case "blue":
          return s.withChannelValue("alpha", 1);
        case "alpha":
          return s;
        default:
          throw new Error("Unknown color channel: " + e);
      }
    },
    getThumbValueLabel() {
      return s.formatChannelValue(e, a);
    },
    getFormattedValue() {
      return s.formatChannelValue(e, a);
    },
    step: g,
    pageSize: y,
    isDragging: b.isThumbDragging(0)
  };
}
const wh = /* @__PURE__ */ j(null), Vv = /* @__PURE__ */ j(null), C6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, wh);
  let { locale: r } = pe(), l = zv({
    ...e,
    locale: r
  }), i = m.useRef(null), a = m.useRef(null), [o, u] = Xe(!e["aria-label"] && !e["aria-labelledby"]), { trackProps: c, thumbProps: s, inputProps: d, labelProps: f, outputProps: h } = Lv({
    ...e,
    label: u,
    trackRef: i,
    inputRef: a
  }, l), p = re({
    ...e,
    values: {
      orientation: l.orientation,
      isDisabled: l.isDisabled,
      state: l
    },
    defaultClassName: "react-aria-ColorSlider"
  }), b = Y(e, {
    global: !0
  });
  return delete b.id, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Vv,
        l
      ],
      [
        Ch,
        l
      ],
      [
        Dh,
        {
          ...c,
          ref: i
        }
      ],
      [
        Mv,
        h
      ],
      [
        ut,
        {
          ...f,
          ref: o,
          children: l.value.getChannelName(e.channel, r)
        }
      ],
      [
        Xi,
        {
          state: l,
          thumbProps: s,
          inputXRef: a,
          xInputProps: d,
          isDisabled: e.isDisabled
        }
      ]
    ]
  }, /* @__PURE__ */ m.createElement(X.div, {
    ...b,
    ...p,
    ref: n,
    slot: e.slot || void 0,
    "data-orientation": l.orientation,
    "data-disabled": l.isDisabled || void 0
  }));
});
function Ov(t) {
  return t && t.__esModule ? t.default : t;
}
function Hv(t) {
  let { color: e, colorName: n } = t, r = e || "#fff0", l = _(() => typeof r == "string" ? _e(r) : r, [
    r
  ]), { locale: i } = pe(), a = Y(t, {
    labelable: !0
  }), o = ke(Ov(Zi), "@react-aria/color"), u = ce(t.id);
  return n || (n = l.getChannelValue("alpha") === 0 ? o.format("transparent") : l.getColorName(i)), {
    colorSwatchProps: {
      ...a,
      role: "img",
      "aria-roledescription": o.format("colorSwatch"),
      "aria-label": [
        n,
        t["aria-label"] || ""
      ].filter(Boolean).join(", "),
      "aria-labelledby": t["aria-labelledby"] ? `${u} ${t["aria-labelledby"]}` : void 0,
      id: u,
      style: {
        backgroundColor: l.toString("css"),
        // @ts-ignore
        forcedColorAdjust: "none"
      }
    },
    color: l || null
  };
}
const ta = /* @__PURE__ */ j(null), D6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, ta);
  let { colorSwatchProps: r, color: l } = Hv(e), i = re({
    ...e,
    defaultClassName: "react-aria-ColorSwatch",
    defaultStyle: r.style,
    values: {
      color: l
    }
  }), a = Y(e, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(a, r, i),
    slot: e.slot || void 0,
    ref: n
  });
});
var Ph = {};
Ph = {
  colorSwatchPicker: "تغييرات الألوان",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "حدد عنصرًا",
  tableResizer: "أداة تغيير الحجم"
};
var Sh = {};
Sh = {
  colorSwatchPicker: "Цветови мостри",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Изберете предмет",
  tableResizer: "Преоразмерител"
};
var kh = {};
kh = {
  colorSwatchPicker: "Vzorky barev",
  dropzoneLabel: "Místo pro přetažení",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Změna velikosti"
};
var Bh = {};
Bh = {
  colorSwatchPicker: "Farveprøver",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vælg et element",
  tableResizer: "Størrelsesændring"
};
var Fh = {};
Fh = {
  colorSwatchPicker: "Farbfelder",
  dropzoneLabel: "Ablegebereich",
  selectPlaceholder: "Element wählen",
  tableResizer: "Größenanpassung"
};
var Th = {};
Th = {
  colorSwatchPicker: "Χρωματικά δείγματα",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Επιλέξτε ένα αντικείμενο",
  tableResizer: "Αλλαγή μεγέθους"
};
var Ah = {};
Ah = {
  selectPlaceholder: "Select an item",
  tableResizer: "Resizer",
  dropzoneLabel: "DropZone",
  colorSwatchPicker: "Color swatches"
};
var Ih = {};
Ih = {
  colorSwatchPicker: "Muestras de colores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Seleccionar un artículo",
  tableResizer: "Cambiador de tamaño"
};
var Kh = {};
Kh = {
  colorSwatchPicker: "Värvinäidised",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valige üksus",
  tableResizer: "Suuruse muutja"
};
var Rh = {};
Rh = {
  colorSwatchPicker: "Värimallit",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valitse kohde",
  tableResizer: "Koon muuttaja"
};
var Nh = {};
Nh = {
  colorSwatchPicker: "Échantillons de couleurs",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Sélectionner un élément",
  tableResizer: "Redimensionneur"
};
var Mh = {};
Mh = {
  colorSwatchPicker: "דוגמיות צבע",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "בחר פריט",
  tableResizer: "שינוי גודל"
};
var Lh = {};
Lh = {
  colorSwatchPicker: "Uzorci boja",
  dropzoneLabel: "Zona spuštanja",
  selectPlaceholder: "Odaberite stavku",
  tableResizer: "Promjena veličine"
};
var zh = {};
zh = {
  colorSwatchPicker: "Színtárak",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Válasszon ki egy elemet",
  tableResizer: "Átméretező"
};
var Vh = {};
Vh = {
  colorSwatchPicker: "Campioni di colore",
  dropzoneLabel: "Zona di rilascio",
  selectPlaceholder: "Seleziona un elemento",
  tableResizer: "Ridimensionamento"
};
var Oh = {};
Oh = {
  colorSwatchPicker: "カラースウォッチ",
  dropzoneLabel: "ドロップゾーン",
  selectPlaceholder: "項目を選択",
  tableResizer: "サイズ変更ツール"
};
var Hh = {};
Hh = {
  colorSwatchPicker: "색상 견본",
  dropzoneLabel: "드롭 영역",
  selectPlaceholder: "항목 선택",
  tableResizer: "크기 조정기"
};
var _h = {};
_h = {
  colorSwatchPicker: "Spalvų pavyzdžiai",
  dropzoneLabel: "„DropZone“",
  selectPlaceholder: "Pasirinkite elementą",
  tableResizer: "Dydžio keitiklis"
};
var Wh = {};
Wh = {
  colorSwatchPicker: "Krāsu paraugi",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izvēlēties vienumu",
  tableResizer: "Izmēra mainītājs"
};
var jh = {};
jh = {
  colorSwatchPicker: "Fargekart",
  dropzoneLabel: "Droppsone",
  selectPlaceholder: "Velg et element",
  tableResizer: "Størrelsesendrer"
};
var Uh = {};
Uh = {
  colorSwatchPicker: "kleurstalen",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecteer een item",
  tableResizer: "Resizer"
};
var Gh = {};
Gh = {
  colorSwatchPicker: "Próbki kolorów",
  dropzoneLabel: "Strefa upuszczania",
  selectPlaceholder: "Wybierz element",
  tableResizer: "Zmiana rozmiaru"
};
var qh = {};
qh = {
  colorSwatchPicker: "Amostras de cores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var Yh = {};
Yh = {
  colorSwatchPicker: "Amostras de cores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var Xh = {};
Xh = {
  colorSwatchPicker: "Specimene de culoare",
  dropzoneLabel: "Zonă de plasare",
  selectPlaceholder: "Selectați un element",
  tableResizer: "Instrument de redimensionare"
};
var Zh = {};
Zh = {
  colorSwatchPicker: "Цветовые образцы",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Выберите элемент",
  tableResizer: "Средство изменения размера"
};
var Jh = {};
Jh = {
  colorSwatchPicker: "Vzorkovníky farieb",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Nástroj na zmenu veľkosti"
};
var Qh = {};
Qh = {
  colorSwatchPicker: "Barvne palete",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izberite element",
  tableResizer: "Spreminjanje velikosti"
};
var ep = {};
ep = {
  colorSwatchPicker: "Uzorci boje",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izaberite stavku",
  tableResizer: "Promena veličine"
};
var tp = {};
tp = {
  colorSwatchPicker: "Färgrutor",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Välj en artikel",
  tableResizer: "Storleksändrare"
};
var np = {};
np = {
  colorSwatchPicker: "Renk örnekleri",
  dropzoneLabel: "Bırakma Bölgesi",
  selectPlaceholder: "Bir öğe seçin",
  tableResizer: "Yeniden boyutlandırıcı"
};
var rp = {};
rp = {
  colorSwatchPicker: "Зразки кольорів",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Виберіть елемент",
  tableResizer: "Засіб змінення розміру"
};
var lp = {};
lp = {
  colorSwatchPicker: "颜色色板",
  dropzoneLabel: "放置区域",
  selectPlaceholder: "选择一个项目",
  tableResizer: "尺寸调整器"
};
var ip = {};
ip = {
  colorSwatchPicker: "色票",
  dropzoneLabel: "放置區",
  selectPlaceholder: "選取項目",
  tableResizer: "大小調整器"
};
var na = {};
na = {
  "ar-AE": Ph,
  "bg-BG": Sh,
  "cs-CZ": kh,
  "da-DK": Bh,
  "de-DE": Fh,
  "el-GR": Th,
  "en-US": Ah,
  "es-ES": Ih,
  "et-EE": Kh,
  "fi-FI": Rh,
  "fr-FR": Nh,
  "he-IL": Mh,
  "hr-HR": Lh,
  "hu-HU": zh,
  "it-IT": Vh,
  "ja-JP": Oh,
  "ko-KR": Hh,
  "lt-LT": _h,
  "lv-LV": Wh,
  "nb-NO": jh,
  "nl-NL": Uh,
  "pl-PL": Gh,
  "pt-BR": qh,
  "pt-PT": Yh,
  "ro-RO": Xh,
  "ru-RU": Zh,
  "sk-SK": Jh,
  "sl-SI": Qh,
  "sr-SP": ep,
  "sv-SE": tp,
  "tr-TR": np,
  "uk-UA": rp,
  "zh-CN": lp,
  "zh-TW": ip
};
const Ct = /* @__PURE__ */ j({}), ra = /* @__PURE__ */ j(null), _v = /* @__PURE__ */ te(function(e, n) {
  let { render: r } = z(ra);
  return /* @__PURE__ */ m.createElement(m.Fragment, null, r(e, n));
});
function la(t, e) {
  let n = t?.renderDropIndicator, r = t?.isVirtualDragging?.(), l = G(
    (i) => {
      if (r || e?.isDropTarget(i)) return n ? n(i) : /* @__PURE__ */ m.createElement(_v, {
        target: i
      });
    },
    // We invalidate whenever the target changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      e?.target,
      r,
      n
    ]
  );
  return t?.useDropIndicator ? l : void 0;
}
function ap(t, e, n) {
  let r = t.focusedKey, l = null;
  if (e?.isVirtualDragging?.() && n?.target?.type === "item" && (l = n.target.key, n.target.dropPosition === "after")) {
    let i = n.collection.getKeyAfter(l), a = null;
    if (i != null) {
      let o = n.collection.getItem(l)?.level ?? 0;
      for (; i != null; ) {
        let u = n.collection.getItem(i);
        if (!u) break;
        if (u.type !== "item") {
          i = n.collection.getKeyAfter(i);
          continue;
        }
        if ((u.level ?? 0) <= o) break;
        a = i, i = n.collection.getKeyAfter(i);
      }
    }
    l = i ?? a ?? l;
  }
  return _(() => new Set([
    r,
    l
  ].filter((i) => i != null)), [
    r,
    l
  ]);
}
const ia = /* @__PURE__ */ j({}), w6 = /* @__PURE__ */ ot(ri, function(e, n) {
  return [e, n] = ie(e, n, ia), /* @__PURE__ */ m.createElement(X.header, {
    className: "react-aria-Header",
    ...e,
    ref: n
  }, e.children);
}), op = /* @__PURE__ */ j(null);
function bn(t) {
  let e = B({});
  return /* @__PURE__ */ m.createElement(op.Provider, {
    value: e
  }, t.children);
}
const Wv = /* @__PURE__ */ te(function(e, n) {
  let { name: r, isVisible: l = !0, children: i, className: a, style: o, render: u, ...c } = e, [s, d] = q(l ? "visible" : "hidden"), f = z(op);
  if (!f) throw new Error("<SharedElement> must be rendered inside a <SharedElementTransition>");
  l && s === "hidden" && d("visible"), n = ge(n), le(() => {
    let p = n.current, b = f.current, g = b[r], y = null;
    if (p && l && g) {
      d("visible");
      let $ = p.getAnimations(), v = g.style.map(([E, S]) => {
        let w = p.style[E];
        if (E === "translate") {
          let C = g.rect, R = p.getBoundingClientRect(), I = C.left - R?.left, N = C.top - R?.top;
          p.style.translate = `${I}px ${N}px`;
        } else p.style[E] = S;
        return [
          E,
          w
        ];
      });
      for (let E of p.getAnimations()) $.includes(E) || E.cancel();
      y = requestAnimationFrame(() => {
        y = null;
        for (let [E, S] of v) p.style[E] = S;
      }), delete b[r];
    } else p && l && !g ? (queueMicrotask(() => Ge(() => d("entering"))), y = requestAnimationFrame(() => {
      y = null, d("visible");
    })) : p && !l && queueMicrotask(() => {
      b[r] ? (delete b[r], Ge(() => d("exiting")), Promise.all(p.getAnimations().map(($) => $.finished)).then(() => d("hidden")).catch(() => {
      })) : d("hidden");
    });
    return () => {
      if (y != null && cancelAnimationFrame(y), p && p.isConnected && !p.hasAttribute("data-exiting")) {
        let $ = window.getComputedStyle(p);
        if ($.transitionProperty !== "none") {
          let v = $.transitionProperty.split(/\s*,\s*/);
          b[r] = {
            rect: p.getBoundingClientRect(),
            style: v.map((E) => [
              E,
              $[E]
            ])
          };
        }
      }
    };
  }, [
    n,
    f,
    r,
    l
  ]);
  let h = re({
    children: i,
    className: a,
    style: o,
    render: u,
    values: {
      isEntering: s === "entering",
      isExiting: s === "exiting"
    }
  });
  return s === "hidden" ? null : /* @__PURE__ */ m.createElement(X.div, {
    ...c,
    ...h,
    ref: n,
    "data-entering": s === "entering" || void 0,
    "data-exiting": s === "exiting" || void 0
  });
}), mn = /* @__PURE__ */ j({
  isSelected: !1
}), P6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, mn);
  let { isSelected: r, ...l } = e;
  return /* @__PURE__ */ m.createElement(Wv, {
    ...l,
    ref: n,
    className: e.className || "react-aria-SelectionIndicator",
    name: "SelectionIndicator",
    isVisible: r
  });
});
function jv(t) {
  let e = Y(t, {
    labelable: !0
  }), n;
  return t.orientation === "vertical" && (n = "vertical"), t.elementType !== "hr" ? {
    separatorProps: {
      ...e,
      role: "separator",
      "aria-orientation": n
    }
  } : {
    separatorProps: e
  };
}
const aa = /* @__PURE__ */ j({}), Ka = class Ka extends Ze {
  filter(e, n) {
    let r = n.getItem(this.prevKey);
    if (r && r.type !== "separator") {
      let l = this.clone();
      return n.addDescendants(l, e), l;
    }
    return null;
  }
};
Ka.type = "separator";
let yi = Ka;
const S6 = /* @__PURE__ */ ot(yi, function(e, n) {
  [e, n] = ie(e, n, aa);
  let { elementType: r, orientation: l, style: i, className: a, slot: o, ...u } = e, c = r || "hr";
  c === "hr" && l === "vertical" && (c = "div");
  let s = X[c], { separatorProps: d } = jv({
    ...u,
    elementType: r,
    orientation: l
  }), f = Y(e, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(s, {
    render: e.render,
    ...L(f, d),
    style: i,
    className: a ?? "react-aria-Separator",
    ref: n,
    slot: o || void 0
  });
}), oa = /* @__PURE__ */ new WeakMap();
function Uv(t) {
  return typeof t == "string" ? t.replace(/\s*/g, "") : "" + t;
}
function Gv(t, e) {
  let n = oa.get(t);
  if (!n) throw new Error("Unknown list");
  return `${n.id}-option-${Uv(e)}`;
}
class qv {
  constructor(e, n, r, l) {
    this._walkerStack = [], this._currentSetFor = /* @__PURE__ */ new Set(), this._acceptNode = (a) => {
      if (a.nodeType === Node.ELEMENT_NODE) {
        const o = a.shadowRoot;
        if (o) {
          const u = this._doc.createTreeWalker(o, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          return this._walkerStack.unshift(u), NodeFilter.FILTER_ACCEPT;
        } else {
          if (typeof this.filter == "function") return this.filter(a);
          if (this.filter?.acceptNode) return this.filter.acceptNode(a);
          if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    }, this._doc = e, this.root = n, this.filter = l ?? null, this.whatToShow = r ?? NodeFilter.SHOW_ALL, this._currentNode = n, this._walkerStack.unshift(e.createTreeWalker(n, r, this._acceptNode));
    const i = n.shadowRoot;
    if (i) {
      const a = this._doc.createTreeWalker(i, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(a);
    }
  }
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(e) {
    if (!ne(this.root, e)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const n = [];
    let r = e, l = e;
    for (this._currentNode = e; r && r !== this.root; ) if (r.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const a = r, o = this._doc.createTreeWalker(a, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      n.push(o), o.currentNode = l, this._currentSetFor.add(o), r = l = a.host;
    } else r = r.parentNode;
    const i = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    n.push(i), i.currentNode = l, this._currentSetFor.add(i), this._walkerStack = n;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let e = this.currentNode, n = this.nextNode();
    return ne(e, n) ? (n && (this.currentNode = n), n) : (this.currentNode = e, null);
  }
  lastChild() {
    let n = this._walkerStack[0].lastChild();
    return n && (this.currentNode = n), n;
  }
  nextNode() {
    const e = this._walkerStack[0].nextNode();
    if (e) {
      if (e.shadowRoot) {
        let r;
        if (typeof this.filter == "function" ? r = this.filter(e) : this.filter?.acceptNode && (r = this.filter.acceptNode(e)), r === NodeFilter.FILTER_ACCEPT)
          return this.currentNode = e, e;
        let l = this.nextNode();
        return l && (this.currentNode = l), l;
      }
      return e && (this.currentNode = e), e;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let n = this.nextNode();
      return n && (this.currentNode = n), n;
    } else return null;
  }
  previousNode() {
    const e = this._walkerStack[0];
    if (e.currentNode === e.root) {
      if (this._currentSetFor.has(e))
        if (this._currentSetFor.delete(e), this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let r = this.previousNode();
          return r && (this.currentNode = r), r;
        } else return null;
      return null;
    }
    const n = e.previousNode();
    if (n) {
      if (n.shadowRoot) {
        let l;
        if (typeof this.filter == "function" ? l = this.filter(n) : this.filter?.acceptNode && (l = this.filter.acceptNode(n)), l === NodeFilter.FILTER_ACCEPT)
          return n && (this.currentNode = n), n;
        let i = this.lastChild();
        return i && (this.currentNode = i), i;
      }
      return n && (this.currentNode = n), n;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let r = this.previousNode();
      return r && (this.currentNode = r), r;
    } else return null;
  }
  /**
  * @deprecated
  */
  nextSibling() {
    return null;
  }
  /**
  * @deprecated
  */
  previousSibling() {
    return null;
  }
  /**
  * @deprecated
  */
  parentNode() {
    return null;
  }
}
function up(t, e, n, r) {
  return Pt() ? new qv(t, e, n, r) : t.createTreeWalker(e, n, r);
}
const Ko = /* @__PURE__ */ m.createContext(null), $i = "react-aria-focus-scope-restore";
let Ee = null;
function vl(t) {
  let { children: e, contain: n, restoreFocus: r, autoFocus: l } = t, i = B(null), a = B(null), o = B([]), { parentNode: u } = z(Ko) || {}, c = _(() => new xi({
    scopeRef: o
  }), [
    o
  ]);
  le(() => {
    let f = u || Fe.root;
    if (Fe.getTreeNode(f.scopeRef) && Ee && !ll(Ee, f.scopeRef)) {
      let h = Fe.getTreeNode(Ee);
      h && (f = h);
    }
    f.addChild(c), Fe.addNode(c);
  }, [
    c,
    u
  ]), le(() => {
    let f = Fe.getTreeNode(o);
    f && (f.contain = !!n);
  }, [
    n
  ]), le(() => {
    let f = i.current?.nextSibling, h = [], p = (b) => b.stopPropagation();
    for (; f && f !== a.current; )
      h.push(f), f.addEventListener($i, p), f = f.nextSibling;
    return o.current = h, () => {
      for (let b of h) b.removeEventListener($i, p);
    };
  }, [
    e
  ]), t0(o, r, n), Jv(o, n), n0(o, r, n), e0(o, l), Q(() => {
    const f = oe(ue(o.current ? o.current[0] : void 0));
    let h = null;
    if (qe(f, o.current)) {
      for (let p of Fe.traverse()) p.scopeRef && qe(f, p.scopeRef.current) && (h = p);
      h === Fe.getTreeNode(o) && (Ee = h.scopeRef);
    }
  }, [
    o
  ]), le(() => () => {
    let f = Fe.getTreeNode(o)?.parent?.scopeRef ?? null;
    (o === Ee || ll(o, Ee)) && (!f || Fe.getTreeNode(f)) && (Ee = f), Fe.removeTreeNode(o);
  }, [
    o
  ]);
  let s = _(() => Yv(o), []), d = _(() => ({
    focusManager: s,
    parentNode: c
  }), [
    c,
    s
  ]);
  return /* @__PURE__ */ m.createElement(Ko.Provider, {
    value: d
  }, /* @__PURE__ */ m.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: i
  }), e, /* @__PURE__ */ m.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: a
  }));
}
function Yv(t) {
  return {
    focusNext(e = {}) {
      let n = t.current, { from: r, tabbable: l, wrap: i, accept: a } = e, o = r || oe(ue(n[0] ?? void 0)), u = n[0].previousElementSibling, c = on(n), s = Ie(c, {
        tabbable: l,
        accept: a
      }, n);
      s.currentNode = qe(o, n) ? o : u;
      let d = s.nextNode();
      return !d && i && (s.currentNode = u, d = s.nextNode()), d && He(d, !0), d;
    },
    focusPrevious(e = {}) {
      let n = t.current, { from: r, tabbable: l, wrap: i, accept: a } = e, o = r || oe(ue(n[0] ?? void 0)), u = n[n.length - 1].nextElementSibling, c = on(n), s = Ie(c, {
        tabbable: l,
        accept: a
      }, n);
      s.currentNode = qe(o, n) ? o : u;
      let d = s.previousNode();
      return !d && i && (s.currentNode = u, d = s.previousNode()), d && He(d, !0), d;
    },
    focusFirst(e = {}) {
      let n = t.current, { tabbable: r, accept: l } = e, i = on(n), a = Ie(i, {
        tabbable: r,
        accept: l
      }, n);
      a.currentNode = n[0].previousElementSibling;
      let o = a.nextNode();
      return o && He(o, !0), o;
    },
    focusLast(e = {}) {
      let n = t.current, { tabbable: r, accept: l } = e, i = on(n), a = Ie(i, {
        tabbable: r,
        accept: l
      }, n);
      a.currentNode = n[n.length - 1].nextElementSibling;
      let o = a.previousNode();
      return o && He(o, !0), o;
    }
  };
}
function on(t) {
  return t[0].parentElement;
}
function rr(t) {
  let e = Fe.getTreeNode(Ee);
  for (; e && e.scopeRef !== t; ) {
    if (e.contain) return !1;
    e = e.parent;
  }
  return !0;
}
function Xv(t) {
  if (!t.form)
    return Array.from(ue(t).querySelectorAll(`input[type="radio"][name="${CSS.escape(t.name)}"]`)).filter((r) => !r.form);
  const e = t.form.elements.namedItem(t.name);
  let n = De(t);
  return e instanceof n.RadioNodeList ? Array.from(e).filter((r) => r instanceof n.HTMLInputElement) : e instanceof n.HTMLInputElement ? [
    e
  ] : [];
}
function Zv(t) {
  if (t.checked) return !0;
  const e = Xv(t);
  return e.length > 0 && !e.some((n) => n.checked);
}
function Jv(t, e) {
  let n = B(void 0), r = B(void 0);
  le(() => {
    let l = t.current;
    if (!e) {
      r.current && (cancelAnimationFrame(r.current), r.current = void 0);
      return;
    }
    const i = ue(l ? l[0] : void 0);
    let a = (c) => {
      if (c.key !== "Tab" || c.altKey || c.ctrlKey || c.metaKey || !rr(t) || c.isComposing) return;
      let s = oe(i), d = t.current;
      if (!d || !qe(s, d)) return;
      let f = on(d), h = Ie(f, {
        tabbable: !0
      }, d);
      if (!s) return;
      h.currentNode = s;
      let p = c.shiftKey ? h.previousNode() : h.nextNode();
      p || (h.currentNode = c.shiftKey ? d[d.length - 1].nextElementSibling : d[0].previousElementSibling, p = c.shiftKey ? h.previousNode() : h.nextNode()), c.preventDefault(), p && (He(p, !0), p instanceof De(p).HTMLInputElement && p.select());
    }, o = (c) => {
      (!Ee || ll(Ee, t)) && qe(H(c), t.current) ? (Ee = t, n.current = H(c)) : rr(t) && !Ot(H(c), t) ? n.current ? n.current.focus() : Ee && Ee.current && vi(Ee.current) : rr(t) && (n.current = H(c));
    }, u = (c) => {
      r.current && cancelAnimationFrame(r.current), r.current = requestAnimationFrame(() => {
        let s = gt(), d = (s === "virtual" || s === null) && _t() && Iu(), f = oe(i);
        if (!d && f && rr(t) && !Ot(f, t)) {
          Ee = t;
          let h = H(c);
          h && h.isConnected ? (n.current = h, n.current?.focus()) : Ee.current && vi(Ee.current);
        }
      });
    };
    return i.addEventListener("keydown", a, !1), i.addEventListener("focusin", o, !1), l?.forEach((c) => c.addEventListener("focusin", o, !1)), l?.forEach((c) => c.addEventListener("focusout", u, !1)), () => {
      i.removeEventListener("keydown", a, !1), i.removeEventListener("focusin", o, !1), l?.forEach((c) => c.removeEventListener("focusin", o, !1)), l?.forEach((c) => c.removeEventListener("focusout", u, !1));
    };
  }, [
    t,
    e
  ]), le(() => () => {
    r.current && cancelAnimationFrame(r.current);
  }, [
    r
  ]);
}
function sp(t) {
  return Ot(t);
}
function qe(t, e) {
  return !t || !e ? !1 : e.some((n) => ne(n, t));
}
function Ot(t, e = null) {
  if (t instanceof Element && t.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: n } of Fe.traverse(Fe.getTreeNode(e)))
    if (n && qe(t, n.current)) return !0;
  return !1;
}
function Qv(t) {
  return Ot(t, Ee);
}
function ll(t, e) {
  let n = Fe.getTreeNode(e)?.parent;
  for (; n; ) {
    if (n.scopeRef === t) return !0;
    n = n.parent;
  }
  return !1;
}
function He(t, e = !1) {
  if (t != null && !e) try {
    Ce(t);
  } catch {
  }
  else if (t != null) try {
    t.focus();
  } catch {
  }
}
function cp(t, e = !0) {
  let n = t[0].previousElementSibling, r = on(t), l = Ie(r, {
    tabbable: e
  }, t);
  l.currentNode = n;
  let i = l.nextNode();
  return e && !i && (r = on(t), l = Ie(r, {
    tabbable: !1
  }, t), l.currentNode = n, i = l.nextNode()), i;
}
function vi(t, e = !0) {
  He(cp(t, e));
}
function e0(t, e) {
  const n = m.useRef(e);
  Q(() => {
    if (n.current) {
      Ee = t;
      const r = ue(t.current ? t.current[0] : void 0);
      !qe(oe(r), Ee.current) && t.current && vi(t.current);
    }
    n.current = !1;
  }, [
    t
  ]);
}
function t0(t, e, n) {
  le(() => {
    if (e || n) return;
    let r = t.current;
    const l = ue(r ? r[0] : void 0);
    let i = (a) => {
      let o = H(a);
      qe(o, t.current) ? Ee = t : sp(o) || (Ee = null);
    };
    return l.addEventListener("focusin", i, !1), r?.forEach((a) => a.addEventListener("focusin", i, !1)), () => {
      l.removeEventListener("focusin", i, !1), r?.forEach((a) => a.removeEventListener("focusin", i, !1));
    };
  }, [
    t,
    e,
    n
  ]);
}
function Ro(t) {
  let e = Fe.getTreeNode(Ee);
  for (; e && e.scopeRef !== t; ) {
    if (e.nodeToRestore) return !1;
    e = e.parent;
  }
  return e?.scopeRef === t;
}
function n0(t, e, n) {
  const r = B(typeof document < "u" ? oe(ue(t.current ? t.current[0] : void 0)) : null);
  le(() => {
    let l = t.current;
    const i = ue(l ? l[0] : void 0);
    if (!e || n) return;
    let a = () => {
      (!Ee || ll(Ee, t)) && qe(oe(i), t.current) && (Ee = t);
    };
    return i.addEventListener("focusin", a, !1), l?.forEach((o) => o.addEventListener("focusin", a, !1)), () => {
      i.removeEventListener("focusin", a, !1), l?.forEach((o) => o.removeEventListener("focusin", a, !1));
    };
  }, [
    t,
    n
  ]), le(() => {
    const l = ue(t.current ? t.current[0] : void 0);
    if (!e) return;
    let i = (a) => {
      if (a.key !== "Tab" || a.altKey || a.ctrlKey || a.metaKey || !rr(t) || a.isComposing) return;
      let o = l.activeElement;
      if (!Ot(o, t) || !Ro(t)) return;
      let u = Fe.getTreeNode(t);
      if (!u) return;
      let c = u.nodeToRestore, s = Ie(l.body, {
        tabbable: !0
      });
      s.currentNode = o;
      let d = a.shiftKey ? s.previousNode() : s.nextNode();
      if ((!c || !c.isConnected || c === l.body) && (c = void 0, u.nodeToRestore = void 0), (!d || !Ot(d, t)) && c) {
        s.currentNode = c;
        do
          d = a.shiftKey ? s.previousNode() : s.nextNode();
        while (Ot(d, t));
        a.preventDefault(), a.stopPropagation(), d ? He(d, !0) : sp(c) ? He(c, !0) : o.blur();
      }
    };
    return n || l.addEventListener("keydown", i, !0), () => {
      n || l.removeEventListener("keydown", i, !0);
    };
  }, [
    t,
    e,
    n
  ]), le(() => {
    const l = ue(t.current ? t.current[0] : void 0);
    if (!e) return;
    let i = Fe.getTreeNode(t);
    if (i)
      return i.nodeToRestore = r.current ?? void 0, () => {
        let a = Fe.getTreeNode(t);
        if (!a) return;
        let o = a.nodeToRestore, u = oe(l);
        if (e && o && (u && Ot(u, t) || u === l.body && Ro(t))) {
          let c = Fe.clone();
          requestAnimationFrame(() => {
            if (l.activeElement === l.body) {
              let s = c.getTreeNode(t);
              for (; s; ) {
                if (s.nodeToRestore && s.nodeToRestore.isConnected) {
                  No(s.nodeToRestore);
                  return;
                }
                s = s.parent;
              }
              for (s = c.getTreeNode(t); s; ) {
                if (s.scopeRef && // TODO: this is probably a false positive based on naming, it's not a real ref, rename.
                // oxlint-disable-next-line react-hooks/exhaustive-deps
                s.scopeRef.current && Fe.getTreeNode(s.scopeRef)) {
                  let d = cp(s.scopeRef.current, !0);
                  No(d);
                  return;
                }
                s = s.parent;
              }
            }
          });
        }
      };
  }, [
    t,
    e
  ]);
}
function No(t) {
  t.dispatchEvent(new CustomEvent($i, {
    bubbles: !0,
    cancelable: !0
  })) && He(t);
}
function Ie(t, e, n) {
  let r = e?.tabbable ? qr : Vi, l = t?.nodeType === Node.ELEMENT_NODE ? t : null, i = ue(l), a = up(i, t || i, NodeFilter.SHOW_ELEMENT, {
    acceptNode(o) {
      return ne(e?.from, o) || e?.tabbable && o.tagName === "INPUT" && o.getAttribute("type") === "radio" && (!Zv(o) || a.currentNode.tagName === "INPUT" && a.currentNode.type === "radio" && a.currentNode.name === o.name) ? NodeFilter.FILTER_REJECT : r(o) && (!n || qe(o, n)) && (!e?.accept || e.accept(o)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return e?.from && (a.currentNode = e.from), a;
}
function r0(t, e = {}) {
  return {
    focusNext(n = {}) {
      let r = t.current;
      if (!r) return null;
      let { from: l, tabbable: i = e.tabbable, wrap: a = e.wrap, accept: o = e.accept } = n, u = l || oe(ue(r)), c = Ie(r, {
        tabbable: i,
        accept: o
      });
      ne(r, u) && (c.currentNode = u);
      let s = c.nextNode();
      return !s && a && (c.currentNode = r, s = c.nextNode()), s && He(s, !0), s;
    },
    focusPrevious(n = e) {
      let r = t.current;
      if (!r) return null;
      let { from: l, tabbable: i = e.tabbable, wrap: a = e.wrap, accept: o = e.accept } = n, u = l || oe(ue(r)), c = Ie(r, {
        tabbable: i,
        accept: o
      });
      if (ne(r, u)) c.currentNode = u;
      else {
        let d = Hl(c);
        return d && He(d, !0), d ?? null;
      }
      let s = c.previousNode();
      if (!s && a) {
        c.currentNode = r;
        let d = Hl(c);
        if (!d)
          return null;
        s = d;
      }
      return s && He(s, !0), s ?? null;
    },
    focusFirst(n = e) {
      let r = t.current;
      if (!r) return null;
      let { tabbable: l = e.tabbable, accept: i = e.accept } = n, o = Ie(r, {
        tabbable: l,
        accept: i
      }).nextNode();
      return o && He(o, !0), o;
    },
    focusLast(n = e) {
      let r = t.current;
      if (!r) return null;
      let { tabbable: l = e.tabbable, accept: i = e.accept } = n, a = Ie(r, {
        tabbable: l,
        accept: i
      }), o = Hl(a);
      return o && He(o, !0), o ?? null;
    }
  };
}
function Hl(t) {
  let e, n;
  do
    n = t.lastChild(), n && (e = n);
  while (n);
  return e;
}
class ua {
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new xi({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(e) {
    return this.fastMap.get(e);
  }
  addTreeNode(e, n, r) {
    let l = this.fastMap.get(n ?? null);
    if (!l) return;
    let i = new xi({
      scopeRef: e
    });
    l.addChild(i), i.parent = l, this.fastMap.set(e, i), r && (i.nodeToRestore = r);
  }
  addNode(e) {
    this.fastMap.set(e.scopeRef, e);
  }
  removeTreeNode(e) {
    if (e === null) return;
    let n = this.fastMap.get(e);
    if (!n) return;
    let r = n.parent;
    for (let i of this.traverse()) i !== n && n.nodeToRestore && i.nodeToRestore && n.scopeRef && n.scopeRef.current && qe(i.nodeToRestore, n.scopeRef.current) && (i.nodeToRestore = n.nodeToRestore);
    let l = n.children;
    r && (r.removeChild(n), l.size > 0 && l.forEach((i) => r && r.addChild(i))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(e = this.root) {
    if (e.scopeRef != null && (yield e), e.children.size > 0) for (let n of e.children) yield* this.traverse(n);
  }
  clone() {
    let e = new ua();
    for (let n of this.traverse()) e.addTreeNode(n.scopeRef, n.parent?.scopeRef ?? null, n.nodeToRestore);
    return e;
  }
}
class xi {
  constructor(e) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = e.scopeRef;
  }
  addChild(e) {
    this.children.add(e), e.parent = this;
  }
  removeChild(e) {
    this.children.delete(e), e.parent = void 0;
  }
}
let Fe = new ua();
function Ei(t) {
  return Cy() ? t.altKey : t.ctrlKey;
}
function un(t, e) {
  let n = `[data-key="${CSS.escape(String(e))}"]`, r = t.current?.dataset.collection;
  return r && (n = `[data-collection="${CSS.escape(r)}"]${n}`), t.current?.querySelector(n);
}
const dp = /* @__PURE__ */ new WeakMap();
function l0(t) {
  let e = ce();
  return dp.set(t, e), e;
}
function i0(t) {
  return dp.get(t);
}
const Mo = 1e3;
function fp(t) {
  let { keyboardDelegate: e, selectionManager: n, onTypeSelect: r } = t, l = B({
    search: "",
    timeout: void 0
  }), i = (o) => {
    if (l.current.search.length > 0 && o.key === " ") {
      if (o.preventDefault(), (!("continuePropagation" in o) || "continuePropagation" in o && !o.isPropagationStopped()) && o.stopPropagation(), l.current.search += " ", e.getKeyForSearch != null) {
        let u = e.getKeyForSearch(l.current.search, n.focusedKey);
        u == null && (u = e.getKeyForSearch(l.current.search)), u != null && (n.setFocusedKey(u), r && r(u));
      }
      clearTimeout(l.current.timeout), l.current.timeout = setTimeout(() => {
        l.current.search = "";
      }, Mo);
    }
  }, a = (o) => {
    let u = a0(o.key);
    if (!(!u || o.ctrlKey || o.metaKey || o.altKey || !ne(o.currentTarget, H(o)) || l.current.search.length === 0 && u === " ")) {
      if (l.current.search += u, e.getKeyForSearch != null) {
        let c = e.getKeyForSearch(l.current.search, n.focusedKey);
        if (c == null && (c = e.getKeyForSearch(l.current.search)), c != null)
          n.setFocusedKey(c), r && r(c), o.preventDefault(), "continuePropagation" in o || o.stopPropagation();
        else {
          l.current.search = "", clearTimeout(l.current.timeout), l.current.timeout = void 0;
          return;
        }
      }
      clearTimeout(l.current.timeout), l.current.timeout = setTimeout(() => {
        l.current.search = "";
      }, Mo);
    }
  };
  return Q(() => {
    let o = l.current.timeout;
    return () => {
      clearTimeout(o);
    };
  }, [
    l
  ]), {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: e.getKeyForSearch ? i : void 0,
      onKeyDown: e.getKeyForSearch ? a : void 0
    }
  };
}
function a0(t) {
  return t.length === 1 || !/^[A-Z]/i.test(t) ? t : "";
}
function Lo(t, e) {
  const n = B(!0), r = B(null);
  le(() => (n.current = !0, () => {
    n.current = !1;
  }), []), le(() => {
    n.current ? n.current = !1 : (!r.current || e.some((l, i) => !Object.is(l, r[i]))) && t(), r.current = e;
  }, e);
}
function sa(t) {
  let { selectionManager: e, keyboardDelegate: n, ref: r, autoFocus: l = !1, shouldFocusWrap: i = !1, disallowEmptySelection: a = !1, disallowSelectAll: o = !1, escapeKeyBehavior: u = "clearSelection", selectOnFocus: c = e.selectionBehavior === "replace", disallowTypeAhead: s = !1, shouldUseVirtualFocus: d, allowsTabNavigation: f = !1, scrollRef: h = r, linkBehavior: p = "action", UNSTABLE_focusOnEntry: b } = t, { direction: g } = pe(), y = Vn(), $ = (D) => {
    if (D.altKey && D.key === "Tab" && D.preventDefault(), !r.current || !ne(r.current, H(D))) return;
    const F = (M, P) => {
      if (M != null) {
        if (e.isLink(M) && p === "selection" && c && !Ei(D)) {
          Ge(() => {
            e.setFocusedKey(M, P);
          });
          let T = un(r, M), W = e.getItemProps(M);
          T && y.open(T, D, W.href, W.routerOptions);
          return;
        }
        if (e.setFocusedKey(M, P), e.isLink(M) && p === "override") return;
        D.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(M) : c && !Ei(D) && e.replaceSelection(M);
      }
    };
    switch (D.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          let M = e.focusedKey != null ? n.getKeyBelow?.(e.focusedKey) : n.getFirstKey?.();
          M == null && i && (M = n.getFirstKey?.(e.focusedKey)), M != null && (D.preventDefault(), F(M));
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          let M = e.focusedKey != null ? n.getKeyAbove?.(e.focusedKey) : n.getLastKey?.();
          M == null && i && (M = n.getLastKey?.(e.focusedKey)), M != null && (D.preventDefault(), F(M));
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          let M = e.focusedKey != null ? n.getKeyLeftOf?.(e.focusedKey) : n.getFirstKey?.();
          M == null && i && (M = g === "rtl" ? n.getFirstKey?.(e.focusedKey) : n.getLastKey?.(e.focusedKey)), M != null && (D.preventDefault(), F(M, g === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          let M = e.focusedKey != null ? n.getKeyRightOf?.(e.focusedKey) : n.getFirstKey?.();
          M == null && i && (M = g === "rtl" ? n.getLastKey?.(e.focusedKey) : n.getFirstKey?.(e.focusedKey)), M != null && (D.preventDefault(), F(M, g === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          if (e.focusedKey === null && D.shiftKey) return;
          D.preventDefault();
          let M = n.getFirstKey(e.focusedKey, ln(D));
          e.setFocusedKey(M), M != null && (ln(D) && D.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(M) : c && e.replaceSelection(M));
        }
        break;
      case "End":
        if (n.getLastKey) {
          if (e.focusedKey === null && D.shiftKey) return;
          D.preventDefault();
          let M = n.getLastKey(e.focusedKey, ln(D));
          e.setFocusedKey(M), M != null && (ln(D) && D.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(M) : c && e.replaceSelection(M));
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow && e.focusedKey != null) {
          let M = n.getKeyPageBelow(e.focusedKey);
          M != null && (D.preventDefault(), F(M));
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove && e.focusedKey != null) {
          let M = n.getKeyPageAbove(e.focusedKey);
          M != null && (D.preventDefault(), F(M));
        }
        break;
      case "a":
        ln(D) && e.selectionMode === "multiple" && o !== !0 && (D.preventDefault(), e.selectAll());
        break;
      case "Escape":
        u === "clearSelection" && !a && e.selectedKeys.size !== 0 && (D.stopPropagation(), D.preventDefault(), e.clearSelection());
        break;
      case "Tab":
        if (!f) {
          if (D.shiftKey) r.current.focus();
          else {
            let M = Ie(r.current, {
              tabbable: !0
            }), P, T;
            do
              T = M.lastChild(), T && (P = T);
            while (T);
            let W = oe();
            P && (!Bt(P) || W && !qr(W)) && Pe(P);
          }
          break;
        }
    }
  }, v = B({
    top: 0,
    left: 0
  });
  Vt(h, "scroll", () => {
    v.current = {
      top: h.current?.scrollTop ?? 0,
      left: h.current?.scrollLeft ?? 0
    };
  });
  let E = (D) => {
    if (e.isFocused) {
      ne(D.currentTarget, H(D)) || e.setFocused(!1);
      return;
    }
    if (!ne(D.currentTarget, H(D))) return;
    let F = gt();
    e.setFocused(!0);
    let M = (P) => {
      P != null && (e.setFocusedKey(P), c && !e.isSelected(P) && e.replaceSelection(P));
    };
    if (b && (F === "keyboard" || F === "virtual"))
      M(b === "first" ? n.getFirstKey?.() : n.getLastKey?.());
    else if (e.focusedKey == null) {
      let P = D.relatedTarget;
      P && D.currentTarget.compareDocumentPosition(P) & Node.DOCUMENT_POSITION_FOLLOWING ? M(e.lastSelectedKey ?? n.getLastKey?.()) : M(e.firstSelectedKey ?? n.getFirstKey?.());
    } else h.current && (h.current.scrollTop = v.current.top, h.current.scrollLeft = v.current.left);
    if (e.focusedKey != null && h.current) {
      let P = un(r, e.focusedKey);
      P instanceof HTMLElement && (!Bt(P) && !d && Pe(P), (F === "keyboard" || b && F === "virtual") && Oe(P, {
        containingElement: r.current
      }));
    }
  }, S = (D) => {
    ne(D.currentTarget, D.relatedTarget) || e.setFocused(!1);
  }, w = B(!1);
  Vt(r, Jl, d ? (D) => {
    let { detail: F } = D;
    D.stopPropagation(), e.setFocused(!0), F?.focusStrategy === "first" && (w.current = !0);
  } : void 0);
  let C = n.getFirstKey?.() ?? null;
  Lo(() => {
    if (w.current)
      if (C == null) {
        let D = oe();
        Mi(r.current), Gr(D, null), e.collection.size > 0 && (w.current = !1);
      } else
        e.setFocusedKey(C), w.current = !1;
  }, [
    C,
    e.collection.size
  ]), Lo(() => {
    e.collection.size > 0 && (w.current = !1);
  }, [
    e.focusedKey
  ]), Vt(r, wu, d ? (D) => {
    D.stopPropagation(), e.setFocused(!1), D.detail?.clearFocusKey && e.setFocusedKey(null);
  } : void 0);
  const R = B(l), I = B(!1);
  Q(() => {
    if (R.current) {
      let D = null;
      l === "first" && (D = n.getFirstKey?.() ?? null), l === "last" && (D = n.getLastKey?.() ?? null);
      let F = e.selectedKeys;
      if (F.size) {
        for (let M of F) if (e.canSelectItem(M)) {
          D = M;
          break;
        }
      }
      e.setFocused(!0), e.setFocusedKey(D), D == null && !d && r.current && Ce(r.current), e.collection.size > 0 && (R.current = !1, I.current = !0);
    }
  });
  let N = B(e.focusedKey), O = B(null);
  Q(() => {
    if (e.isFocused && e.focusedKey != null && (e.focusedKey !== N.current || I.current) && h.current && r.current) {
      let D = gt(), F = un(r, e.focusedKey);
      if (!(F instanceof HTMLElement))
        return;
      (D === "keyboard" || I.current) && (O.current && cancelAnimationFrame(O.current), O.current = requestAnimationFrame(() => {
        h.current && (Wr(h.current, F), D !== "virtual" && Oe(F, {
          containingElement: r.current
        }));
      }));
    }
    !d && e.isFocused && e.focusedKey == null && N.current != null && r.current && Ce(r.current), N.current = e.focusedKey, I.current = !1;
  }), Q(() => () => {
    O.current && cancelAnimationFrame(O.current);
  }, []), Vt(r, "react-aria-focus-scope-restore", (D) => {
    D.preventDefault(), e.setFocused(!0);
  });
  let A = {
    onKeyDown: $,
    onFocus: E,
    onBlur: S,
    onMouseDown(D) {
      h.current === H(D) && D.preventDefault();
    }
  }, { typeSelectProps: V } = fp({
    keyboardDelegate: n,
    selectionManager: e
  });
  s || (A = L(V, A));
  let x;
  d || (x = e.focusedKey == null ? 0 : -1);
  let K = l0(e.collection);
  return {
    collectionProps: L(A, {
      tabIndex: x,
      "data-collection": K
    })
  };
}
class Ci {
  constructor(e) {
    this.ref = e;
  }
  getItemRect(e) {
    let n = this.ref.current;
    if (!n) return null;
    let r = e != null ? un(this.ref, e) : null;
    if (!r) return null;
    let l = n.getBoundingClientRect(), i = r.getBoundingClientRect();
    return {
      x: i.left - l.left - n.clientLeft + n.scrollLeft,
      y: i.top - l.top - n.clientTop + n.scrollTop,
      width: i.width,
      height: i.height
    };
  }
  getContentSize() {
    let e = this.ref.current;
    return {
      width: e?.scrollWidth ?? 0,
      height: e?.scrollHeight ?? 0
    };
  }
  getVisibleRect() {
    let e = this.ref.current;
    return {
      x: e?.scrollLeft ?? 0,
      y: e?.scrollTop ?? 0,
      width: e?.clientWidth ?? 0,
      height: e?.clientHeight ?? 0
    };
  }
}
class Pr {
  constructor(...e) {
    if (e.length === 1) {
      let n = e[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = n.disabledBehavior || "all", this.orientation = n.orientation || "vertical", this.direction = n.direction, this.layout = n.layout || "stack", this.layoutDelegate = n.layoutDelegate || new Ci(n.ref);
    } else
      this.collection = e[0], this.disabledKeys = e[1], this.ref = e[2], this.collator = e[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new Ci(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
  isDisabled(e) {
    return this.disabledBehavior === "all" && (e.props?.isDisabled || this.disabledKeys.has(e.key)) && e.props?.disabledBehavior !== "selection";
  }
  findNextNonDisabled(e, n, r = !1) {
    let l = e;
    for (; l != null; ) {
      let i = this.collection.getItem(l);
      if (i?.type === "item" && (r || !this.isDisabled(i))) return l;
      l = n(l);
    }
    return null;
  }
  getNextKey(e, n) {
    let r = e;
    return r = this.collection.getKeyAfter(r), this.findNextNonDisabled(r, (l) => this.collection.getKeyAfter(l), n?.includeDisabled);
  }
  getPreviousKey(e, n) {
    let r = e;
    return r = this.collection.getKeyBefore(r), this.findNextNonDisabled(r, (l) => this.collection.getKeyBefore(l), n?.includeDisabled);
  }
  findKey(e, n, r) {
    let l = e, i = this.layoutDelegate.getItemRect(l);
    if (!i || l == null) return null;
    let a = i;
    do {
      if (l = n(l), l == null) break;
      i = this.layoutDelegate.getItemRect(l);
    } while (i && r(a, i) && l != null);
    return l;
  }
  isSameRow(e, n) {
    return e.y === n.y || e.x !== n.x;
  }
  isSameColumn(e, n) {
    return e.x === n.x || e.y !== n.y;
  }
  // checks to see if the next/prev key is spatially above/below the current key. If not, that means we are in
  // a reversed column layout and need to adjust appropriately
  // TODO: still need to see how this works with virtualizer once there is handling for the reverse layout
  // this felt like a simpler approach then changing getKeyAbove/Below to be purely spatial calculations
  isReversed(e) {
    let n = this.getNextKey(e), r = un(this.ref, e);
    if (n != null) {
      let i = un(this.ref, n);
      return !r || !i ? !1 : r.getBoundingClientRect().top > i.getBoundingClientRect().top;
    }
    let l = this.getPreviousKey(e);
    if (l != null) {
      let i = un(this.ref, l);
      return !r || !i ? !1 : i.getBoundingClientRect().top > r.getBoundingClientRect().top;
    }
    return !1;
  }
  getKeyBelow(e, n) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (r) => this.getNextKey(r, n), this.isSameRow) : this.orientation === "vertical" ? this.isReversed(e) ? this.getPreviousKey(e, n) : this.getNextKey(e, n) : this.getNextKey(e, n);
  }
  getKeyAbove(e, n) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (r) => this.getPreviousKey(r, n), this.isSameRow) : this.orientation === "vertical" ? this.isReversed(e) ? this.getNextKey(e, n) : this.getPreviousKey(e, n) : this.getPreviousKey(e, n);
  }
  getNextColumn(e, n, r) {
    return n ? this.getPreviousKey(e, r) : this.getNextKey(e, r);
  }
  getKeyRightOf(e, n) {
    let r = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[r] ? (e = this.layoutDelegate[r](e), this.findNextNonDisabled(e, (l) => this.layoutDelegate[r](l), n?.includeDisabled)) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "rtl", n) : this.findKey(e, (l) => this.getNextColumn(l, this.direction === "rtl", n), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "rtl", n) : null;
  }
  getKeyLeftOf(e, n) {
    let r = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[r] ? (e = this.layoutDelegate[r](e), this.findNextNonDisabled(e, (l) => this.layoutDelegate[r](l), n?.includeDisabled)) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "ltr", n) : this.findKey(e, (l) => this.getNextColumn(l, this.direction === "ltr", n), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "ltr", n) : null;
  }
  getFirstKey() {
    let e = this.collection.getFirstKey();
    return this.findNextNonDisabled(e, (n) => this.collection.getKeyAfter(n));
  }
  getLastKey() {
    let e = this.collection.getLastKey();
    return this.findNextNonDisabled(e, (n) => this.collection.getKeyBefore(n));
  }
  getKeyPageAbove(e) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(e);
    if (!r) return null;
    let l = this.isReversed(e);
    if (n && !jt(n)) return this.getFirstKey();
    let i = e;
    if (this.orientation === "horizontal") {
      let a = Math.max(0, r.x + r.width - this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x > a && i != null; )
        i = this.getKeyAbove(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    } else {
      let a = this.layoutDelegate.getVisibleRect(), o = l ? r.y - a.height : Math.max(0, r.y + r.height - a.height);
      for (; r && r.y > o && i != null; )
        i = this.getKeyAbove(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    }
    return i ?? (l ? this.getLastKey() : this.getFirstKey());
  }
  getKeyPageBelow(e) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(e);
    if (!r) return null;
    let l = this.isReversed(e);
    if (n && !jt(n)) return this.getLastKey();
    let i = e;
    if (this.orientation === "horizontal") {
      let a = Math.min(this.layoutDelegate.getContentSize().width, r.x - r.width + this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x < a && i != null; )
        i = this.getKeyBelow(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    } else {
      let a = Math.min(this.layoutDelegate.getContentSize().height, r.y - r.height + this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y < a && i != null; )
        i = this.getKeyBelow(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    }
    return i ?? (l ? this.getFirstKey() : this.getLastKey());
  }
  getKeyForSearch(e, n) {
    if (!this.collator) return null;
    let r = this.collection, l = n || this.getFirstKey();
    for (; l != null; ) {
      let i = r.getItem(l);
      if (!i) return null;
      let a = i.textValue.slice(0, e.length);
      if (i.textValue && this.collator.compare(a, e) === 0) return l;
      l = this.getNextKey(l);
    }
    return null;
  }
}
let _l = /* @__PURE__ */ new Map();
function jn(t) {
  let { locale: e } = pe(), n = e + (t ? Object.entries(t).sort((l, i) => l[0] < i[0] ? -1 : 1).join() : "");
  if (_l.has(n)) return _l.get(n);
  let r = new Intl.Collator(e, t);
  return _l.set(n, r), r;
}
function ca(t) {
  let { selectionManager: e, collection: n, disabledKeys: r, ref: l, keyboardDelegate: i, layoutDelegate: a, orientation: o } = t, u = jn({
    usage: "search",
    sensitivity: "base"
  }), c = e.disabledBehavior, s = _(() => i || new Pr({
    collection: n,
    disabledKeys: r,
    disabledBehavior: c,
    ref: l,
    collator: u,
    layoutDelegate: a,
    orientation: o
  }), [
    i,
    a,
    n,
    r,
    l,
    u,
    c,
    o
  ]), { collectionProps: d } = sa({
    ...t,
    ref: l,
    selectionManager: e,
    keyboardDelegate: s
  });
  return {
    listProps: d
  };
}
function o0(t, e, n) {
  let r = Y(t, {
    labelable: !0
  }), l = t.selectionBehavior || "toggle", i = t.orientation || "vertical", a = t.linkBehavior || (l === "replace" ? "action" : "override");
  l === "toggle" && a === "action" && (a = "override");
  let { listProps: o } = ca({
    ...t,
    ref: n,
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    linkBehavior: a
  }), { focusWithinProps: u } = Et({
    onFocusWithin: t.onFocus,
    onBlurWithin: t.onBlur,
    onFocusWithinChange: t.onFocusChange
  }), c = ce(t.id);
  oa.set(e, {
    id: c,
    shouldUseVirtualFocus: t.shouldUseVirtualFocus,
    shouldSelectOnPressUp: t.shouldSelectOnPressUp,
    shouldFocusOnHover: t.shouldFocusOnHover,
    isVirtualized: t.isVirtualized,
    onAction: t.onAction,
    linkBehavior: a,
    // @ts-ignore
    UNSTABLE_itemBehavior: t.UNSTABLE_itemBehavior
  });
  let { labelProps: s, fieldProps: d } = Cr({
    ...t,
    id: c,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: s,
    listBoxProps: L(r, u, e.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      "aria-orientation": i,
      ...L(d, o)
    })
  };
}
const u0 = 500;
function hp(t) {
  let { isDisabled: e, onLongPressStart: n, onLongPressEnd: r, onLongPress: l, threshold: i = u0, accessibilityDescription: a } = t;
  const o = B(void 0);
  let { addGlobalListener: u, removeGlobalListener: c } = It(), { pressProps: s } = lt({
    isDisabled: e,
    onPressStart(f) {
      if (f.continuePropagation(), (f.pointerType === "mouse" || f.pointerType === "touch") && (n && n({
        ...f,
        type: "longpressstart"
      }), o.current = setTimeout(() => {
        f.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), ue(f.target).activeElement !== f.target && Pe(f.target), l && l({
          ...f,
          type: "longpress"
        }), o.current = void 0;
      }, i), f.pointerType === "touch")) {
        let h = (b) => {
          b.preventDefault();
        }, p = De(f.target);
        u(f.target, "contextmenu", h, {
          once: !0
        }), u(p, "pointerup", () => {
          setTimeout(() => {
            c(f.target, "contextmenu", h);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(f) {
      o.current && clearTimeout(o.current), r && (f.pointerType === "mouse" || f.pointerType === "touch") && r({
        ...f,
        type: "longpressend"
      });
    }
  }), d = _n(l && !e ? a : void 0);
  return {
    longPressProps: L(s, d)
  };
}
function Un(t) {
  let { id: e, selectionManager: n, key: r, ref: l, shouldSelectOnPressUp: i, shouldUseVirtualFocus: a, focus: o, isDisabled: u, onAction: c, allowsDifferentPressOrigin: s, linkBehavior: d = "action" } = t, f = Vn();
  e = ce(e);
  let h = (T) => {
    if (T.pointerType === "keyboard" && Ei(T)) n.toggleSelection(r);
    else {
      if (n.selectionMode === "none") return;
      if (n.isLink(r)) {
        if (d === "selection" && l.current) {
          let W = n.getItemProps(r);
          f.open(l.current, T, W.href, W.routerOptions), n.setSelectedKeys(n.selectedKeys);
          return;
        } else if (d === "override" || d === "none") return;
      }
      n.selectionMode === "single" ? n.isSelected(r) && !n.disallowEmptySelection ? n.toggleSelection(r) : n.replaceSelection(r) : T && T.shiftKey ? n.extendSelection(r) : n.selectionBehavior === "toggle" || T && (ln(T) || T.pointerType === "touch" || T.pointerType === "virtual") ? n.toggleSelection(r) : n.replaceSelection(r);
    }
  };
  Q(() => {
    r === n.focusedKey && n.isFocused && (a ? Mi(l.current) : o ? o() : oe() !== l.current && l.current && Ce(l.current));
  }, [
    l,
    r,
    n.focusedKey,
    n.childFocusStrategy,
    n.isFocused,
    a
  ]), u = u || n.isDisabled(r);
  let p = {};
  !a && !u ? p = {
    tabIndex: r === n.focusedKey ? 0 : -1,
    onFocus(T) {
      H(T) === l.current && n.setFocusedKey(r);
    }
  } : u && (p.onMouseDown = (T) => {
    T.preventDefault();
  }), Q(() => {
    u && n.focusedKey === r && n.setFocusedKey(null);
  }, [
    n,
    u,
    r
  ]);
  let b = n.isLink(r) && d === "override", g = c && t.UNSTABLE_itemBehavior === "action", y = n.isLink(r) && d !== "selection" && d !== "none", $ = !u && n.canSelectItem(r) && !b && !g, v = (c || y) && !u, E = v && (n.selectionBehavior === "replace" ? !$ : !$ || n.isEmpty), S = v && $ && n.selectionBehavior === "replace", w = E || S, C = B(null), R = w && $, I = B(!1), N = B(!1), O = n.getItemProps(r), A = (T) => {
    c && (c(), l.current?.dispatchEvent(new CustomEvent("react-aria-item-action", {
      bubbles: !0
    }))), y && l.current && f.open(l.current, T, O.href, O.routerOptions);
  }, V = {
    ref: l
  };
  if (i ? (V.onPressStart = (T) => {
    C.current = T.pointerType, I.current = R, T.pointerType === "keyboard" && (!w || Vo(T.key)) && h(T);
  }, s ? (V.onPressUp = E ? void 0 : (T) => {
    T.pointerType === "mouse" && $ && h(T);
  }, V.onPress = E ? A : (T) => {
    T.pointerType !== "keyboard" && T.pointerType !== "mouse" && $ && h(T);
  }) : V.onPress = (T) => {
    if (E || S && T.pointerType !== "mouse") {
      if (T.pointerType === "keyboard" && !zo(T.key)) return;
      A(T);
    } else T.pointerType !== "keyboard" && $ && h(T);
  }) : (V.onPressStart = (T) => {
    C.current = T.pointerType, I.current = R, N.current = E, $ && (T.pointerType === "mouse" && !E || T.pointerType === "keyboard" && (!v || Vo(T.key))) && h(T);
  }, V.onPress = (T) => {
    (T.pointerType === "touch" || T.pointerType === "pen" || T.pointerType === "virtual" || T.pointerType === "keyboard" && w && zo(T.key) || T.pointerType === "mouse" && N.current) && (w ? A(T) : $ && h(T));
  }), p["data-collection"] = i0(n.collection), p["data-key"] = r, V.preventFocusOnPress = a, a && (V = L(V, {
    onPressStart(T) {
      T.pointerType !== "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    },
    onPress(T) {
      T.pointerType === "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    }
  })), O)
    for (let T of [
      "onPressStart",
      "onPressEnd",
      "onPressChange",
      "onPress",
      "onPressUp",
      "onClick"
    ]) O[T] && (V[T] = Ye(V[T], O[T]));
  let { pressProps: x, isPressed: K } = lt(V), D = S ? (T) => {
    C.current === "mouse" && (T.stopPropagation(), T.preventDefault(), A(T));
  } : void 0, { longPressProps: F } = hp({
    isDisabled: !R,
    onLongPress(T) {
      T.pointerType === "touch" && (h(T), n.setSelectionBehavior("toggle"));
    }
  }), M = (T) => {
    C.current === "touch" && I.current && T.preventDefault();
  }, P = d !== "none" && n.isLink(r) ? (T) => {
    $t.isOpening || T.preventDefault();
  } : void 0;
  return {
    itemProps: L(
      p,
      $ || E || a && !u ? x : {},
      R ? F : {},
      {
        onDoubleClick: D,
        onDragStartCapture: M,
        onClick: P,
        id: e
      },
      // Prevent DOM focus from moving on mouse down when using virtual focus
      a ? {
        onMouseDown: (T) => T.preventDefault()
      } : void 0
    ),
    isPressed: K,
    isSelected: n.isSelected(r),
    isFocused: n.isFocused && n.focusedKey === r,
    isDisabled: u,
    allowsSelection: $,
    hasAction: w
  };
}
function zo(t) {
  return t === "Enter";
}
function Vo(t) {
  return t === " ";
}
function Te(t, e) {
  return typeof e.getChildren == "function" ? e.getChildren(t.key) : t.childNodes;
}
function St(t) {
  return lr(t, 0);
}
function lr(t, e) {
  if (e < 0) return;
  let n = 0;
  for (let r of t) {
    if (n === e) return r;
    n++;
  }
}
function Pn(t) {
  let e;
  for (let n of t) e = n;
  return e;
}
function Wl(t, e, n) {
  if (e.parentKey === n.parentKey) return e.index - n.index;
  let r = [
    ...Oo(t, e),
    e
  ], l = [
    ...Oo(t, n),
    n
  ], i = r.slice(0, l.length).findIndex((a, o) => a !== l[o]);
  return i !== -1 ? (e = r[i], n = l[i], e.index - n.index) : r.findIndex((a) => a === n) >= 0 ? 1 : (l.findIndex((a) => a === e) >= 0, -1);
}
function Oo(t, e) {
  let n = [], r = e;
  for (; r?.parentKey != null; )
    r = t.getItem(r.parentKey), r && n.unshift(r);
  return n;
}
const Ho = /* @__PURE__ */ new WeakMap();
function pp(t) {
  let e = Ho.get(t);
  if (e != null) return e;
  let n = 0, r = (l) => {
    for (let i of l)
      i.type === "section" ? r(Te(i, t)) : i.type === "item" && n++;
  };
  return r(t), Ho.set(t, n), n;
}
function s0(t, e, n) {
  let { key: r } = t, l = oa.get(e), i = t.isDisabled ?? e.selectionManager.isDisabled(r), a = t.isSelected ?? e.selectionManager.isSelected(r), o = t.shouldSelectOnPressUp ?? l?.shouldSelectOnPressUp, u = t.shouldFocusOnHover ?? l?.shouldFocusOnHover, c = t.shouldUseVirtualFocus ?? l?.shouldUseVirtualFocus, s = t.isVirtualized ?? l?.isVirtualized, d = mt(), f = mt(), h = {
    role: "option",
    "aria-disabled": i || void 0,
    "aria-selected": e.selectionManager.selectionMode !== "none" ? a : void 0,
    "aria-label": t["aria-label"],
    "aria-labelledby": d,
    "aria-describedby": f
  }, p = e.collection.getItem(r);
  if (s) {
    let I = Number(p?.index);
    h["aria-posinset"] = Number.isNaN(I) ? void 0 : I + 1, h["aria-setsize"] = pp(e.collection);
  }
  let b = l?.onAction ? () => l?.onAction?.(r) : void 0, g = Gv(e, r), { itemProps: y, isPressed: $, isFocused: v, hasAction: E, allowsSelection: S } = Un({
    selectionManager: e.selectionManager,
    key: r,
    ref: n,
    shouldSelectOnPressUp: o,
    allowsDifferentPressOrigin: o && u,
    isVirtualized: s,
    shouldUseVirtualFocus: c,
    isDisabled: i,
    onAction: b || p?.props?.onAction ? Ye(p?.props?.onAction, b) : void 0,
    linkBehavior: l?.linkBehavior,
    // @ts-ignore
    UNSTABLE_itemBehavior: l?.UNSTABLE_itemBehavior,
    id: g
  }), { hoverProps: w } = ve({
    isDisabled: i || !u,
    onHoverStart() {
      vt() || (e.selectionManager.setFocused(!0), e.selectionManager.setFocusedKey(r));
    }
  }), C = Y(p?.props);
  delete C.id;
  let R = fl(p?.props);
  return {
    optionProps: {
      ...h,
      ...L(C, y, w, R),
      id: g
    },
    labelProps: {
      id: d
    },
    descriptionProps: {
      id: f
    },
    isFocused: v,
    isFocusVisible: v && e.selectionManager.isFocused && vt(),
    isSelected: a,
    isDisabled: i,
    isPressed: $,
    allowsSelection: S,
    hasAction: E
  };
}
function c0(t) {
  let { heading: e, "aria-label": n } = t, r = ce();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: e ? {
      // Technically, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: r,
      role: "presentation",
      onMouseDown: (l) => {
        l.preventDefault();
      }
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": e ? r : void 0
    }
  };
}
function il(t) {
  const e = Xg.split(".");
  return parseInt(e[0], 10) >= 19 ? t : t ? "true" : void 0;
}
class _o {
  constructor(e) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e;
    let n = (a) => {
      if (this.keyMap.set(a.key, a), a.childNodes && a.type === "section") for (let o of a.childNodes) n(o);
    };
    for (let a of e) n(a);
    let r = null, l = 0, i = 0;
    for (let [a, o] of this.keyMap)
      r ? (r.nextKey = a, o.prevKey = r.key) : (this.firstKey = a, o.prevKey = void 0), o.type === "item" && (o.index = l++), (o.type === "section" || o.type === "item") && i++, r = o, r.nextKey = void 0;
    this._size = i, this.lastKey = r?.key ?? null;
  }
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let n = this.keyMap.get(e);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(e) {
    let n = this.keyMap.get(e);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    return this.keyMap.get(e) ?? null;
  }
  at(e) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[e]);
  }
  getChildren(e) {
    return this.keyMap.get(e)?.childNodes || [];
  }
}
class tt extends Set {
  constructor(e, n, r) {
    super(e), e instanceof tt ? (this.anchorKey = n ?? e.anchorKey, this.currentKey = r ?? e.currentKey) : (this.anchorKey = n ?? null, this.currentKey = r ?? null);
  }
}
function d0(t, e) {
  if (t.size !== e.size) return !1;
  for (let n of t)
    if (!e.has(n)) return !1;
  return !0;
}
function Sr(t) {
  let { selectionMode: e = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: r, selectionBehavior: l = "toggle", disabledBehavior: i = "all" } = t, a = B(!1), [, o] = q(!1), u = B(null), c = B(null), [, s] = q(null), d = _(() => Wo(t.selectedKeys), [
    t.selectedKeys
  ]), f = _(() => Wo(t.defaultSelectedKeys, new tt()), [
    t.defaultSelectedKeys
  ]), [h, p] = Be(d, f, t.onSelectionChange), b = _(() => t.disabledKeys ? new Set(t.disabledKeys) : /* @__PURE__ */ new Set(), [
    t.disabledKeys
  ]), [g, y] = q(l);
  l === "replace" && g === "toggle" && typeof h == "object" && h.size === 0 && y("replace");
  let $ = B(l);
  return Q(() => {
    l !== $.current && (y(l), $.current = l);
  }, [
    l
  ]), {
    selectionMode: e,
    disallowEmptySelection: n,
    selectionBehavior: g,
    setSelectionBehavior: y,
    get isFocused() {
      return a.current;
    },
    setFocused(v) {
      a.current = v, o(v);
    },
    get focusedKey() {
      return u.current;
    },
    get childFocusStrategy() {
      return c.current;
    },
    setFocusedKey(v, E = "first") {
      u.current = v, c.current = E, s(v);
    },
    selectedKeys: h,
    setSelectedKeys(v) {
      (r || !d0(v, h)) && p(v);
    },
    disabledKeys: b,
    disabledBehavior: i
  };
}
function Wo(t, e) {
  return t ? t === "all" ? "all" : new tt(t) : e;
}
class Gn {
  constructor(e, n, r) {
    this.collection = e, this.state = n, this.allowsCellSelection = r?.allowsCellSelection ?? !1, this._isSelectAll = null, this.layoutDelegate = r?.layoutDelegate || null, this.fullCollection = r?.fullCollection || null;
  }
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(e) {
    this.state.setSelectionBehavior(e);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(e) {
    this.state.setFocused(e);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(e, n) {
    (e == null || this.collection.getItem(e)) && this.state.setFocusedKey(e, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(e) {
    if (this.state.selectionMode === "none") return !1;
    let n = this.getKey(e);
    return n == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(n) : this.state.selectedKeys.has(n);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let e = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = e.every((r) => n.has(r)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let e = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!e || r && Wl(this.collection, r, e) < 0) && (e = r);
    }
    return e?.key ?? null;
  }
  get lastSelectedKey() {
    let e = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!e || r && Wl(this.collection, r, e) > 0) && (e = r);
    }
    return e?.key ?? null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(e);
      return;
    }
    let n = this.getKey(e);
    if (n == null) return;
    let r;
    if (this.state.selectedKeys === "all") r = new tt([
      n
    ], n, n);
    else {
      let l = this.state.selectedKeys, i = l.anchorKey ?? n;
      r = new tt(l, i, n);
      for (let a of this.getKeyRange(i, l.currentKey ?? n)) r.delete(a);
      for (let a of this.getKeyRange(n, i)) this.canSelectItem(a) && r.add(a);
    }
    this.state.setSelectedKeys(r);
  }
  getKeyRange(e, n) {
    let r = this.collection.getItem(e), l = this.collection.getItem(n);
    return r && l ? Wl(this.collection, r, l) <= 0 ? this.getKeyRangeInternal(e, n) : this.getKeyRangeInternal(n, e) : [];
  }
  getKeyRangeInternal(e, n) {
    if (this.layoutDelegate?.getKeyRange) return this.layoutDelegate.getKeyRange(e, n);
    let r = [], l = e;
    for (; l != null; ) {
      let i = this.collection.getItem(l);
      if (i && (i.type === "item" || i.type === "cell" && this.allowsCellSelection) && r.push(l), l === n) return r;
      l = this.collection.getKeyAfter(l);
    }
    return [];
  }
  getKey(e) {
    let n = this.collection.getItem(e);
    if (!n || n.type === "cell" && this.allowsCellSelection) return e;
    for (; n && n.type !== "item" && n.parentKey != null; ) n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(e)) {
      this.replaceSelection(e);
      return;
    }
    let n = this.getKey(e);
    if (n == null) return;
    let r = new tt(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    r.has(n) ? r.delete(n) : this.canSelectItem(n) && (r.add(n), r.anchorKey = n, r.currentKey = n), !(this.disallowEmptySelection && r.size === 0) && this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(e) {
    if (this.selectionMode === "none") return;
    let n = this.getKey(e);
    if (n == null) return;
    let r = this.canSelectItem(n) ? new tt([
      n
    ], n, n) : new tt();
    this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(e) {
    if (this.selectionMode === "none") return;
    let n = new tt();
    for (let r of e) {
      let l = this.getKey(r);
      if (l != null && (n.add(l), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let e = this.fullCollection ?? this.collection, n = [], r = (l) => {
      for (; l != null; ) {
        if (this.canSelectItemIn(l, e)) {
          let i = e.getItem(l);
          i?.type === "item" && n.push(l), i?.hasChildNodes && (this.allowsCellSelection || i.type !== "item") && r(St(Te(i, e))?.key ?? null);
        }
        l = e.getKeyAfter(l);
      }
    };
    return r(e.getFirstKey()), n;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new tt());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(e, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(e) && !this.disallowEmptySelection ? this.toggleSelection(e) : this.replaceSelection(e) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(e) : this.replaceSelection(e));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(e) {
    if (e === this.state.selectedKeys) return !0;
    let n = this.selectedKeys;
    if (e.size !== n.size) return !1;
    for (let r of e)
      if (!n.has(r)) return !1;
    for (let r of n)
      if (!e.has(r)) return !1;
    return !0;
  }
  canSelectItem(e) {
    return this.canSelectItemIn(e, this.collection);
  }
  canSelectItemIn(e, n) {
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(e)) return !1;
    let r = n.getItem(e);
    return !(!r || r?.props?.isDisabled || r.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(e) {
    let n = this.collection.getItem(e);
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(e) || !!n?.props?.isDisabled) && n?.props?.disabledBehavior !== "selection";
  }
  isLink(e) {
    return !!this.collection.getItem(e)?.props?.href;
  }
  getItemProps(e) {
    return this.collection.getItem(e)?.props;
  }
  withCollection(e) {
    return new Gn(e, this.state, {
      allowsCellSelection: this.allowsCellSelection,
      layoutDelegate: this.layoutDelegate || void 0,
      fullCollection: this.fullCollection ?? this.collection
    });
  }
}
class f0 {
  build(e, n) {
    return this.context = n, jo(() => this.iterateCollection(e));
  }
  *iterateCollection(e) {
    let { children: n, items: r } = e;
    if (m.isValidElement(n) && n.type === m.Fragment) yield* this.iterateCollection({
      children: n.props.children,
      items: r
    });
    else if (typeof n == "function") {
      if (!r) throw new Error("props.children was a function but props.items is missing");
      let l = 0;
      for (let i of r)
        yield* this.getFullNode({
          value: i,
          index: l
        }, {
          renderer: n
        }), l++;
    } else {
      let l = [];
      m.Children.forEach(n, (a) => {
        a && l.push(a);
      });
      let i = 0;
      for (let a of l) {
        let o = this.getFullNode({
          element: a,
          index: i
        }, {});
        for (let u of o)
          i++, yield u;
      }
    }
  }
  getKey(e, n, r, l) {
    if (e.key != null) return e.key;
    if (n.type === "cell" && n.key != null) return `${l}${n.key}`;
    let i = n.value;
    if (i != null) {
      let a = i.key ?? i.id;
      if (a == null) throw new Error("No key found for item");
      return a;
    }
    return l ? `${l}.${n.index}` : `$.${n.index}`;
  }
  getChildState(e, n) {
    return {
      renderer: n.renderer || e.renderer
    };
  }
  *getFullNode(e, n, r, l) {
    if (m.isValidElement(e.element) && e.element.type === m.Fragment) {
      let u = [];
      m.Children.forEach(e.element.props.children, (s) => {
        u.push(s);
      });
      let c = e.index ?? 0;
      for (const s of u) yield* this.getFullNode({
        element: s,
        index: c++
      }, n, r, l);
      return;
    }
    let i = e.element;
    if (!i && e.value && n && n.renderer) {
      let u = this.cache.get(e.value);
      if (u && (!u.shouldInvalidate || !u.shouldInvalidate(this.context))) {
        u.index = e.index, u.parentKey = l ? l.key : null, yield u;
        return;
      }
      i = n.renderer(e.value);
    }
    if (m.isValidElement(i)) {
      let u = i.type;
      if (typeof u != "function" && typeof u.getCollectionNode != "function") {
        let f = i.type;
        throw new Error(`Unknown element <${f}> in collection.`);
      }
      let c = u.getCollectionNode(i.props, this.context), s = e.index ?? 0, d = c.next();
      for (; !d.done && d.value; ) {
        let f = d.value;
        e.index = s;
        let h = f.key ?? null;
        h == null && (h = f.element ? null : this.getKey(i, e, n, r));
        let b = [
          ...this.getFullNode({
            ...f,
            key: h,
            index: s,
            wrapper: h0(e.wrapper, f.wrapper)
          }, this.getChildState(n, f), r ? `${r}${i.key}` : i.key, l)
        ];
        for (let g of b) {
          if (g.value = f.value ?? e.value ?? null, g.value && this.cache.set(g.value, g), e.type && g.type !== e.type) throw new Error(`Unsupported type <${jl(g.type)}> in <${jl(l?.type ?? "unknown parent type")}>. Only <${jl(e.type)}> is supported.`);
          s++, yield g;
        }
        d = c.next(b);
      }
      return;
    }
    if (e.key == null || e.type == null) return;
    let a = this, o = {
      type: e.type,
      props: e.props,
      key: e.key,
      parentKey: l ? l.key : null,
      value: e.value ?? null,
      level: (l?.level ?? 0) + (l?.type === "item" ? 1 : 0),
      index: e.index,
      rendered: e.rendered,
      textValue: e.textValue ?? "",
      "aria-label": e["aria-label"],
      wrapper: e.wrapper,
      shouldInvalidate: e.shouldInvalidate,
      hasChildNodes: e.hasChildNodes || !1,
      childNodes: jo(function* () {
        if (!e.hasChildNodes || !e.childNodes) return;
        let u = 0;
        for (let c of e.childNodes()) {
          c.key != null && (c.key = `${o.key}${c.key}`);
          let s = a.getFullNode({
            ...c,
            index: u
          }, a.getChildState(n, c), o.key, o);
          for (let d of s)
            u++, yield d;
        }
      })
    };
    yield o;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function jo(t) {
  let e = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let r of e) yield r;
      n || (n = t());
      for (let r of n)
        e.push(r), yield r;
    }
  };
}
function h0(t, e) {
  if (t && e) return (n) => t(e(n));
  if (t) return t;
  if (e) return e;
}
function jl(t) {
  return t[0].toUpperCase() + t.slice(1);
}
function da(t, e, n) {
  let r = _(() => new f0(), []), { children: l, items: i, collection: a } = t;
  return _(() => {
    if (a) return a;
    let u = r.build({
      children: l,
      items: i
    }, n);
    return e(u);
  }, [
    r,
    l,
    i,
    a,
    n,
    e
  ]);
}
function xl(t) {
  let { filter: e, layoutDelegate: n } = t, r = Sr(t), l = _(() => t.disabledKeys ? new Set(t.disabledKeys) : /* @__PURE__ */ new Set(), [
    t.disabledKeys
  ]), i = G((c) => e ? new _o(e(c)) : new _o(c), [
    e
  ]), a = _(() => ({
    suppressTextValueWarning: t.suppressTextValueWarning
  }), [
    t.suppressTextValueWarning
  ]), o = da(t, i, a), u = _(() => new Gn(o, r, {
    layoutDelegate: n
  }), [
    o,
    r,
    n
  ]);
  return mp(o, u), {
    collection: o,
    disabledKeys: l,
    selectionManager: u
  };
}
function bp(t, e) {
  let n = _(() => e ? t.collection.filter(e) : t.collection, [
    t.collection,
    e
  ]), r = t.selectionManager.withCollection(n);
  return mp(n, r), {
    collection: n,
    selectionManager: r,
    disabledKeys: t.disabledKeys
  };
}
function mp(t, e) {
  const n = B(null);
  Q(() => {
    if (e.focusedKey != null && !t.getItem(e.focusedKey) && n.current) {
      let r = n.current.getKeyAfter(e.focusedKey), l = null;
      for (; r != null; ) {
        let i = t.getItem(r);
        if (i && i.type === "item" && !e.isDisabled(r)) {
          l = r;
          break;
        }
        r = n.current.getKeyAfter(r);
      }
      if (l == null)
        for (r = n.current.getKeyBefore(e.focusedKey); r != null; ) {
          let i = t.getItem(r);
          if (i && i.type === "item" && !e.isDisabled(r)) {
            l = r;
            break;
          }
          r = n.current.getKeyBefore(r);
        }
      e.setFocusedKey(l);
    }
    n.current = t;
  }, [
    t,
    e
  ]);
}
function gp(t, e) {
  let { collection: n, onLoadMore: r, scrollOffset: l = 1 } = t, i = B(null), a = ye((o) => {
    for (let u of o)
      u.isIntersecting && r && r();
  });
  le(() => (e.current && (i.current = new IntersectionObserver(a, {
    root: Me(e?.current),
    rootMargin: `0px ${100 * l}% ${100 * l}% ${100 * l}%`
  }), i.current.observe(e.current)), () => {
    i.current && i.current.disconnect();
  }), [
    n,
    e,
    l
  ]);
}
const fa = /* @__PURE__ */ j(null), ct = /* @__PURE__ */ j(null), p0 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, fa);
  let r = z(ct);
  return r ? /* @__PURE__ */ m.createElement(yp, {
    state: r,
    props: e,
    listBoxRef: n
  }) : /* @__PURE__ */ m.createElement(hn, {
    content: /* @__PURE__ */ m.createElement(At, e)
  }, (l) => /* @__PURE__ */ m.createElement(b0, {
    props: e,
    listBoxRef: n,
    collection: l
  }));
});
function b0({ props: t, listBoxRef: e, collection: n }) {
  t = {
    ...t,
    collection: n,
    children: null,
    items: null
  };
  let { layoutDelegate: r } = z(me), l = xl({
    ...t,
    layoutDelegate: r
  });
  return /* @__PURE__ */ m.createElement(yp, {
    state: l,
    props: t,
    listBoxRef: e
  });
}
function yp({ state: t, props: e, listBoxRef: n }) {
  [e, n] = ie(e, n, dn);
  let { dragAndDropHooks: r, layout: l = "stack", orientation: i = "vertical", filter: a } = e, o = bp(t, a), { collection: u, selectionManager: c } = o, s = !!r?.useDraggableCollectionState, d = !!r?.useDroppableCollectionState, { direction: f } = pe(), { disabledBehavior: h, disabledKeys: p } = c, b = jn({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: g, layoutDelegate: y, dropTargetDelegate: $, CollectionRoot: v } = z(me), E = _(() => e.keyboardDelegate || new Pr({
    collection: u,
    collator: b,
    ref: n,
    disabledKeys: p,
    disabledBehavior: h,
    layout: l,
    orientation: i,
    direction: f,
    layoutDelegate: y
  }), [
    u,
    b,
    n,
    h,
    p,
    i,
    f,
    e.keyboardDelegate,
    l,
    y
  ]), { listBoxProps: S } = o0({
    ...e,
    shouldSelectOnPressUp: s || e.shouldSelectOnPressUp,
    keyboardDelegate: E,
    isVirtualized: g
  }, o, n), w = B(s), C = B(d);
  Q(() => {
    process.env.NODE_ENV !== "production" && (w.current !== s && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), C.current !== d && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."));
  }, [
    s,
    d
  ]);
  let R, I, N, O = !1, A = null, V = B(null);
  if (s && r) {
    R = r.useDraggableCollectionState({
      collection: u,
      selectionManager: c,
      preview: r.renderDragPreview ? V : void 0
    }), r.useDraggableCollection({}, R, n);
    let U = r.DragPreview;
    A = r.renderDragPreview ? /* @__PURE__ */ m.createElement(U, {
      ref: V
    }, r.renderDragPreview) : null;
  }
  if (d && r) {
    I = r.useDroppableCollectionState({
      collection: u,
      selectionManager: c
    });
    let U = r.dropTargetDelegate || $ || new r.ListDropTargetDelegate(u, n, {
      orientation: i,
      layout: l,
      direction: f
    });
    N = r.useDroppableCollection({
      keyboardDelegate: E,
      dropTargetDelegate: U
    }, I, n), O = I.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: x, isFocused: K, isFocusVisible: D } = $e(), F = o.collection.size === 0, M = {
    isDropTarget: O,
    isEmpty: F,
    isFocused: K,
    isFocusVisible: D,
    layout: e.layout || "stack",
    orientation: i,
    state: o
  }, P = re({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-ListBox",
    values: M
  }), T = null;
  F && e.renderEmptyState && (T = /* @__PURE__ */ m.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState(M)));
  let W = Y(e, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(vl, null, /* @__PURE__ */ m.createElement(X.div, {
    ...L(W, P, S, x, N?.collectionProps),
    ref: n,
    slot: e.slot || void 0,
    onScroll: e.onScroll,
    "data-drop-target": O || void 0,
    "data-empty": F || void 0,
    "data-focused": K || void 0,
    "data-focus-visible": D || void 0,
    "data-layout": e.layout || "stack",
    "data-orientation": i
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        fa,
        e
      ],
      [
        ct,
        o
      ],
      [
        Ct,
        {
          dragAndDropHooks: r,
          dragState: R,
          dropState: I
        }
      ],
      [
        aa,
        {
          elementType: "div"
        }
      ],
      [
        ra,
        {
          render: y0
        }
      ],
      [
        Ks,
        {
          name: "ListBoxSection",
          render: m0
        }
      ]
    ]
  }, /* @__PURE__ */ m.createElement(bn, null, /* @__PURE__ */ m.createElement(v, {
    collection: u,
    scrollRef: n,
    persistedKeys: ap(c, r, I),
    renderDropIndicator: la(r, I)
  }))), T, A));
}
function m0(t, e, n, r = "react-aria-ListBoxSection") {
  let l = z(ct), { dragAndDropHooks: i, dropState: a } = z(Ct), { CollectionBranch: o } = z(me), [u, c] = Xe(), { headingProps: s, groupProps: d } = c0({
    heading: c,
    "aria-label": t["aria-label"] ?? void 0
  }), f = re({
    ...t,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    values: void 0
  }), h = Y(t, {
    global: !0
  });
  return delete h.id, /* @__PURE__ */ m.createElement(X.section, {
    ...L(h, f, d),
    ref: e
  }, /* @__PURE__ */ m.createElement(ia.Provider, {
    value: {
      ...s,
      ref: u
    }
  }, /* @__PURE__ */ m.createElement(o, {
    collection: l.collection,
    parent: n,
    renderDropIndicator: la(i, a)
  })));
}
const g0 = /* @__PURE__ */ ot(cr, function(e, n, r) {
  let l = ge(n), i = z(ct), { dragAndDropHooks: a, dragState: o, dropState: u } = z(Ct), c = o && !(o.isDisabled || o.selectionManager.isDisabled(r.key)), { optionProps: s, labelProps: d, descriptionProps: f, ...h } = s0({
    key: r.key,
    "aria-label": e?.["aria-label"]
  }, i, l), { hoverProps: p, isHovered: b } = ve({
    isDisabled: !h.allowsSelection && !h.hasAction && !c,
    onHoverStart: r.props.onHoverStart,
    onHoverChange: r.props.onHoverChange,
    onHoverEnd: r.props.onHoverEnd
  }), { keyboardProps: g } = Hn(e), { focusProps: y } = In(e), $ = null;
  o && a && ($ = a.useDraggableItem({
    key: r.key,
    hasAction: h.hasAction
  }, o));
  let v = null;
  u && a && (v = a.useDroppableItem({
    target: {
      type: "item",
      key: r.key,
      dropPosition: "on"
    }
  }, u, l));
  let E = o && o.isDragging(r.key), S = re({
    ...e,
    id: void 0,
    children: e.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...h,
      isHovered: b,
      selectionMode: i.selectionManager.selectionMode,
      selectionBehavior: i.selectionManager.selectionBehavior,
      allowsDragging: !!o,
      isDragging: E,
      isDropTarget: v?.isDropTarget
    }
  });
  Q(() => {
    !r.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    r.textValue
  ]);
  let w = e.href ? X.a : X.div, C = Y(e, {
    global: !0
  });
  return delete C.id, delete C.onClick, e.href && s.tabIndex == null && (s.tabIndex = -1), /* @__PURE__ */ m.createElement(w, {
    ...L(C, S, s, p, g, y, $?.dragProps, v?.dropProps),
    ref: l,
    "data-allows-dragging": !!o || void 0,
    "data-selected": h.isSelected || void 0,
    "data-disabled": h.isDisabled || void 0,
    "data-hovered": b || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": h.isFocusVisible || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-dragging": E || void 0,
    "data-drop-target": v?.isDropTarget || void 0,
    "data-selection-mode": i.selectionManager.selectionMode === "none" ? void 0 : i.selectionManager.selectionMode
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Qe,
        {
          slots: {
            [rt]: d,
            label: d,
            description: f
          }
        }
      ],
      [
        mn,
        {
          isSelected: h.isSelected
        }
      ]
    ]
  }, S.children));
});
function y0(t, e) {
  e = ge(e);
  let { dragAndDropHooks: n, dropState: r } = z(Ct), { dropIndicatorProps: l, isHidden: i, isDropTarget: a } = n.useDropIndicator(t, r, e);
  return i ? null : /* @__PURE__ */ m.createElement(v0, {
    ...t,
    dropIndicatorProps: l,
    isDropTarget: a,
    ref: e
  });
}
function $0(t, e) {
  let { dropIndicatorProps: n, isDropTarget: r, ...l } = t, i = re({
    ...l,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(X.div, {
    ...n,
    ...i,
    role: "option",
    ref: e,
    "data-drop-target": r || void 0
  }));
}
const v0 = /* @__PURE__ */ te($0), k6 = ot(Jr, function(e, n, r) {
  let l = z(ct), { isLoading: i, onLoadMore: a, scrollOffset: o, ...u } = e, c = B(null), s = _(() => ({
    onLoadMore: a,
    collection: l?.collection,
    sentinelRef: c,
    scrollOffset: o
  }), [
    a,
    o,
    l?.collection
  ]);
  gp(s, c);
  let d = re({
    ...u,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-ListBoxLoadingIndicator",
    values: void 0
  }), f = {
    // For Android talkback
    tabIndex: -1
  };
  return /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement("div", {
    style: {
      position: "relative",
      width: 0,
      height: 0
    },
    inert: il(!0)
  }, /* @__PURE__ */ m.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: c,
    style: {
      position: "absolute",
      height: 1,
      width: 1
    }
  })), i && d.children && /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(X.div, {
    ...L(Y(e, {
      global: !0
    }), f),
    ...d,
    // aria-selected isn't needed here since this option is not selectable.
    role: "option",
    ref: n
  }, d.children)));
});
function $p(t) {
  let e = fn(t.value), n = fn(t.defaultValue || "#000000"), [r, l] = Be(e || void 0, n, t.onChange);
  return {
    color: r,
    setColor(i) {
      i != null && l(i || _e("#000000"));
    }
  };
}
function x0(t) {
  return t && t.__esModule ? t.default : t;
}
const vp = /* @__PURE__ */ j(null), xp = /* @__PURE__ */ j(null), B6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, vp);
  let r = $p(e), l = _(() => /* @__PURE__ */ new Map(), []), i = ke(x0(na), "react-aria-components");
  return /* @__PURE__ */ m.createElement(p0, {
    ...Y(e, {
      labelable: !0
    }),
    ref: n,
    className: e.className || "react-aria-ColorSwatchPicker",
    style: e.style,
    "aria-label": e["aria-label"] || (e["aria-labelledby"] ? void 0 : i.format("colorSwatchPicker")),
    layout: e.layout || "grid",
    selectionMode: "single",
    selectedKeys: [
      r.color.toString("hexa")
    ],
    onSelectionChange: (a) => {
      a !== "all" && r.setColor(l.get([
        ...a
      ][0]));
    },
    disallowEmptySelection: !0
  }, /* @__PURE__ */ m.createElement(xp.Provider, {
    value: l
  }, e.children));
}), F6 = /* @__PURE__ */ te(function(e, n) {
  let r = e.color || "#0000", l = _(() => typeof r == "string" ? _e(r) : r, [
    r
  ]), { locale: i } = pe(), a = z(xp);
  Q(() => {
    let u = l.toString("hexa");
    return a.set(u, l), () => {
      a.delete(u);
    };
  }, [
    l,
    a
  ]);
  let o = (u) => typeof u == "function" ? (c) => u({
    ...c,
    color: l
  }) : u;
  return /* @__PURE__ */ m.createElement(g0, {
    ...e,
    // ColorSwatchPickerItem is never a link.
    render: e.render,
    ref: n,
    id: l.toString("hexa"),
    textValue: l.getColorName(i),
    className: o(e.className || "react-aria-ColorSwatchPickerItem"),
    style: o(e.style)
  }, cy(o(e.children), (u) => /* @__PURE__ */ m.createElement(ta.Provider, {
    value: {
      color: l
    }
  }, u)));
}), E0 = /* @__PURE__ */ j(null), C0 = /* @__PURE__ */ j(null), D0 = /* @__PURE__ */ j(null);
function T6(t) {
  let e = We(C0, t.slot);
  t = L(e, t);
  let n = $p(t), r = re({
    ...t,
    values: {
      color: n.color
    }
  });
  return /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        D0,
        n
      ],
      [
        wh,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        Zd,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        E0,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        xh,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        ta,
        {
          color: n.color
        }
      ],
      [
        vp,
        {
          value: n.color,
          onChange: n.setColor
        }
      ]
    ]
  }, r.children);
}
const Ep = /* @__PURE__ */ j({
  placement: "bottom"
}), w0 = typeof HTMLElement < "u" && "inert" in HTMLElement.prototype;
function Uo(t) {
  return t.dataset.liveAnnouncer === "true" || t.dataset.reactAriaTopLayer !== void 0;
}
let Qn = /* @__PURE__ */ new WeakMap(), ze = [];
function Cp(t, e) {
  let n = De(t?.[0]), r = e instanceof n.Element ? {
    root: e
  } : e, l = r?.root ?? document.body, i = r?.shouldUseInert && w0, a = new Set(t), o = /* @__PURE__ */ new Set(), u = (g) => i && g instanceof n.HTMLElement ? g.inert : g.getAttribute("aria-hidden") === "true", c = (g, y) => {
    i && g instanceof n.HTMLElement ? g.inert = y : y ? g.setAttribute("aria-hidden", "true") : (g.removeAttribute("aria-hidden"), g instanceof n.HTMLElement && (g.inert = !1));
  }, s = /* @__PURE__ */ new Set();
  if (Pt())
    for (let g of t) {
      let y = g;
      for (; y && y !== l; ) {
        let $ = y.getRootNode();
        "shadowRoot" in $ && s.add($.shadowRoot), y = $.parentNode;
      }
    }
  let d = (g) => {
    for (let E of g.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) a.add(E);
    let y = (E) => {
      if (o.has(E) || a.has(E) || E.parentElement && o.has(E.parentElement) && E.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let S of a)
        if (ne(E, S)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, $ = up(ue(g), g, NodeFilter.SHOW_ELEMENT, {
      acceptNode: y
    }), v = y(g);
    if (v === NodeFilter.FILTER_ACCEPT && f(g), v !== NodeFilter.FILTER_REJECT) {
      let E = $.nextNode();
      for (; E != null; )
        f(E), E = $.nextNode();
    }
  }, f = (g) => {
    let y = Qn.get(g) ?? 0;
    u(g) && y === 0 || (y === 0 && c(g, !0), o.add(g), Qn.set(g, y + 1));
  };
  ze.length && ze[ze.length - 1].disconnect(), d(l);
  let h = new MutationObserver((g) => {
    for (let y of g)
      if (y.type === "childList") {
        if (y.target.isConnected && ![
          ...a,
          ...o
        ].some(($) => ne($, y.target))) for (let $ of y.addedNodes)
          ($ instanceof HTMLElement || $ instanceof SVGElement) && Uo($) ? a.add($) : $ instanceof Element && d($);
        if (Pt()) {
          for (let $ of s) if (!$.isConnected) {
            h.disconnect();
            break;
          }
        }
      }
  });
  h.observe(l, {
    childList: !0,
    subtree: !0
  });
  let p = /* @__PURE__ */ new Set();
  if (Pt()) for (let g of s) {
    let y = new MutationObserver(($) => {
      for (let v of $)
        if (v.type === "childList") {
          if (v.target.isConnected && ![
            ...a,
            ...o
          ].some((E) => ne(E, v.target))) for (let E of v.addedNodes)
            (E instanceof HTMLElement || E instanceof SVGElement) && Uo(E) ? a.add(E) : E instanceof Element && d(E);
          if (Pt()) {
            for (let E of s) if (!E.isConnected) {
              h.disconnect();
              break;
            }
          }
        }
    });
    y.observe(g, {
      childList: !0,
      subtree: !0
    }), p.add(y);
  }
  let b = {
    visibleNodes: a,
    hiddenNodes: o,
    observe() {
      h.observe(l, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      h.disconnect();
    }
  };
  return ze.push(b), () => {
    if (h.disconnect(), Pt()) for (let g of p) g.disconnect();
    for (let g of o) {
      let y = Qn.get(g);
      y != null && (y === 1 ? (c(g, !1), Qn.delete(g)) : Qn.set(g, y - 1));
    }
    b === ze[ze.length - 1] ? (ze.pop(), ze.length && ze[ze.length - 1].observe()) : ze.splice(ze.indexOf(b), 1);
  };
}
function P0(t) {
  let e = ze[ze.length - 1];
  if (e && !e.visibleNodes.has(t))
    return e.visibleNodes.add(t), () => {
      e.visibleNodes.delete(t);
    };
}
const Ue = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, al = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, S0 = {
  top: "left",
  left: "top"
}, Di = {
  top: "height",
  left: "width"
}, Dp = {
  width: "totalWidth",
  height: "totalHeight"
}, Lr = {};
let k0 = () => typeof document < "u" ? window.visualViewport : null;
function Go(t, e) {
  let n = 0, r = 0, l = 0, i = 0, a = 0, o = 0, u = {}, c = (e?.scale ?? 1) > 1;
  if (t.tagName === "BODY" || t.tagName === "HTML") {
    let s = document.documentElement;
    l = s.clientWidth, i = s.clientHeight, n = e?.width ?? l, r = e?.height ?? i, u.top = s.scrollTop || t.scrollTop, u.left = s.scrollLeft || t.scrollLeft, e && (a = e.offsetTop, o = e.offsetLeft);
  } else
    ({ width: n, height: r, top: a, left: o } = gr(t, !1)), u.top = t.scrollTop, u.left = t.scrollLeft, l = n, i = r;
  return Au() && (t.tagName === "BODY" || t.tagName === "HTML") && c && (u.top = 0, u.left = 0, a = e?.pageTop ?? 0, o = e?.pageLeft ?? 0), {
    width: n,
    height: r,
    totalWidth: l,
    totalHeight: i,
    scroll: u,
    top: a,
    left: o
  };
}
function B0(t) {
  return {
    top: t.scrollTop,
    left: t.scrollLeft,
    width: t.scrollWidth,
    height: t.scrollHeight
  };
}
function qo(t, e, n, r, l, i, a) {
  let o = l.scroll[t] ?? 0, u = r[Di[t]], c = a[t] + r.scroll[Ue[t]] + i, s = a[t] + r.scroll[Ue[t]] + u - i, d = e - o + r.scroll[Ue[t]] + a[t] - r[Ue[t]], f = e - o + n + r.scroll[Ue[t]] + a[t] - r[Ue[t]];
  return d < c ? c - d : f > s ? Math.max(s - f, c - d) : 0;
}
function F0(t) {
  let e = window.getComputedStyle(t);
  return {
    top: parseInt(e.marginTop, 10) || 0,
    bottom: parseInt(e.marginBottom, 10) || 0,
    left: parseInt(e.marginLeft, 10) || 0,
    right: parseInt(e.marginRight, 10) || 0
  };
}
function Yo(t) {
  if (Lr[t]) return Lr[t];
  let [e, n] = t.split(" "), r = Ue[e] || "right", l = S0[r];
  Ue[n] || (n = "center");
  let i = Di[r], a = Di[l];
  return Lr[t] = {
    placement: e,
    crossPlacement: n,
    axis: r,
    crossAxis: l,
    size: i,
    crossSize: a
  }, Lr[t];
}
function Ul(t, e, n, r, l, i, a, o, u, c, s) {
  let { placement: d, crossPlacement: f, axis: h, crossAxis: p, size: b, crossSize: g } = r, y = {};
  y[p] = t[p] ?? 0, f === "center" ? y[p] += ((t[g] ?? 0) - (n[g] ?? 0)) / 2 : f !== p && (y[p] += (t[g] ?? 0) - (n[g] ?? 0)), y[p] += i;
  const $ = t[p] - n[g] + u + c, v = t[p] + t[g] - u - c;
  if (y[p] = Re(y[p], $, v), d === h) {
    let E = o ? s[b] : s[Dp[b]];
    y[al[h]] = Math.floor(E - t[h] + l);
  } else y[h] = Math.floor(t[h] + t[b] + l);
  return y;
}
function T0(t, e, n, r, l, i, a, o, u, c, s) {
  let d = (t.top != null ? t.top : u[Dp.height] - (t.bottom ?? 0) - a) - (u.scroll.top ?? 0), f = c ? n.top : 0, h = {
    // This should be boundary top in container coord system vs viewport top in container coord system
    // For the viewport top, there are several cases
    // 1. pinchzoom case where we want the viewports offset top as top here
    // 2. case where container is offset from the boundary and is contained by the boundary. In this case the top we want here is NOT 0, we want to take boundary's top even though is is a negative number OR the visual viewport, whichever is more restrictive
    top: Math.max(e.top + f, (s?.offsetTop ?? e.top) + f),
    bottom: Math.min(e.top + e.height + f, (s?.offsetTop ?? 0) + (s?.height ?? 0))
  };
  return o !== "top" ? Math.max(0, h.bottom - // this is the bottom of the boundary
  d - // this is the top of the overlay
  ((l.top ?? 0) + (l.bottom ?? 0) + i)) : Math.max(0, d + a - // this is the bottom of the overlay
  h.top - // this is the top of the boundary
  ((l.top ?? 0) + (l.bottom ?? 0) + i));
}
function Xo(t, e, n, r, l, i, a, o) {
  let { placement: u, axis: c, size: s } = i;
  return u === c ? Math.max(0, n[c] - // trigger start
  (a.scroll[c] ?? 0) - // transform trigger position to be with respect to viewport 0,0
  (t[c] + (o ? e[c] : 0)) - // boundary start
  (r[c] ?? 0) - // margins usually for arrows or other decorations
  r[al[c]] - l) : Math.max(0, t[s] + t[c] + (o ? e[c] : 0) - n[c] - n[s] + (a.scroll[c] ?? 0) - (r[c] ?? 0) - r[al[c]] - l);
}
function A0(t, e, n, r, l, i, a, o, u, c, s, d, f, h, p, b, g, y) {
  let $ = Yo(t), { size: v, crossAxis: E, crossSize: S, placement: w, crossPlacement: C } = $, R = Ul(e, o, n, $, s, d, c, f, p, b, u), I = s, N = Xo(o, c, e, l, i + s, $, u, g);
  if (a && n[v] > N) {
    let Z = Yo(`${al[w]} ${C}`), de = Ul(e, o, n, Z, s, d, c, f, p, b, u);
    Xo(o, c, e, l, i + s, Z, u, g) > N && ($ = Z, R = de, I = s);
  }
  let O = "bottom";
  $.axis === "top" ? $.placement === "top" ? O = "top" : $.placement === "bottom" && (O = "bottom") : $.crossAxis === "top" && ($.crossPlacement === "top" ? O = "bottom" : $.crossPlacement === "bottom" && (O = "top"));
  let A = qo(E, R[E], n[S], o, u, i, c);
  R[E] += A;
  let V = T0(R, o, c, f, l, i, n.height, O, u, g, y);
  h && h < V && (V = h), n.height = Math.min(n.height, V), R = Ul(e, o, n, $, I, d, c, f, p, b, u), A = qo(E, R[E], n[S], o, u, i, c), R[E] += A;
  let x = {}, K = e[E] - R[E] - l[Ue[E]], D = K + 0.5 * e[S];
  const F = p / 2 + b, M = Ue[E] === "left" ? (l.left ?? 0) + (l.right ?? 0) : (l.top ?? 0) + (l.bottom ?? 0), P = n[S] - M - p / 2 - b, T = e[E] + p / 2 - (R[E] + l[Ue[E]]), W = e[E] + e[S] - p / 2 - (R[E] + l[Ue[E]]), U = Re(D, T, W);
  x[E] = Re(U, F, P), { placement: w, crossPlacement: C } = $, p ? K = x[E] : C === "right" ? K += e[S] : C === "center" && (K += e[S] / 2);
  let k = w === "left" || w === "top" ? n[v] : 0, ee = {
    x: w === "top" || w === "bottom" ? K : k,
    y: w === "left" || w === "right" ? K : k
  };
  return {
    position: R,
    maxHeight: V,
    arrowOffsetLeft: x.left,
    arrowOffsetTop: x.top,
    placement: w,
    triggerAnchorPoint: ee
  };
}
function I0(t) {
  let { placement: e, targetNode: n, overlayNode: r, scrollNode: l, padding: i, shouldFlip: a, boundaryElement: o, offset: u, crossOffset: c, maxHeight: s, arrowSize: d = 0, arrowBoundaryOffset: f = 0, targetRect: h } = t, p = k0(), b = r instanceof HTMLElement ? K0(r) : document.documentElement, g = b === document.documentElement;
  const y = window.getComputedStyle(b).position;
  let $ = !!y && y !== "static", v = g ? gr(n, !1, h) : Zo(n, b, !1, h);
  if (!g) {
    let { marginTop: O, marginLeft: A } = window.getComputedStyle(n);
    v.top += parseInt(O, 10) || 0, v.left += parseInt(A, 10) || 0;
  }
  let E = gr(r, !0), S = F0(r);
  E.width += (S.left ?? 0) + (S.right ?? 0), E.height += (S.top ?? 0) + (S.bottom ?? 0);
  let w = B0(l), C = Go(o, p), R = Go(b, p), I;
  if ((o.tagName === "BODY" || o.tagName === "HTML") && !g) {
    let O = El(b, !1);
    I = {
      top: -(O.top - C.top),
      left: -(O.left - C.left),
      width: 0,
      height: 0
    };
  } else (o.tagName === "BODY" || o.tagName === "HTML") && g ? I = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  } : I = Zo(o, b, !1);
  let N = ne(o, b);
  return A0(e, v, E, w, S, i, a, C, R, I, u, c, $, s, d, f, N, p);
}
function El(t, e) {
  let { top: n, left: r, width: l, height: i } = t.getBoundingClientRect();
  return e && t instanceof t.ownerDocument.defaultView.HTMLElement && (l = t.offsetWidth, i = t.offsetHeight), {
    top: n,
    left: r,
    width: l,
    height: i
  };
}
function gr(t, e, n) {
  let { top: r, left: l, width: i, height: a } = n || El(t, e), { scrollTop: o, scrollLeft: u, clientTop: c, clientLeft: s } = document.documentElement;
  return {
    top: r + o - c,
    left: l + u - s,
    width: i,
    height: a
  };
}
function Zo(t, e, n, r) {
  let l = window.getComputedStyle(t), i;
  if (l.position === "fixed") i = r || El(t, n);
  else {
    i = gr(t, n, r);
    let a = gr(e, n), o = window.getComputedStyle(e);
    a.top += (parseInt(o.borderTopWidth, 10) || 0) - e.scrollTop, a.left += (parseInt(o.borderLeftWidth, 10) || 0) - e.scrollLeft, i.top -= a.top, i.left -= a.left;
  }
  return i.top -= parseInt(l.marginTop, 10) || 0, i.left -= parseInt(l.marginLeft, 10) || 0, i;
}
function K0(t) {
  let e = t.offsetParent;
  if (e && e === document.body && window.getComputedStyle(e).position === "static" && !Jo(e) && (e = document.documentElement), e == null)
    for (e = t.parentElement; e && !Jo(e); ) e = e.parentElement;
  return e || document.documentElement;
}
function Jo(t) {
  let e = window.getComputedStyle(t);
  return e.transform !== "none" || /transform|perspective/.test(e.willChange) || e.filter !== "none" || e.contain === "paint" || "backdropFilter" in e && e.backdropFilter !== "none" || "WebkitBackdropFilter" in e && e.WebkitBackdropFilter !== "none";
}
const wp = /* @__PURE__ */ new WeakMap();
function R0(t) {
  let { triggerRef: e, isOpen: n, onClose: r } = t;
  Q(() => {
    if (!n || r === null) return;
    let l = (i) => {
      let a = H(i);
      if (!e.current || a instanceof Node && !ne(a, e.current) || a instanceof HTMLInputElement || a instanceof HTMLTextAreaElement) return;
      let o = r || wp.get(e.current);
      o && o();
    };
    return window.addEventListener("scroll", l, !0), () => {
      window.removeEventListener("scroll", l, !0);
    };
  }, [
    n,
    r,
    e
  ]);
}
function N0() {
  return typeof window.ResizeObserver < "u";
}
function Nn(t) {
  const { ref: e, box: n, onResize: r } = t;
  let l = ye(r);
  Q(() => {
    let i = e?.current;
    if (i)
      if (N0()) {
        const a = new window.ResizeObserver((o) => {
          o.length && l();
        });
        return a.observe(i, {
          box: n
        }), () => {
          i && a.unobserve(i);
        };
      } else
        return window.addEventListener("resize", l, !1), () => {
          window.removeEventListener("resize", l, !1);
        };
  }, [
    e,
    n
  ]);
}
let en = typeof document < "u" ? window.visualViewport : null;
function Pp(t) {
  let { direction: e } = pe(), { arrowSize: n, targetRef: r, overlayRef: l, arrowRef: i, scrollRef: a = l, placement: o = "bottom", containerPadding: u = 12, shouldFlip: c = !0, boundaryElement: s = typeof document < "u" ? document.body : null, offset: d = 0, crossOffset: f = 0, shouldUpdatePosition: h = !0, isOpen: p = !0, onClose: b, maxHeight: g, arrowBoundaryOffset: y = 0, getTargetRect: $ } = t, [v, E] = q(null), S = [
    h,
    o,
    l.current,
    r.current,
    i?.current,
    a.current,
    u,
    c,
    s,
    d,
    f,
    p,
    e,
    g,
    y,
    n
  ], w = B(en?.scale);
  Q(() => {
    p && (w.current = en?.scale);
  }, [
    p
  ]);
  let C = G(() => {
    if (h === !1 || !p || !l.current || !r.current || !s || en?.scale !== w.current) return;
    let N = null;
    if (a.current && Bt(a.current)) {
      let x = oe()?.getBoundingClientRect(), K = a.current.getBoundingClientRect();
      N = {
        type: "top",
        offset: (x?.top ?? 0) - K.top
      }, N.offset > K.height / 2 && (N.type = "bottom", N.offset = (x?.bottom ?? 0) - K.bottom);
    }
    let O = l.current;
    !g && l.current && (O.style.top = "0px", O.style.bottom = "", O.style.maxHeight = (window.visualViewport?.height ?? window.innerHeight) + "px");
    let A = I0({
      placement: L0(o, e),
      overlayNode: l.current,
      targetNode: r.current,
      scrollNode: a.current || l.current,
      padding: u,
      shouldFlip: c,
      boundaryElement: s,
      offset: d,
      crossOffset: f,
      maxHeight: g,
      arrowSize: n ?? (i?.current ? El(i.current, !0).width : 0),
      arrowBoundaryOffset: y,
      targetRect: $?.(r.current)
    });
    if (!A.position) return;
    O.style.top = "", O.style.bottom = "", O.style.left = "", O.style.right = "", Object.keys(A.position).forEach((x) => O.style[x] = A.position[x] + "px"), O.style.maxHeight = A.maxHeight != null ? A.maxHeight + "px" : "";
    let V = oe();
    if (N && V && a.current) {
      let x = V.getBoundingClientRect(), K = a.current.getBoundingClientRect(), D = x[N.type] - K[N.type];
      a.current.scrollTop += D - N.offset;
    }
    E(A);
  }, S);
  le(C, S), M0(C), Nn({
    ref: l,
    onResize: C
  }), Nn({
    ref: r,
    onResize: C
  });
  let R = B(!1);
  le(() => {
    let N, O = () => {
      R.current = !0, clearTimeout(N), N = setTimeout(() => {
        R.current = !1;
      }, 500), C();
    }, A = () => {
      R.current && O();
    };
    return en?.addEventListener("resize", O), en?.addEventListener("scroll", A), () => {
      en?.removeEventListener("resize", O), en?.removeEventListener("scroll", A);
    };
  }, [
    C
  ]);
  let I = G(() => {
    R.current || b?.();
  }, [
    b,
    R
  ]);
  return R0({
    triggerRef: r,
    isOpen: p,
    onClose: b && I
  }), {
    overlayProps: {
      style: {
        position: v ? "absolute" : "fixed",
        top: v ? void 0 : 0,
        left: v ? void 0 : 0,
        zIndex: 1e5,
        ...v?.position,
        maxHeight: v?.maxHeight ?? "100vh"
      }
    },
    placement: v?.placement ?? null,
    triggerAnchorPoint: v?.triggerAnchorPoint ?? null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: v?.arrowOffsetLeft,
        top: v?.arrowOffsetTop
      }
    },
    updatePosition: C
  };
}
function M0(t) {
  le(() => (window.addEventListener("resize", t, !1), () => {
    window.removeEventListener("resize", t, !1);
  }), [
    t
  ]);
}
function L0(t, e) {
  return e === "rtl" ? t.replace("start", "right").replace("end", "left") : t.replace("start", "left").replace("end", "right");
}
function z0(t) {
  let { ref: e, onInteractOutside: n, isDisabled: r, onInteractOutsideStart: l } = t, i = B({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), a = ye((u) => {
    n && zr(u, e) && (l && l(u), i.current.isPointerDown = !0);
  }), o = ye((u) => {
    n && n(u);
  });
  Q(() => {
    let u = i.current;
    if (r) return;
    const c = e.current, s = ue(c);
    if (typeof PointerEvent < "u") {
      let d = (f) => {
        u.isPointerDown && zr(f, e) && o(f), u.isPointerDown = !1;
      };
      return s.addEventListener("pointerdown", a, !0), s.addEventListener("click", d, !0), () => {
        s.removeEventListener("pointerdown", a, !0), s.removeEventListener("click", d, !0);
      };
    } else if (process.env.NODE_ENV === "test") {
      let d = (h) => {
        u.ignoreEmulatedMouseEvents ? u.ignoreEmulatedMouseEvents = !1 : u.isPointerDown && zr(h, e) && o(h), u.isPointerDown = !1;
      }, f = (h) => {
        u.ignoreEmulatedMouseEvents = !0, u.isPointerDown && zr(h, e) && o(h), u.isPointerDown = !1;
      };
      return s.addEventListener("mousedown", a, !0), s.addEventListener("mouseup", d, !0), s.addEventListener("touchstart", a, !0), s.addEventListener("touchend", f, !0), () => {
        s.removeEventListener("mousedown", a, !0), s.removeEventListener("mouseup", d, !0), s.removeEventListener("touchstart", a, !0), s.removeEventListener("touchend", f, !0);
      };
    }
  }, [
    e,
    r
  ]);
}
function zr(t, e) {
  if (t.button > 0) return !1;
  let n = H(t);
  if (n) {
    const r = n.ownerDocument;
    if (!r || !ne(r.documentElement, n) || n.closest("[data-react-aria-top-layer]")) return !1;
  }
  return e.current ? !t.composedPath().includes(e.current) : !1;
}
const pt = [];
function Sp(t, e) {
  let { onClose: n, shouldCloseOnBlur: r, isOpen: l, isDismissable: i = !1, isKeyboardDismissDisabled: a = !1, shouldCloseOnInteractOutside: o } = t, u = B(void 0);
  Q(() => {
    if (l && !pt.includes(e))
      return pt.push(e), () => {
        let p = pt.indexOf(e);
        p >= 0 && pt.splice(p, 1);
      };
  }, [
    l,
    e
  ]);
  let c = () => {
    pt[pt.length - 1] === e && n && n();
  }, s = (p) => {
    const b = pt[pt.length - 1];
    u.current = b, (!o || o(H(p))) && b === e && p.stopPropagation();
  }, d = (p) => {
    (!o || o(H(p))) && (pt[pt.length - 1] === e && p.stopPropagation(), u.current === e && c()), u.current = void 0;
  }, f = (p) => {
    p.key === "Escape" && !a && !p.nativeEvent.isComposing && (p.stopPropagation(), p.preventDefault(), c());
  };
  z0({
    ref: e,
    onInteractOutside: i && l ? d : void 0,
    onInteractOutsideStart: s
  });
  let { focusWithinProps: h } = Et({
    isDisabled: !r,
    onBlurWithin: (p) => {
      !p.relatedTarget || Qv(p.relatedTarget) || (!o || o(p.relatedTarget)) && n?.();
    }
  });
  return {
    overlayProps: {
      onKeyDown: f,
      ...h
    },
    underlayProps: {}
  };
}
const or = typeof document < "u" && window.visualViewport;
let Vr = 0, Gl;
function kp(t = {}) {
  let { isDisabled: e } = t;
  le(() => {
    if (!e)
      return Vr++, Vr === 1 && (yt() ? Gl = O0() : Gl = V0()), () => {
        Vr--, Vr === 0 && Gl();
      };
  }, [
    e
  ]);
}
function V0() {
  let t = window.innerWidth - document.documentElement.clientWidth;
  return Ye(t > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
  ("scrollbarGutter" in document.documentElement.style ? jr(document.documentElement, "scrollbarGutter", "stable") : jr(document.documentElement, "paddingRight", `${t}px`)), jr(document.documentElement, "overflow", "hidden"));
}
function O0() {
  let t = jr(document.documentElement, "overflow", "hidden"), e, n = !1, r = (s) => {
    let d = H(s);
    e = jt(d) ? d : Me(d, !0), n = !1;
    let f = d.ownerDocument.defaultView.getSelection();
    f && !f.isCollapsed && f.containsNode(d, !0) && (n = !0), s.composedPath().some((h) => h instanceof HTMLInputElement && h.type === "range") && (n = !0), "selectionStart" in d && "selectionEnd" in d && d.selectionStart < d.selectionEnd && d.ownerDocument.activeElement === d && (n = !0);
  }, l = document.createElement("style"), i = Ns();
  i && (l.nonce = i), l.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim(), document.head.prepend(l);
  let a = (s) => {
    if (!(s.touches.length === 2 || n)) {
      if (!e || e === document.documentElement || e === document.body) {
        s.preventDefault();
        return;
      }
      e.scrollHeight === e.clientHeight && e.scrollWidth === e.clientWidth && s.preventDefault();
    }
  }, o = (s) => {
    let d = H(s), f = s.relatedTarget;
    f && ar(f) ? (f.focus({
      preventScroll: !0
    }), Qo(f, ar(d))) : f || d.parentElement?.closest("[tabindex]")?.focus({
      preventScroll: !0
    });
  }, u = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function(s) {
    let d = oe(), f = d != null && ar(d);
    u.call(this, {
      ...s,
      preventScroll: !0
    }), (!s || !s.preventScroll) && Qo(this, f);
  };
  let c = Ye(ql(document, "touchstart", r, {
    passive: !1,
    capture: !0
  }), ql(document, "touchmove", a, {
    passive: !1,
    capture: !0
  }), ql(document, "blur", o, !0));
  return () => {
    t(), c(), l.remove(), HTMLElement.prototype.focus = u;
  };
}
function jr(t, e, n) {
  let r = t.style[e];
  return t.style[e] = n, () => {
    t.style[e] = r;
  };
}
function ql(t, e, n, r) {
  return t.addEventListener(e, n, r), () => {
    t.removeEventListener(e, n, r);
  };
}
function Qo(t, e) {
  e || !or ? eu(t) : or.addEventListener("resize", () => eu(t), {
    once: !0
  });
}
function eu(t) {
  let e = document.scrollingElement || document.documentElement, n = t;
  for (; n && n !== e; ) {
    let r = Me(n);
    if (r !== document.documentElement && r !== document.body && r !== n) {
      let l = r.getBoundingClientRect(), i = n.getBoundingClientRect();
      if (i.top < l.top || i.bottom > l.top + n.clientHeight) {
        let a = l.bottom;
        or && (a = Math.min(a, or.offsetTop + or.height));
        let o = i.top - l.top - ((a - l.top) / 2 - i.height / 2);
        r.scrollTo({
          // Clamp to the valid range to prevent over-scrolling.
          top: Math.max(0, Math.min(r.scrollHeight - r.clientHeight, r.scrollTop + o)),
          behavior: "smooth"
        });
      }
    }
    n = r.parentElement;
  }
}
function H0(t, e) {
  let { triggerRef: n, popoverRef: r, groupRef: l, isNonModal: i, isKeyboardDismissDisabled: a, shouldCloseOnInteractOutside: o, ...u } = t, c = u.trigger === "SubmenuTrigger", { overlayProps: s, underlayProps: d } = Sp({
    isOpen: e.isOpen,
    onClose: e.close,
    shouldCloseOnBlur: !0,
    isDismissable: !i || c,
    isKeyboardDismissDisabled: a,
    shouldCloseOnInteractOutside: o
  }, l ?? r), { overlayProps: f, arrowProps: h, placement: p, triggerAnchorPoint: b } = Pp({
    ...u,
    targetRef: n,
    overlayRef: r,
    isOpen: e.isOpen,
    onClose: i && !c ? e.close : null
  });
  return kp({
    isDisabled: i || !e.isOpen
  }), Q(() => {
    if (e.isOpen && r.current)
      return i ? P0(l?.current ?? r.current) : Cp([
        l?.current ?? r.current
      ], {
        shouldUseInert: !0
      });
  }, [
    i,
    e.isOpen,
    r,
    l
  ]), {
    popoverProps: L(s, f),
    arrowProps: h,
    underlayProps: d,
    placement: p,
    triggerAnchorPoint: b
  };
}
var Bp = {};
Bp = {
  dismiss: "تجاهل"
};
var Fp = {};
Fp = {
  dismiss: "Отхвърляне"
};
var Tp = {};
Tp = {
  dismiss: "Odstranit"
};
var Ap = {};
Ap = {
  dismiss: "Luk"
};
var Ip = {};
Ip = {
  dismiss: "Schließen"
};
var Kp = {};
Kp = {
  dismiss: "Απόρριψη"
};
var Rp = {};
Rp = {
  dismiss: "Dismiss"
};
var Np = {};
Np = {
  dismiss: "Descartar"
};
var Mp = {};
Mp = {
  dismiss: "Lõpeta"
};
var Lp = {};
Lp = {
  dismiss: "Hylkää"
};
var zp = {};
zp = {
  dismiss: "Rejeter"
};
var Vp = {};
Vp = {
  dismiss: "התעלם"
};
var Op = {};
Op = {
  dismiss: "Odbaci"
};
var Hp = {};
Hp = {
  dismiss: "Elutasítás"
};
var _p = {};
_p = {
  dismiss: "Ignora"
};
var Wp = {};
Wp = {
  dismiss: "閉じる"
};
var jp = {};
jp = {
  dismiss: "무시"
};
var Up = {};
Up = {
  dismiss: "Atmesti"
};
var Gp = {};
Gp = {
  dismiss: "Nerādīt"
};
var qp = {};
qp = {
  dismiss: "Lukk"
};
var Yp = {};
Yp = {
  dismiss: "Negeren"
};
var Xp = {};
Xp = {
  dismiss: "Zignoruj"
};
var Zp = {};
Zp = {
  dismiss: "Descartar"
};
var Jp = {};
Jp = {
  dismiss: "Dispensar"
};
var Qp = {};
Qp = {
  dismiss: "Revocare"
};
var eb = {};
eb = {
  dismiss: "Пропустить"
};
var tb = {};
tb = {
  dismiss: "Zrušiť"
};
var nb = {};
nb = {
  dismiss: "Opusti"
};
var rb = {};
rb = {
  dismiss: "Odbaci"
};
var lb = {};
lb = {
  dismiss: "Avvisa"
};
var ib = {};
ib = {
  dismiss: "Kapat"
};
var ab = {};
ab = {
  dismiss: "Скасувати"
};
var ob = {};
ob = {
  dismiss: "取消"
};
var ub = {};
ub = {
  dismiss: "關閉"
};
var sb = {};
sb = {
  "ar-AE": Bp,
  "bg-BG": Fp,
  "cs-CZ": Tp,
  "da-DK": Ap,
  "de-DE": Ip,
  "el-GR": Kp,
  "en-US": Rp,
  "es-ES": Np,
  "et-EE": Mp,
  "fi-FI": Lp,
  "fr-FR": zp,
  "he-IL": Vp,
  "hr-HR": Op,
  "hu-HU": Hp,
  "it-IT": _p,
  "ja-JP": Wp,
  "ko-KR": jp,
  "lt-LT": Up,
  "lv-LV": Gp,
  "nb-NO": qp,
  "nl-NL": Yp,
  "pl-PL": Xp,
  "pt-BR": Zp,
  "pt-PT": Jp,
  "ro-RO": Qp,
  "ru-RU": eb,
  "sk-SK": tb,
  "sl-SI": nb,
  "sr-SP": rb,
  "sv-SE": lb,
  "tr-TR": ib,
  "uk-UA": ab,
  "zh-CN": ob,
  "zh-TW": ub
};
function _0(t) {
  return t && t.__esModule ? t.default : t;
}
function wi(t) {
  let { onDismiss: e, ...n } = t, r = ke(_0(sb), "@react-aria/overlays"), l = kt(n, r.format("dismiss")), i = () => {
    e && e();
  };
  return /* @__PURE__ */ m.createElement(ml, null, /* @__PURE__ */ m.createElement("button", {
    ...l,
    tabIndex: -1,
    onClick: i,
    style: {
      width: 1,
      height: 1
    }
  }));
}
const cb = /* @__PURE__ */ m.forwardRef(({ children: t, ...e }, n) => {
  let r = B(!1), l = z(fr), i = L(l || {}, {
    ...e,
    register() {
      r.current = !0, l && l.register();
    }
  });
  return i.ref = ge(n || l?.ref), ji(l, i.ref), Q(() => {
    r.current || (process.env.NODE_ENV !== "production" && console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), r.current = !0);
  }, []), /* @__PURE__ */ m.createElement(fr.Provider, {
    value: i
  }, t);
});
function W0({ children: t }) {
  let e = _(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ m.createElement(fr.Provider, {
    value: e
  }, t);
}
const j0 = /* @__PURE__ */ j({});
function ha() {
  return z(j0) ?? {};
}
const db = /* @__PURE__ */ m.createContext(null);
function Pi(t) {
  let e = it(), { portalContainer: n = e ? null : document.body, isExiting: r } = t, [l, i] = q(!1), a = _(() => ({
    contain: l,
    setContain: i
  }), [
    l,
    i
  ]), { getContainer: o } = ha();
  if (!t.portalContainer && o && (n = o()), !n) return null;
  let u = t.children;
  return t.disableFocusManagement || (u = /* @__PURE__ */ m.createElement(vl, {
    restoreFocus: !0,
    contain: (t.shouldContainFocus || l) && !r
  }, u)), u = /* @__PURE__ */ m.createElement(db.Provider, {
    value: a
  }, /* @__PURE__ */ m.createElement(W0, null, u)), /* @__PURE__ */ Ni.createPortal(u, n);
}
function fb() {
  let e = z(db)?.setContain;
  le(() => {
    e?.(!0);
  }, [
    e
  ]);
}
function kr(t) {
  let [e, n] = Be(t.isOpen, t.defaultOpen || !1, t.onOpenChange);
  const r = G(() => {
    n(!0);
  }, [
    n
  ]), l = G(() => {
    n(!1);
  }, [
    n
  ]), i = G(() => {
    n(!e);
  }, [
    n,
    e
  ]);
  return {
    isOpen: e,
    setOpen: n,
    open: r,
    close: l,
    toggle: i
  };
}
function Br(t, e = !0) {
  let [n, r] = q(!0), l = n && e;
  return le(() => {
    if (l && t.current && "getAnimations" in t.current)
      for (let i of t.current.getAnimations()) i instanceof CSSTransition && i.cancel();
  }, [
    t,
    l
  ]), hb(t, l, G(() => r(!1), [])), l;
}
function yr(t, e) {
  let [n, r] = q(e ? "open" : "closed");
  switch (n) {
    case "open":
      e || r("exiting");
      break;
    case "closed":
    case "exiting":
      e && r("open");
      break;
  }
  let l = n === "exiting";
  return hb(t, l, G(() => {
    r((i) => i === "exiting" ? "closed" : i);
  }, [])), l;
}
function hb(t, e, n) {
  le(() => {
    if (e && t.current) {
      if (!("getAnimations" in t.current)) {
        n();
        return;
      }
      let r = t.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let l = !1;
      return Promise.allSettled(r.map((i) => i.finished)).then(() => {
        l || Ge(() => {
          n();
        });
      }), () => {
        l = !0;
      };
    }
  }, [
    t,
    e,
    n
  ]);
}
const Fr = /* @__PURE__ */ j(null), tu = /* @__PURE__ */ j(null), A6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, Fr);
  let r = z(Kt), l = kr(e), i = e.isOpen != null || e.defaultOpen != null || !r ? l : r, a = yr(n, i.isOpen) || e.isExiting || !1, o = Fs(), { direction: u } = pe();
  if (o) {
    let c = e.children;
    return typeof c == "function" && (c = c({
      trigger: e.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ m.createElement(m.Fragment, null, c);
  }
  return i && !i.isOpen && !a ? null : /* @__PURE__ */ m.createElement(U0, {
    ...e,
    triggerRef: e.triggerRef,
    state: i,
    popoverRef: n,
    isExiting: a,
    dir: u
  });
});
function U0({ state: t, isExiting: e, UNSTABLE_portalContainer: n, clearContexts: r, ...l }) {
  let i = B(null), a = B(null), o = z(tu), u = o && l.trigger === "SubmenuTrigger", { popoverProps: c, underlayProps: s, arrowProps: d, placement: f, triggerAnchorPoint: h } = H0({
    ...l,
    offset: l.offset ?? 8,
    arrowRef: i,
    // If this is a submenu/subdialog, use the root popover's container
    // to detect outside interaction and add aria-hidden.
    groupRef: u ? o : a
  }, t), p = l.popoverRef, b = Br(p, !!f) || l.isEntering || !1, g = re({
    ...l,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: l.trigger || null,
      placement: f,
      isEntering: b,
      isExiting: e
    }
  }), y = !l.isNonModal || l.trigger === "SubmenuTrigger", [$, v] = q(!1);
  le(() => {
    p.current && v(y && !p.current.querySelector("[role=dialog]"));
  }, [
    p,
    y
  ]), Q(() => {
    $ && (l.trigger !== "SubmenuTrigger" || gt() !== "pointer") && p.current && !Bt(p.current) && Ce(p.current);
  }, [
    $,
    p,
    l.trigger
  ]);
  let E = _(() => {
    let N = g.children;
    if (r) for (let O of r) N = /* @__PURE__ */ m.createElement(O.Provider, {
      value: null
    }, N);
    return N;
  }, [
    g.children,
    r
  ]), [S, w] = q(null), C = G(() => {
    l.triggerRef.current && w(l.triggerRef.current.getBoundingClientRect().width + "px");
  }, [
    l.triggerRef
  ]);
  le(C, [
    C
  ]), Nn({
    ref: g.style?.["--trigger-width"] ? void 0 : l.triggerRef,
    onResize: C
  });
  let R = {
    ...c.style,
    "--trigger-anchor-point": h ? `${h.x}px ${h.y}px` : void 0,
    ...g.style,
    "--trigger-width": g.style?.["--trigger-width"] || S
  }, I = /* @__PURE__ */ m.createElement(X.div, {
    ...L(Y(l, {
      global: !0
    }), c),
    ...g,
    role: $ ? "dialog" : void 0,
    tabIndex: $ ? -1 : void 0,
    "aria-label": l["aria-label"],
    "aria-labelledby": l["aria-labelledby"],
    ref: p,
    slot: l.slot || void 0,
    style: R,
    dir: l.dir,
    "data-trigger": l.trigger,
    "data-placement": f,
    "data-entering": b || void 0,
    "data-exiting": e || void 0
  }, !l.isNonModal && /* @__PURE__ */ m.createElement(wi, {
    onDismiss: t.close
  }), /* @__PURE__ */ m.createElement(Ep.Provider, {
    value: {
      ...d,
      placement: f,
      ref: i
    }
  }, E), /* @__PURE__ */ m.createElement(wi, {
    onDismiss: t.close
  }));
  return u ? /* @__PURE__ */ m.createElement(Pi, {
    ...l,
    shouldContainFocus: $,
    isExiting: e,
    portalContainer: n ?? o?.current ?? void 0
  }, I) : /* @__PURE__ */ m.createElement(Pi, {
    ...l,
    shouldContainFocus: $,
    isExiting: e,
    portalContainer: n
  }, !l.isNonModal && t.isOpen && /* @__PURE__ */ m.createElement("div", {
    "data-testid": "underlay",
    ...s,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ m.createElement("div", {
    ref: a,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ m.createElement(tu.Provider, {
    value: a
  }, I)));
}
const G0 = /* @__PURE__ */ j({});
var pb = {};
pb = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var bb = {};
bb = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var mb = {};
mb = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var gb = {};
gb = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var yb = {};
yb = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var $b = {};
$b = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var vb = {};
vb = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var xb = {};
xb = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var Eb = {};
Eb = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var Cb = {};
Cb = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var Db = {};
Db = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var wb = {};
wb = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var Pb = {};
Pb = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var Sb = {};
Sb = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var kb = {};
kb = {
  longPressMessage: "Premi a lungo o premi Alt + Freccia giù per aprire il menu"
};
var Bb = {};
Bb = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var Fb = {};
Fb = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var Tb = {};
Tb = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var Ab = {};
Ab = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var Ib = {};
Ib = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var Kb = {};
Kb = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var Rb = {};
Rb = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var Nb = {};
Nb = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var Mb = {};
Mb = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var Lb = {};
Lb = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var zb = {};
zb = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var Vb = {};
Vb = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var Ob = {};
Ob = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var Hb = {};
Hb = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var _b = {};
_b = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var Wb = {};
Wb = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var jb = {};
jb = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var Ub = {};
Ub = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var Gb = {};
Gb = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var qb = {};
qb = {
  "ar-AE": pb,
  "bg-BG": bb,
  "cs-CZ": mb,
  "da-DK": gb,
  "de-DE": yb,
  "el-GR": $b,
  "en-US": vb,
  "es-ES": xb,
  "et-EE": Eb,
  "fi-FI": Cb,
  "fr-FR": Db,
  "he-IL": wb,
  "hr-HR": Pb,
  "hu-HU": Sb,
  "it-IT": kb,
  "ja-JP": Bb,
  "ko-KR": Fb,
  "lt-LT": Tb,
  "lv-LV": Ab,
  "nb-NO": Ib,
  "nl-NL": Kb,
  "pl-PL": Rb,
  "pt-BR": Nb,
  "pt-PT": Mb,
  "ro-RO": Lb,
  "ru-RU": zb,
  "sk-SK": Vb,
  "sl-SI": Ob,
  "sr-SP": Hb,
  "sv-SE": _b,
  "tr-TR": Wb,
  "uk-UA": jb,
  "zh-CN": Ub,
  "zh-TW": Gb
};
function Yb(t, e, n) {
  let { type: r } = t, { isOpen: l } = e;
  Q(() => {
    n && n.current && wp.set(n.current, e.close);
  });
  let i;
  r === "menu" ? i = !0 : r === "listbox" && (i = "listbox");
  let a = ce();
  return {
    triggerProps: {
      "aria-haspopup": i,
      "aria-expanded": l,
      "aria-controls": l ? a : void 0,
      onPress: e.toggle
    },
    overlayProps: {
      id: a
    }
  };
}
function q0(t) {
  return t && t.__esModule ? t.default : t;
}
function Xb(t, e, n) {
  let { type: r = "menu", isDisabled: l, trigger: i = "press" } = t, a = ce(), { triggerProps: o, overlayProps: u } = Yb({
    type: r
  }, e, n), c = (h) => {
    if (!l && !(i === "longPress" && !h.altKey) && n && n.current)
      switch (h.key) {
        case "Enter":
        case " ":
          if (i === "longPress" || h.isDefaultPrevented()) return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in h || h.stopPropagation(), h.preventDefault(), e.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in h || h.stopPropagation(), h.preventDefault(), e.toggle("last");
          break;
        default:
          "continuePropagation" in h && h.continuePropagation();
      }
  }, s = ke(q0(qb), "@react-aria/menu"), { longPressProps: d } = hp({
    isDisabled: l || i !== "longPress",
    accessibilityDescription: s.format("longPressMessage"),
    onLongPressStart() {
      e.close();
    },
    onLongPress() {
      e.open("first");
    }
  }), f = {
    preventFocusOnPress: !0,
    onPressStart(h) {
      h.pointerType !== "touch" && h.pointerType !== "keyboard" && !l && (Pe(h.target), e.open(h.pointerType === "virtual" ? "first" : null));
    },
    onPress(h) {
      h.pointerType === "touch" && !l && (Pe(h.target), e.toggle());
    }
  };
  return delete o.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...o,
      ...i === "press" ? f : d,
      id: a,
      onKeyDown: c
    },
    menuProps: {
      ...u,
      "aria-labelledby": a,
      autoFocus: e.focusStrategy || !0,
      onClose: e.close
    }
  };
}
const Zb = /* @__PURE__ */ new WeakMap();
function Y0(t, e, n) {
  let { shouldFocusWrap: r = !0, onKeyDown: l, onKeyUp: i, ...a } = t;
  !t["aria-label"] && !t["aria-labelledby"] && process.env.NODE_ENV !== "production" && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let o = Y(t, {
    labelable: !0
  }), { listProps: u } = ca({
    ...a,
    ref: n,
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    shouldFocusWrap: r,
    linkBehavior: "override"
  });
  return Zb.set(e, {
    onClose: t.onClose,
    onAction: t.onAction,
    shouldUseVirtualFocus: t.shouldUseVirtualFocus
  }), {
    menuProps: L(o, {
      onKeyDown: l,
      onKeyUp: i
    }, {
      role: "menu",
      ...u,
      onKeyDown: (c) => {
        (c.key !== "Escape" || t.shouldUseVirtualFocus) && u.onKeyDown?.(c);
      }
    })
  };
}
function X0(t, e, n) {
  let { id: r, key: l, closeOnSelect: i, shouldCloseOnSelect: a, isVirtualized: o, "aria-haspopup": u, onPressStart: c, onPressUp: s, onPress: d, onPressChange: f, onPressEnd: h, onClick: p, onHoverStart: b, onHoverChange: g, onHoverEnd: y, onKeyDown: $, onKeyUp: v, onFocus: E, onFocusChange: S, onBlur: w, selectionManager: C = e.selectionManager } = t, R = !!u, I = R && t["aria-expanded"] === "true", N = t.isDisabled ?? C.isDisabled(l), O = t.isSelected ?? C.isSelected(l), A = Zb.get(e), V = e.collection.getItem(l), x = t.onClose || A.onClose, K = Vn(), D = () => {
    if (!R && (V?.props?.onAction ? V.props.onAction() : t.onAction && t.onAction(l), A.onAction)) {
      let fe = A.onAction;
      fe(l, V?.value);
    }
  }, F = "menuitem";
  R || (C.selectionMode === "single" ? F = "menuitemradio" : C.selectionMode === "multiple" && (F = "menuitemcheckbox"));
  let M = mt(), P = mt(), T = mt(), W = {
    id: r,
    "aria-disabled": N || void 0,
    role: F,
    "aria-label": t["aria-label"],
    "aria-labelledby": M,
    "aria-describedby": [
      t["aria-describedby"],
      P,
      T
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": t["aria-controls"],
    "aria-haspopup": u,
    "aria-expanded": t["aria-expanded"]
  };
  if (C.selectionMode !== "none" && !R && (W["aria-checked"] = O), o) {
    let fe = Number(V?.index);
    W["aria-posinset"] = Number.isNaN(fe) ? void 0 : fe + 1, W["aria-setsize"] = pp(e.collection);
  }
  let U = B(!1), k = (fe) => {
    f?.(fe), U.current = fe;
  }, ee = B(null), Z = (fe) => {
    fe.pointerType !== "keyboard" && (ee.current = {
      pointerType: fe.pointerType
    }), fe.pointerType === "mouse" && (U.current || fe.target.click()), s?.(fe);
  }, de = (fe) => {
    p?.(fe), D(), Mu(fe, K, V.props.href, V?.props.routerOptions);
    let Rt = ee.current?.pointerType === "keyboard" ? ee.current?.key === "Enter" || C.selectionMode === "none" || C.isLink(l) : C.selectionMode !== "multiple" || C.isLink(l);
    Rt = a ?? i ?? Rt, x && !R && Rt && x(), ee.current = null;
  }, { itemProps: ae, isFocused: se } = Un({
    id: r,
    selectionManager: C,
    key: l,
    ref: n,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: A.shouldUseVirtualFocus
  }), { pressProps: Se, isPressed: Yn } = lt({
    onPressStart: c,
    onPress: d,
    onPressUp: Z,
    onPressChange: k,
    onPressEnd: h,
    isDisabled: N
  }), { hoverProps: et } = ve({
    isDisabled: N,
    onHoverStart(fe) {
      !vt() && !(I && u) && (C.setFocused(!0), C.setFocusedKey(l)), b?.(fe);
    },
    onHoverChange: g,
    onHoverEnd: y
  }), { keyboardProps: gn } = Hn({
    onKeyDown: (fe) => {
      if (fe.repeat) {
        fe.continuePropagation();
        return;
      }
      switch (fe.key) {
        case " ":
          ee.current = {
            pointerType: "keyboard",
            key: " "
          }, H(fe).click(), sr("keyboard");
          break;
        case "Enter":
          ee.current = {
            pointerType: "keyboard",
            key: "Enter"
          }, H(fe).tagName !== "A" && H(fe).click(), sr("keyboard");
          break;
        default:
          R || fe.continuePropagation(), $?.(fe);
          break;
      }
    },
    onKeyUp: v
  }), { focusableProps: wt } = Je({
    onBlur: w,
    onFocus: E,
    onFocusChange: S
  }, n), yn = Y(V?.props);
  delete yn.id;
  let $n = fl(V?.props);
  return {
    menuItemProps: {
      ...W,
      ...L(
        yn,
        $n,
        R ? {
          onFocus: ae.onFocus,
          "data-collection": ae["data-collection"],
          "data-key": ae["data-key"]
        } : ae,
        Se,
        et,
        gn,
        wt,
        // Prevent DOM focus from moving on mouse down when using virtual focus or this is a submenu/subdialog trigger.
        A.shouldUseVirtualFocus || R ? {
          onMouseDown: (fe) => fe.preventDefault()
        } : void 0,
        N ? void 0 : {
          onClick: de
        }
      ),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: ae.tabIndex != null && I && !A.shouldUseVirtualFocus ? -1 : ae.tabIndex
    },
    labelProps: {
      id: M
    },
    descriptionProps: {
      id: P
    },
    keyboardShortcutProps: {
      id: T
    },
    isFocused: se,
    isFocusVisible: se && C.isFocused && vt() && !I,
    isSelected: O,
    isPressed: Yn,
    isDisabled: N
  };
}
function Z0(t) {
  let { heading: e, "aria-label": n } = t, r = ce();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: e ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: r,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": e ? r : void 0
    }
  };
}
const Or = 2, J0 = 50, Q0 = 1e3, nu = Math.PI / 12;
function e1(t) {
  let { menuRef: e, submenuRef: n, isOpen: r, isDisabled: l } = t, i = B(void 0), a = B(void 0), o = B(0), u = B(void 0), c = B(void 0), s = B(void 0), d = B(2), [f, h] = q(!1);
  Nn({
    ref: r ? n : void 0,
    onResize: () => {
      n.current && (a.current = n.current.getBoundingClientRect(), s.current = void 0);
    }
  });
  let b = () => {
    h(!1), d.current = Or, i.current = void 0;
  }, g = pl(), y = ye(($) => {
    f && $.preventDefault();
  });
  Q(() => {
    f && e.current ? e.current.style.pointerEvents = "none" : e.current.style.pointerEvents = "";
  }, [
    e,
    f
  ]), le(() => {
    let $ = n.current, v = e.current;
    if (l || !$ || !r || g !== "pointer" || !v) {
      b();
      return;
    }
    a.current = $.getBoundingClientRect();
    let E = (S) => {
      if (S.pointerType === "touch" || S.pointerType === "pen") return;
      let w = Date.now();
      if (w - o.current < J0) return;
      clearTimeout(u.current), clearTimeout(c.current);
      let { clientX: C, clientY: R } = S;
      if (!i.current) {
        i.current = {
          x: C,
          y: R
        };
        return;
      }
      if (!a.current) return;
      if (s.current || (s.current = C > a.current.right ? "left" : "right"), C < v.getBoundingClientRect().left || C > v.getBoundingClientRect().right || R < v.getBoundingClientRect().top || R > v.getBoundingClientRect().bottom) {
        b();
        return;
      }
      let I = i.current.x, N = i.current.y, O = s.current === "right" ? a.current.left - I : I - a.current.right, A = Math.atan2(N - a.current.top, O) + nu, V = Math.atan2(N - a.current.bottom, O) - nu, x = Math.atan2(N - R, s.current === "left" ? -(C - I) : C - I), K = x < A && x > V;
      d.current = K ? Math.min(d.current + 1, Or) : Math.max(d.current - 1, 0), d.current >= Or ? h(!0) : h(!1), o.current = w, i.current = {
        x: C,
        y: R
      }, K && (u.current = setTimeout(() => {
        b(), c.current = setTimeout(() => {
          let D = document.elementFromPoint(C, R);
          D && ne(v, D) && D.dispatchEvent(new PointerEvent("pointerover", {
            bubbles: !0,
            cancelable: !0
          }));
        }, 100);
      }, Q0));
    };
    return window.addEventListener("pointermove", E), process.env.NODE_ENV !== "test" && window.addEventListener("pointerdown", y, !0), () => {
      window.removeEventListener("pointermove", E), process.env.NODE_ENV !== "test" && window.removeEventListener("pointerdown", y, !0), clearTimeout(u.current), clearTimeout(c.current), d.current = Or;
    };
  }, [
    l,
    r,
    e,
    g,
    h,
    n
  ]);
}
function t1(t, e, n) {
  let { parentMenuRef: r, submenuRef: l, type: i = "menu", isDisabled: a, delay: o = 200, shouldUseVirtualFocus: u } = t, c = ce(), s = ce(), { direction: d } = pe(), f = B(void 0), h = G(() => {
    f.current && (clearTimeout(f.current), f.current = void 0);
  }, [
    f
  ]), p = G((C) => {
    h(), e.open(C);
  }, [
    e,
    h
  ]), b = G(() => {
    h(), e.close();
  }, [
    e,
    h
  ]);
  le(() => () => {
    h();
  }, [
    h
  ]);
  let g = (C) => {
    if (Bt(C.currentTarget))
      switch (C.key) {
        case "ArrowLeft":
          d === "ltr" && ne(C.currentTarget, H(C)) && (C.preventDefault(), C.stopPropagation(), b(), !u && n.current && Pe(n.current));
          break;
        case "ArrowRight":
          d === "rtl" && ne(C.currentTarget, H(C)) && (C.preventDefault(), C.stopPropagation(), b(), !u && n.current && Pe(n.current));
          break;
        case "Escape":
          ne(l.current, H(C)) && (C.stopPropagation(), b(), !u && n.current && Pe(n.current));
          break;
      }
  }, y = {
    id: s,
    "aria-labelledby": c,
    submenuLevel: e.submenuLevel,
    ...i === "menu" && {
      onClose: e.closeAll,
      autoFocus: e.focusStrategy ?? void 0,
      onKeyDown: g
    }
  }, $ = (C) => {
    switch (C.key) {
      case "ArrowRight":
        a || (d === "ltr" ? (C.preventDefault(), e.isOpen || p("first"), i === "menu" && l?.current && oe() === n?.current && Pe(l.current)) : e.isOpen ? b() : C.continuePropagation());
        break;
      case "ArrowLeft":
        a || (d === "rtl" ? (C.preventDefault(), e.isOpen || p("first"), i === "menu" && l?.current && oe() === n?.current && Pe(l.current)) : e.isOpen ? b() : C.continuePropagation());
        break;
      default:
        C.continuePropagation();
        break;
    }
  }, v = (C) => {
    !a && (C.pointerType === "virtual" || C.pointerType === "keyboard") && p("first");
  }, E = (C) => {
    !a && (C.pointerType === "touch" || C.pointerType === "mouse") && p();
  }, S = (C) => {
    a || (C && !e.isOpen ? f.current || (f.current = setTimeout(() => {
      p();
    }, o)) : C || h());
  };
  Vt(r, "focusin", (C) => {
    e.isOpen && ne(r.current, H(C)) && H(C) !== n.current && b();
  });
  let w = (C) => C !== n.current;
  return e1({
    menuRef: r,
    submenuRef: l,
    isOpen: e.isOpen,
    isDisabled: a
  }), {
    submenuTriggerProps: {
      id: c,
      "aria-controls": e.isOpen ? s : void 0,
      "aria-haspopup": a ? void 0 : i,
      "aria-expanded": e.isOpen ? "true" : "false",
      onPressStart: v,
      onPress: E,
      onHoverChange: S,
      onKeyDown: $,
      isOpen: e.isOpen
    },
    submenuProps: y,
    popoverProps: {
      isNonModal: !0,
      shouldCloseOnInteractOutside: w
    }
  };
}
function pa(t) {
  let e = kr(t), [n, r] = q(null), [l, i] = q([]), a = () => {
    i([]), e.close();
  };
  return {
    focusStrategy: n,
    ...e,
    open(c = null) {
      r(c), e.open();
    },
    toggle(c = null) {
      r(c), e.toggle();
    },
    close() {
      a();
    },
    expandedKeysStack: l,
    openSubmenu: (c, s) => {
      i((d) => s > d.length ? d : [
        ...d.slice(0, s),
        c
      ]);
    },
    closeSubmenu: (c, s) => {
      i((d) => d[s] === c ? d.slice(0, s) : d);
    }
  };
}
function n1(t, e) {
  let { triggerKey: n } = t, { expandedKeysStack: r, openSubmenu: l, closeSubmenu: i, close: a } = e, [o] = q(r?.length), u = _(() => r[o] === n, [
    r,
    n,
    o
  ]), [c, s] = q(null), d = G((p) => {
    s(p ?? null), l(n, o);
  }, [
    l,
    o,
    n
  ]), f = G(() => {
    s(null), i(n, o);
  }, [
    i,
    o,
    n
  ]), h = G((p) => {
    s(p ?? null), u ? f() : d(p);
  }, [
    f,
    d,
    u
  ]);
  return _(() => ({
    focusStrategy: c,
    isOpen: u,
    open: d,
    close: f,
    closeAll: a,
    submenuLevel: o,
    // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
    // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
    setOpen: () => {
    },
    toggle: h
  }), [
    u,
    d,
    f,
    a,
    c,
    h,
    o
  ]);
}
class r1 {
  constructor(e, { expandedKeys: n } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e, n = n || /* @__PURE__ */ new Set();
    let r = (a) => {
      if (this.keyMap.set(a.key, a), a.childNodes && (a.type === "section" || n.has(a.key))) for (let o of a.childNodes) r(o);
    };
    for (let a of e) r(a);
    let l = null, i = 0;
    for (let [a, o] of this.keyMap)
      l ? (l.nextKey = a, o.prevKey = l.key) : (this.firstKey = a, o.prevKey = void 0), o.type === "item" && (o.index = i++), l = o, l.nextKey = void 0;
    this.lastKey = l?.key ?? null;
  }
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let n = this.keyMap.get(e);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(e) {
    let n = this.keyMap.get(e);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    return this.keyMap.get(e) ?? null;
  }
  at(e) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[e]);
  }
}
function l1(t) {
  let { onExpandedChange: e } = t, [n, r] = Be(t.expandedKeys ? new Set(t.expandedKeys) : void 0, t.defaultExpandedKeys ? new Set(t.defaultExpandedKeys) : /* @__PURE__ */ new Set(), e), l = Sr(t), i = _(() => t.disabledKeys ? new Set(t.disabledKeys) : /* @__PURE__ */ new Set(), [
    t.disabledKeys
  ]), a = da(t, G((u) => new r1(u, {
    expandedKeys: n
  }), [
    n
  ]), null);
  return Q(() => {
    l.focusedKey != null && !a.getItem(l.focusedKey) && l.setFocusedKey(null);
  }, [
    a,
    l.focusedKey
  ]), {
    collection: a,
    expandedKeys: n,
    disabledKeys: i,
    toggleKey: (u) => {
      r(i1(n, u));
    },
    setExpandedKeys: r,
    selectionManager: new Gn(a, l)
  };
}
function i1(t, e) {
  let n = new Set(t);
  return n.has(e) ? n.delete(e) : n.add(e), n;
}
const ba = /* @__PURE__ */ j(null), Cl = /* @__PURE__ */ j(null), $r = /* @__PURE__ */ j(null), ol = /* @__PURE__ */ j(null);
function I6(t) {
  let e = pa(t), n = B(null), { menuTriggerProps: r, menuProps: l } = Xb({
    ...t,
    type: "menu"
  }, e, n), i = B(null);
  return Fs() ? null : /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        ba,
        {
          ...l,
          ref: i
        }
      ],
      [
        Kt,
        e
      ],
      [
        $r,
        e
      ],
      [
        Fr,
        {
          trigger: "MenuTrigger",
          triggerRef: n,
          scrollRef: i,
          placement: "bottom start",
          "aria-labelledby": l["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ m.createElement(cb, {
    ...r,
    ref: n,
    isPressed: e.isOpen
  }, t.children));
}
const Jb = /* @__PURE__ */ j(null), Ra = class Ra extends Ze {
  filter(e, n, r) {
    let l = e.getItem(this.firstChildKey);
    if (l && r(l.textValue, this)) {
      let i = this.clone();
      return n.addDescendants(i, e), i;
    }
    return null;
  }
};
Ra.type = "submenutrigger";
let Si = Ra;
const K6 = /* @__PURE__ */ xr(Si, (t, e, n) => {
  let { CollectionBranch: r } = z(me), l = z(Cl), i = z($r), a = n1({
    triggerKey: n.key
  }, i), o = B(null), u = ge(e), { parentMenuRef: c, shouldUseVirtualFocus: s } = z(Jb), { submenuTriggerProps: d, submenuProps: f, popoverProps: h } = t1({
    parentMenuRef: c,
    submenuRef: o,
    delay: t.delay,
    shouldUseVirtualFocus: s
  }, a, u);
  return /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Mn,
        {
          ...d,
          onAction: void 0,
          ref: u
        }
      ],
      [
        ba,
        {
          ref: o,
          ...f
        }
      ],
      [
        Kt,
        a
      ],
      [
        Fr,
        {
          trigger: "SubmenuTrigger",
          triggerRef: u,
          placement: "end top",
          "aria-labelledby": f["aria-labelledby"],
          ...h
        }
      ]
    ]
  }, /* @__PURE__ */ m.createElement(r, {
    collection: l.collection,
    parent: n
  }), t.children[1]);
}, (t) => t.children[0]), R6 = /* @__PURE__ */ te(function(e, n) {
  return [e, n] = ie(e, n, ba), /* @__PURE__ */ m.createElement(hn, {
    content: /* @__PURE__ */ m.createElement(At, e)
  }, (r) => /* @__PURE__ */ m.createElement(a1, {
    props: e,
    collection: r,
    menuRef: n
  }));
});
function a1({ props: t, collection: e, menuRef: n }) {
  [t, n] = ie(t, n, dn);
  let { filter: r, ...l } = t, i = _(() => r ? e.filter(r) : e, [
    e,
    r
  ]), a = l1({
    ...t,
    collection: i,
    children: void 0
  }), o = z($r), { isVirtualized: u, CollectionRoot: c } = z(me), { menuProps: s } = Y0({
    ...t,
    isVirtualized: u,
    onClose: t.onClose || o?.close
  }, a, n), d = re({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-Menu",
    values: {
      isEmpty: a.collection.size === 0
    }
  }), f = null;
  a.collection.size === 0 && t.renderEmptyState && (f = /* @__PURE__ */ m.createElement("div", {
    role: "menuitem",
    style: {
      display: "contents"
    }
  }, t.renderEmptyState()));
  let h = Y(t, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(vl, null, /* @__PURE__ */ m.createElement(X.div, {
    ...L(h, d, s),
    ref: n,
    slot: t.slot || void 0,
    "data-empty": a.collection.size === 0 || void 0,
    onScroll: t.onScroll
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Cl,
        a
      ],
      [
        aa,
        {
          elementType: "div"
        }
      ],
      [
        Ks,
        {
          name: "MenuSection",
          render: Qb
        }
      ],
      [
        Jb,
        {
          parentMenuRef: n,
          shouldUseVirtualFocus: l?.shouldUseVirtualFocus
        }
      ],
      [
        Mn,
        {
          shouldCloseOnSelect: t.shouldCloseOnSelect
        }
      ],
      [
        dn,
        null
      ],
      [
        vr,
        null
      ],
      [
        ol,
        a.selectionManager
      ],
      /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */
      /* We assume the context can never change between defined and undefined. */
      /* eslint-disable-next-line react-hooks/rules-of-hooks */
      [
        $r,
        o ?? pa({})
      ]
    ]
  }, /* @__PURE__ */ m.createElement(bn, null, /* @__PURE__ */ m.createElement(c, {
    collection: a.collection,
    persistedKeys: Gi(a.selectionManager.focusedKey),
    scrollRef: n
  }))), f));
}
class o1 extends Gn {
  constructor(e, n) {
    super(e.collection, n), this.parent = e;
  }
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(e, n) {
    return this.parent.setFocusedKey(e, n);
  }
  setFocused(e) {
    this.parent.setFocused(e);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
}
function Qb(t, e, n, r = "react-aria-MenuSection") {
  let l = z(Cl), { CollectionBranch: i } = z(me), [a, o] = Xe(), { headingProps: u, groupProps: c } = Z0({
    heading: o,
    "aria-label": n.props["aria-label"] ?? void 0
  }), s = re({
    ...t,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    className: n.props?.className,
    style: n.props?.style,
    values: void 0
  }), d = z(ol), f = Sr(t), h = t.selectionMode != null ? new o1(d, f) : d, p = We(Mn)?.shouldCloseOnSelect, b = Y(t, {
    global: !0
  });
  return delete b.id, /* @__PURE__ */ m.createElement(X.section, {
    ...L(b, s, c),
    ref: e
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        ia,
        {
          ...u,
          ref: a
        }
      ],
      [
        ol,
        h
      ],
      [
        Mn,
        {
          shouldCloseOnSelect: t.shouldCloseOnSelect ?? p
        }
      ]
    ]
  }, /* @__PURE__ */ m.createElement(i, {
    collection: l.collection,
    parent: n
  })));
}
const N6 = /* @__PURE__ */ xr(li, Qb), Mn = /* @__PURE__ */ j(null), M6 = /* @__PURE__ */ ot(cr, function(e, n, r) {
  [e, n] = ie(e, n, Mn);
  let l = We(Mn)?.id, i = z(Cl), a = ge(n), o = z(ol), { isVirtualized: u } = z(me), { menuItemProps: c, labelProps: s, descriptionProps: d, keyboardShortcutProps: f, ...h } = X0({
    ...e,
    id: l,
    key: r.key,
    selectionManager: o,
    isVirtualized: u
  }, i, a), { hoverProps: p, isHovered: b } = ve({
    isDisabled: h.isDisabled
  }), g = re({
    ...e,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...h,
      isHovered: b,
      isFocusVisible: h.isFocusVisible,
      selectionMode: o.selectionMode,
      selectionBehavior: o.selectionBehavior,
      hasSubmenu: !!e["aria-haspopup"],
      isOpen: e["aria-expanded"] === "true"
    }
  }), y = e.href ? X.a : X.div, $ = Y(e, {
    global: !0
  });
  return delete $.id, delete $.onClick, /* @__PURE__ */ m.createElement(y, {
    ...L($, g, c, p),
    ref: a,
    "data-disabled": h.isDisabled || void 0,
    "data-hovered": b || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": h.isFocusVisible || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-selected": h.isSelected || void 0,
    "data-selection-mode": o.selectionMode === "none" ? void 0 : o.selectionMode,
    "data-has-submenu": !!e["aria-haspopup"] || void 0,
    "data-open": e["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Qe,
        {
          slots: {
            [rt]: s,
            label: s,
            description: d
          }
        }
      ],
      [
        G0,
        f
      ],
      [
        mn,
        {
          isSelected: h.isSelected
        }
      ]
    ]
  }, g.children));
});
function u1(t, e) {
  let { role: n = "dialog" } = t, r = mt();
  r = t["aria-label"] ? void 0 : r;
  let l = B(!1);
  Q(() => {
    if (e.current && !Bt(e.current)) {
      Ce(e.current);
      let a = setTimeout(() => {
        (oe() === e.current || oe() === document.body) && (l.current = !0, e.current && (e.current.blur(), Ce(e.current)), l.current = !1);
      }, 500);
      return () => {
        clearTimeout(a);
      };
    }
  }, [
    e
  ]), fb();
  let i = B(!1);
  return Q(() => {
    if (process.env.NODE_ENV !== "production" && !i.current && e.current) {
      let a = e.current, o = a.hasAttribute("aria-label"), u = a.hasAttribute("aria-labelledby");
      !o && !u && (console.warn("A dialog must have a title for accessibility. Either provide an aria-label or aria-labelledby prop, or render a heading element inside the dialog."), i.current = !0);
    }
  }), {
    dialogProps: {
      ...Y(t, {
        labelable: !0
      }),
      role: n,
      tabIndex: -1,
      "aria-labelledby": t["aria-labelledby"] || r,
      // Prevent blur events from reaching useOverlay, which may cause
      // popovers to close. Since focus is contained within the dialog,
      // we don't want this to occur due to the above useEffect.
      onBlur: (a) => {
        l.current && a.stopPropagation();
      }
    },
    titleProps: {
      id: r
    }
  };
}
const e4 = /* @__PURE__ */ j(null), Kt = /* @__PURE__ */ j(null);
function L6(t) {
  let e = pa(t), n = B(null), { triggerProps: r, overlayProps: l } = Yb({
    type: "dialog"
  }, e, n);
  return r.id = ce(), l["aria-labelledby"] = r.id, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Kt,
        e
      ],
      [
        $r,
        e
      ],
      [
        e4,
        l
      ],
      [
        Fr,
        {
          trigger: "DialogTrigger",
          triggerRef: n,
          "aria-labelledby": l["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ m.createElement(cb, {
    ...r,
    ref: n,
    isPressed: e.isOpen
  }, t.children));
}
const z6 = /* @__PURE__ */ te(function(e, n) {
  let r = e["aria-labelledby"];
  [e, n] = ie(e, n, e4);
  let { dialogProps: l, titleProps: i } = u1({
    ...e,
    // Only pass aria-labelledby from props, not context.
    // Context is used as a fallback below.
    "aria-labelledby": r
  }, n), a = z(Kt);
  !l["aria-label"] && !l["aria-labelledby"] && (e["aria-labelledby"] ? l["aria-labelledby"] = e["aria-labelledby"] : process.env.NODE_ENV !== "production" && console.warn('If a Dialog does not contain a <Heading slot="title">, it must have an aria-label or aria-labelledby attribute for accessibility.'));
  let o = re({
    defaultClassName: "react-aria-Dialog",
    className: e.className,
    style: e.style,
    children: e.children,
    values: {
      close: a?.close || (() => {
      })
    }
  }), u = Y(e, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.section, {
    ...L(u, o, l),
    render: e.render,
    ref: n,
    slot: e.slot || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        wc,
        {
          slots: {
            [rt]: {},
            title: {
              ...i,
              level: 2
            }
          }
        }
      ],
      [
        st,
        {
          slots: {
            [rt]: {},
            close: {
              onPress: () => a?.close()
            }
          }
        }
      ]
    ]
  }, o.children));
});
function V6(t) {
  let e = jn({
    usage: "search",
    ...t
  }), n = G((i, a) => a.length === 0 ? !0 : (i = i.normalize("NFC"), a = a.normalize("NFC"), e.compare(i.slice(0, a.length), a) === 0), [
    e
  ]), r = G((i, a) => a.length === 0 ? !0 : (i = i.normalize("NFC"), a = a.normalize("NFC"), e.compare(i.slice(-a.length), a) === 0), [
    e
  ]), l = G((i, a) => {
    if (a.length === 0) return !0;
    i = i.normalize("NFC"), a = a.normalize("NFC");
    let o = 0, u = a.length;
    for (; o + u <= i.length; o++) {
      let c = i.slice(o, o + u);
      if (e.compare(a, c) === 0) return !0;
    }
    return !1;
  }, [
    e
  ]);
  return _(() => ({
    startsWith: n,
    endsWith: r,
    contains: l
  }), [
    n,
    r,
    l
  ]);
}
function s1(t, e, n) {
  let { isDisabled: r } = t, l = ce(), i = ce(), a = it(), o = B(null), u = G(() => {
    o.current = requestAnimationFrame(() => {
      n.current && n.current.setAttribute("hidden", "until-found");
    }), Ge(() => {
      e.toggle();
    });
  }, [
    n,
    e
  ]);
  Vt(n, "beforematch", u);
  let c = B(null);
  return le(() => {
    if (o.current && cancelAnimationFrame(o.current), n.current && !a) {
      let s = n.current;
      c.current == null || typeof s.getAnimations != "function" ? e.isExpanded ? (s.removeAttribute("hidden"), s.style.setProperty("--disclosure-panel-width", "auto"), s.style.setProperty("--disclosure-panel-height", "auto")) : (s.setAttribute("hidden", "until-found"), s.style.setProperty("--disclosure-panel-width", "0px"), s.style.setProperty("--disclosure-panel-height", "0px")) : e.isExpanded !== c.current && (e.isExpanded ? (s.removeAttribute("hidden"), s.style.setProperty("--disclosure-panel-width", s.scrollWidth + "px"), s.style.setProperty("--disclosure-panel-height", s.scrollHeight + "px"), Promise.all(s.getAnimations().map((d) => d.finished)).then(() => {
        s.style.setProperty("--disclosure-panel-width", "auto"), s.style.setProperty("--disclosure-panel-height", "auto");
      }).catch(() => {
      })) : (s.style.setProperty("--disclosure-panel-width", s.scrollWidth + "px"), s.style.setProperty("--disclosure-panel-height", s.scrollHeight + "px"), window.getComputedStyle(s).height, s.style.setProperty("--disclosure-panel-width", "0px"), s.style.setProperty("--disclosure-panel-height", "0px"), Promise.all(s.getAnimations().map((d) => d.finished)).then(() => s.setAttribute("hidden", "until-found")).catch(() => {
      }))), c.current = e.isExpanded;
    }
  }, [
    r,
    n,
    e.isExpanded,
    a
  ]), Q(() => () => {
    o.current && cancelAnimationFrame(o.current);
  }, []), {
    buttonProps: {
      id: l,
      "aria-expanded": e.isExpanded,
      "aria-controls": i,
      onPress: (s) => {
        !r && s.pointerType !== "keyboard" && e.toggle();
      },
      isDisabled: r,
      onPressStart(s) {
        s.pointerType === "keyboard" && !r && e.toggle();
      }
    },
    panelProps: {
      id: i,
      // This can be overridden at the panel element level.
      role: "group",
      "aria-labelledby": l,
      "aria-hidden": !e.isExpanded,
      hidden: a ? !e.isExpanded : void 0
    }
  };
}
function c1(t) {
  let { allowsMultipleExpanded: e = !1, isDisabled: n = !1 } = t, [r, l] = Be(_(() => t.expandedKeys ? new Set(t.expandedKeys) : void 0, [
    t.expandedKeys
  ]), _(() => t.defaultExpandedKeys ? new Set(t.defaultExpandedKeys) : /* @__PURE__ */ new Set(), [
    t.defaultExpandedKeys
  ]), t.onExpandedChange);
  return Q(() => {
    if (!e && r.size > 1) {
      let i = r.values().next().value;
      i != null && l(/* @__PURE__ */ new Set([
        i
      ]));
    }
  }), {
    allowsMultipleExpanded: e,
    isDisabled: n,
    expandedKeys: r,
    setExpandedKeys: l,
    toggleKey(i) {
      let a;
      e ? (a = new Set(r), a.has(i) ? a.delete(i) : a.add(i)) : a = new Set(r.has(i) ? [] : [
        i
      ]), l(a);
    }
  };
}
function d1(t) {
  let [e, n] = Be(t.isExpanded, t.defaultExpanded || !1, t.onExpandedChange);
  const r = G(() => {
    n(!0);
  }, [
    n
  ]), l = G(() => {
    n(!1);
  }, [
    n
  ]), i = G(() => {
    n(!e);
  }, [
    n,
    e
  ]);
  return {
    isExpanded: e,
    setExpanded: n,
    expand: r,
    collapse: l,
    toggle: i
  };
}
const t4 = /* @__PURE__ */ j(null), O6 = /* @__PURE__ */ te(function(e, n) {
  let r = c1(e), l = re({
    ...e,
    defaultClassName: "react-aria-DisclosureGroup",
    values: {
      isDisabled: r.isDisabled,
      state: r
    }
  }), i = Y(e, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...i,
    ...l,
    ref: n,
    "data-disabled": e.isDisabled || void 0
  }, /* @__PURE__ */ m.createElement(t4.Provider, {
    value: r
  }, l.children));
}), f1 = /* @__PURE__ */ j(null), h1 = /* @__PURE__ */ j(null), n4 = /* @__PURE__ */ j(null), H6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, f1);
  let r = z(t4), { id: l, ...i } = e, a = ce();
  l ||= a;
  let o = r ? r.expandedKeys.has(l) : e.isExpanded, u = d1({
    ...e,
    isExpanded: o,
    onExpandedChange(y) {
      r && r.toggleKey(l), e.onExpandedChange?.(y);
    }
  }), c = m.useRef(null), s = e.isDisabled || r?.isDisabled || !1, { buttonProps: d, panelProps: f } = s1({
    ...e,
    isExpanded: o,
    isDisabled: s
  }, u, c), { isFocusVisible: h, focusProps: p } = $e({
    within: !0
  }), b = re({
    ...e,
    id: void 0,
    defaultClassName: "react-aria-Disclosure",
    values: {
      isExpanded: u.isExpanded,
      isDisabled: s,
      isFocusVisibleWithin: h,
      state: u
    }
  }), g = Y(i, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        st,
        {
          slots: {
            [rt]: {},
            trigger: d
          }
        }
      ],
      [
        n4,
        {
          panelProps: f,
          panelRef: c
        }
      ],
      [
        h1,
        u
      ]
    ]
  }, /* @__PURE__ */ m.createElement(X.div, {
    ...L(g, b, p),
    ref: n,
    "data-expanded": u.isExpanded || void 0,
    "data-disabled": s || void 0,
    "data-focus-visible-within": h || void 0
  }, b.children));
}), _6 = /* @__PURE__ */ te(function(e, n) {
  let { role: r = "group" } = e, { panelProps: l, panelRef: i } = z(n4), { isFocusVisible: a, focusProps: o } = $e({
    within: !0
  }), u = re({
    ...e,
    defaultClassName: "react-aria-DisclosurePanel",
    values: {
      isFocusVisibleWithin: a
    }
  }), c = Y(e, {
    global: !0,
    labelable: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(c, u, l, o),
    ref: at(n, i),
    role: r,
    "data-focus-visible-within": a || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        st,
        null
      ]
    ]
  }, e.children));
}), ma = /* @__PURE__ */ new WeakMap();
function ru(t, e) {
  let { id: n } = ma.get(t) ?? {};
  if (!n) throw new Error("Unknown list");
  return `${n}-${p1(e)}`;
}
function p1(t) {
  return typeof t == "string" ? t.replace(/\s*/g, "") : "" + t;
}
var r4 = {};
r4 = {
  deselectedItem: (t) => `${t.item} غير المحدد`,
  longPressToSelect: "اضغط مطولًا للدخول إلى وضع التحديد.",
  select: "تحديد",
  selectedAll: "جميع العناصر المحددة.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "لم يتم تحديد عناصر",
    one: () => `${e.number(t.count)} عنصر محدد`,
    other: () => `${e.number(t.count)} عنصر محدد`
  })}.`,
  selectedItem: (t) => `${t.item} المحدد`
};
var l4 = {};
l4 = {
  deselectedItem: (t) => `${t.item} не е избран.`,
  longPressToSelect: "Натиснете и задръжте за да влезете в избирателен режим.",
  select: "Изберете",
  selectedAll: "Всички елементи са избрани.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Няма избрани елементи",
    one: () => `${e.number(t.count)} избран елемент`,
    other: () => `${e.number(t.count)} избрани елементи`
  })}.`,
  selectedItem: (t) => `${t.item} избран.`
};
var i4 = {};
i4 = {
  deselectedItem: (t) => `Položka ${t.item} není vybrána.`,
  longPressToSelect: "Dlouhým stisknutím přejdete do režimu výběru.",
  select: "Vybrat",
  selectedAll: "Vybrány všechny položky.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nevybrány žádné položky",
    one: () => `Vybrána ${e.number(t.count)} položka`,
    other: () => `Vybráno ${e.number(t.count)} položek`
  })}.`,
  selectedItem: (t) => `Vybrána položka ${t.item}.`
};
var a4 = {};
a4 = {
  deselectedItem: (t) => `${t.item} ikke valgt.`,
  longPressToSelect: "Lav et langt tryk for at aktivere valgtilstand.",
  select: "Vælg",
  selectedAll: "Alle elementer valgt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ingen elementer valgt",
    one: () => `${e.number(t.count)} element valgt`,
    other: () => `${e.number(t.count)} elementer valgt`
  })}.`,
  selectedItem: (t) => `${t.item} valgt.`
};
var o4 = {};
o4 = {
  deselectedItem: (t) => `${t.item} nicht ausgewählt.`,
  longPressToSelect: "Gedrückt halten, um Auswahlmodus zu öffnen.",
  select: "Auswählen",
  selectedAll: "Alle Elemente ausgewählt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Keine Elemente ausgewählt",
    one: () => `${e.number(t.count)} Element ausgewählt`,
    other: () => `${e.number(t.count)} Elemente ausgewählt`
  })}.`,
  selectedItem: (t) => `${t.item} ausgewählt.`
};
var u4 = {};
u4 = {
  deselectedItem: (t) => `Δεν επιλέχθηκε το στοιχείο ${t.item}.`,
  longPressToSelect: "Πατήστε παρατεταμένα για να μπείτε σε λειτουργία επιλογής.",
  select: "Επιλογή",
  selectedAll: "Επιλέχθηκαν όλα τα στοιχεία.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Δεν επιλέχθηκαν στοιχεία",
    one: () => `Επιλέχθηκε ${e.number(t.count)} στοιχείο`,
    other: () => `Επιλέχθηκαν ${e.number(t.count)} στοιχεία`
  })}.`,
  selectedItem: (t) => `Επιλέχθηκε το στοιχείο ${t.item}.`
};
var s4 = {};
s4 = {
  deselectedItem: (t) => `${t.item} not selected.`,
  select: "Select",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "No items selected",
    one: () => `${e.number(t.count)} item selected`,
    other: () => `${e.number(t.count)} items selected`
  })}.`,
  selectedAll: "All items selected.",
  selectedItem: (t) => `${t.item} selected.`,
  longPressToSelect: "Long press to enter selection mode."
};
var c4 = {};
c4 = {
  deselectedItem: (t) => `${t.item} no seleccionado.`,
  longPressToSelect: "Mantenga pulsado para abrir el modo de selección.",
  select: "Seleccionar",
  selectedAll: "Todos los elementos seleccionados.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ningún elemento seleccionado",
    one: () => `${e.number(t.count)} elemento seleccionado`,
    other: () => `${e.number(t.count)} elementos seleccionados`
  })}.`,
  selectedItem: (t) => `${t.item} seleccionado.`
};
var d4 = {};
d4 = {
  deselectedItem: (t) => `${t.item} pole valitud.`,
  longPressToSelect: "Valikurežiimi sisenemiseks vajutage pikalt.",
  select: "Vali",
  selectedAll: "Kõik üksused valitud.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Üksusi pole valitud",
    one: () => `${e.number(t.count)} üksus valitud`,
    other: () => `${e.number(t.count)} üksust valitud`
  })}.`,
  selectedItem: (t) => `${t.item} valitud.`
};
var f4 = {};
f4 = {
  deselectedItem: (t) => `Kohdetta ${t.item} ei valittu.`,
  longPressToSelect: "Siirry valintatilaan painamalla pitkään.",
  select: "Valitse",
  selectedAll: "Kaikki kohteet valittu.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ei yhtään kohdetta valittu",
    one: () => `${e.number(t.count)} kohde valittu`,
    other: () => `${e.number(t.count)} kohdetta valittu`
  })}.`,
  selectedItem: (t) => `${t.item} valittu.`
};
var h4 = {};
h4 = {
  deselectedItem: (t) => `${t.item} non sélectionné.`,
  longPressToSelect: "Appuyez de manière prolongée pour passer en mode de sélection.",
  select: "Sélectionner",
  selectedAll: "Tous les éléments sélectionnés.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Aucun élément sélectionné",
    one: () => `${e.number(t.count)} élément sélectionné`,
    other: () => `${e.number(t.count)} éléments sélectionnés`
  })}.`,
  selectedItem: (t) => `${t.item} sélectionné.`
};
var p4 = {};
p4 = {
  deselectedItem: (t) => `${t.item} לא נבחר.`,
  longPressToSelect: "הקשה ארוכה לכניסה למצב בחירה.",
  select: "בחר",
  selectedAll: "כל הפריטים נבחרו.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "לא נבחרו פריטים",
    one: () => `פריט ${e.number(t.count)} נבחר`,
    other: () => `${e.number(t.count)} פריטים נבחרו`
  })}.`,
  selectedItem: (t) => `${t.item} נבחר.`
};
var b4 = {};
b4 = {
  deselectedItem: (t) => `Stavka ${t.item} nije odabrana.`,
  longPressToSelect: "Dugo pritisnite za ulazak u način odabira.",
  select: "Odaberite",
  selectedAll: "Odabrane su sve stavke.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nije odabrana nijedna stavka",
    one: () => `Odabrana je ${e.number(t.count)} stavka`,
    other: () => `Odabrano je ${e.number(t.count)} stavki`
  })}.`,
  selectedItem: (t) => `Stavka ${t.item} je odabrana.`
};
var m4 = {};
m4 = {
  deselectedItem: (t) => `${t.item} nincs kijelölve.`,
  longPressToSelect: "Nyomja hosszan a kijelöléshez.",
  select: "Kijelölés",
  selectedAll: "Az összes elem kijelölve.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Egy elem sincs kijelölve",
    one: () => `${e.number(t.count)} elem kijelölve`,
    other: () => `${e.number(t.count)} elem kijelölve`
  })}.`,
  selectedItem: (t) => `${t.item} kijelölve.`
};
var g4 = {};
g4 = {
  deselectedItem: (t) => `${t.item} non selezionato.`,
  longPressToSelect: "Premi a lungo per passare alla modalità di selezione.",
  select: "Seleziona",
  selectedAll: "Tutti gli elementi selezionati.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nessun elemento selezionato",
    one: () => `${e.number(t.count)} elemento selezionato`,
    other: () => `${e.number(t.count)} elementi selezionati`
  })}.`,
  selectedItem: (t) => `${t.item} selezionato.`
};
var y4 = {};
y4 = {
  deselectedItem: (t) => `${t.item} が選択されていません。`,
  longPressToSelect: "長押しして選択モードを開きます。",
  select: "選択",
  selectedAll: "すべての項目を選択しました。",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "項目が選択されていません",
    one: () => `${e.number(t.count)} 項目を選択しました`,
    other: () => `${e.number(t.count)} 項目を選択しました`
  })}。`,
  selectedItem: (t) => `${t.item} を選択しました。`
};
var $4 = {};
$4 = {
  deselectedItem: (t) => `${t.item}이(가) 선택되지 않았습니다.`,
  longPressToSelect: "선택 모드로 들어가려면 길게 누르십시오.",
  select: "선택",
  selectedAll: "모든 항목이 선택되었습니다.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "선택된 항목이 없습니다",
    one: () => `${e.number(t.count)}개 항목이 선택되었습니다`,
    other: () => `${e.number(t.count)}개 항목이 선택되었습니다`
  })}.`,
  selectedItem: (t) => `${t.item}이(가) 선택되었습니다.`
};
var v4 = {};
v4 = {
  deselectedItem: (t) => `${t.item} nepasirinkta.`,
  longPressToSelect: "Norėdami įjungti pasirinkimo režimą, paspauskite ir palaikykite.",
  select: "Pasirinkti",
  selectedAll: "Pasirinkti visi elementai.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nepasirinktas nė vienas elementas",
    one: () => `Pasirinktas ${e.number(t.count)} elementas`,
    other: () => `Pasirinkta elementų: ${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `Pasirinkta: ${t.item}.`
};
var x4 = {};
x4 = {
  deselectedItem: (t) => `Vienums ${t.item} nav atlasīts.`,
  longPressToSelect: "Ilgi turiet nospiestu. lai ieslēgtu atlases režīmu.",
  select: "Atlasīt",
  selectedAll: "Atlasīti visi vienumi.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nav atlasīts neviens vienums",
    one: () => `Atlasīto vienumu skaits: ${e.number(t.count)}`,
    other: () => `Atlasīto vienumu skaits: ${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `Atlasīts vienums ${t.item}.`
};
var E4 = {};
E4 = {
  deselectedItem: (t) => `${t.item} er ikke valgt.`,
  longPressToSelect: "Bruk et langt trykk for å gå inn i valgmodus.",
  select: "Velg",
  selectedAll: "Alle elementer er valgt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Ingen elementer er valgt",
    one: () => `${e.number(t.count)} element er valgt`,
    other: () => `${e.number(t.count)} elementer er valgt`
  })}.`,
  selectedItem: (t) => `${t.item} er valgt.`
};
var C4 = {};
C4 = {
  deselectedItem: (t) => `${t.item} niet geselecteerd.`,
  longPressToSelect: "Druk lang om de selectiemodus te openen.",
  select: "Selecteren",
  selectedAll: "Alle items geselecteerd.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Geen items geselecteerd",
    one: () => `${e.number(t.count)} item geselecteerd`,
    other: () => `${e.number(t.count)} items geselecteerd`
  })}.`,
  selectedItem: (t) => `${t.item} geselecteerd.`
};
var D4 = {};
D4 = {
  deselectedItem: (t) => `Nie zaznaczono ${t.item}.`,
  longPressToSelect: "Naciśnij i przytrzymaj, aby wejść do trybu wyboru.",
  select: "Zaznacz",
  selectedAll: "Wszystkie zaznaczone elementy.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nie zaznaczono żadnych elementów",
    one: () => `${e.number(t.count)} zaznaczony element`,
    other: () => `${e.number(t.count)} zaznaczonych elementów`
  })}.`,
  selectedItem: (t) => `Zaznaczono ${t.item}.`
};
var w4 = {};
w4 = {
  deselectedItem: (t) => `${t.item} não selecionado.`,
  longPressToSelect: "Mantenha pressionado para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${e.number(t.count)} item selecionado`,
    other: () => `${e.number(t.count)} itens selecionados`
  })}.`,
  selectedItem: (t) => `${t.item} selecionado.`
};
var P4 = {};
P4 = {
  deselectedItem: (t) => `${t.item} não selecionado.`,
  longPressToSelect: "Prima continuamente para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${e.number(t.count)} item selecionado`,
    other: () => `${e.number(t.count)} itens selecionados`
  })}.`,
  selectedItem: (t) => `${t.item} selecionado.`
};
var S4 = {};
S4 = {
  deselectedItem: (t) => `${t.item} neselectat.`,
  longPressToSelect: "Apăsați lung pentru a intra în modul de selectare.",
  select: "Selectare",
  selectedAll: "Toate elementele selectate.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Niciun element selectat",
    one: () => `${e.number(t.count)} element selectat`,
    other: () => `${e.number(t.count)} elemente selectate`
  })}.`,
  selectedItem: (t) => `${t.item} selectat.`
};
var k4 = {};
k4 = {
  deselectedItem: (t) => `${t.item} не выбрано.`,
  longPressToSelect: "Нажмите и удерживайте для входа в режим выбора.",
  select: "Выбрать",
  selectedAll: "Выбраны все элементы.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Нет выбранных элементов",
    one: () => `${e.number(t.count)} элемент выбран`,
    other: () => `${e.number(t.count)} элементов выбрано`
  })}.`,
  selectedItem: (t) => `${t.item} выбрано.`
};
var B4 = {};
B4 = {
  deselectedItem: (t) => `Nevybraté položky: ${t.item}.`,
  longPressToSelect: "Dlhším stlačením prejdite do režimu výberu.",
  select: "Vybrať",
  selectedAll: "Všetky vybraté položky.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Žiadne vybraté položky",
    one: () => `${e.number(t.count)} vybratá položka`,
    other: () => `Počet vybratých položiek:${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `Vybraté položky: ${t.item}.`
};
var F4 = {};
F4 = {
  deselectedItem: (t) => `Element ${t.item} ni izbran.`,
  longPressToSelect: "Za izbirni način pritisnite in dlje časa držite.",
  select: "Izberite",
  selectedAll: "Vsi elementi so izbrani.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Noben element ni izbran",
    one: () => `${e.number(t.count)} element je izbran`,
    other: () => `${e.number(t.count)} elementov je izbranih`
  })}.`,
  selectedItem: (t) => `Element ${t.item} je izbran.`
};
var T4 = {};
T4 = {
  deselectedItem: (t) => `${t.item} nije izabrano.`,
  longPressToSelect: "Dugo pritisnite za ulazak u režim biranja.",
  select: "Izaberite",
  selectedAll: "Izabrane su sve stavke.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Nije izabrana nijedna stavka",
    one: () => `Izabrana je ${e.number(t.count)} stavka`,
    other: () => `Izabrano je ${e.number(t.count)} stavki`
  })}.`,
  selectedItem: (t) => `${t.item} je izabrano.`
};
var A4 = {};
A4 = {
  deselectedItem: (t) => `${t.item} ej markerat.`,
  longPressToSelect: "Tryck länge när du vill öppna väljarläge.",
  select: "Markera",
  selectedAll: "Alla markerade objekt.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Inga markerade objekt",
    one: () => `${e.number(t.count)} markerat objekt`,
    other: () => `${e.number(t.count)} markerade objekt`
  })}.`,
  selectedItem: (t) => `${t.item} markerat.`
};
var I4 = {};
I4 = {
  deselectedItem: (t) => `${t.item} seçilmedi.`,
  longPressToSelect: "Seçim moduna girmek için uzun basın.",
  select: "Seç",
  selectedAll: "Tüm ögeler seçildi.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Hiçbir öge seçilmedi",
    one: () => `${e.number(t.count)} öge seçildi`,
    other: () => `${e.number(t.count)} öge seçildi`
  })}.`,
  selectedItem: (t) => `${t.item} seçildi.`
};
var K4 = {};
K4 = {
  deselectedItem: (t) => `${t.item} не вибрано.`,
  longPressToSelect: "Виконайте довге натиснення, щоб перейти в режим вибору.",
  select: "Вибрати",
  selectedAll: "Усі елементи вибрано.",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "Жодних елементів не вибрано",
    one: () => `${e.number(t.count)} елемент вибрано`,
    other: () => `Вибрано елементів: ${e.number(t.count)}`
  })}.`,
  selectedItem: (t) => `${t.item} вибрано.`
};
var R4 = {};
R4 = {
  deselectedItem: (t) => `未选择 ${t.item}。`,
  longPressToSelect: "长按以进入选择模式。",
  select: "选择",
  selectedAll: "已选择所有项目。",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "未选择项目",
    one: () => `已选择 ${e.number(t.count)} 个项目`,
    other: () => `已选择 ${e.number(t.count)} 个项目`
  })}。`,
  selectedItem: (t) => `已选择 ${t.item}。`
};
var N4 = {};
N4 = {
  deselectedItem: (t) => `未選取「${t.item}」。`,
  longPressToSelect: "長按以進入選擇模式。",
  select: "選取",
  selectedAll: "已選取所有項目。",
  selectedCount: (t, e) => `${e.plural(t.count, {
    "=0": "未選取任何項目",
    one: () => `已選取 ${e.number(t.count)} 個項目`,
    other: () => `已選取 ${e.number(t.count)} 個項目`
  })}。`,
  selectedItem: (t) => `已選取「${t.item}」。`
};
var Dl = {};
Dl = {
  "ar-AE": r4,
  "bg-BG": l4,
  "cs-CZ": i4,
  "da-DK": a4,
  "de-DE": o4,
  "el-GR": u4,
  "en-US": s4,
  "es-ES": c4,
  "et-EE": d4,
  "fi-FI": f4,
  "fr-FR": h4,
  "he-IL": p4,
  "hr-HR": b4,
  "hu-HU": m4,
  "it-IT": g4,
  "ja-JP": y4,
  "ko-KR": $4,
  "lt-LT": v4,
  "lv-LV": x4,
  "nb-NO": E4,
  "nl-NL": C4,
  "pl-PL": D4,
  "pt-BR": w4,
  "pt-PT": P4,
  "ro-RO": S4,
  "ru-RU": k4,
  "sk-SK": B4,
  "sl-SI": F4,
  "sr-SP": T4,
  "sv-SE": A4,
  "tr-TR": I4,
  "uk-UA": K4,
  "zh-CN": R4,
  "zh-TW": N4
};
function b1(t) {
  return t && t.__esModule ? t.default : t;
}
function M4(t, e) {
  let { getRowText: n = (o) => e.collection.getTextValue?.(o) ?? e.collection.getItem(o)?.textValue } = t, r = ke(b1(Dl), "@react-aria/grid"), l = e.selectionManager.rawSelection, i = B(l), a = G(() => {
    if (!e.selectionManager.isFocused || l === i.current) {
      i.current = l;
      return;
    }
    let o = lu(l, i.current), u = lu(i.current, l), c = e.selectionManager.selectionBehavior === "replace", s = [];
    if (e.selectionManager.selectedKeys.size === 1 && c) {
      let d = e.selectionManager.selectedKeys.keys().next().value;
      if (d != null && e.collection.getItem(d)) {
        let f = n(d);
        f && s.push(r.format("selectedItem", {
          item: f
        }));
      }
    } else if (o.size === 1 && u.size === 0) {
      let d = o.keys().next().value;
      if (d != null) {
        let f = n(d);
        f && s.push(r.format("selectedItem", {
          item: f
        }));
      }
    } else if (u.size === 1 && o.size === 0) {
      let d = u.keys().next().value;
      if (d != null && e.collection.getItem(d)) {
        let f = n(d);
        f && s.push(r.format("deselectedItem", {
          item: f
        }));
      }
    }
    e.selectionManager.selectionMode === "multiple" && (s.length === 0 || l === "all" || l.size > 1 || i.current === "all" || i.current?.size > 1) && s.push(l === "all" ? r.format("selectedAll") : r.format("selectedCount", {
      count: l.size
    })), s.length > 0 && Kn(s.join(" ")), i.current = l;
  }, [
    l,
    e.selectionManager.selectedKeys,
    e.selectionManager.isFocused,
    e.selectionManager.selectionBehavior,
    e.selectionManager.selectionMode,
    e.collection,
    n,
    r
  ]);
  Pc(() => {
    if (e.selectionManager.isFocused) a();
    else {
      let o = requestAnimationFrame(a);
      return () => cancelAnimationFrame(o);
    }
  }, [
    l,
    e.selectionManager.isFocused
  ]);
}
function lu(t, e) {
  let n = /* @__PURE__ */ new Set();
  if (t === "all" || e === "all") return n;
  for (let r of t.keys()) e.has(r) || n.add(r);
  return n;
}
function ga(t, e) {
  let n = e?.isDisabled, [r, l] = q(!1);
  return le(() => {
    if (t?.current && !n) {
      let i = () => {
        if (t.current) {
          let o = Ie(t.current, {
            tabbable: !0
          });
          l(!!o.nextNode());
        }
      };
      i();
      let a = new MutationObserver(i);
      return a.observe(t.current, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: [
          "tabIndex",
          "disabled"
        ]
      }), () => {
        a.disconnect();
      };
    }
  }), n ? !1 : r;
}
function m1(t) {
  return t && t.__esModule ? t.default : t;
}
function L4(t) {
  let e = ke(m1(Dl), "@react-aria/grid"), n = pl(), r = (n === "pointer" || n === "virtual" || n == null) && typeof window < "u" && "ontouchstart" in window, l = _(() => {
    let a = t.selectionManager.selectionMode, o = t.selectionManager.selectionBehavior, u;
    return r && (u = e.format("longPressToSelect")), o === "replace" && a !== "none" && t.hasItemActions ? u : void 0;
  }, [
    t.selectionManager.selectionMode,
    t.selectionManager.selectionBehavior,
    t.hasItemActions,
    e,
    r
  ]);
  return _n(l);
}
function g1(t, e, n) {
  let { isVirtualized: r, keyboardDelegate: l, layoutDelegate: i, onAction: a, disallowTypeAhead: o, linkBehavior: u = "action", keyboardNavigationBehavior: c = "arrow", escapeKeyBehavior: s = "clearSelection", shouldSelectOnPressUp: d } = t;
  !t["aria-label"] && !t["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let { listProps: f } = ca({
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    ref: n,
    keyboardDelegate: l,
    layoutDelegate: i,
    isVirtualized: r,
    selectOnFocus: e.selectionManager.selectionBehavior === "replace",
    shouldFocusWrap: t.shouldFocusWrap,
    linkBehavior: u,
    disallowTypeAhead: o,
    autoFocus: t.autoFocus,
    escapeKeyBehavior: s,
    UNSTABLE_focusOnEntry: t.UNSTABLE_focusOnEntry
  }), h = ce(t.id);
  ma.set(e, {
    id: h,
    onAction: a,
    linkBehavior: u,
    keyboardNavigationBehavior: c,
    shouldSelectOnPressUp: d
  });
  let p = L4({
    selectionManager: e.selectionManager,
    hasItemActions: !!a
  }), b = ga(n, {
    isDisabled: e.collection.size !== 0
  }), g = Y(t, {
    labelable: !0
  }), y = L(
    g,
    {
      role: "grid",
      id: h,
      "aria-multiselectable": e.selectionManager.selectionMode === "multiple" ? "true" : void 0
    },
    // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    e.collection.size === 0 ? {
      tabIndex: b ? -1 : 0
    } : f,
    p
  );
  return r && (y["aria-rowcount"] = e.collection.size, y["aria-colcount"] = 1), M4({}, e), {
    gridProps: y
  };
}
const iu = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function y1(t, e, n) {
  let { node: r, isVirtualized: l } = t, { direction: i } = pe(), { onAction: a, linkBehavior: o, keyboardNavigationBehavior: u, shouldSelectOnPressUp: c } = ma.get(e), s = mt(), d = B(null), f = () => {
    n.current !== null && (d.current != null && r.key !== d.current || !Bt(n.current)) && Ce(n.current);
  }, h = {}, p = t.hasChildItems, b = e.selectionManager.isLink(r.key);
  if (r != null && "expandedKeys" in e) {
    let A = e.collection.getChildren?.(r.key);
    p = p || [
      ...A ?? []
    ].length > 1, a == null && !b && e.selectionManager.selectionMode === "none" && p && (a = () => e.toggleKey(r.key));
    let V = p ? e.expandedKeys.has(r.key) : void 0, x = 1, K = r.index;
    if (r.level >= 0 && r?.parentKey != null) {
      let D = e.collection.getItem(r.parentKey);
      if (D) {
        let F = $1(D, e.collection);
        x = [
          ...F
        ].filter((M) => M.type === "item").length, K > 0 && F[0].type !== "item" && (K -= 1);
      }
    } else x = [
      ...e.collection
    ].filter((D) => D.level === 0 && D.type === "item").length;
    h = {
      "aria-expanded": V,
      "aria-level": r.level + 1,
      "aria-posinset": K + 1,
      "aria-setsize": x
    };
  }
  let { itemProps: g, ...y } = Un({
    selectionManager: e.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: l,
    shouldSelectOnPressUp: t.shouldSelectOnPressUp || c,
    onAction: a || r.props?.onAction ? Ye(r.props?.onAction, a ? () => a(r.key) : void 0) : void 0,
    focus: f,
    linkBehavior: o
  }), $ = (A) => {
    let V = oe();
    if (!ne(A.currentTarget, H(A)) || !n.current || !V) return;
    let x = Ie(n.current);
    if (x.currentNode = V, !au(A, e, r, p, i, V, n.current))
      switch (A.key) {
        case "ArrowLeft":
          if (u === "arrow") {
            let K = i === "rtl" ? x.nextNode() : x.previousNode();
            if (K)
              A.preventDefault(), A.stopPropagation(), Ce(K), Oe(K, {
                containingElement: Me(n.current)
              });
            else if (A.preventDefault(), A.stopPropagation(), i === "rtl")
              Ce(n.current), Oe(n.current, {
                containingElement: Me(n.current)
              });
            else {
              x.currentNode = n.current;
              let D = ou(x);
              D && (Ce(D), Oe(D, {
                containingElement: Me(n.current)
              }));
            }
          }
          break;
        case "ArrowRight":
          if (u === "arrow") {
            let K = i === "rtl" ? x.previousNode() : x.nextNode();
            if (K)
              A.preventDefault(), A.stopPropagation(), Ce(K), Oe(K, {
                containingElement: Me(n.current)
              });
            else if (A.preventDefault(), A.stopPropagation(), i === "ltr")
              Ce(n.current), Oe(n.current, {
                containingElement: Me(n.current)
              });
            else {
              x.currentNode = n.current;
              let D = ou(x);
              D && (Ce(D), Oe(D, {
                containingElement: Me(n.current)
              }));
            }
          }
          break;
        case "ArrowUp":
        case "ArrowDown":
          !A.altKey && ne(n.current, H(A)) && (A.stopPropagation(), A.preventDefault(), n.current.parentElement?.dispatchEvent(new KeyboardEvent(A.nativeEvent.type, A.nativeEvent)));
          break;
      }
  }, v = (A) => {
    if (d.current = r.key, H(A) !== n.current) {
      vt() || e.selectionManager.setFocusedKey(r.key);
      return;
    }
  }, E = (A) => {
    let V = oe();
    if (!(!ne(A.currentTarget, H(A)) || !n.current || !V)) {
      if (u === "tab") {
        if (H(A) !== n.current && A.key !== "Tab") {
          A.stopPropagation();
          return;
        }
        if (au(A, e, r, p, i, V, n.current)) return;
      }
      switch (A.key) {
        case "Tab":
          if (u === "tab") {
            let x = Ie(n.current, {
              tabbable: !0
            });
            x.currentNode = V, (A.shiftKey ? x.previousNode() : x.nextNode()) && A.stopPropagation();
          }
      }
    }
  }, S = _i(r.props), w = y.hasAction ? S : {}, C = L(g, w, {
    role: "row",
    onKeyDownCapture: u === "arrow" ? $ : void 0,
    onFocus: v,
    // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
    "aria-label": r["aria-label"] || r.textValue || void 0,
    "aria-selected": e.selectionManager.canSelectItem(r.key) ? e.selectionManager.isSelected(r.key) : void 0,
    "aria-disabled": e.selectionManager.isDisabled(r.key) || void 0,
    "aria-labelledby": s && (r["aria-label"] || r.textValue) ? `${ru(e, r.key)} ${s}` : void 0,
    id: ru(e, r.key)
  }), R = C.onKeyDown;
  C.onKeyDown = (A) => {
    E(A), A.isPropagationStopped() || R?.(A);
  };
  let I = C.onPointerDown;
  C.onPointerDown = (A) => {
    let V = H(A);
    if (V && V !== n.current && qr(V)) {
      A.stopPropagation();
      return;
    }
    I?.(A);
  };
  let N = C.onMouseDown;
  if (C.onMouseDown = (A) => {
    let V = H(A);
    if (V && V !== n.current && qr(V)) {
      A.stopPropagation();
      return;
    }
    N?.(A);
  }, l) {
    let { collection: A } = e, V = [
      ...A
    ];
    C["aria-rowindex"] = V.find((x) => x.type === "section") ? [
      ...A.getKeys()
    ].filter((x) => A.getItem(x)?.type !== "section").findIndex((x) => x === r.key) + 1 : r.index + 1;
  }
  let O = {
    role: "gridcell",
    "aria-colindex": 1
  };
  return {
    rowProps: {
      ...L(C, h)
    },
    gridCellProps: O,
    descriptionProps: {
      id: s
    },
    ...y
  };
}
function au(t, e, n, r, l, i, a) {
  if (!("expandedKeys" in e) || i !== a) return !1;
  if (t.key === iu.expand[l] && e.selectionManager.focusedKey === n.key && r && !e.expandedKeys.has(n.key))
    return e.toggleKey(n.key), t.stopPropagation(), !0;
  if (t.key === iu.collapse[l] && e.selectionManager.focusedKey === n.key) {
    if (r && e.expandedKeys.has(n.key))
      return e.toggleKey(n.key), t.stopPropagation(), !0;
    if (!e.expandedKeys.has(n.key) && n.parentKey && e.collection.getItem(n.parentKey)?.type === "item")
      return e.selectionManager.setFocusedKey(n.parentKey), t.stopPropagation(), !0;
  }
  return !1;
}
function ou(t) {
  let e = null, n = null;
  do
    n = t.lastChild(), n && (e = n);
  while (n);
  return e;
}
function $1(t, e) {
  let n = e.getChildren?.(t.key), r = n ? Array.from(n) : [], l = r.length > 0 ? r[0] : null, i = [];
  for (; l; )
    i.push(l), l = l.nextKey != null ? e.getItem(l.nextKey) : null;
  return i;
}
function v1(t) {
  return t && t.__esModule ? t.default : t;
}
function x1(t, e) {
  let { key: n } = t, r = e.selectionManager, l = ce(), i = !e.selectionManager.canSelectItem(n), a = e.selectionManager.isSelected(n), o = () => r.toggleSelection(n);
  const u = ke(v1(Dl), "@react-aria/grid");
  return {
    checkboxProps: {
      id: l,
      "aria-label": u.format("select"),
      isSelected: a,
      isDisabled: i,
      onChange: o
    }
  };
}
function E1(t, e, n) {
  let { overlayProps: r, underlayProps: l } = Sp({
    ...t,
    isOpen: e.isOpen,
    onClose: e.close
  }, n);
  return kp({
    isDisabled: !e.isOpen
  }), fb(), Q(() => {
    if (e.isOpen && n.current) return Cp([
      n.current
    ], {
      shouldUseInert: !0
    });
  }, [
    e.isOpen,
    n
  ]), {
    modalProps: L(r),
    underlayProps: l
  };
}
let Ve = typeof document < "u" && window.visualViewport;
function C1() {
  let t = it(), [e, n] = q(() => t ? {
    width: 0,
    height: 0
  } : Yl());
  return Q(() => {
    let r = (o) => {
      n((u) => o.width === u.width && o.height === u.height ? u : o);
    }, l = () => {
      Ve && Ve.scale > 1 || r(Yl());
    }, i, a = (o) => {
      Ve && Ve.scale > 1 || ar(H(o)) && (i = requestAnimationFrame(() => {
        let u = oe();
        (!u || !ar(u)) && r({
          width: document.documentElement.clientWidth,
          height: document.documentElement.clientHeight
        });
      }));
    };
    return r(Yl()), yt() && window.addEventListener("blur", a, !0), Ve ? Ve.addEventListener("resize", l) : window.addEventListener("resize", l), () => {
      cancelAnimationFrame(i), yt() && window.removeEventListener("blur", a, !0), Ve ? Ve.removeEventListener("resize", l) : window.removeEventListener("resize", l);
    };
  }, []), e;
}
function Yl() {
  return {
    // Multiply by the visualViewport scale to get the "natural" size, unaffected by pinch zooming.
    width: Ve ? (
      // the visual viewport and the document element to ensure that the scrollbar width is always excluded.
      // See: https://github.com/w3c/csswg-drafts/issues/8099
      Math.min(Ve.width * Ve.scale, document.documentElement.clientWidth)
    ) : document.documentElement.clientWidth,
    height: Ve ? Ve.height * Ve.scale : document.documentElement.clientHeight
  };
}
const D1 = /* @__PURE__ */ j(null), ya = /* @__PURE__ */ j(null), W6 = /* @__PURE__ */ te(function(e, n) {
  if (z(ya)) {
    if (process.env.NODE_ENV !== "production" && (e.onOpenChange || e.defaultOpen !== void 0 || e.isOpen !== void 0)) {
      const b = /* @__PURE__ */ new Set([
        "isDismissable",
        "isKeyboardDismissDisabled",
        "isOpen",
        "defaultOpen",
        "onOpenChange",
        "isEntering",
        "isExiting",
        "UNSTABLE_portalContainer",
        "shouldCloseOnInteractOutside"
      ]), g = Object.keys(e).filter((y) => b.has(y));
      console.warn(`This modal is already wrapped in a ModalOverlay, props [${g.join(", ")}] should be placed on the ModalOverlay instead.`);
    }
    return /* @__PURE__ */ m.createElement(uu, {
      ...e,
      modalRef: n
    }, e.children);
  }
  let { isDismissable: l, isKeyboardDismissDisabled: i, isOpen: a, defaultOpen: o, onOpenChange: u, children: c, isEntering: s, isExiting: d, UNSTABLE_portalContainer: f, shouldCloseOnInteractOutside: h, ...p } = e;
  return /* @__PURE__ */ m.createElement(P1, {
    isDismissable: l,
    isKeyboardDismissDisabled: i,
    isOpen: a,
    defaultOpen: o,
    onOpenChange: u,
    isEntering: s,
    isExiting: d,
    UNSTABLE_portalContainer: f,
    shouldCloseOnInteractOutside: h
  }, /* @__PURE__ */ m.createElement(uu, {
    ...p,
    modalRef: n
  }, c));
});
function w1(t, e) {
  [t, e] = ie(t, e, D1);
  let n = z(Kt), r = kr(t), l = t.isOpen != null || t.defaultOpen != null || !n ? r : n;
  l === n && process.env.NODE_ENV !== "production" && (t.onOpenChange || t.defaultOpen !== void 0 || t.isOpen !== void 0) && console.warn("This modals state is controlled by a trigger, place onOpenChange on the trigger instead.");
  let i = ge(e), a = B(null), o = yr(i, l.isOpen), u = yr(a, l.isOpen), c = o || u || t.isExiting || !1, s = it();
  return !l.isOpen && !c || s ? null : /* @__PURE__ */ m.createElement(S1, {
    ...t,
    state: l,
    isExiting: c,
    overlayRef: i,
    modalRef: a
  });
}
const P1 = /* @__PURE__ */ te(w1);
function S1({ UNSTABLE_portalContainer: t, ...e }) {
  let n = e.modalRef, { state: r } = e, { modalProps: l, underlayProps: i } = E1(e, r, n), a = Br(e.overlayRef) || e.isEntering || !1, o = re({
    ...e,
    defaultClassName: "react-aria-ModalOverlay",
    values: {
      isEntering: a,
      isExiting: e.isExiting,
      state: r
    }
  }), u = C1(), c, s;
  if (typeof document < "u") {
    let f = jt(document.body) ? document.body : document.scrollingElement || document.documentElement, h = f.getBoundingClientRect().width % 1, p = f.getBoundingClientRect().height % 1;
    c = f.scrollWidth - h, s = f.scrollHeight - p;
  }
  let d = {
    ...o.style,
    "--visual-viewport-width": u.width + "px",
    "--visual-viewport-height": u.height + "px",
    "--page-width": c !== void 0 ? c + "px" : void 0,
    "--page-height": s !== void 0 ? s + "px" : void 0
  };
  return /* @__PURE__ */ m.createElement(Pi, {
    isExiting: e.isExiting,
    portalContainer: t
  }, /* @__PURE__ */ m.createElement(X.div, {
    ...L(Y(e, {
      global: !0
    }), i),
    ...o,
    style: d,
    ref: e.overlayRef,
    "data-entering": a || void 0,
    "data-exiting": e.isExiting || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        ya,
        {
          modalProps: l,
          modalRef: n,
          isExiting: e.isExiting,
          isDismissable: e.isDismissable
        }
      ],
      [
        Kt,
        r
      ]
    ]
  }, o.children)));
}
function uu(t) {
  let { modalProps: e, modalRef: n, isExiting: r, isDismissable: l } = z(ya), i = z(Kt), a = _(() => at(t.modalRef, n), [
    t.modalRef,
    n
  ]), o = ge(a), u = Br(o), c = re({
    ...t,
    defaultClassName: "react-aria-Modal",
    values: {
      isEntering: u,
      isExiting: r,
      state: i
    }
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(Y(t, {
      global: !0
    }), e),
    ...c,
    ref: o,
    "data-entering": u || void 0,
    "data-exiting": r || void 0
  }, l && /* @__PURE__ */ m.createElement(wi, {
    onDismiss: i.close
  }), c.children);
}
const k1 = /* @__PURE__ */ j(null), B1 = /* @__PURE__ */ j(null), j6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, k1);
  let { validationBehavior: r } = We(Wn) || {}, l = e.validationBehavior ?? r ?? "native", { locale: i } = pe(), a = vh({
    ...e,
    locale: i,
    validationBehavior: l
  }), o = B(null), [u, c] = Xe(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: s, groupProps: d, inputProps: f, incrementButtonProps: h, decrementButtonProps: p, descriptionProps: b, errorMessageProps: g, ...y } = yh({
    ...xt(e),
    label: c,
    validationBehavior: l
  }, a, o), $ = re({
    ...e,
    values: {
      state: a,
      isDisabled: e.isDisabled || !1,
      isInvalid: y.isInvalid || !1,
      isRequired: e.isRequired || !1,
      isReadOnly: e.isReadOnly || !1
    },
    defaultClassName: "react-aria-NumberField"
  }), v = Y(e, {
    global: !0
  });
  return delete v.id, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        B1,
        a
      ],
      [
        Dr,
        d
      ],
      [
        wr,
        {
          ...f,
          ref: o
        }
      ],
      [
        ut,
        {
          ...s,
          ref: u
        }
      ],
      [
        st,
        {
          slots: {
            increment: h,
            decrement: p
          }
        }
      ],
      [
        Qe,
        {
          slots: {
            description: b,
            errorMessage: g
          }
        }
      ],
      [
        Yt,
        y
      ]
    ]
  }, /* @__PURE__ */ m.createElement(X.div, {
    ...v,
    ...$,
    ref: n,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-readonly": e.isReadOnly || void 0,
    "data-required": e.isRequired || void 0,
    "data-invalid": y.isInvalid || void 0
  }), e.name && /* @__PURE__ */ m.createElement("input", {
    type: "hidden",
    name: e.name,
    form: e.form,
    value: isNaN(a.numberValue) ? "" : a.numberValue,
    disabled: e.isDisabled || void 0
  }));
}), z4 = /* @__PURE__ */ new WeakMap();
function F1(t, e, n) {
  let { value: r, children: l, "aria-label": i, "aria-labelledby": a, onPressStart: o, onPressEnd: u, onPressChange: c, onPress: s, onPressUp: d, onClick: f } = t;
  const h = t.isDisabled || e.isDisabled;
  let p = l != null, b = i != null || a != null;
  !p && !b && process.env.NODE_ENV !== "production" && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let g = e.selectedValue === r, y = (D) => {
    D.stopPropagation(), e.setSelectedValue(r);
  }, { pressProps: $, isPressed: v } = lt({
    onPressStart: o,
    onPressEnd: u,
    onPressChange: c,
    onPress: s,
    onPressUp: d,
    onClick: f,
    isDisabled: h
  }), { pressProps: E, isPressed: S } = lt({
    onPressStart: o,
    onPressEnd: u,
    onPressChange: c,
    onPressUp: d,
    onClick: f,
    isDisabled: h,
    onPress(D) {
      s?.(D), e.setSelectedValue(r), n.current?.focus();
    }
  }), { focusableProps: w } = Je(L(t, {
    onFocus: () => e.setLastFocusedValue(r)
  }), n), C = L($, w), R = Y(t, {
    labelable: !0
  }), I = -1;
  e.selectedValue != null ? e.selectedValue === r && (I = 0) : (e.lastFocusedValue === r || e.lastFocusedValue == null) && (I = 0), h && (I = void 0);
  let { name: N, form: O, descriptionId: A, errorMessageId: V, validationBehavior: x } = z4.get(e);
  Xt(n, e.defaultSelectedValue, e.setSelectedValue), yl({
    validationBehavior: x
  }, e, n);
  let K = bi();
  return {
    labelProps: L(E, _(() => ({
      onClick: (D) => D.preventDefault(),
      // Prevent label from being focused when mouse down on it.
      // Note, this does not prevent the input from being focused in the `click` event.
      onMouseDown: (D) => D.preventDefault()
    }), [])),
    inputProps: L(R, {
      ...C,
      type: "radio",
      name: N,
      form: O,
      tabIndex: I,
      disabled: h,
      required: e.isRequired && x === "native",
      checked: g,
      value: r,
      onChange: y,
      "aria-describedby": [
        t["aria-describedby"],
        K.id,
        e.isInvalid ? V : null,
        A
      ].filter(Boolean).join(" ") || void 0
    }),
    descriptionProps: K,
    isDisabled: h,
    isSelected: g,
    isPressed: v || S
  };
}
function T1(t, e) {
  let { name: n, form: r, isReadOnly: l, isRequired: i, isDisabled: a, orientation: o = "vertical", validationBehavior: u = "aria" } = t, { direction: c } = pe(), { isInvalid: s, validationErrors: d, validationDetails: f } = e.displayValidation, { labelProps: h, fieldProps: p, descriptionProps: b, errorMessageProps: g } = gl({
    ...t,
    // Radio group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid: e.isInvalid,
    errorMessage: t.errorMessage || d
  }), y = Y(t, {
    labelable: !0
  }), { focusWithinProps: $ } = Et({
    onBlurWithin(S) {
      t.onBlur?.(S), e.selectedValue || e.setLastFocusedValue(null);
    },
    onFocusWithin: t.onFocus,
    onFocusWithinChange: t.onFocusChange
  }), v = (S) => {
    let w;
    switch (S.key) {
      case "ArrowRight":
        c === "rtl" && o !== "vertical" ? w = "prev" : w = "next";
        break;
      case "ArrowLeft":
        c === "rtl" && o !== "vertical" ? w = "next" : w = "prev";
        break;
      case "ArrowDown":
        w = "next";
        break;
      case "ArrowUp":
        w = "prev";
        break;
      default:
        return;
    }
    S.preventDefault();
    let C = Ie(S.currentTarget, {
      from: H(S),
      accept: (I) => I instanceof De(I).HTMLInputElement && I.type === "radio"
    }), R;
    w === "next" ? (R = C.nextNode(), R || (C.currentNode = S.currentTarget, R = C.firstChild())) : (R = C.previousNode(), R || (C.currentNode = S.currentTarget, R = C.lastChild())), R && (R.focus(), e.setSelectedValue(R.value));
  }, E = ce(n);
  return z4.set(e, {
    name: E,
    form: r,
    descriptionId: b.id,
    errorMessageId: g.id,
    validationBehavior: u
  }), {
    radioGroupProps: L(y, {
      // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
      role: "radiogroup",
      onKeyDown: v,
      "aria-invalid": e.isInvalid || void 0,
      "aria-errormessage": t["aria-errormessage"],
      "aria-readonly": l || void 0,
      "aria-required": i || void 0,
      "aria-disabled": a || void 0,
      "aria-orientation": o,
      ...p,
      ...$
    }),
    labelProps: h,
    descriptionProps: b,
    errorMessageProps: g,
    isInvalid: s,
    validationErrors: d,
    validationDetails: f
  };
}
let A1 = Math.round(Math.random() * 1e10), I1 = 0;
function K1(t) {
  let e = _(() => t.name || `radio-group-${A1}-${++I1}`, [
    t.name
  ]), [n, r] = Be(t.value, t.defaultValue ?? null, t.onChange), [l] = q(n), [i, a] = q(null), o = pn({
    ...t,
    value: n
  }), u = (s) => {
    !t.isReadOnly && !t.isDisabled && (r(s), o.commitValidation());
  }, c = o.displayValidation.isInvalid;
  return {
    ...o,
    name: e,
    selectedValue: n,
    defaultSelectedValue: t.value !== void 0 ? l : t.defaultValue ?? null,
    setSelectedValue: u,
    lastFocusedValue: i,
    setLastFocusedValue: a,
    isDisabled: t.isDisabled || !1,
    isReadOnly: t.isReadOnly || !1,
    isRequired: t.isRequired || !1,
    validationState: t.validationState || (c ? "invalid" : null),
    isInvalid: c
  };
}
const R1 = /* @__PURE__ */ j(null), N1 = /* @__PURE__ */ j(null), $a = /* @__PURE__ */ j(null), U6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, R1);
  let { validationBehavior: r } = We(Wn) || {}, l = e.validationBehavior ?? r ?? "native", i = K1({
    ...e,
    validationBehavior: l
  }), [a, o] = Xe(!e["aria-label"] && !e["aria-labelledby"]), { radioGroupProps: u, labelProps: c, descriptionProps: s, errorMessageProps: d, ...f } = T1({
    ...e,
    label: o,
    validationBehavior: l
  }, i), h = re({
    ...e,
    values: {
      orientation: e.orientation || "vertical",
      isDisabled: i.isDisabled,
      isReadOnly: i.isReadOnly,
      isRequired: i.isRequired,
      isInvalid: i.isInvalid,
      state: i
    },
    defaultClassName: "react-aria-RadioGroup"
  }), p = Y(e, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(p, h, u),
    ref: n,
    slot: e.slot || void 0,
    "data-orientation": e.orientation || "vertical",
    "data-invalid": i.isInvalid || void 0,
    "data-disabled": i.isDisabled || void 0,
    "data-readonly": i.isReadOnly || void 0,
    "data-required": i.isRequired || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        $a,
        i
      ],
      [
        ut,
        {
          ...c,
          ref: a,
          elementType: "span"
        }
      ],
      [
        Qe,
        {
          slots: {
            description: s,
            errorMessage: d
          }
        }
      ],
      [
        Yt,
        f
      ]
    ]
  }, /* @__PURE__ */ m.createElement(bn, null, h.children)));
}), G6 = /* @__PURE__ */ te(function(e, n) {
  let { inputRef: r = null, ...l } = e;
  [e, n] = ie(l, n, N1);
  let i = m.useContext($a), a = ge(_(() => at(r, e.inputRef !== void 0 ? e.inputRef : null), [
    r,
    e.inputRef
  ])), o = F1({
    ...xt(e),
    // ReactNode type doesn't allow function children.
    children: typeof e.children == "function" ? !0 : e.children
  }, i, a);
  return /* @__PURE__ */ m.createElement(V4.Provider, {
    value: {
      ...o,
      inputRef: a,
      defaultClassName: "react-aria-Radio"
    }
  }, /* @__PURE__ */ m.createElement(M1, {
    ...e,
    ref: n
  }));
}), V4 = /* @__PURE__ */ j(null), M1 = /* @__PURE__ */ te(function(e, n) {
  let { labelProps: r, inputProps: l, isSelected: i, isDisabled: a, isPressed: o, defaultClassName: u, inputRef: c } = z(V4), s = m.useContext($a), { isFocused: d, isFocusVisible: f, focusProps: h } = $e(), p = a || s.isReadOnly, { hoverProps: b, isHovered: g } = ve({
    ...e,
    isDisabled: p
  }), y = re({
    ...e,
    defaultClassName: u,
    values: {
      isSelected: i,
      isPressed: o,
      isHovered: g,
      isFocused: d,
      isFocusVisible: f,
      isDisabled: a,
      isReadOnly: s.isReadOnly,
      isInvalid: s.isInvalid,
      isRequired: s.isRequired
    }
  }), $ = Y(e, {
    global: !0
  });
  return delete $.id, delete $.onClick, /* @__PURE__ */ m.createElement(X.label, {
    ...L($, r, b, y),
    ref: n,
    "data-selected": i || void 0,
    "data-pressed": o || void 0,
    "data-hovered": g || void 0,
    "data-focused": d || void 0,
    "data-focus-visible": f || void 0,
    "data-disabled": a || void 0,
    "data-readonly": s.isReadOnly || void 0,
    "data-invalid": s.isInvalid || void 0,
    "data-required": s.isRequired || void 0
  }, /* @__PURE__ */ m.createElement(ml, {
    elementType: "span"
  }, /* @__PURE__ */ m.createElement("input", {
    ...L(l, h),
    ref: c
  })), y.children);
});
var O4 = {};
O4 = {
  "Clear search": "مسح البحث"
};
var H4 = {};
H4 = {
  "Clear search": "Изчистване на търсене"
};
var _4 = {};
_4 = {
  "Clear search": "Vymazat hledání"
};
var W4 = {};
W4 = {
  "Clear search": "Ryd søgning"
};
var j4 = {};
j4 = {
  "Clear search": "Suche zurücksetzen"
};
var U4 = {};
U4 = {
  "Clear search": "Απαλοιφή αναζήτησης"
};
var G4 = {};
G4 = {
  "Clear search": "Clear search"
};
var q4 = {};
q4 = {
  "Clear search": "Borrar búsqueda"
};
var Y4 = {};
Y4 = {
  "Clear search": "Tühjenda otsing"
};
var X4 = {};
X4 = {
  "Clear search": "Tyhjennä haku"
};
var Z4 = {};
Z4 = {
  "Clear search": "Effacer la recherche"
};
var J4 = {};
J4 = {
  "Clear search": "נקה חיפוש"
};
var Q4 = {};
Q4 = {
  "Clear search": "Obriši pretragu"
};
var em = {};
em = {
  "Clear search": "Keresés törlése"
};
var tm = {};
tm = {
  "Clear search": "Cancella ricerca"
};
var nm = {};
nm = {
  "Clear search": "検索をクリア"
};
var rm = {};
rm = {
  "Clear search": "검색 지우기"
};
var lm = {};
lm = {
  "Clear search": "Išvalyti iešką"
};
var im = {};
im = {
  "Clear search": "Notīrīt meklēšanu"
};
var am = {};
am = {
  "Clear search": "Tøm søk"
};
var om = {};
om = {
  "Clear search": "Zoekactie wissen"
};
var um = {};
um = {
  "Clear search": "Wyczyść zawartość wyszukiwania"
};
var sm = {};
sm = {
  "Clear search": "Limpar pesquisa"
};
var cm = {};
cm = {
  "Clear search": "Limpar pesquisa"
};
var dm = {};
dm = {
  "Clear search": "Ştergeţi căutarea"
};
var fm = {};
fm = {
  "Clear search": "Очистить поиск"
};
var hm = {};
hm = {
  "Clear search": "Vymazať vyhľadávanie"
};
var pm = {};
pm = {
  "Clear search": "Počisti iskanje"
};
var bm = {};
bm = {
  "Clear search": "Obriši pretragu"
};
var mm = {};
mm = {
  "Clear search": "Rensa sökning"
};
var gm = {};
gm = {
  "Clear search": "Aramayı temizle"
};
var ym = {};
ym = {
  "Clear search": "Очистити пошук"
};
var $m = {};
$m = {
  "Clear search": "清除搜索"
};
var vm = {};
vm = {
  "Clear search": "清除搜尋條件"
};
var xm = {};
xm = {
  "ar-AE": O4,
  "bg-BG": H4,
  "cs-CZ": _4,
  "da-DK": W4,
  "de-DE": j4,
  "el-GR": U4,
  "en-US": G4,
  "es-ES": q4,
  "et-EE": Y4,
  "fi-FI": X4,
  "fr-FR": Z4,
  "he-IL": J4,
  "hr-HR": Q4,
  "hu-HU": em,
  "it-IT": tm,
  "ja-JP": nm,
  "ko-KR": rm,
  "lt-LT": lm,
  "lv-LV": im,
  "nb-NO": am,
  "nl-NL": om,
  "pl-PL": um,
  "pt-BR": sm,
  "pt-PT": cm,
  "ro-RO": dm,
  "ru-RU": fm,
  "sk-SK": hm,
  "sl-SI": pm,
  "sr-SP": bm,
  "sv-SE": mm,
  "tr-TR": gm,
  "uk-UA": ym,
  "zh-CN": $m,
  "zh-TW": vm
};
function L1(t) {
  return t && t.__esModule ? t.default : t;
}
function z1(t, e, n) {
  let r = ke(L1(xm), "@react-aria/searchfield"), { isDisabled: l, isReadOnly: i, onSubmit: a, onClear: o, type: u = "search" } = t, c = (y) => {
    const $ = y.key;
    $ === "Enter" && (l || i) && y.preventDefault(), !(l || i) && ($ === "Enter" && a && (y.preventDefault(), a(e.value)), $ === "Escape" && (e.value === "" && (!n.current || n.current.value === "") ? y.continuePropagation() : (y.preventDefault(), e.setValue(""), o && o())));
  }, s = () => {
    e.setValue(""), o && o();
  }, d = () => {
    n.current?.focus();
  }, { labelProps: f, inputProps: h, descriptionProps: p, errorMessageProps: b, ...g } = Qi({
    ...t,
    value: e.value,
    onChange: e.setValue,
    onKeyDown: i ? t.onKeyDown : Ye(c, t.onKeyDown),
    type: u
  }, n);
  return {
    labelProps: f,
    inputProps: {
      ...h,
      // already handled by useSearchFieldState
      defaultValue: void 0
    },
    clearButtonProps: {
      "aria-label": r.format("Clear search"),
      excludeFromTabOrder: !0,
      preventFocusOnPress: !0,
      isDisabled: l || i,
      onPress: s,
      onPressStart: d
    },
    descriptionProps: p,
    errorMessageProps: b,
    ...g
  };
}
function V1(t) {
  let [e, n] = Be(su(t.value), su(t.defaultValue) || "", t.onChange);
  return {
    value: e,
    setValue: n
  };
}
function su(t) {
  if (t != null)
    return t.toString();
}
const O1 = /* @__PURE__ */ j(null), q6 = /* @__PURE__ */ Gt(function(e, n) {
  [e, n] = ie(e, n, O1);
  let { validationBehavior: r } = We(Wn) || {}, l = e.validationBehavior ?? r ?? "native", i = B(null);
  [e, i] = ie(e, i, vr);
  let [a, o] = Xe(!e["aria-label"] && !e["aria-labelledby"]), u = V1({
    ...e,
    validationBehavior: l
  }), { labelProps: c, inputProps: s, clearButtonProps: d, descriptionProps: f, errorMessageProps: h, ...p } = z1({
    ...xt(e),
    label: o,
    validationBehavior: l
  }, u, i), b = re({
    ...e,
    values: {
      isEmpty: u.value === "",
      isDisabled: e.isDisabled || !1,
      isInvalid: p.isInvalid || !1,
      isReadOnly: e.isReadOnly || !1,
      isRequired: e.isRequired || !1,
      state: u
    },
    defaultClassName: "react-aria-SearchField"
  }), g = Y(e, {
    global: !0
  });
  return delete g.id, /* @__PURE__ */ m.createElement(X.div, {
    ...g,
    ...b,
    ref: n,
    slot: e.slot || void 0,
    "data-empty": u.value === "" || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": p.isInvalid || void 0,
    "data-readonly": e.isReadOnly || void 0,
    "data-required": e.isRequired || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        ut,
        {
          ...c,
          ref: a
        }
      ],
      [
        wr,
        {
          ...s,
          ref: i
        }
      ],
      [
        st,
        d
      ],
      [
        Qe,
        {
          slots: {
            description: f,
            errorMessage: h
          }
        }
      ],
      [
        Dr,
        {
          isInvalid: p.isInvalid,
          isDisabled: e.isDisabled || !1
        }
      ],
      [
        Yt,
        p
      ]
    ]
  }, b.children));
}), va = /* @__PURE__ */ new WeakMap();
function H1(t, e, n) {
  let { keyboardDelegate: r, isDisabled: l, isRequired: i, name: a, form: o, validationBehavior: u = "aria" } = t, c = jn({
    usage: "search",
    sensitivity: "base"
  }), s = _(() => r || new Pr(e.collection, e.disabledKeys, n, c), [
    r,
    e.collection,
    e.disabledKeys,
    c,
    n
  ]), { menuTriggerProps: d, menuProps: f } = Xb({
    isDisabled: l,
    type: "listbox"
  }, e, n), h = (I) => {
    if (e.selectionManager.selectionMode !== "multiple")
      switch (I.key) {
        case "ArrowLeft": {
          I.preventDefault();
          let N = e.selectedKey != null ? s.getKeyAbove?.(e.selectedKey) : s.getFirstKey?.();
          N != null && e.setSelectedKey(N);
          break;
        }
        case "ArrowRight": {
          I.preventDefault();
          let N = e.selectedKey != null ? s.getKeyBelow?.(e.selectedKey) : s.getFirstKey?.();
          N != null && e.setSelectedKey(N);
          break;
        }
      }
  }, { typeSelectProps: p } = fp({
    keyboardDelegate: s,
    selectionManager: e.selectionManager,
    onTypeSelect(I) {
      e.setSelectedKey(I);
    }
  }), { isInvalid: b, validationErrors: g, validationDetails: y } = e.displayValidation, { labelProps: $, fieldProps: v, descriptionProps: E, errorMessageProps: S } = gl({
    ...t,
    labelElementType: "span",
    isInvalid: b,
    errorMessage: t.errorMessage || g
  });
  e.selectionManager.selectionMode === "multiple" && (p = {});
  let w = Y(t, {
    labelable: !0
  }), C = L(p, d, v), R = ce();
  return va.set(e, {
    isDisabled: l,
    isRequired: i,
    name: a,
    form: o,
    validationBehavior: u
  }), {
    labelProps: {
      ...$,
      onClick: () => {
        t.isDisabled || (n.current?.focus(), sr("keyboard"));
      }
    },
    triggerProps: L(w, {
      ...C,
      isDisabled: l,
      onKeyDown: Ye(C.onKeyDown, h, t.onKeyDown),
      onKeyUp: t.onKeyUp,
      "aria-labelledby": [
        R,
        C["aria-labelledby"],
        C["aria-label"] && !C["aria-labelledby"] ? C.id : null
      ].filter(Boolean).join(" "),
      onFocus(I) {
        e.isFocused || (t.onFocus && t.onFocus(I), t.onFocusChange && t.onFocusChange(!0), e.setFocused(!0));
      },
      onBlur(I) {
        e.isOpen || (t.onBlur && t.onBlur(I), t.onFocusChange && t.onFocusChange(!1), e.setFocused(!1));
      }
    }),
    valueProps: {
      id: R
    },
    menuProps: {
      ...f,
      onAction: void 0,
      autoFocus: e.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (I) => {
        ne(I.currentTarget, I.relatedTarget) || (t.onBlur && t.onBlur(I), t.onFocusChange && t.onFocusChange(!1), e.setFocused(!1));
      },
      "aria-labelledby": [
        v["aria-labelledby"],
        C["aria-label"] && !v["aria-labelledby"] ? C.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: E,
    errorMessageProps: S,
    isInvalid: b,
    validationErrors: g,
    validationDetails: y,
    hiddenSelectProps: {
      isDisabled: l,
      name: a,
      label: t.label,
      state: e,
      triggerRef: n,
      form: o
    }
  };
}
function _1(t, e, n) {
  let r = va.get(e) || {}, { autoComplete: l, name: i = r.name, form: a = r.form, isDisabled: o = r.isDisabled } = t, { validationBehavior: u, isRequired: c } = r, { visuallyHiddenProps: s } = qt({
    style: {
      // Prevent page scrolling.
      position: "fixed",
      top: 0,
      left: 0
    }
  });
  Xt(t.selectRef, e.defaultValue, e.setValue), yl({
    validationBehavior: u,
    focus: () => n.current?.focus()
  }, e, t.selectRef);
  let d = e.setValue, f = G((h) => {
    let p = H(h);
    p.multiple ? d(Array.from(p.selectedOptions, (b) => b.value)) : d(h.currentTarget.value);
  }, [
    d
  ]);
  return {
    containerProps: {
      ...s,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: l,
      disabled: o,
      multiple: e.selectionManager.selectionMode === "multiple",
      required: u === "native" && c,
      name: i,
      form: a,
      value: e.value ?? "",
      onChange: f,
      onInput: f
    }
  };
}
function W1(t) {
  let { state: e, triggerRef: n, label: r, name: l, form: i, isDisabled: a } = t, o = B(null), u = B(null), { containerProps: c, selectProps: s } = _1({
    ...t,
    selectRef: e.collection.size <= 300 ? o : u
  }, e, n), d = Array.isArray(e.value) ? e.value : [
    e.value
  ];
  if (e.collection.size <= 300) return /* @__PURE__ */ m.createElement("div", {
    ...c,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ m.createElement("label", null, r, /* @__PURE__ */ m.createElement("select", {
    ...s,
    ref: o
  }, /* @__PURE__ */ m.createElement("option", {
    value: "",
    label: " "
  }, " "), [
    ...e.collection.getKeys()
  ].map((f) => {
    let h = e.collection.getItem(f);
    if (h && h.type === "item") return /* @__PURE__ */ m.createElement("option", {
      key: h.key,
      value: h.key
    }, h.textValue);
  }), e.collection.size === 0 && l && d.map((f, h) => /* @__PURE__ */ m.createElement("option", {
    key: h,
    value: f ?? ""
  })))));
  if (l) {
    let f = va.get(e) || {}, { validationBehavior: h } = f;
    d.length === 0 && (d = [
      null
    ]);
    let p = d.map((b, g) => {
      let y = {
        type: "hidden",
        autoComplete: s.autoComplete,
        name: l,
        form: i,
        disabled: a,
        value: b ?? ""
      };
      return h === "native" ? /* @__PURE__ */ m.createElement("input", {
        key: g,
        ...y,
        ref: g === 0 ? u : null,
        style: {
          display: "none"
        },
        type: "text",
        required: g === 0 ? s.required : !1,
        onChange: () => {
        }
      }) : /* @__PURE__ */ m.createElement("input", {
        key: g,
        ...y,
        ref: g === 0 ? u : null
      });
    });
    return /* @__PURE__ */ m.createElement(m.Fragment, null, p);
  }
  return null;
}
function j1(t) {
  let { selectionMode: e = "single", shouldCloseOnSelect: n = e === "single" } = t, r = kr(t), [l, i] = q(null), a = _(() => t.defaultValue !== void 0 ? t.defaultValue : e === "single" ? t.defaultSelectedKey ?? null : [], [
    t.defaultValue,
    t.defaultSelectedKey,
    e
  ]), o = _(() => t.value !== void 0 ? t.value : e === "single" ? t.selectedKey : void 0, [
    t.value,
    t.selectedKey,
    e
  ]), [u, c] = Be(o, a, t.onChange), s = e === "single" && Array.isArray(u) ? u[0] : u, d = (v) => {
    if (e === "single") {
      let E = Array.isArray(v) ? v[0] ?? null : v;
      c(E), E !== s && t.onSelectionChange?.(E);
    } else {
      let E = [];
      Array.isArray(v) ? E = v : v != null && (E = [
        v
      ]), c(E);
    }
  }, f = xl({
    ...t,
    selectionMode: e,
    disallowEmptySelection: e === "single",
    allowDuplicateSelectionEvents: !0,
    selectedKeys: _(() => U1(s), [
      s
    ]),
    onSelectionChange: (v) => {
      if (v !== "all") {
        if (e === "single") {
          let E = v.values().next().value ?? null;
          d(E);
        } else d([
          ...v
        ]);
        n && r.close(), b.commitValidation();
      }
    }
  }), h = f.selectionManager.firstSelectedKey, p = _(() => [
    ...f.selectionManager.selectedKeys
  ].map((v) => f.collection.getItem(v)).filter((v) => v != null), [
    f.selectionManager.selectedKeys,
    f.collection
  ]), b = pn({
    ...t,
    value: Array.isArray(s) && s.length === 0 ? null : s
  }), [g, y] = q(!1), [$] = q(s);
  return {
    ...b,
    ...f,
    ...r,
    value: s,
    defaultValue: a ?? $,
    setValue: d,
    selectedKey: h,
    setSelectedKey: d,
    selectedItem: p[0] ?? null,
    selectedItems: p,
    defaultSelectedKey: t.defaultSelectedKey ?? (t.selectionMode === "single" ? $ : null),
    focusStrategy: l,
    open(v = null) {
      (f.collection.size !== 0 || t.allowsEmptyCollection) && (i(v), r.open());
    },
    toggle(v = null) {
      (f.collection.size !== 0 || t.allowsEmptyCollection) && (i(v), r.toggle());
    },
    isFocused: g,
    setFocused: y
  };
}
function U1(t) {
  if (t !== void 0)
    return t === null ? [] : Array.isArray(t) ? t : [
      t
    ];
}
const Em = /* @__PURE__ */ j(null), G1 = /* @__PURE__ */ j(null), Y6 = /* @__PURE__ */ Gt(function(e, n) {
  [e, n] = ie(e, n, Em);
  let { children: r, isDisabled: l = !1, isInvalid: i = !1, isRequired: a = !1 } = e, o = _(() => typeof r == "function" ? r({
    isOpen: !1,
    isDisabled: l,
    isInvalid: i,
    isRequired: a,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : r, [
    r,
    l,
    i,
    a
  ]);
  return /* @__PURE__ */ m.createElement(hn, {
    content: o
  }, (u) => /* @__PURE__ */ m.createElement(Y1, {
    props: e,
    collection: u,
    selectRef: n
  }));
}), q1 = [
  ut,
  st,
  Qe
];
function Y1({ props: t, selectRef: e, collection: n }) {
  let { validationBehavior: r } = We(Wn) || {}, l = t.validationBehavior ?? r ?? "native", i = j1({
    ...t,
    collection: n,
    children: void 0,
    validationBehavior: l
  }), { isFocusVisible: a, focusProps: o } = $e({
    within: !0
  }), u = B(null), [c, s] = Xe(!t["aria-label"] && !t["aria-labelledby"]), { labelProps: d, triggerProps: f, valueProps: h, menuProps: p, descriptionProps: b, errorMessageProps: g, hiddenSelectProps: y, ...$ } = H1({
    ...xt(t),
    label: s,
    validationBehavior: l
  }, i, u), v = _(() => ({
    isOpen: i.isOpen,
    isFocused: i.isFocused,
    isFocusVisible: a,
    isDisabled: t.isDisabled || !1,
    isInvalid: $.isInvalid || !1,
    isRequired: t.isRequired || !1
  }), [
    i.isOpen,
    i.isFocused,
    a,
    t.isDisabled,
    $.isInvalid,
    t.isRequired
  ]), E = re({
    ...t,
    values: v,
    defaultClassName: "react-aria-Select"
  }), S = Y(t, {
    global: !0
  });
  delete S.id;
  let w = B(null);
  return /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Em,
        t
      ],
      [
        G1,
        i
      ],
      [
        X1,
        h
      ],
      [
        ut,
        {
          ...d,
          ref: c,
          elementType: "span"
        }
      ],
      [
        st,
        {
          ...f,
          ref: u,
          isPressed: i.isOpen,
          autoFocus: t.autoFocus
        }
      ],
      [
        Kt,
        i
      ],
      [
        Fr,
        {
          trigger: "Select",
          triggerRef: u,
          scrollRef: w,
          placement: "bottom start",
          "aria-labelledby": p["aria-labelledby"],
          clearContexts: q1
        }
      ],
      [
        fa,
        {
          ...p,
          ref: w
        }
      ],
      [
        ct,
        i
      ],
      [
        Qe,
        {
          slots: {
            description: b,
            errorMessage: g
          }
        }
      ],
      [
        Yt,
        $
      ]
    ]
  }, /* @__PURE__ */ m.createElement(X.div, {
    ...L(S, E, o),
    ref: e,
    slot: t.slot || void 0,
    "data-focused": i.isFocused || void 0,
    "data-focus-visible": a || void 0,
    "data-open": i.isOpen || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": $.isInvalid || void 0,
    "data-required": t.isRequired || void 0
  }, E.children, /* @__PURE__ */ m.createElement(W1, {
    ...y,
    autoComplete: t.autoComplete
  })));
}
const X1 = /* @__PURE__ */ j(null);
function Z1(t, e, n) {
  let { labelProps: r, inputProps: l, isSelected: i, ...a } = Bc(t, e, n);
  return {
    labelProps: r,
    inputProps: {
      ...l,
      role: "switch",
      checked: i
    },
    isSelected: i,
    ...a
  };
}
const J1 = /* @__PURE__ */ j(null), Cm = /* @__PURE__ */ j(null), X6 = /* @__PURE__ */ te(function(e, n) {
  let { inputRef: r = null, ...l } = e;
  [e, n] = ie(l, n, J1);
  let i = ge(at(r, e.inputRef !== void 0 ? e.inputRef : null)), a = $l(e), o = Z1({
    ...xt(e),
    // ReactNode type doesn't allow function children.
    children: typeof e.children == "function" ? !0 : e.children
  }, a, i);
  return /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Cm,
        a
      ],
      [
        Dm,
        {
          ...o,
          inputRef: i,
          defaultClassName: "react-aria-Switch"
        }
      ]
    ]
  }, /* @__PURE__ */ m.createElement(Q1, {
    ...e,
    ref: n
  }));
}), Dm = /* @__PURE__ */ j(null), Q1 = /* @__PURE__ */ te(function(e, n) {
  let { labelProps: r, inputProps: l, isSelected: i, isDisabled: a, isReadOnly: o, isPressed: u, isInvalid: c, inputRef: s, defaultClassName: d, isRequired: f } = z(Dm), { isFocused: h, isFocusVisible: p, focusProps: b } = $e(), g = a || o, y = z(Cm), { hoverProps: $, isHovered: v } = ve({
    ...e,
    isDisabled: g
  }), E = re({
    ...e,
    defaultClassName: d,
    values: {
      isSelected: i,
      isPressed: u,
      isHovered: v,
      isFocused: h,
      isFocusVisible: p,
      isDisabled: a,
      isReadOnly: o,
      isInvalid: c,
      isRequired: f || !1,
      state: y
    }
  }), S = Y(e, {
    global: !0
  });
  return delete S.id, delete S.onClick, /* @__PURE__ */ m.createElement(X.label, {
    ...L(S, r, $, E),
    ref: n,
    slot: e.slot || void 0,
    "data-selected": i || void 0,
    "data-pressed": u || void 0,
    "data-hovered": v || void 0,
    "data-focused": h || void 0,
    "data-focus-visible": p || void 0,
    "data-disabled": a || void 0,
    "data-readonly": o || void 0,
    "data-invalid": c || void 0,
    "data-required": f || void 0
  }, /* @__PURE__ */ m.createElement(ml, {
    elementType: "span"
  }, /* @__PURE__ */ m.createElement("input", {
    ...L(l, b),
    ref: s
  })), E.children);
}), cu = 10, du = 5;
class e5 {
  setup(e, n, r) {
    this.delegate = e, this.state = n, this.direction = r;
  }
  getDropTargetFromPoint(e, n, r) {
    let l = this.delegate.getDropTargetFromPoint(e, n, r);
    return !l || l.type === "root" ? l : this.resolveDropTarget(l, e, n, r);
  }
  resolveDropTarget(e, n, r, l) {
    let i = this.pointerTracking, a = r - i.lastY, o = n - i.lastX, u = i.yDirection, c = i.xDirection;
    if (Math.abs(a) > du && (u = a > 0 ? "down" : "up", i.yDirection = u, i.lastY = r), Math.abs(o) > cu && (c = o > 0 ? "right" : "left", i.xDirection = c, i.lastX = n), e.dropPosition === "before") {
      let f = this.state.collection.getKeyBefore(e.key);
      for (; f != null; ) {
        let h = this.state.collection.getItem(f);
        if (h?.type === "item") break;
        f = h?.parentKey ?? null;
      }
      if (f != null) {
        let h = {
          type: "item",
          key: f,
          dropPosition: "after"
        };
        l(h) && (e = h);
      }
    }
    let s = this.getPotentialTargets(e, l);
    if (s.length === 0) return {
      type: "root"
    };
    let d;
    return s.length > 1 ? d = this.selectTarget(s, e, n, r, u, c) : (d = s[0], i.boundaryContext = null), d;
  }
  // Returns potential targets for an ambiguous drop position (e.g. after the last child of a parent, or after the parent itself)
  // Ordered by level, from innermost to outermost.
  getPotentialTargets(e, n) {
    if (e.dropPosition === "on") return [
      e
    ];
    let r = e, l = this.state.collection, i = l.getItem(r.key);
    for (; i && i?.type !== "item" && i.nextKey != null; )
      r.key = i.nextKey, i = l.getItem(i.nextKey);
    let a = [
      r
    ];
    if (i && i.hasChildNodes && this.state.expandedKeys.has(i.key) && l.getChildren && r.dropPosition === "after") {
      let c = i.firstChildKey != null ? l.getItem(i.firstChildKey) : null;
      for (; c && c.type !== "item"; ) c = c.nextKey != null ? l.getItem(c.nextKey) : null;
      if (c?.type === "item") {
        const s = {
          type: "item",
          key: c.key,
          dropPosition: "before"
        };
        return n(s) ? [
          s
        ] : [];
      }
    }
    if (i?.nextKey != null) return [
      e
    ];
    let o = i?.parentKey, u = [];
    for (; o != null; ) {
      let c = l.getItem(o), s = c?.nextKey != null ? l.getItem(c.nextKey) : null;
      if (!s || s.parentKey !== o) {
        let f = {
          type: "item",
          key: o,
          dropPosition: "after"
        };
        if (n(f) && u.push(f), s) break;
      }
      o = c?.parentKey;
    }
    if (u.length > 0 && a.push(...u), a.length === 1) {
      let c = l.getKeyAfter(r.key), s = c != null ? l.getItem(c) : null;
      if (c != null && s && i && s.level != null && i.level != null && s.level > i.level) {
        let d = {
          type: "item",
          key: c,
          dropPosition: "before"
        };
        if (n(d)) return [
          d
        ];
      }
    }
    return a.filter(n);
  }
  selectTarget(e, n, r, l, i, a) {
    if (e.length < 2) return e[0];
    let o = this.pointerTracking, c = this.state.collection.getItem(n.key)?.parentKey;
    if (c == null) return e[0];
    if (!o.boundaryContext || o.boundaryContext.parentKey !== c) {
      let p = o.yDirection === "up" ? e.length - 1 : 0;
      o.boundaryContext = {
        parentKey: c,
        preferredTargetIndex: p,
        lastSwitchY: l,
        lastSwitchX: r
      };
    }
    let s = o.boundaryContext, d = Math.abs(r - s.lastSwitchX);
    if (Math.abs(l - s.lastSwitchY) > du && i) {
      let p = s.preferredTargetIndex || 0;
      i === "down" && p === 0 ? s.preferredTargetIndex = e.length - 1 : i === "up" && p === e.length - 1 && (s.preferredTargetIndex = 0), o.xDirection = null;
    }
    if (d > cu && a) {
      let p = s.preferredTargetIndex || 0;
      a === "left" ? this.direction === "ltr" ? p < e.length - 1 && (s.preferredTargetIndex = p + 1, s.lastSwitchX = r) : p > 0 && (s.preferredTargetIndex = p - 1, s.lastSwitchX = r) : a === "right" && (this.direction === "ltr" ? p > 0 && (s.preferredTargetIndex = p - 1, s.lastSwitchX = r) : p < e.length - 1 && (s.preferredTargetIndex = p + 1, s.lastSwitchX = r)), o.yDirection = null;
    }
    let h = Math.max(0, Math.min(s.preferredTargetIndex || 0, e.length - 1));
    return e[h];
  }
  constructor() {
    this.delegate = null, this.state = null, this.direction = "ltr", this.pointerTracking = {
      lastY: 0,
      lastX: 0,
      yDirection: null,
      xDirection: null,
      boundaryContext: null
    };
  }
}
class t5 {
  constructor(e) {
    this.keyMap = /* @__PURE__ */ new Map(), this.keyMap = /* @__PURE__ */ new Map(), this.columnCount = e?.columnCount, this.rows = [];
    let n = (i) => {
      let a = this.keyMap.get(i.key);
      e.visitNode && (i = e.visitNode(i)), this.keyMap.set(i.key, i);
      let o = /* @__PURE__ */ new Set(), u = null, c = !1;
      if (i.type === "item") {
        for (let s of i.childNodes) if (s.props?.colSpan !== void 0) {
          c = !0;
          break;
        }
      }
      for (let s of i.childNodes)
        s.type === "cell" && c && (s.colspan = s.props?.colSpan, s.colSpan = s.props?.colSpan, s.colIndex = u ? (u.colIndex ?? u.index) + (u.colSpan ?? 1) : s.index), s.type === "cell" && s.parentKey == null && (s.parentKey = i.key), o.add(s.key), u ? (u.nextKey = s.key, s.prevKey = u.key) : s.prevKey = null, n(s), u = s;
      if (u && (u.nextKey = null), a)
        for (let s of a.childNodes) o.has(s.key) || r(s);
    }, r = (i) => {
      this.keyMap.delete(i.key);
      for (let a of i.childNodes) this.keyMap.get(a.key) === a && r(a);
    }, l = null;
    for (let [i, a] of e.items.entries()) {
      let o = {
        ...a,
        level: a.level ?? 0,
        key: a.key ?? "row-" + i,
        type: a.type ?? "row",
        value: a.value ?? null,
        hasChildNodes: !0,
        childNodes: [
          ...a.childNodes
        ],
        rendered: a.rendered,
        textValue: a.textValue ?? "",
        index: a.index ?? i
      };
      l ? (l.nextKey = o.key, o.prevKey = l.key) : o.prevKey = null, this.rows.push(o), n(o), l = o;
    }
    l && (l.nextKey = null);
  }
  *[Symbol.iterator]() {
    yield* [
      ...this.rows
    ];
  }
  get size() {
    return [
      ...this.rows
    ].length;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let n = this.keyMap.get(e);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(e) {
    let n = this.keyMap.get(e);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return [
      ...this.rows
    ][0]?.key;
  }
  getLastKey() {
    let e = [
      ...this.rows
    ];
    return e[e.length - 1]?.key;
  }
  getItem(e) {
    return this.keyMap.get(e) ?? null;
  }
  at(e) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[e]);
  }
  getChildren(e) {
    return this.keyMap.get(e)?.childNodes || [];
  }
}
const wm = "row-header-column-" + Math.random().toString(36).slice(2);
let ki = "row-header-column-" + Math.random().toString(36).slice(2);
for (; wm === ki; ) ki = "row-header-column-" + Math.random().toString(36).slice(2);
function Pm(t, e) {
  if (e.length === 0) return [];
  let n = [], r = /* @__PURE__ */ new Map();
  for (let u of e) {
    let c = u.parentKey, s = [
      u
    ];
    for (; c != null; ) {
      let d = t.get(c);
      if (!d) break;
      if (r.has(d)) {
        d.colSpan ??= 0, d.colSpan++, d.colspan = d.colSpan;
        let { column: f, index: h } = r.get(d);
        if (h > s.length) break;
        for (let p = h; p < s.length; p++) f.splice(p, 0, null);
        for (let p = s.length; p < f.length; p++)
          f[p] && r.has(f[p]) && (r.get(f[p]).index = p);
      } else
        d.colSpan = 1, d.colspan = 1, s.push(d), r.set(d, {
          column: s,
          index: s.length - 1
        });
      c = d.parentKey;
    }
    n.push(s), u.index = n.length - 1;
  }
  let l = Math.max(...n.map((u) => u.length)), i = Array(l).fill(0).map(() => []), a = 0;
  for (let u of n) {
    let c = l - 1;
    for (let s of u) {
      if (s) {
        let d = i[c], f = d.reduce((h, p) => h + (p.colSpan ?? 1), 0);
        if (f < a) {
          let h = {
            type: "placeholder",
            key: "placeholder-" + s.key,
            colspan: a - f,
            colSpan: a - f,
            index: f,
            value: null,
            rendered: null,
            level: c,
            hasChildNodes: !1,
            childNodes: [],
            textValue: ""
          };
          d.length > 0 && (d[d.length - 1].nextKey = h.key, h.prevKey = d[d.length - 1].key), d.push(h);
        }
        d.length > 0 && (d[d.length - 1].nextKey = s.key, s.prevKey = d[d.length - 1].key), s.level = c, s.colIndex = a, d.push(s);
      }
      c--;
    }
    a++;
  }
  let o = 0;
  for (let u of i) {
    let c = u.reduce((s, d) => s + (d.colSpan ?? 1), 0);
    if (c < e.length) {
      let s = {
        type: "placeholder",
        key: "placeholder-" + u[u.length - 1].key,
        colSpan: e.length - c,
        colspan: e.length - c,
        index: c,
        value: null,
        rendered: null,
        level: o,
        hasChildNodes: !1,
        childNodes: [],
        textValue: "",
        prevKey: u[u.length - 1].key
      };
      u.push(s);
    }
    o++;
  }
  return i.map((u, c) => ({
    type: "headerrow",
    key: "headerrow-" + c,
    index: c,
    value: null,
    rendered: null,
    level: 0,
    hasChildNodes: !0,
    childNodes: u,
    textValue: ""
  }));
}
class n5 extends t5 {
  constructor(e, n, r) {
    let l = /* @__PURE__ */ new Set(), i = null, a = [];
    if (r?.showSelectionCheckboxes) {
      let d = {
        type: "column",
        key: wm,
        value: null,
        textValue: "",
        level: 0,
        index: r?.showDragButtons ? 1 : 0,
        hasChildNodes: !1,
        rendered: null,
        childNodes: [],
        props: {
          isSelectionCell: !0
        }
      };
      a.unshift(d);
    }
    if (r?.showDragButtons) {
      let d = {
        type: "column",
        key: ki,
        value: null,
        textValue: "",
        level: 0,
        index: 0,
        hasChildNodes: !1,
        rendered: null,
        childNodes: [],
        props: {
          isDragButtonCell: !0
        }
      };
      a.unshift(d);
    }
    let o = [], u = /* @__PURE__ */ new Map(), c = (d) => {
      switch (d.type) {
        case "body":
          i = d;
          break;
        case "column":
          u.set(d.key, d), d.hasChildNodes || (a.push(d), d.props.isRowHeader && l.add(d.key));
          break;
        case "item":
          o.push(d);
          return;
      }
      for (let f of d.childNodes) c(f);
    };
    for (let d of e) c(d);
    let s = Pm(u, a);
    if (s.forEach((d, f) => o.splice(f, 0, d)), super({
      columnCount: a.length,
      items: o,
      visitNode: (d) => (d.column = a[d.index], d)
    }), this._size = 0, this.columns = a, this.rowHeaderColumnKeys = l, this.body = i, this.headerRows = s, this._size = [
      ...i.childNodes
    ].length, this.rowHeaderColumnKeys.size === 0) {
      let d = this.columns.find((f) => !f.props?.isDragButtonCell && !f.props?.isSelectionCell);
      d && this.rowHeaderColumnKeys.add(d.key);
    }
  }
  *[Symbol.iterator]() {
    yield* this.body.childNodes;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    return this.keyMap.get(e)?.prevKey ?? null;
  }
  getKeyAfter(e) {
    return this.keyMap.get(e)?.nextKey ?? null;
  }
  getFirstKey() {
    return St(this.body.childNodes)?.key ?? null;
  }
  getLastKey() {
    return Pn(this.body.childNodes)?.key ?? null;
  }
  getItem(e) {
    return e === this.body.key ? this.body : this.keyMap.get(e) ?? null;
  }
  at(e) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[e]);
  }
  getChildren(e) {
    if (e === this.body.key) return this.body.childNodes;
    let n = this.getItem(e);
    return n?.type === "item" ? [
      ...n.childNodes
    ].filter((r) => r.type === "cell") : super.getChildren(e);
  }
  getTextValue(e) {
    let n = this.getItem(e);
    if (!n) return "";
    if (n.textValue) return n.textValue;
    let r = this.rowHeaderColumnKeys;
    if (r) {
      let l = [];
      for (let i of n.childNodes) {
        let a = this.columns[i.index];
        if (r.has(a.key) && i.textValue && l.push(i.textValue), l.length === r.size) break;
      }
      return l.join(" ");
    }
    return "";
  }
}
function r5(t) {
  return t != null && (!isNaN(t) || String(t).match(/^(\d+)(?=%$)/) !== null);
}
function l5(t) {
  if (!t || typeof t == "number") return 1;
  let e = t.match(/^(.+)(?=fr$)/);
  return e ? parseFloat(e[0]) : (process.env.NODE_ENV !== "production" && console.warn(`width: ${t} is not a supported format, width should be a number (ex. 150), percentage (ex. '50%') or fr unit (ex. '2fr')`, "defaulting to '1fr'"), 1);
}
function xa(t, e) {
  if (typeof t == "string") {
    let n = t.match(/^(\d+)(?=%$)/);
    if (!n) throw new Error("Only percentages or numbers are supported for static column widths");
    return e * (parseFloat(n[0]) / 100);
  }
  return t;
}
function Sm(t, e) {
  return t != null ? xa(t, e) : Number.MAX_SAFE_INTEGER;
}
function km(t, e) {
  return t != null ? xa(t, e) : 0;
}
function i5(t, e, n, r, l) {
  let i = !1, a = e.map((o, u) => {
    let c = n.get(o.key) != null ? n.get(o.key) ?? "1fr" : o.width ?? o.defaultWidth ?? r?.(u) ?? "1fr", s = !1, d = 0, f = 0, h = 0;
    r5(c) ? (d = xa(c, t), s = !0) : (f = l5(c), f <= 0 && (s = !0));
    let p = km(o.minWidth ?? l?.(u) ?? 0, t), b = Sm(o.maxWidth, t), g = Math.max(p, Math.min(d, b));
    return s ? h = g : d > g && (s = !0, h = g), s || (i = !0), {
      frozen: s,
      baseSize: d,
      hypotheticalMainSize: g,
      min: p,
      max: b,
      flex: f,
      targetMainSize: h,
      violation: 0
    };
  });
  for (; i; ) {
    let o = 0, u = 0;
    a.forEach((d) => {
      d.frozen ? o += d.targetMainSize : (o += d.baseSize, u += d.flex);
    });
    let c = t - o;
    c > 0 && a.forEach((d) => {
      if (!d.frozen) {
        let f = d.flex / u;
        d.targetMainSize = d.baseSize + f * c;
      }
    });
    let s = 0;
    a.forEach((d) => {
      if (d.violation = 0, !d.frozen) {
        let { min: f, max: h, targetMainSize: p } = d;
        d.targetMainSize = Math.max(f, Math.min(p, h)), d.violation = d.targetMainSize - p, s += d.violation;
      }
    }), i = !1, a.forEach((d) => {
      s === 0 || Math.sign(s) === Math.sign(d.violation) ? d.frozen = !0 : d.frozen || (i = !0);
    });
  }
  return a5(a);
}
function a5(t) {
  let e = 0, n = 0, r = [];
  return t.forEach(function(l) {
    let i = l.targetMainSize, a = Math.round(i + e) - n;
    e += i, n += a, r.push(a);
  }), r;
}
class o5 {
  constructor(e) {
    this.columnWidths = /* @__PURE__ */ new Map(), this.columnMinWidths = /* @__PURE__ */ new Map(), this.columnMaxWidths = /* @__PURE__ */ new Map(), this.getDefaultWidth = e?.getDefaultWidth ?? (() => "1fr"), this.getDefaultMinWidth = e?.getDefaultMinWidth ?? (() => 75);
  }
  /**
  * Takes an array of columns and splits it into 2 maps of columns with controlled and columns with
  * uncontrolled widths.
  */
  splitColumnsIntoControlledAndUncontrolled(e) {
    return e.reduce((n, r) => (r.props.width != null ? n[0].set(r.key, r) : n[1].set(r.key, r), n), [
      /* @__PURE__ */ new Map(),
      /* @__PURE__ */ new Map()
    ]);
  }
  /** Takes uncontrolled and controlled widths and joins them into a single Map. */
  recombineColumns(e, n, r, l) {
    return new Map(e.map((i) => r.has(i.key) ? [
      i.key,
      n.get(i.key)
    ] : [
      i.key,
      l.get(i.key).props.width
    ]));
  }
  /** Used to make an initial Map of the uncontrolled widths based on default widths. */
  getInitialUncontrolledWidths(e) {
    return new Map(Array.from(e).map(([n, r]) => [
      n,
      r.props.defaultWidth ?? this.getDefaultWidth?.(r) ?? "1fr"
    ]));
  }
  getColumnWidth(e) {
    return this.columnWidths.get(e) ?? 0;
  }
  getColumnMinWidth(e) {
    return this.columnMinWidths.get(e) ?? 0;
  }
  getColumnMaxWidth(e) {
    return this.columnMaxWidths.get(e) ?? 0;
  }
  resizeColumnWidth(e, n, r, l) {
    let i = this.columnWidths, a = !0, o = /* @__PURE__ */ new Map();
    return l = Math.max(this.getColumnMinWidth(r), Math.min(this.getColumnMaxWidth(r), Math.floor(l))), e.columns.forEach((u) => {
      u.key === r ? (o.set(u.key, l), a = !1) : a ? o.set(u.key, i.get(u.key) ?? 0) : o.set(u.key, u.props.width ?? n.get(u.key));
    }), o;
  }
  buildColumnWidths(e, n, r) {
    return this.columnWidths = /* @__PURE__ */ new Map(), this.columnMinWidths = /* @__PURE__ */ new Map(), this.columnMaxWidths = /* @__PURE__ */ new Map(), i5(e, n.columns.map((i) => ({
      ...i.props,
      key: i.key
    })), r, (i) => this.getDefaultWidth(n.columns[i]), (i) => this.getDefaultMinWidth(n.columns[i])).forEach((i, a) => {
      let o = n.columns[a].key, u = n.columns[a];
      this.columnWidths.set(o, i), this.columnMinWidths.set(o, km(u.props.minWidth ?? this.getDefaultMinWidth(u), e)), this.columnMaxWidths.set(o, Sm(u.props.maxWidth, e));
    }), this.columnWidths;
  }
}
function u5(t, e) {
  let { getDefaultWidth: n, getDefaultMinWidth: r, tableWidth: l = 0 } = t, [i, a] = q(null), o = _(() => new o5({
    getDefaultWidth: n,
    getDefaultMinWidth: r
  }), [
    n,
    r
  ]), [u, c] = _(() => o.splitColumnsIntoControlledAndUncontrolled(e.collection.columns), [
    e.collection.columns,
    o
  ]), [s, d] = q(() => o.getInitialUncontrolledWidths(c)), [f, h] = q(e.collection.columns);
  if (e.collection.columns !== f) {
    if (e.collection.columns.length !== f.length || e.collection.columns.some((v, E) => v.key !== f[E].key)) {
      let v = o.getInitialUncontrolledWidths(c);
      d(v);
    }
    h(e.collection.columns);
  }
  let p = _(() => o.recombineColumns(e.collection.columns, s, c, u), [
    e.collection.columns,
    s,
    c,
    u,
    o
  ]), b = G((v) => {
    a(v);
  }, [
    a
  ]), g = G((v, E) => {
    let S = o.resizeColumnWidth(e.collection, s, v, E), w = new Map(Array.from(c).map(([C]) => [
      C,
      S.get(C)
    ]));
    return w.set(v, E), d(w), S;
  }, [
    c,
    d,
    o,
    e.collection,
    s
  ]), y = G(() => {
    a(null);
  }, [
    a
  ]), $ = _(() => o.buildColumnWidths(l, e.collection, p), [
    l,
    e.collection,
    p,
    o
  ]);
  return _(() => ({
    resizingColumn: i,
    updateResizedColumns: g,
    startResize: b,
    endResize: y,
    getColumnWidth: (v) => o.getColumnWidth(v),
    getColumnMinWidth: (v) => o.getColumnMinWidth(v),
    getColumnMaxWidth: (v) => o.getColumnMaxWidth(v),
    tableState: e,
    columnWidths: $
  }), [
    o,
    $,
    i,
    g,
    b,
    y,
    e
  ]);
}
function s5(t) {
  let { collection: e, focusMode: n } = t, r = t.UNSAFE_selectionState || Sr(t), l = _(() => t.disabledKeys ? new Set(t.disabledKeys) : /* @__PURE__ */ new Set(), [
    t.disabledKeys
  ]), i = r.setFocusedKey;
  r.setFocusedKey = (u, c) => {
    if (n === "cell" && u != null) {
      let s = e.getItem(u);
      if (s?.type === "item") {
        let d = Te(s, e);
        c === "last" ? u = Pn(d)?.key ?? null : u = St(d)?.key ?? null;
      }
    }
    i(u, c);
  };
  let a = _(() => new Gn(e, r), [
    e,
    r
  ]);
  const o = B(null);
  return Q(() => {
    if (r.focusedKey != null && o.current && !e.getItem(r.focusedKey)) {
      const u = o.current.getItem(r.focusedKey), c = u?.parentKey != null && (u.type === "cell" || u.type === "rowheader" || u.type === "column") ? o.current.getItem(u.parentKey) : u;
      if (!c) {
        r.setFocusedKey(null);
        return;
      }
      const s = o.current.rows, d = e.rows, f = s.length - d.length;
      let h = Math.min(f > 1 ? Math.max(c.index - f + 1, 0) : c.index, d.length - 1), p = null;
      for (; h >= 0; ) {
        if (!a.isDisabled(d[h].key) && d[h].type !== "headerrow") {
          p = d[h];
          break;
        }
        h < d.length - 1 ? h++ : (h > c.index && (h = c.index), h--);
      }
      if (p) {
        const b = p.hasChildNodes ? [
          ...Te(p, e)
        ] : [], g = p.hasChildNodes && c !== u && u && u.index < b.length ? b[u.index].key : p.key;
        r.setFocusedKey(g);
      } else r.setFocusedKey(null);
    }
    o.current = e;
  }, [
    e,
    a,
    r,
    r.focusedKey
  ]), {
    collection: e,
    disabledKeys: l,
    isKeyboardNavigationDisabled: !1,
    selectionManager: a
  };
}
const c5 = {
  ascending: "descending",
  descending: "ascending"
};
function d5(t) {
  let [e, n] = q(!1), { selectionMode: r = "none", showSelectionCheckboxes: l, showDragButtons: i, treeColumn: a = null } = t, o = _(
    () => ({
      showSelectionCheckboxes: l && r !== "none",
      showDragButtons: i,
      selectionMode: r,
      columns: []
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t.children,
      l,
      r,
      i
    ]
  ), u = da(t, G((h) => new n5(h, null, o), [
    o
  ]), o), { disabledKeys: c, selectionManager: s } = s5({
    ...t,
    collection: u,
    disabledBehavior: t.disabledBehavior || "selection"
  }), [d, f] = Be(t.expandedKeys ? new Set(t.expandedKeys) : void 0, t.defaultExpandedKeys ? new Set(t.defaultExpandedKeys) : /* @__PURE__ */ new Set(), t.onExpandedChange);
  return {
    collection: u,
    disabledKeys: c,
    selectionManager: s,
    showSelectionCheckboxes: t.showSelectionCheckboxes || !1,
    sortDescriptor: t.sortDescriptor ?? null,
    isKeyboardNavigationDisabled: u.size === 0 || e,
    setKeyboardNavigationDisabled: n,
    sort(h, p) {
      t.onSortChange?.({
        column: h,
        direction: p ?? (t.sortDescriptor?.column === h ? c5[t.sortDescriptor.direction] : "ascending")
      });
    },
    expandedKeys: d,
    toggleKey(h) {
      f((p) => {
        let b = new Set(p);
        return b.has(h) ? b.delete(h) : b.add(h), b;
      });
    },
    treeColumn: a
  };
}
function f5(t, e) {
  let n = _(() => e ? t.collection.filter(e) : t.collection, [
    t.collection,
    e
  ]), r = t.selectionManager.withCollection(n);
  return {
    ...t,
    collection: n,
    selectionManager: r
  };
}
class Bm {
  constructor(e) {
    if (this.collection = e.collection, this.disabledKeys = e.disabledKeys, this.disabledBehavior = e.disabledBehavior || "all", this.direction = e.direction, this.collator = e.collator, !e.layout && !e.ref) throw new Error("Either a layout or a ref must be specified.");
    this.layoutDelegate = e.layoutDelegate || (e.layout ? new h5(e.layout) : new Ci(e.ref)), this.focusMode = e.focusMode ?? "row";
  }
  isCell(e) {
    return e.type === "cell";
  }
  isRow(e) {
    return e.type === "row" || e.type === "item";
  }
  isDisabled(e) {
    return this.disabledBehavior === "all" && (e.props?.isDisabled || this.disabledKeys.has(e.key)) && e.props?.disabledBehavior !== "selection";
  }
  findPreviousKey(e, n, r = !1) {
    let l = e != null ? this.collection.getKeyBefore(e) : this.collection.getLastKey();
    for (; l != null; ) {
      let i = this.collection.getItem(l);
      if (!i) return null;
      if ((r || !this.isDisabled(i)) && (!n || n(i))) return l;
      l = this.collection.getKeyBefore(l);
    }
    return null;
  }
  findNextKey(e, n, r = !1) {
    let l = e != null ? this.collection.getKeyAfter(e) : this.collection.getFirstKey();
    for (; l != null; ) {
      let i = this.collection.getItem(l);
      if (!i) return null;
      if ((r || !this.isDisabled(i)) && (!n || n(i))) return l;
      if (l = this.collection.getKeyAfter(l), l == null) return null;
    }
    return null;
  }
  getKeyForItemInRowByIndex(e, n = 0) {
    if (n < 0) return null;
    let r = this.collection.getItem(e);
    if (!r) return null;
    let l = 0;
    for (let i of Te(r, this.collection)) {
      if (i.colSpan && i.colSpan + l > n || (i.colSpan && (l = l + i.colSpan - 1), l === n)) return i.key ?? null;
      l++;
    }
    return null;
  }
  getKeyBelow(e, n) {
    let r = e, l = this.collection.getItem(r);
    if (!l || (this.isCell(l) && (r = l.parentKey ?? null), r == null)) return null;
    if (r = this.findNextKey(r, (i) => i.type === "item", n?.includeDisabled), r != null) {
      if (this.isCell(l)) {
        let i = l.colIndex ? l.colIndex : l.index;
        return this.getKeyForItemInRowByIndex(r, i);
      }
      if (this.focusMode === "row") return r;
    }
    return null;
  }
  getKeyAbove(e, n) {
    let r = e, l = this.collection.getItem(r);
    if (!l || (this.isCell(l) && (r = l.parentKey ?? null), r == null)) return null;
    if (r = this.findPreviousKey(r, (i) => i.type === "item", n?.includeDisabled), r != null) {
      if (this.isCell(l)) {
        let i = l.colIndex ? l.colIndex : l.index;
        return this.getKeyForItemInRowByIndex(r, i);
      }
      if (this.focusMode === "row") return r;
    }
    return null;
  }
  getKeyRightOf(e) {
    let n = this.collection.getItem(e);
    if (!n) return null;
    if (this.isRow(n)) {
      let r = Te(n, this.collection);
      return (this.direction === "rtl" ? Pn(r)?.key : St(r)?.key) ?? null;
    }
    if (this.isCell(n) && n.parentKey != null) {
      let r = this.collection.getItem(n.parentKey);
      if (!r) return null;
      let l = Te(r, this.collection), i = (this.direction === "rtl" ? lr(l, n.index - 1) : lr(l, n.index + 1)) ?? null;
      return i ? i.key ?? null : this.focusMode === "row" ? n.parentKey ?? null : (this.direction === "rtl" ? this.getFirstKey(e) : this.getLastKey(e)) ?? null;
    }
    return null;
  }
  getKeyLeftOf(e) {
    let n = this.collection.getItem(e);
    if (!n) return null;
    if (this.isRow(n)) {
      let r = Te(n, this.collection);
      return (this.direction === "rtl" ? St(r)?.key : Pn(r)?.key) ?? null;
    }
    if (this.isCell(n) && n.parentKey != null) {
      let r = this.collection.getItem(n.parentKey);
      if (!r) return null;
      let l = Te(r, this.collection), i = (this.direction === "rtl" ? lr(l, n.index + 1) : lr(l, n.index - 1)) ?? null;
      return i ? i.key ?? null : this.focusMode === "row" ? n.parentKey ?? null : (this.direction === "rtl" ? this.getLastKey(e) : this.getFirstKey(e)) ?? null;
    }
    return null;
  }
  getFirstKey(e, n) {
    let r = e ?? null, l;
    if (r != null) {
      if (l = this.collection.getItem(r), !l) return null;
      if (this.isCell(l) && !n && l.parentKey != null) {
        let i = this.collection.getItem(l.parentKey);
        return i ? St(Te(i, this.collection))?.key ?? null : null;
      }
    }
    if (r = this.findNextKey(void 0, (i) => i.type === "item"), r != null && (l && this.isCell(l) && n || this.focusMode === "cell")) {
      let i = this.collection.getItem(r);
      if (!i) return null;
      r = St(Te(i, this.collection))?.key ?? null;
    }
    return r;
  }
  getLastKey(e, n) {
    let r = e ?? null, l;
    if (r != null) {
      if (l = this.collection.getItem(r), !l) return null;
      if (this.isCell(l) && !n && l.parentKey != null) {
        let i = this.collection.getItem(l.parentKey);
        if (!i) return null;
        let a = Te(i, this.collection);
        return Pn(a)?.key ?? null;
      }
    }
    if (r = this.findPreviousKey(void 0, (i) => i.type === "item"), r != null && (l && this.isCell(l) && n || this.focusMode === "cell")) {
      let i = this.collection.getItem(r);
      if (!i) return null;
      let a = Te(i, this.collection);
      r = Pn(a)?.key ?? null;
    }
    return r;
  }
  getKeyPageAbove(e) {
    let n = e, r = this.layoutDelegate.getItemRect(n);
    if (!r) return null;
    let l = Math.max(0, r.y + r.height - this.layoutDelegate.getVisibleRect().height);
    for (; r && r.y > l && n != null && (n = this.getKeyAbove(n) ?? null, n != null); )
      r = this.layoutDelegate.getItemRect(n);
    return n;
  }
  getKeyPageBelow(e) {
    let n = e, r = this.layoutDelegate.getItemRect(n);
    if (!r) return null;
    let l = this.layoutDelegate.getVisibleRect().height, i = Math.min(this.layoutDelegate.getContentSize().height, r.y + l);
    for (; r && r.y + r.height < i; ) {
      let a = this.getKeyBelow(n);
      if (a == null) break;
      r = this.layoutDelegate.getItemRect(a), n = a;
    }
    return n;
  }
  getKeyForSearch(e, n) {
    let r = n ?? null;
    if (!this.collator) return null;
    let l = this.collection;
    if (r = n ?? this.getFirstKey(), r == null) return null;
    let i = l.getItem(r);
    if (!i) return null;
    i.type === "cell" && (r = i.parentKey ?? null);
    let a = !1;
    for (; r != null; ) {
      let o = l.getItem(r);
      if (!o) return null;
      if (o.textValue) {
        let u = o.textValue.slice(0, e.length);
        if (this.collator.compare(u, e) === 0)
          return this.isRow(o) && this.focusMode === "cell" ? St(Te(o, this.collection))?.key ?? null : o.key;
      }
      r = this.findNextKey(r, (u) => u.type === "item"), r == null && !a && (r = this.getFirstKey(), a = !0);
    }
    return null;
  }
}
class h5 {
  constructor(e) {
    this.layout = e;
  }
  getContentSize() {
    return this.layout.getContentSize();
  }
  getItemRect(e) {
    return this.layout.getLayoutInfo(e)?.rect || null;
  }
  getVisibleRect() {
    return this.layout.virtualizer.visibleRect;
  }
}
const Ea = /* @__PURE__ */ new WeakMap();
function p5(t, e, n) {
  let { isVirtualized: r, disallowTypeAhead: l, keyboardDelegate: i, focusMode: a, scrollRef: o, getRowText: u, onRowAction: c, onCellAction: s, escapeKeyBehavior: d = "clearSelection", shouldSelectOnPressUp: f } = t, { selectionManager: h } = e;
  !t["aria-label"] && !t["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let p = jn({
    usage: "search",
    sensitivity: "base"
  }), { direction: b } = pe(), g = e.selectionManager.disabledBehavior, y = _(() => i || new Bm({
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    disabledBehavior: g,
    ref: n,
    direction: b,
    collator: p,
    focusMode: a
  }), [
    i,
    e.collection,
    e.disabledKeys,
    g,
    n,
    b,
    p,
    a
  ]), { collectionProps: $ } = sa({
    ref: n,
    selectionManager: h,
    keyboardDelegate: y,
    isVirtualized: r,
    scrollRef: o,
    disallowTypeAhead: l,
    escapeKeyBehavior: d
  }), v = ce(t.id);
  Ea.set(e, {
    keyboardDelegate: y,
    actions: {
      onRowAction: c,
      onCellAction: s
    },
    shouldSelectOnPressUp: f
  });
  let E = L4({
    selectionManager: h,
    hasItemActions: !!(c || s)
  }), S = Y(t, {
    labelable: !0
  }), w = G((N) => {
    if (h.isFocused) {
      ne(N.currentTarget, H(N)) || h.setFocused(!1);
      return;
    }
    ne(N.currentTarget, H(N)) && h.setFocused(!0);
  }, [
    h
  ]), C = _(() => ({
    onBlur: $.onBlur,
    onFocus: w
  }), [
    w,
    $.onBlur
  ]), R = ga(n, {
    isDisabled: e.collection.size !== 0
  }), I = L(
    S,
    {
      role: "grid",
      id: v,
      "aria-multiselectable": h.selectionMode === "multiple" ? "true" : void 0
    },
    e.isKeyboardNavigationDisabled ? C : $,
    // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    e.collection.size === 0 && {
      tabIndex: R ? -1 : 0
    } || void 0,
    E
  );
  return r && (I["aria-rowcount"] = e.collection.size, I["aria-colcount"] = e.collection.columnCount), M4({
    getRowText: u
  }, e), {
    gridProps: I
  };
}
const Ca = /* @__PURE__ */ new WeakMap();
function Bi(t) {
  return typeof t == "string" ? t.replace(/\s*/g, "") : "" + t;
}
function Fm(t, e) {
  let n = Ca.get(t);
  if (!n) throw new Error("Unknown grid");
  return `${n}-${Bi(e)}`;
}
function Tm(t, e, n) {
  let r = Ca.get(t);
  if (!r) throw new Error("Unknown grid");
  return `${r}-${Bi(e)}-${Bi(n)}`;
}
function Fi(t, e) {
  return [
    ...t.collection.rowHeaderColumnKeys
  ].map((n) => Tm(t, e, n)).join(" ");
}
var Am = {};
Am = {
  ascending: "تصاعدي",
  ascendingSort: (t) => `ترتيب حسب العمود ${t.columnName} بترتيب تصاعدي`,
  columnSize: (t) => `${t.value} بالبكسل`,
  descending: "تنازلي",
  descendingSort: (t) => `ترتيب حسب العمود ${t.columnName} بترتيب تنازلي`,
  resizerDescription: "اضغط على مفتاح Enter لبدء تغيير الحجم",
  select: "تحديد",
  selectAll: "تحديد الكل",
  sortable: "عمود قابل للترتيب",
  collapse: "طي",
  expand: "تمديد"
};
var Im = {};
Im = {
  ascending: "възходящ",
  ascendingSort: (t) => `сортирано по колона ${t.columnName} във възходящ ред`,
  columnSize: (t) => `${t.value} пиксела`,
  descending: "низходящ",
  descendingSort: (t) => `сортирано по колона ${t.columnName} в низходящ ред`,
  resizerDescription: "Натиснете „Enter“, за да започнете да преоразмерявате",
  select: "Изберете",
  selectAll: "Изберете всичко",
  sortable: "сортираща колона",
  collapse: "Свиване",
  expand: "Разширяване"
};
var Km = {};
Km = {
  ascending: "vzestupně",
  ascendingSort: (t) => `řazeno vzestupně podle sloupce ${t.columnName}`,
  columnSize: (t) => `${t.value} pixelů`,
  descending: "sestupně",
  descendingSort: (t) => `řazeno sestupně podle sloupce ${t.columnName}`,
  resizerDescription: "Stisknutím klávesy Enter začnete měnit velikost",
  select: "Vybrat",
  selectAll: "Vybrat vše",
  sortable: "sloupec s možností řazení",
  collapse: "Sbalit",
  expand: "Roztáhnout"
};
var Rm = {};
Rm = {
  ascending: "stigende",
  ascendingSort: (t) => `sorteret efter kolonne ${t.columnName} i stigende rækkefølge`,
  columnSize: (t) => `${t.value} pixels`,
  descending: "faldende",
  descendingSort: (t) => `sorteret efter kolonne ${t.columnName} i faldende rækkefølge`,
  resizerDescription: "Tryk på Enter for at ændre størrelse",
  select: "Vælg",
  selectAll: "Vælg alle",
  sortable: "sorterbar kolonne",
  collapse: "Skjul",
  expand: "Udvid"
};
var Nm = {};
Nm = {
  ascending: "aufsteigend",
  ascendingSort: (t) => `sortiert nach Spalte ${t.columnName} in aufsteigender Reihenfolge`,
  columnSize: (t) => `${t.value} Pixel`,
  descending: "absteigend",
  descendingSort: (t) => `sortiert nach Spalte ${t.columnName} in absteigender Reihenfolge`,
  resizerDescription: "Eingabetaste zum Starten der Größenänderung drücken",
  select: "Auswählen",
  selectAll: "Alles auswählen",
  sortable: "sortierbare Spalte",
  collapse: "Reduzieren",
  expand: "Erweitern"
};
var Mm = {};
Mm = {
  ascending: "αύξουσα",
  ascendingSort: (t) => `διαλογή ανά στήλη ${t.columnName} σε αύξουσα σειρά`,
  columnSize: (t) => `${t.value} pixel`,
  descending: "φθίνουσα",
  descendingSort: (t) => `διαλογή ανά στήλη ${t.columnName} σε φθίνουσα σειρά`,
  resizerDescription: "Πατήστε Enter για έναρξη της αλλαγής μεγέθους",
  select: "Επιλογή",
  selectAll: "Επιλογή όλων",
  sortable: "Στήλη διαλογής",
  collapse: "Σύμπτυξη",
  expand: "Ανάπτυξη"
};
var Lm = {};
Lm = {
  select: "Select",
  selectAll: "Select All",
  sortable: "sortable column",
  ascending: "ascending",
  descending: "descending",
  ascendingSort: (t) => `sorted by column ${t.columnName} in ascending order`,
  descendingSort: (t) => `sorted by column ${t.columnName} in descending order`,
  columnSize: (t) => `${t.value} pixels`,
  resizerDescription: "Press Enter to start resizing",
  expand: "Expand",
  collapse: "Collapse"
};
var zm = {};
zm = {
  ascending: "ascendente",
  ascendingSort: (t) => `ordenado por columna ${t.columnName} en sentido ascendente`,
  columnSize: (t) => `${t.value} píxeles`,
  descending: "descendente",
  descendingSort: (t) => `ordenado por columna ${t.columnName} en orden descendente`,
  resizerDescription: "Pulse Intro para empezar a redimensionar",
  select: "Seleccionar",
  selectAll: "Seleccionar todos",
  sortable: "columna ordenable",
  collapse: "Contraer",
  expand: "Ampliar"
};
var Vm = {};
Vm = {
  ascending: "tõusev järjestus",
  ascendingSort: (t) => `sorditud veeru järgi ${t.columnName} tõusvas järjestuses`,
  columnSize: (t) => `${t.value} pikslit`,
  descending: "laskuv järjestus",
  descendingSort: (t) => `sorditud veeru järgi ${t.columnName} laskuvas järjestuses`,
  resizerDescription: "Suuruse muutmise alustamiseks vajutage klahvi Enter",
  select: "Vali",
  selectAll: "Vali kõik",
  sortable: "sorditav veerg",
  collapse: "Ahenda",
  expand: "Laienda"
};
var Om = {};
Om = {
  ascending: "nouseva",
  ascendingSort: (t) => `lajiteltu sarakkeen ${t.columnName} mukaan nousevassa järjestyksessä`,
  columnSize: (t) => `${t.value} pikseliä`,
  descending: "laskeva",
  descendingSort: (t) => `lajiteltu sarakkeen ${t.columnName} mukaan laskevassa järjestyksessä`,
  resizerDescription: "Aloita koon muutos painamalla Enter-näppäintä",
  select: "Valitse",
  selectAll: "Valitse kaikki",
  sortable: "lajiteltava sarake",
  collapse: "Pienennä",
  expand: "Laajenna"
};
var Hm = {};
Hm = {
  ascending: "croissant",
  ascendingSort: (t) => `trié en fonction de la colonne ${t.columnName} par ordre croissant`,
  columnSize: (t) => `${t.value} pixels`,
  descending: "décroissant",
  descendingSort: (t) => `trié en fonction de la colonne ${t.columnName} par ordre décroissant`,
  resizerDescription: "Appuyez sur Entrée pour commencer le redimensionnement.",
  select: "Sélectionner",
  selectAll: "Sélectionner tout",
  sortable: "colonne triable",
  collapse: "Réduire",
  expand: "Développer"
};
var _m = {};
_m = {
  ascending: "עולה",
  ascendingSort: (t) => `מוין לפי עמודה ${t.columnName} בסדר עולה`,
  columnSize: (t) => `${t.value} פיקסלים`,
  descending: "יורד",
  descendingSort: (t) => `מוין לפי עמודה ${t.columnName} בסדר יורד`,
  resizerDescription: "הקש Enter כדי לשנות את הגודל",
  select: "בחר",
  selectAll: "בחר הכול",
  sortable: "עמודה שניתן למיין",
  collapse: "כווץ",
  expand: "הרחב"
};
var Wm = {};
Wm = {
  ascending: "rastući",
  ascendingSort: (t) => `razvrstano po stupcima ${t.columnName} rastućem redoslijedom`,
  columnSize: (t) => `${t.value} piksela`,
  descending: "padajući",
  descendingSort: (t) => `razvrstano po stupcima ${t.columnName} padajućim redoslijedom`,
  resizerDescription: "Pritisnite Enter da biste započeli promenu veličine",
  select: "Odaberite",
  selectAll: "Odaberite sve",
  sortable: "stupac koji se može razvrstati",
  collapse: "Sažmi",
  expand: "Proširi"
};
var jm = {};
jm = {
  ascending: "növekvő",
  ascendingSort: (t) => `rendezve a(z) ${t.columnName} oszlop szerint, növekvő sorrendben`,
  columnSize: (t) => `${t.value} képpont`,
  descending: "csökkenő",
  descendingSort: (t) => `rendezve a(z) ${t.columnName} oszlop szerint, csökkenő sorrendben`,
  resizerDescription: "Nyomja le az Enter billentyűt az átméretezés megkezdéséhez",
  select: "Kijelölés",
  selectAll: "Összes kijelölése",
  sortable: "rendezendő oszlop",
  collapse: "Összecsukás",
  expand: "Kibontás"
};
var Um = {};
Um = {
  ascending: "crescente",
  ascendingSort: (t) => `in ordine crescente in base alla colonna ${t.columnName}`,
  columnSize: (t) => `${t.value} pixel`,
  descending: "decrescente",
  descendingSort: (t) => `in ordine decrescente in base alla colonna ${t.columnName}`,
  resizerDescription: "Premi Invio per iniziare a ridimensionare",
  select: "Seleziona",
  selectAll: "Seleziona tutto",
  sortable: "colonna ordinabile",
  collapse: "Comprimi",
  expand: "Espandi"
};
var Gm = {};
Gm = {
  ascending: "昇順",
  ascendingSort: (t) => `列 ${t.columnName} を昇順で並べ替え`,
  columnSize: (t) => `${t.value} ピクセル`,
  descending: "降順",
  descendingSort: (t) => `列 ${t.columnName} を降順で並べ替え`,
  resizerDescription: "Enter キーを押してサイズ変更を開始",
  select: "選択",
  selectAll: "すべて選択",
  sortable: "並べ替え可能な列",
  collapse: "折りたたむ",
  expand: "展開"
};
var qm = {};
qm = {
  ascending: "오름차순",
  ascendingSort: (t) => `${t.columnName} 열을 기준으로 오름차순으로 정렬됨`,
  columnSize: (t) => `${t.value} 픽셀`,
  descending: "내림차순",
  descendingSort: (t) => `${t.columnName} 열을 기준으로 내림차순으로 정렬됨`,
  resizerDescription: "크기 조정을 시작하려면 Enter를 누르세요.",
  select: "선택",
  selectAll: "모두 선택",
  sortable: "정렬 가능한 열",
  collapse: "접기",
  expand: "펼치기"
};
var Ym = {};
Ym = {
  ascending: "didėjančia tvarka",
  ascendingSort: (t) => `surikiuota pagal stulpelį ${t.columnName} didėjančia tvarka`,
  columnSize: (t) => `${t.value} piks.`,
  descending: "mažėjančia tvarka",
  descendingSort: (t) => `surikiuota pagal stulpelį ${t.columnName} mažėjančia tvarka`,
  resizerDescription: "Paspauskite „Enter“, kad pradėtumėte keisti dydį",
  select: "Pasirinkti",
  selectAll: "Pasirinkti viską",
  sortable: "rikiuojamas stulpelis",
  collapse: "Sutraukti",
  expand: "Išskleisti"
};
var Xm = {};
Xm = {
  ascending: "augošā secībā",
  ascendingSort: (t) => `kārtots pēc kolonnas ${t.columnName} augošā secībā`,
  columnSize: (t) => `${t.value} pikseļi`,
  descending: "dilstošā secībā",
  descendingSort: (t) => `kārtots pēc kolonnas ${t.columnName} dilstošā secībā`,
  resizerDescription: "Nospiediet Enter, lai sāktu izmēru mainīšanu",
  select: "Atlasīt",
  selectAll: "Atlasīt visu",
  sortable: "kārtojamā kolonna",
  collapse: "Sakļaut",
  expand: "Izvērst"
};
var Zm = {};
Zm = {
  ascending: "stigende",
  ascendingSort: (t) => `sortert etter kolonne ${t.columnName} i stigende rekkefølge`,
  columnSize: (t) => `${t.value} piksler`,
  descending: "synkende",
  descendingSort: (t) => `sortert etter kolonne ${t.columnName} i synkende rekkefølge`,
  resizerDescription: "Trykk på Enter for å starte størrelsesendring",
  select: "Velg",
  selectAll: "Velg alle",
  sortable: "kolonne som kan sorteres",
  collapse: "Skjul",
  expand: "Utvid"
};
var Jm = {};
Jm = {
  ascending: "oplopend",
  ascendingSort: (t) => `gesorteerd in oplopende volgorde in kolom ${t.columnName}`,
  columnSize: (t) => `${t.value} pixels`,
  descending: "aflopend",
  descendingSort: (t) => `gesorteerd in aflopende volgorde in kolom ${t.columnName}`,
  resizerDescription: "Druk op Enter om het formaat te wijzigen",
  select: "Selecteren",
  selectAll: "Alles selecteren",
  sortable: "sorteerbare kolom",
  collapse: "Samenvouwen",
  expand: "Uitvouwen"
};
var Qm = {};
Qm = {
  ascending: "rosnąco",
  ascendingSort: (t) => `posortowano według kolumny ${t.columnName} w porządku rosnącym`,
  columnSize: (t) => `Liczba pikseli: ${t.value}`,
  descending: "malejąco",
  descendingSort: (t) => `posortowano według kolumny ${t.columnName} w porządku malejącym`,
  resizerDescription: "Naciśnij Enter, aby rozpocząć zmienianie rozmiaru",
  select: "Zaznacz",
  selectAll: "Zaznacz wszystko",
  sortable: "kolumna z możliwością sortowania",
  collapse: "Zwiń",
  expand: "Rozwiń"
};
var e3 = {};
e3 = {
  ascending: "crescente",
  ascendingSort: (t) => `classificado pela coluna ${t.columnName} em ordem crescente`,
  columnSize: (t) => `${t.value} pixels`,
  descending: "decrescente",
  descendingSort: (t) => `classificado pela coluna ${t.columnName} em ordem decrescente`,
  resizerDescription: "Pressione Enter para começar a redimensionar",
  select: "Selecionar",
  selectAll: "Selecionar tudo",
  sortable: "coluna classificável",
  collapse: "Recolher",
  expand: "Expandir"
};
var t3 = {};
t3 = {
  ascending: "ascendente",
  ascendingSort: (t) => `Ordenar por coluna ${t.columnName} em ordem ascendente`,
  columnSize: (t) => `${t.value} pixels`,
  descending: "descendente",
  descendingSort: (t) => `Ordenar por coluna ${t.columnName} em ordem descendente`,
  resizerDescription: "Prima Enter para iniciar o redimensionamento",
  select: "Selecionar",
  selectAll: "Selecionar tudo",
  sortable: "Coluna ordenável",
  collapse: "Colapsar",
  expand: "Expandir"
};
var n3 = {};
n3 = {
  ascending: "crescătoare",
  ascendingSort: (t) => `sortate după coloana ${t.columnName} în ordine crescătoare`,
  columnSize: (t) => `${t.value} pixeli`,
  descending: "descrescătoare",
  descendingSort: (t) => `sortate după coloana ${t.columnName} în ordine descrescătoare`,
  resizerDescription: "Apăsați pe Enter pentru a începe redimensionarea",
  select: "Selectare",
  selectAll: "Selectare totală",
  sortable: "coloană sortabilă",
  collapse: "Restrângeți",
  expand: "Extindeți"
};
var r3 = {};
r3 = {
  ascending: "возрастание",
  ascendingSort: (t) => `сортировать столбец ${t.columnName} в порядке возрастания`,
  columnSize: (t) => `${t.value} пикс.`,
  descending: "убывание",
  descendingSort: (t) => `сортировать столбец ${t.columnName} в порядке убывания`,
  resizerDescription: "Нажмите клавишу Enter для начала изменения размеров",
  select: "Выбрать",
  selectAll: "Выбрать все",
  sortable: "сортируемый столбец",
  collapse: "Свернуть",
  expand: "Развернуть"
};
var l3 = {};
l3 = {
  ascending: "vzostupne",
  ascendingSort: (t) => `zoradené zostupne podľa stĺpca ${t.columnName}`,
  columnSize: (t) => `Počet pixelov: ${t.value}`,
  descending: "zostupne",
  descendingSort: (t) => `zoradené zostupne podľa stĺpca ${t.columnName}`,
  resizerDescription: "Stlačením klávesu Enter začnete zmenu veľkosti",
  select: "Vybrať",
  selectAll: "Vybrať všetko",
  sortable: "zoraditeľný stĺpec",
  collapse: "Zbaliť",
  expand: "Rozbaliť"
};
var i3 = {};
i3 = {
  ascending: "naraščajoče",
  ascendingSort: (t) => `razvrščeno po stolpcu ${t.columnName} v naraščajočem vrstnem redu`,
  columnSize: (t) => `${t.value} slikovnih pik`,
  descending: "padajoče",
  descendingSort: (t) => `razvrščeno po stolpcu ${t.columnName} v padajočem vrstnem redu`,
  resizerDescription: "Pritisnite tipko Enter da začnete spreminjati velikost",
  select: "Izberite",
  selectAll: "Izberite vse",
  sortable: "razvrstljivi stolpec",
  collapse: "Strni",
  expand: "Razširi"
};
var a3 = {};
a3 = {
  ascending: "rastući",
  ascendingSort: (t) => `sortirano po kolonama ${t.columnName} rastućim redosledom`,
  columnSize: (t) => `${t.value} piksela`,
  descending: "padajući",
  descendingSort: (t) => `sortirano po kolonama ${t.columnName} padajućim redosledom`,
  resizerDescription: "Pritisnite Enter da biste započeli promenu veličine",
  select: "Izaberite",
  selectAll: "Izaberite sve",
  sortable: "kolona koja se može sortirati",
  collapse: " Skupi",
  expand: "Proširi"
};
var o3 = {};
o3 = {
  ascending: "stigande",
  ascendingSort: (t) => `sorterat på kolumn ${t.columnName} i stigande ordning`,
  columnSize: (t) => `${t.value} pixlar`,
  descending: "fallande",
  descendingSort: (t) => `sorterat på kolumn ${t.columnName} i fallande ordning`,
  resizerDescription: "Tryck på Retur för att börja ändra storlek",
  select: "Markera",
  selectAll: "Markera allt",
  sortable: "sorterbar kolumn",
  collapse: "Dölj",
  expand: "Expandera"
};
var u3 = {};
u3 = {
  ascending: "artan sırada",
  ascendingSort: (t) => `${t.columnName} sütuna göre artan düzende sırala`,
  columnSize: (t) => `${t.value} piksel`,
  descending: "azalan sırada",
  descendingSort: (t) => `${t.columnName} sütuna göre azalan düzende sırala`,
  resizerDescription: "Yeniden boyutlandırmak için Enter'a basın",
  select: "Seç",
  selectAll: "Tümünü Seç",
  sortable: "Sıralanabilir sütun",
  collapse: "Daralt",
  expand: "Genişlet"
};
var s3 = {};
s3 = {
  ascending: "висхідний",
  ascendingSort: (t) => `відсортовано за стовпцем ${t.columnName} у висхідному порядку`,
  columnSize: (t) => `${t.value} пікс.`,
  descending: "низхідний",
  descendingSort: (t) => `відсортовано за стовпцем ${t.columnName} у низхідному порядку`,
  resizerDescription: "Натисніть Enter, щоб почати зміну розміру",
  select: "Вибрати",
  selectAll: "Вибрати все",
  sortable: "сортувальний стовпець",
  collapse: "Згорнути",
  expand: "Розгорнути"
};
var c3 = {};
c3 = {
  ascending: "升序",
  ascendingSort: (t) => `按列 ${t.columnName} 升序排序`,
  columnSize: (t) => `${t.value} 像素`,
  descending: "降序",
  descendingSort: (t) => `按列 ${t.columnName} 降序排序`,
  resizerDescription: "按“输入”键开始调整大小。",
  select: "选择",
  selectAll: "全选",
  sortable: "可排序的列",
  collapse: "折叠",
  expand: "扩展"
};
var d3 = {};
d3 = {
  ascending: "遞增",
  ascendingSort: (t) => `已依據「${t.columnName}」欄遞增排序`,
  columnSize: (t) => `${t.value} 像素`,
  descending: "遞減",
  descendingSort: (t) => `已依據「${t.columnName}」欄遞減排序`,
  resizerDescription: "按 Enter 鍵以開始調整大小",
  select: "選取",
  selectAll: "全選",
  sortable: "可排序的欄",
  collapse: "收合",
  expand: "展開"
};
var qn = {};
qn = {
  "ar-AE": Am,
  "bg-BG": Im,
  "cs-CZ": Km,
  "da-DK": Rm,
  "de-DE": Nm,
  "el-GR": Mm,
  "en-US": Lm,
  "es-ES": zm,
  "et-EE": Vm,
  "fi-FI": Om,
  "fr-FR": Hm,
  "he-IL": _m,
  "hr-HR": Wm,
  "hu-HU": jm,
  "it-IT": Um,
  "ja-JP": Gm,
  "ko-KR": qm,
  "lt-LT": Ym,
  "lv-LV": Xm,
  "nb-NO": Zm,
  "nl-NL": Jm,
  "pl-PL": Qm,
  "pt-BR": e3,
  "pt-PT": t3,
  "ro-RO": n3,
  "ru-RU": r3,
  "sk-SK": l3,
  "sl-SI": i3,
  "sr-SP": a3,
  "sv-SE": o3,
  "tr-TR": u3,
  "uk-UA": s3,
  "zh-CN": c3,
  "zh-TW": d3
};
class b5 extends Bm {
  isCell(e) {
    return e.type === "cell" || e.type === "rowheader" || e.type === "column";
  }
  getKeyBelow(e, n) {
    let r = this.collection.getItem(e);
    if (!r) return null;
    if (r.type === "column") {
      let l = St(Te(r, this.collection));
      if (l) return l.key;
      let i = this.getFirstKey();
      return i == null || !this.collection.getItem(i) ? null : super.getKeyForItemInRowByIndex(i, r.index);
    }
    return super.getKeyBelow(e, n);
  }
  getKeyAbove(e, n) {
    let r = this.collection.getItem(e);
    if (!r) return null;
    if (r.type === "column") {
      let a = r.parentKey != null ? this.collection.getItem(r.parentKey) : null;
      return a && a.type === "column" ? a.key : null;
    }
    let l = super.getKeyAbove(e, n), i = l != null ? this.collection.getItem(l) : null;
    return i && i.type !== "headerrow" ? l : this.isCell(r) ? this.collection.columns[r.index].key : this.collection.columns[0].key;
  }
  findNextColumnKey(e) {
    let n = this.findNextKey(e.key, (l) => l.type === "column");
    if (n != null) return n;
    let r = this.collection.headerRows[e.level];
    for (let l of Te(r, this.collection))
      if (l.type === "column") return l.key;
    return null;
  }
  findPreviousColumnKey(e) {
    let n = this.findPreviousKey(e.key, (i) => i.type === "column");
    if (n != null) return n;
    let r = this.collection.headerRows[e.level], l = [
      ...Te(r, this.collection)
    ];
    for (let i = l.length - 1; i >= 0; i--) {
      let a = l[i];
      if (a.type === "column") return a.key;
    }
    return null;
  }
  getKeyRightOf(e) {
    let n = this.collection.getItem(e);
    return n ? n.type === "column" ? this.direction === "rtl" ? this.findPreviousColumnKey(n) : this.findNextColumnKey(n) : super.getKeyRightOf(e) : null;
  }
  getKeyLeftOf(e) {
    let n = this.collection.getItem(e);
    return n ? n.type === "column" ? this.direction === "rtl" ? this.findNextColumnKey(n) : this.findPreviousColumnKey(n) : super.getKeyLeftOf(e) : null;
  }
  getKeyForSearch(e, n) {
    if (!this.collator) return null;
    let r = this.collection, l = n ?? this.getFirstKey();
    if (l == null) return null;
    let i = r.getItem(l);
    i?.type === "cell" && (l = i.parentKey ?? null);
    let a = !1;
    for (; l != null; ) {
      let o = r.getItem(l);
      if (!o) return null;
      if (o.textValue) {
        let u = o.textValue.slice(0, e.length);
        if (this.collator.compare(u, e) === 0) return o.key;
      }
      for (let u of Te(o, this.collection)) {
        let c = r.columns[u.index];
        if (r.rowHeaderColumnKeys.has(c.key) && u.textValue) {
          let s = u.textValue.slice(0, e.length);
          if (this.collator.compare(s, e) === 0)
            return (n != null ? r.getItem(n) : i)?.type === "cell" ? u.key : o.key;
        }
      }
      l = this.getKeyBelow(l), l == null && !a && (l = this.getFirstKey(), a = !0);
    }
    return null;
  }
}
function m5(t) {
  return t && t.__esModule ? t.default : t;
}
function g5(t, e, n) {
  let { keyboardDelegate: r, isVirtualized: l, layoutDelegate: i, layout: a } = t, o = jn({
    usage: "search",
    sensitivity: "base"
  }), { direction: u } = pe(), c = e.selectionManager.disabledBehavior, s = _(() => r || new b5({
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    disabledBehavior: c,
    ref: n,
    direction: u,
    collator: o,
    layoutDelegate: i,
    layout: a
  }), [
    r,
    e.collection,
    e.disabledKeys,
    c,
    n,
    u,
    o,
    i,
    a
  ]), d = ce(t.id);
  Ca.set(e, d);
  let { gridProps: f } = p5({
    ...t,
    id: d,
    keyboardDelegate: s
  }, e, n);
  l && (f["aria-rowcount"] = e.collection.size + e.collection.headerRows.length), e.treeColumn != null && (f.role = "treegrid");
  let { column: h, direction: p } = e.sortDescriptor || {}, b = ke(m5(qn), "@react-aria/table"), g = _(() => {
    let $ = e.collection.columns.find((v) => v.key === h)?.textValue ?? "";
    return p && h ? b.format(`${p}Sort`, {
      columnName: $
    }) : void 0;
  }, [
    p,
    h,
    e.collection.columns
  ]), y = _n(g);
  return Pc(() => {
    g && Kn(g, "assertive", 500);
  }, [
    g
  ]), {
    gridProps: L(f, y, {
      // merge sort description with long press information
      "aria-describedby": [
        y["aria-describedby"],
        f["aria-describedby"]
      ].filter(Boolean).join(" ")
    })
  };
}
function f3(t, e, n) {
  let { node: r, isVirtualized: l, focusMode: i = "child", shouldSelectOnPressUp: a, onAction: o } = t, { direction: u } = pe(), { keyboardDelegate: c, actions: { onCellAction: s } } = Ea.get(e), d = B(null), f = () => {
    if (n.current) {
      let $ = Ie(n.current);
      if (i === "child") {
        if (Bt(n.current) && n.current !== oe()) return;
        let v = e.selectionManager.childFocusStrategy === "last" ? Xl($) : $.firstChild();
        if (v) {
          Ce(v);
          return;
        }
      }
      (d.current != null && r.key !== d.current || !Bt(n.current)) && Ce(n.current);
    }
  }, { itemProps: h, isPressed: p } = Un({
    selectionManager: e.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: l,
    focus: f,
    shouldSelectOnPressUp: a,
    onAction: s ? () => s(r.key) : o,
    isDisabled: e.collection.size === 0
  }), b = ($) => {
    let v = oe();
    if (!ne($.currentTarget, H($)) || e.isKeyboardNavigationDisabled || !n.current || !v) return;
    let E = Ie(n.current);
    switch (E.currentNode = v, $.key) {
      case "ArrowLeft": {
        let S = u === "rtl" ? E.nextNode() : E.previousNode();
        if (i === "child" && S === n.current && (S = null), $.preventDefault(), $.stopPropagation(), S)
          Ce(S), Oe(S, {
            containingElement: Me(n.current)
          });
        else {
          if (c.getKeyLeftOf?.(r.key) !== r.key) {
            n.current.parentElement?.dispatchEvent(new KeyboardEvent($.nativeEvent.type, $.nativeEvent));
            break;
          }
          i === "cell" && u === "rtl" ? (Ce(n.current), Oe(n.current, {
            containingElement: Me(n.current)
          })) : (E.currentNode = n.current, S = u === "rtl" ? E.firstChild() : Xl(E), S && (Ce(S), Oe(S, {
            containingElement: Me(n.current)
          })));
        }
        break;
      }
      case "ArrowRight": {
        let S = u === "rtl" ? E.previousNode() : E.nextNode();
        if (i === "child" && S === n.current && (S = null), $.preventDefault(), $.stopPropagation(), S)
          Ce(S), Oe(S, {
            containingElement: Me(n.current)
          });
        else {
          if (c.getKeyRightOf?.(r.key) !== r.key) {
            n.current.parentElement?.dispatchEvent(new KeyboardEvent($.nativeEvent.type, $.nativeEvent));
            break;
          }
          i === "cell" && u === "ltr" ? (Ce(n.current), Oe(n.current, {
            containingElement: Me(n.current)
          })) : (E.currentNode = n.current, S = u === "rtl" ? Xl(E) : E.firstChild(), S && (Ce(S), Oe(S, {
            containingElement: Me(n.current)
          })));
        }
        break;
      }
      case "ArrowUp":
      case "ArrowDown":
        !$.altKey && ne(n.current, H($)) && ($.stopPropagation(), $.preventDefault(), n.current.parentElement?.dispatchEvent(new KeyboardEvent($.nativeEvent.type, $.nativeEvent)));
        break;
    }
  }, g = ($) => {
    if (d.current = r.key, H($) !== n.current) {
      vt() || e.selectionManager.setFocusedKey(r.key);
      return;
    }
    requestAnimationFrame(() => {
      i === "child" && oe() === n.current && f();
    });
  }, y = L(h, {
    role: "gridcell",
    onKeyDownCapture: b,
    "aria-colspan": r.colSpan,
    "aria-colindex": r.colIndex != null ? r.colIndex + 1 : void 0,
    colSpan: l ? void 0 : r.colSpan,
    onFocus: g
  });
  return l && (y["aria-colindex"] = (r.colIndex ?? r.index) + 1), a && y.tabIndex != null && y.onPointerDown == null && (y.onPointerDown = ($) => {
    let v = $.currentTarget, E = v.getAttribute("tabindex");
    v.removeAttribute("tabindex"), requestAnimationFrame(() => {
      E != null && v.setAttribute("tabindex", E);
    });
  }), {
    gridCellProps: y,
    isPressed: p
  };
}
function Xl(t) {
  let e = null, n = null;
  do
    n = t.lastChild(), n && (e = n);
  while (n);
  return e;
}
function y5(t) {
  return t && t.__esModule ? t.default : t;
}
function $5(t, e, n) {
  let { node: r } = t, l = r.props.allowsSorting, { gridCellProps: i } = f3({
    ...t,
    focusMode: "child"
  }, e, n), a = r.props.isSelectionCell && e.selectionManager.selectionMode === "single", { pressProps: o, isPressed: u } = lt({
    isDisabled: !l || a,
    onPress() {
      e.sort(r.key);
    },
    ref: n
  }), { focusableProps: c } = Je({}, n), s, d = e.sortDescriptor?.column === r.key, f = e.sortDescriptor?.direction;
  r.props.allowsSorting && !_t() && (s = d ? f : "none");
  let h = ke(y5(qn), "@react-aria/table"), p;
  l && (p = `${h.format("sortable")}`, d && f && _t() && (p = `${p}, ${h.format(f)}`));
  let b = _n(p), g = e.collection.size === 0;
  return Q(() => {
    g && e.selectionManager.focusedKey === r.key && e.selectionManager.setFocusedKey(null);
  }, [
    g,
    e.selectionManager,
    r.key
  ]), {
    columnHeaderProps: {
      ...L(
        c,
        i,
        o,
        b,
        // If the table is empty, make all column headers untabbable
        g ? {
          tabIndex: -1
        } : null
      ),
      role: "columnheader",
      id: Fm(e, r.key),
      "aria-colspan": r.colSpan && r.colSpan > 1 ? r.colSpan : void 0,
      "aria-sort": s
    },
    isPressed: u
  };
}
function v5(t, e, n) {
  let { node: r, isVirtualized: l, shouldSelectOnPressUp: i, onAction: a } = t, { actions: o, shouldSelectOnPressUp: u } = Ea.get(e), c = o.onRowAction ? () => o.onRowAction?.(r.key) : a, { itemProps: s, ...d } = Un({
    selectionManager: e.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: l,
    shouldSelectOnPressUp: u || i,
    onAction: c || r?.props?.onAction ? Ye(r?.props?.onAction, c) : void 0,
    isDisabled: e.collection.size === 0
  }), f = e.selectionManager.isSelected(r.key), h = {
    role: "row",
    "aria-selected": e.selectionManager.selectionMode !== "none" ? f : void 0,
    "aria-disabled": d.isDisabled || void 0,
    ...s
  };
  return l && (h["aria-rowindex"] = r.index + 1), {
    rowProps: h,
    ...d
  };
}
function x5(t) {
  return t && t.__esModule ? t.default : t;
}
const fu = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function E5(t, e, n) {
  let { node: r, isVirtualized: l } = t, { rowProps: i, ...a } = v5(t, e, n), { direction: o } = pe();
  l && e.treeColumn == null ? i["aria-rowindex"] = r.index + 1 + e.collection.headerRows.length : delete i["aria-rowindex"];
  let u = e.treeColumn != null && (e.expandedKeys === "all" || e.expandedKeys.has(r.key)), c = ke(x5(qn), "@react-aria/table"), s = kt({
    "aria-label": u ? c.format("collapse") : c.format("expand"),
    "aria-labelledby": Fi(e, r.key)
  }), d = {}, f = {};
  if (e.treeColumn != null) {
    let b = e.collection.getItem(r.key);
    if (b != null) {
      let g = hu(e.collection, r), y = b.props?.hasChildRows || b.props?.UNSTABLE_childItems || g?.type !== "cell", $ = e.collection.getItem(r.parentKey), v = $.type === "tablebody" || $.type === "body", E = hu(e.collection, $);
      for (; E && E.type !== "item" && E.prevKey != null; ) E = e.collection.getItem(E.prevKey);
      d = {
        onKeyDown: (S) => {
          S.key === fu.expand[o] && e.selectionManager.focusedKey === b.key && y && e.expandedKeys !== "all" && !e.expandedKeys.has(b.key) ? (e.toggleKey(b.key), S.stopPropagation()) : S.key === fu.collapse[o] && e.selectionManager.focusedKey === b.key && (e.expandedKeys !== "all" ? y && e.expandedKeys.has(b.key) ? (e.toggleKey(b.key), S.stopPropagation()) : !e.expandedKeys.has(b.key) && b.parentKey != null && b.level > 0 && (e.selectionManager.setFocusedKey(b.parentKey), S.stopPropagation()) : e.expandedKeys === "all" && (e.toggleKey(b.key), S.stopPropagation()));
        },
        "aria-expanded": y ? e.expandedKeys === "all" || e.expandedKeys.has(r.key) : void 0,
        "aria-level": b.level + 1,
        "aria-posinset": b.index - (v ? 0 : e.collection.columnCount) + 1,
        "aria-setsize": E.index - (v ? 0 : e.collection.columnCount) + 1
      }, f = {
        isDisabled: a.isDisabled,
        onPress: () => {
          a.isDisabled || (e.toggleKey(r.key), e.selectionManager.setFocused(!0), e.selectionManager.setFocusedKey(r.key));
        },
        excludeFromTabOrder: !0,
        preventFocusOnPress: !0,
        // @ts-ignore
        "data-react-aria-prevent-focus": !0,
        ...s
      };
    }
  }
  let h = _i(r.props), p = a.hasAction ? h : {};
  return {
    rowProps: {
      ...L(i, d, p),
      "aria-labelledby": Fi(e, r.key)
    },
    expandButtonProps: f,
    ...a
  };
}
function hu(t, e) {
  return "lastChildKey" in e ? e.lastChildKey != null ? t.getItem(e.lastChildKey) : null : Array.from(e.childNodes).findLast((n) => n.parentKey === e.key);
}
function C5(t, e, n) {
  let { node: r, isVirtualized: l } = t, i = {
    role: "row"
  };
  return l && e.treeColumn == null && (i["aria-rowindex"] = r.index + 1), {
    rowProps: i
  };
}
function D5(t, e, n) {
  let { gridCellProps: r, isPressed: l } = f3(t, e, n), i = t.node.column?.key;
  return i != null && e.collection.rowHeaderColumnKeys.has(i) && (r.role = "rowheader", r.id = Tm(e, t.node.parentKey, i)), {
    gridCellProps: r,
    isPressed: l
  };
}
function w5(t) {
  return t && t.__esModule ? t.default : t;
}
function P5(t, e) {
  let { key: n } = t;
  const { checkboxProps: r } = x1(t, e);
  return {
    checkboxProps: {
      ...r,
      "aria-labelledby": `${r.id} ${Fi(e, n)}`
    }
  };
}
function S5(t) {
  let { isEmpty: e, isSelectAll: n, selectionMode: r } = t.selectionManager;
  return {
    checkboxProps: {
      "aria-label": ke(w5(qn), "@react-aria/table").format(r === "single" ? "select" : "selectAll"),
      isSelected: n,
      isDisabled: r !== "multiple" || t.collection.size === 0 || t.collection.rows.length === 1 && t.collection.rows[0].type === "loader",
      isIndeterminate: !e && !n,
      onChange: () => t.selectionManager.toggleSelectAll()
    }
  };
}
function k5(t) {
  return t && t.__esModule ? t.default : t;
}
function B5(t, e, n) {
  let { column: r, triggerRef: l, isDisabled: i, onResizeStart: a, onResize: o, onResizeEnd: u, "aria-label": c } = t;
  const s = ke(k5(qn), "@react-aria/table");
  let d = ce(), f = e.resizingColumn === r.key, h = B(f), p = B(null), b = B(!1), g = e.tableState.isKeyboardNavigationDisabled, { direction: y } = pe(), $ = G((k) => {
    h.current || (p.current = e.updateResizedColumns(k.key, e.getColumnWidth(k.key)), e.startResize(k.key), e.tableState.setKeyboardNavigationDisabled(!0), a?.(p.current)), h.current = !0;
  }, [
    e,
    a
  ]), v = G((k, ee) => {
    let Z = e.updateResizedColumns(k.key, ee);
    o?.(Z), p.current = Z;
  }, [
    e,
    o
  ]), E = G((k) => {
    h.current && (p.current == null && (p.current = e.updateResizedColumns(k.key, e.getColumnWidth(k.key))), e.endResize(), e.tableState.setKeyboardNavigationDisabled(!1), u?.(p.current), h.current = !1, l?.current && !b.current && Ce(l.current)), p.current = null;
  }, [
    e,
    l,
    u
  ]), { keyboardProps: S } = Hn({
    onKeyDown: (k) => {
      g ? (k.key === "Escape" || k.key === "Enter" || k.key === " " || k.key === "Tab") && (k.preventDefault(), E(r)) : (k.continuePropagation(), k.key === "Enter" && $(r));
    }
  });
  const w = B(0), { moveProps: C } = mr({
    onMoveStart() {
      w.current = e.getColumnWidth(r.key), $(r);
    },
    onMove(k) {
      let { deltaX: ee, deltaY: Z, pointerType: de } = k;
      y === "rtl" && (ee *= -1), de === "keyboard" && (Z !== 0 && ee === 0 && (ee = Z * -1), ee *= 10), ee !== 0 && (w.current += ee, v(r, w.current));
    },
    onMoveEnd(k) {
      let { pointerType: ee } = k;
      w.current = 0, (ee === "mouse" || ee === "touch" && b.current) && E(r);
    }
  });
  let R = G((k) => {
    g && C.onKeyDown?.(k);
  }, [
    g,
    C
  ]), I = Math.floor(e.getColumnMinWidth(r.key)), N = Math.floor(e.getColumnMaxWidth(r.key));
  N === 1 / 0 && (N = Number.MAX_SAFE_INTEGER);
  let O = Math.floor(e.getColumnWidth(r.key)), A = pl();
  A === "virtual" && typeof window < "u" && "ontouchstart" in window && (A = "touch");
  let V = l?.current == null && (A === "keyboard" || A === "virtual") && !f ? s.format("resizerDescription") : void 0, x = _n(V), K = {
    "aria-label": c,
    "aria-orientation": "horizontal",
    "aria-labelledby": `${d} ${Fm(e.tableState, r.key)}`,
    "aria-valuetext": s.format("columnSize", {
      value: O
    }),
    type: "range",
    min: I,
    max: N,
    value: O,
    ...x
  };
  const D = G(() => {
    n.current && Ce(n.current);
  }, [
    n
  ]);
  let F = e.resizingColumn, M = B(null), P = ye($);
  Q(() => {
    if (M.current !== F && F != null && F === r.key) {
      b.current = oe() === n.current, P(r);
      let k = setTimeout(() => D(), 0), ee = setTimeout(D, 400);
      return () => {
        clearTimeout(k), clearTimeout(ee);
      };
    }
    M.current = F;
  }, [
    F,
    r,
    D,
    n
  ]);
  let T = (k) => {
    let ee = e.getColumnWidth(r.key), Z = parseFloat(H(k).value);
    Z > ee ? Z = ee + 10 : Z = ee - 10, v(r, Z);
  }, { pressProps: W } = lt({
    preventFocusOnPress: !0,
    onPressStart: (k) => {
      if (!(k.ctrlKey || k.altKey || k.metaKey || k.shiftKey || k.pointerType === "keyboard")) {
        if (k.pointerType === "virtual" && e.resizingColumn != null) {
          E(r);
          return;
        }
        D(), k.pointerType !== "virtual" && $(r);
      }
    },
    onPress: (k) => {
      (k.pointerType === "touch" && b.current || k.pointerType === "mouse") && e.resizingColumn != null && E(r);
    }
  }), { visuallyHiddenProps: U } = qt();
  return {
    resizerProps: L(S, {
      ...C,
      onKeyDown: R
    }, W, {
      style: {
        touchAction: "none"
      }
    }),
    inputProps: L(U, {
      id: d,
      onBlur: () => {
        E(r);
      },
      onChange: T,
      disabled: i
    }, K),
    isResizing: f
  };
}
function F5() {
  return {
    rowGroupProps: {
      role: "rowgroup"
    }
  };
}
function h3() {
  return F5();
}
function T5(t) {
  return t && t.__esModule ? t.default : t;
}
class A5 extends Ps {
  withExpandedKeys(e) {
    let n = this.clone();
    return n.expandedKeys = e, n.frozen = this.frozen, n.rows = Array.from(n.getRows()), n;
  }
  addNode(e) {
    super.addNode(e), this.columnsDirty ||= e.type === "column", e.type === "tableheader" && (this.head = e);
  }
  getRows() {
    let e = [];
    for (let n of this) (n.type === "tablebody" || n.type === "tablefooter") && e.push(...this.getChildren(n.key));
    return e;
  }
  // backward compatibility
  get body() {
    for (let e of this)
      if (e.type === "tablebody") return e;
    return new sl(-2);
  }
  commit(e, n, r = !1) {
    this.updateColumns(r), this.firstKey = e, this.lastKey = n, this.rows = [];
    for (let l of this.getRows()) {
      let i = l.lastChildKey;
      if (i != null) {
        let a = this.getItem(i);
        for (; a && a.type !== "cell"; ) a = a.prevKey != null ? this.getItem(a.prevKey) : null;
        if (a) {
          let o = (a.colIndex ?? a.index) + (a.colSpan ?? 1);
          if (o !== this.columns.length && !r) throw new Error(`Cell count must match column count. Found ${o} cells and ${this.columns.length} columns.`);
        }
      }
      this.rows.push(l);
    }
    super.commit(e, n, r);
  }
  updateColumns(e) {
    if (!this.columnsDirty) return;
    this.rowHeaderColumnKeys = /* @__PURE__ */ new Set(), this.columns = [];
    let n = /* @__PURE__ */ new Map(), r = (l) => {
      l.type === "column" && (n.set(l.key, l), l.hasChildNodes || (l.index = this.columns.length, this.columns.push(l), l.props.isRowHeader && this.rowHeaderColumnKeys.add(l.key)));
      for (let i of this.getChildren(l.key)) r(i);
    };
    for (let l of this.getChildren(this.head.key)) r(l);
    if (this.headerRows = Pm(n, this.columns), this.columnsDirty = !1, this.rowHeaderColumnKeys.size === 0 && this.columns.length > 0 && !e) throw new Error("A table must have at least one Column with the isRowHeader prop set to true");
  }
  get columnCount() {
    return this.columns.length;
  }
  *[Symbol.iterator]() {
    let e = this.firstKey;
    for (; e != null; ) {
      let n = this.getItem(e);
      n && (yield n), e = n?.nextKey ?? null;
    }
  }
  getFirstKey() {
    for (let e of this)
      if (e.type === "tablebody") return e.firstChildKey ?? null;
    return null;
  }
  getLastKey() {
    let e = this.lastKey;
    if (e == null) return null;
    let n = this.getItem(e);
    for (; n?.lastChildKey != null && (n.type !== "item" || this.expandedKeys.has(n.key)); ) n = this.getItem(n.lastChildKey);
    return n?.key;
  }
  getKeyAfter(e) {
    let n = this.getItem(e);
    if (n?.type === "column") return n.nextKey ?? null;
    if (!n) return null;
    if (n.type === "item" && n.firstChildKey != null && this.expandedKeys.has(n.key)) {
      let r = this.getItem(n.firstChildKey);
      for (; r; ) {
        if (r.type === "item") return r.key;
        r = r.nextKey != null ? this.getItem(r.nextKey) : null;
      }
    }
    return super.getKeyAfter(e);
  }
  getKeyBefore(e) {
    let n = this.getItem(e);
    if (n?.type === "column") return n.prevKey ?? null;
    if (!n) return null;
    let r = null;
    if (n.prevKey != null) {
      for (n = this.getItem(n.prevKey); n && (n.type !== "item" || this.expandedKeys.has(n.key)) && n.lastChildKey != null; ) n = this.getItem(n.lastChildKey);
      r = n?.key ?? null;
    }
    return r == null && (r = n.parentKey), r != null && this.getItem(r)?.type === "tableheader" ? null : r;
  }
  getChildren(e) {
    let n = this.getItem(e);
    if (!n) {
      for (let l of this.headerRows)
        if (l.key === e) return l.childNodes;
    }
    let r = this;
    return n?.type === "tablebody" || n?.type === "tablefooter" ? {
      *[Symbol.iterator]() {
        let l = n.firstChildKey, i = l != null ? r.getItem(l) : null;
        for (; i; ) {
          yield i;
          let a = r.getKeyAfter(i.key);
          if (i = a != null ? r.getItem(a) : null, i && i.parentKey === n.parentKey) break;
        }
      }
    } : {
      *[Symbol.iterator]() {
        let l = r.getItem(e), i = l?.firstChildKey != null ? r.getItem(l.firstChildKey) : null;
        for (; i && (yield i, i = i.nextKey != null ? r.getItem(i.nextKey) : null, !(l?.type === "item" && i?.type !== "cell")); )
          ;
      }
    };
  }
  clone() {
    let e = super.clone();
    return e.headerRows = this.headerRows, e.columns = this.columns, e.rows = this.rows, e.rowHeaderColumnKeys = this.rowHeaderColumnKeys, e.head = this.head, e;
  }
  getTextValue(e) {
    let n = this.getItem(e);
    if (!n) return "";
    if (n.textValue) return n.textValue;
    let r = this.rowHeaderColumnKeys, l = [];
    for (let i of this.getChildren(e)) {
      let a = this.columns[i.index];
      if (r.has(a.key) && i.textValue && l.push(i.textValue), l.length === r.size) break;
    }
    return l.join(" ");
  }
  constructor(...e) {
    super(...e), this.headerRows = [], this.columns = [], this.rows = [], this.rowHeaderColumnKeys = /* @__PURE__ */ new Set(), this.head = new ul(-1), this.columnsDirty = !0, this.expandedKeys = /* @__PURE__ */ new Set();
  }
}
const Da = /* @__PURE__ */ j(null), Z6 = /* @__PURE__ */ te(function(e, n) {
  let r = ge(n), l = B(null), i = B(null), [a, o] = q(0);
  le(() => {
    let c = l.current;
    for (; c && c !== r.current && !jt(c); ) c = c.parentElement;
    i.current = c;
  }, [
    r
  ]), Nn({
    ref: i,
    box: "border-box",
    onResize() {
      o(i.current?.clientWidth ?? 0);
    }
  }), le(() => {
    o(i.current?.clientWidth ?? 0);
  }, []);
  let u = _(() => ({
    tableRef: l,
    scrollRef: i,
    tableWidth: a,
    useTableColumnResizeState: u5,
    onResizeStart: e.onResizeStart,
    onResize: e.onResize,
    onResizeEnd: e.onResizeEnd
  }), [
    l,
    a,
    e.onResizeStart,
    e.onResize,
    e.onResizeEnd
  ]);
  return /* @__PURE__ */ m.createElement(X.div, {
    render: e.render,
    ...Y(e, {
      global: !0
    }),
    ref: r,
    className: e.className || "react-aria-ResizableTableContainer",
    style: e.style,
    onScroll: e.onScroll
  }, /* @__PURE__ */ m.createElement(Da.Provider, {
    value: u
  }, e.children));
}), I5 = /* @__PURE__ */ j(null), Dt = /* @__PURE__ */ j(null), wa = /* @__PURE__ */ j(null), J6 = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, I5);
  let r = Sr(e), { selectionBehavior: l, selectionMode: i, disallowEmptySelection: a } = r, o = !!e.dragAndDropHooks?.useDraggableCollectionState, u = _(() => ({
    selectionBehavior: i === "none" ? null : l,
    selectionMode: i,
    disallowEmptySelection: a,
    allowsDragging: o
  }), [
    l,
    i,
    a,
    o
  ]), c = /* @__PURE__ */ m.createElement(p3.Provider, {
    value: u
  }, /* @__PURE__ */ m.createElement(At, e));
  return /* @__PURE__ */ m.createElement(hn, {
    content: c,
    createCollection: () => new A5()
  }, (s) => /* @__PURE__ */ m.createElement(R5, {
    props: e,
    forwardedRef: n,
    selectionState: r,
    collection: s
  }));
});
let K5 = /* @__PURE__ */ te(function(e, n) {
  let { isVirtualized: r } = z(me);
  return r ? /* @__PURE__ */ m.createElement(X.div, {
    ...e,
    ref: n
  }) : /* @__PURE__ */ m.createElement(X.table, {
    ...e,
    ref: n
  });
});
const pu = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function R5({ props: t, forwardedRef: e, selectionState: n, collection: r }) {
  [t, e] = ie(t, e, dn);
  let { shouldUseVirtualFocus: l, disallowTypeAhead: i, filter: a, ...o } = t, u = z(Da);
  e = ge(_(() => at(e, u?.tableRef), [
    e,
    u?.tableRef
  ]));
  let [c, s] = Be(t.expandedKeys ? new Set(t.expandedKeys) : void 0, t.defaultExpandedKeys ? new Set(t.defaultExpandedKeys) : /* @__PURE__ */ new Set(), t.onExpandedChange);
  r = _(() => r.withExpandedKeys(c), [
    r,
    c
  ]);
  let d = d5({
    ...o,
    collection: r,
    children: void 0,
    UNSAFE_selectionState: n,
    expandedKeys: c,
    onExpandedChange: s
  }), f = f5(d, a), { isVirtualized: h, layoutDelegate: p, dropTargetDelegate: b, CollectionRoot: g } = z(me), { dragAndDropHooks: y } = t, { gridProps: $ } = g5({
    ...o,
    layoutDelegate: p,
    isVirtualized: h
  }, f, e), v = f.selectionManager, E = !!y?.useDraggableCollectionState, S = !!y?.useDroppableCollectionState, w = B(E), C = B(S);
  Q(() => {
    process.env.NODE_ENV !== "production" && (w.current !== E && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), C.current !== S && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."));
  }, [
    E,
    S
  ]);
  let R, I, N, O = !1, A = null, V = B(null), { direction: x } = pe(), [K] = q(() => new e5());
  if (E && y) {
    R = y.useDraggableCollectionState({
      collection: f.collection,
      selectionManager: v,
      preview: y.renderDragPreview ? V : void 0
    }), y.useDraggableCollection({}, R, e);
    let ee = y.DragPreview;
    A = y.renderDragPreview ? /* @__PURE__ */ m.createElement(ee, {
      ref: V
    }, y.renderDragPreview) : null;
  }
  if (S && y) {
    I = y.useDroppableCollectionState({
      collection: f.collection,
      selectionManager: v
    });
    let ee = new Pr({
      collection: f.collection,
      disabledKeys: v.disabledKeys,
      disabledBehavior: v.disabledBehavior,
      ref: e,
      layoutDelegate: p
    }), Z = y.dropTargetDelegate || b || new y.ListDropTargetDelegate(r.rows, e);
    K.setup(Z, d, x), N = y.useDroppableCollection({
      keyboardDelegate: ee,
      dropTargetDelegate: K,
      onDropActivate: (de) => {
        if (de.target.type === "item") {
          let ae = de.target.key, se = d.collection.getItem(ae), Se = c.has(ae);
          se && se.hasChildNodes && (!Se || y?.isVirtualDragging?.()) && d.toggleKey(ae);
        }
      },
      onKeyDown: (de) => {
        let ae = I?.target;
        if (ae && ae.type === "item" && ae.dropPosition === "on") {
          let se = d.collection.getItem(ae.key);
          (de.key === pu.expand[x] && se?.hasChildNodes && !d.expandedKeys.has(ae.key) || de.key === pu.collapse[x] && se?.hasChildNodes && d.expandedKeys.has(ae.key)) && d.toggleKey(ae.key);
        }
      }
    }, I, e), O = I.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: D, isFocused: F, isFocusVisible: M } = $e(), P = re({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-Table",
    values: {
      isDropTarget: O,
      isFocused: F,
      isFocusVisible: M,
      state: f
    }
  }), T = !!(E && !R?.isDisabled), W = P.style, U = null;
  u && (U = u.useTableColumnResizeState({
    tableWidth: u.tableWidth
  }, f), h || (W = {
    ...W,
    tableLayout: "fixed",
    // due to https://bugzilla.mozilla.org/show_bug.cgi?id=1959353, we can't use "fit-content".
    // Causes the table columns to grow to fill the available space in Firefox, ignoring user set column widths
    width: "min-content"
  }));
  let k = Y(t, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Dt,
        f
      ],
      [
        wa,
        U
      ],
      [
        Ct,
        {
          dragAndDropHooks: y,
          dragState: R,
          dropState: I
        }
      ],
      [
        ra,
        {
          render: O5
        }
      ],
      [
        dn,
        null
      ],
      [
        vr,
        null
      ]
    ]
  }, /* @__PURE__ */ m.createElement(vl, null, /* @__PURE__ */ m.createElement(K5, {
    ...L(k, P, $, D, N?.collectionProps),
    style: W,
    ref: e,
    slot: t.slot || void 0,
    onScroll: t.onScroll,
    "data-allows-dragging": T || void 0,
    "data-drop-target": O || void 0,
    "data-focused": F || void 0,
    "data-focus-visible": M || void 0
  }, /* @__PURE__ */ m.createElement(bn, null, /* @__PURE__ */ m.createElement(g, {
    collection: f.collection,
    scrollRef: u?.scrollRef ?? e,
    persistedKeys: ap(v, y, I)
  })))), A);
}
const p3 = /* @__PURE__ */ j(null);
function Q6() {
  return z(p3);
}
const Na = class Na extends Ze {
};
Na.type = "tableheader";
let ul = Na, N5 = /* @__PURE__ */ te(function(e, n) {
  let { isVirtualized: r } = z(me);
  return r ? /* @__PURE__ */ m.createElement(X.div, {
    ...e,
    ref: n
  }) : /* @__PURE__ */ m.createElement(X.thead, {
    ...e,
    ref: n
  });
});
const ex = /* @__PURE__ */ xr(ul, (t, e) => {
  let n = z(Dt).collection, r = Wi({
    items: n.headerRows,
    children: G((u) => {
      if (u.type === "headerrow")
        return /* @__PURE__ */ m.createElement(L5, {
          item: u
        });
      throw new Error("Unsupported node type in TableHeader: " + u.type);
    }, [])
  }), { rowGroupProps: l } = h3(), { hoverProps: i, isHovered: a } = ve({
    onHoverStart: t.onHoverStart,
    onHoverChange: t.onHoverChange,
    onHoverEnd: t.onHoverEnd
  }), o = re({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-TableHeader",
    values: {
      isHovered: a
    }
  });
  return /* @__PURE__ */ m.createElement(N5, {
    ...L(Y(t, {
      global: !0
    }), l, i),
    ...o,
    ref: e,
    "data-hovered": a || void 0
  }, r);
}, (t) => /* @__PURE__ */ m.createElement(At, {
  dependencies: t.dependencies,
  items: t.columns
}, t.children));
let M5 = /* @__PURE__ */ te(function(e, n) {
  let { isVirtualized: r } = z(me);
  return r ? /* @__PURE__ */ m.createElement("div", {
    ...e,
    ref: n
  }) : /* @__PURE__ */ m.createElement("tr", {
    ...e,
    ref: n
  });
});
function L5({ item: t }) {
  let e = B(null), n = z(Dt), { isVirtualized: r, CollectionBranch: l } = z(me), { rowProps: i } = C5({
    node: t,
    isVirtualized: r
  }, n, e), { checkboxProps: a } = S5(n);
  return /* @__PURE__ */ m.createElement(M5, {
    ...i,
    ref: e
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Yi,
        {
          slots: {
            selection: a
          }
        }
      ],
      [
        Tc,
        {
          slots: {
            selection: a
          }
        }
      ]
    ]
  }, /* @__PURE__ */ m.createElement(l, {
    collection: n.collection,
    parent: t
  })));
}
const Ma = class Ma extends Ze {
};
Ma.type = "column";
let Ti = Ma, z5 = /* @__PURE__ */ te(function(e, n) {
  let { isVirtualized: r } = z(me);
  return r ? /* @__PURE__ */ m.createElement(X.div, {
    ...e,
    ref: n
  }) : /* @__PURE__ */ m.createElement(X.th, {
    ...e,
    ref: n
  });
});
const tx = /* @__PURE__ */ ot(Ti, (t, e, n) => {
  let r = ge(e), l = z(Dt), { isVirtualized: i } = z(me), { columnHeaderProps: a, isPressed: o } = $5({
    node: n,
    isVirtualized: i
  }, l, r), { isFocused: u, isFocusVisible: c, focusProps: s } = $e(), d = z(wa), f = !1;
  if (d) f = d.resizingColumn === n.key;
  else if (process.env.NODE_ENV !== "production")
    for (let $ in [
      "width",
      "defaultWidth",
      "minWidth",
      "maxWidth"
    ]) $ in n.props && console.warn(`The ${$} prop on a <Column> only applies when a <Table> is wrapped in a <ResizableTableContainer>. If you aren't using column resizing, you can set the width of a column with CSS.`);
  let { hoverProps: h, isHovered: p } = ve({
    isDisabled: !t.allowsSorting
  }), b = re({
    ...t,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Column",
    values: {
      isHovered: p,
      isPressed: o,
      isFocused: u,
      isFocusVisible: c,
      allowsSorting: n.props.allowsSorting,
      sortDirection: l.sortDescriptor?.column === n.key ? l.sortDescriptor.direction : void 0,
      isResizing: f,
      startResize: () => {
        if (d)
          d.startResize(n.key), l.setKeyboardNavigationDisabled(!0);
        else throw new Error("Wrap your <Table> in a <ResizableTableContainer> to enable column resizing");
      },
      sort: ($) => {
        l.sort(n.key, $);
      }
    }
  }), g = b.style;
  d && (g = {
    ...g,
    width: d.getColumnWidth(n.key)
  });
  let y = Y(t, {
    global: !0
  });
  return delete y.id, /* @__PURE__ */ m.createElement(z5, {
    ...L(y, a, s, h),
    ...b,
    style: g,
    ref: r,
    "data-hovered": p || void 0,
    "data-pressed": o || void 0,
    "data-focused": u || void 0,
    "data-focus-visible": c || void 0,
    "data-resizing": f || void 0,
    "data-allows-sorting": n.props.allowsSorting || void 0,
    "data-sort-direction": l.sortDescriptor?.column === n.key ? l.sortDescriptor.direction : void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        b3,
        {
          column: n,
          triggerRef: r
        }
      ],
      [
        me,
        Er
      ]
    ]
  }, b.children));
}), b3 = /* @__PURE__ */ j(null), nx = /* @__PURE__ */ te(function(e, n) {
  let r = z(wa);
  if (!r) throw new Error("Wrap your <Table> in a <ResizableTableContainer> to enable column resizing");
  let l = ke(T5(na), "react-aria-components"), { onResizeStart: i, onResize: a, onResizeEnd: o } = z(Da), { column: u, triggerRef: c } = z(b3), s = B(null), { resizerProps: d, inputProps: f, isResizing: h } = B5({
    column: u,
    "aria-label": e["aria-label"] || l.format("tableResizer"),
    onResizeStart: i,
    onResize: a,
    onResizeEnd: o,
    triggerRef: c
  }, r, s), { focusProps: p, isFocused: b, isFocusVisible: g } = $e(), { hoverProps: y, isHovered: $ } = ve(e), v = r.getColumnMinWidth(u.key) >= r.getColumnWidth(u.key), E = r.getColumnMaxWidth(u.key) <= r.getColumnWidth(u.key), { direction: S } = pe(), w = "both";
  v ? w = S === "rtl" ? "right" : "left" : E ? w = S === "rtl" ? "left" : "right" : w = "both";
  let C = ge(n), [R, I] = q("");
  Q(() => {
    if (!C.current) return;
    let K = window.getComputedStyle(C.current);
    I(K.cursor);
  }, [
    C,
    w
  ]);
  let N = re({
    ...e,
    defaultClassName: "react-aria-ColumnResizer",
    values: {
      isFocused: b,
      isFocusVisible: g,
      isResizing: h,
      isHovered: $,
      resizableDirection: w
    }
  }), [O, A] = q(!1), V = (K) => {
    K.pointerType === "mouse" && A(!0);
  };
  !h && O && A(!1);
  let x = Y(e, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ref: C,
    role: "presentation",
    ...L(x, N, d, {
      onPointerDown: V
    }, y),
    "data-hovered": $ || void 0,
    "data-focused": b || void 0,
    "data-focus-visible": g || void 0,
    "data-resizing": h || void 0,
    "data-resizable-direction": w
  }, N.children, /* @__PURE__ */ m.createElement("input", {
    ref: s,
    ...L(f, p)
  }), h && O && /* @__PURE__ */ Ni.createPortal(/* @__PURE__ */ m.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      cursor: R
    }
  }), document.body));
}), La = class La extends bl {
};
La.type = "tablebody";
let sl = La, V5 = /* @__PURE__ */ te(function(e, n) {
  let { isVirtualized: r } = z(me);
  return r ? /* @__PURE__ */ m.createElement(X.div, {
    ...e,
    ref: n
  }) : /* @__PURE__ */ m.createElement(X.tbody, {
    ...e,
    ref: n
  });
});
const rx = /* @__PURE__ */ xr(sl, (t, e, n) => {
  let r = z(Dt), { isVirtualized: l } = z(me), i = r.collection, { CollectionBranch: a } = z(me), { dragAndDropHooks: o, dropState: u } = z(Ct), c = !!o?.useDroppableCollectionState && !u?.isDisabled, s = c && !!u && (u.isDropTarget({
    type: "root"
  }) ?? !1), d = i.size === 0, f = {
    isDropTarget: s,
    isEmpty: d
  }, h = re({
    ...t,
    id: void 0,
    children: void 0,
    defaultClassName: "react-aria-TableBody",
    values: f
  }), p, b = i.columnCount;
  if (d && t.renderEmptyState && r) {
    let $ = {}, v = {}, E = {};
    l ? (v["aria-colspan"] = b, E = {
      display: "contents"
    }) : v.colSpan = b, p = /* @__PURE__ */ m.createElement(Ln, {
      role: "row",
      ...$,
      style: E
    }, /* @__PURE__ */ m.createElement(zn, {
      role: "rowheader",
      ...v,
      style: E
    }, t.renderEmptyState(f)));
  }
  let { rowGroupProps: g } = h3(), y = Y(t, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(V5, {
    ...L(y, h, g),
    ref: e,
    "data-empty": d || void 0
  }, c && /* @__PURE__ */ m.createElement(U5, null), /* @__PURE__ */ m.createElement(a, {
    collection: i,
    parent: n,
    renderDropIndicator: la(o, u)
  }), p);
}), za = class za extends bl {
};
za.type = "tablefooter";
let bu = za;
const m3 = /* @__PURE__ */ j({
  isFocusVisibleWithinRow: !1
}), Va = class Va extends Ze {
  filter(e, n, r) {
    let l = e.getChildren(this.key);
    for (let i of l) if (r(i.textValue, i)) {
      let a = this.clone();
      return n.addDescendants(a, e), a;
    }
    return null;
  }
};
Va.type = "item";
let Ai = Va, Ln = /* @__PURE__ */ te(function(e, n) {
  let { isVirtualized: r } = z(me);
  return r ? /* @__PURE__ */ m.createElement(X.div, {
    ...e,
    ref: n
  }) : /* @__PURE__ */ m.createElement(X.tr, {
    ...e,
    ref: n
  });
});
const lx = /* @__PURE__ */ xr(Ai, (t, e, n) => {
  let r = ge(e), l = z(Dt), { dragAndDropHooks: i, dragState: a, dropState: o } = z(Ct), { isVirtualized: u, CollectionBranch: c } = z(me), s = a && !(a.isDisabled || a.selectionManager.isDisabled(n.key)), { rowProps: d, expandButtonProps: f, ...h } = E5({
    node: n,
    shouldSelectOnPressUp: !!a,
    isVirtualized: u
  }, l, r), { isFocused: p, isFocusVisible: b, focusProps: g } = $e(), { isFocusVisible: y, focusProps: $ } = $e({
    within: !0
  }), { hoverProps: v, isHovered: E } = ve({
    // because of https://bugs.webkit.org/show_bug.cgi?id=214609, supporting hover styles when a item is ONLY isDraggable
    // results in hover styles sticking around after a reorder/drop operation...
    isDisabled: !h.allowsSelection && !h.hasAction && !s,
    onHoverStart: t.onHoverStart,
    onHoverChange: t.onHoverChange,
    onHoverEnd: t.onHoverEnd
  }), { checkboxProps: S } = P5({
    key: n.key
  }, l), w;
  a && i && (w = i.useDraggableItem({
    key: n.key,
    hasDragButton: !0
  }, a));
  let C, R = B(null), { visuallyHiddenProps: I } = qt();
  o && i && (C = i.useDropIndicator({
    target: {
      type: "item",
      key: n.key,
      dropPosition: "on"
    }
  }, o, R));
  let N = B(null);
  Q(() => {
    a && !N.current && process.env.NODE_ENV !== "production" && console.warn('Draggable items in a Table must contain a <Button slot="drag"> element so that keyboard and screen reader users can drag them.');
  }, []);
  let O = a && a.isDragging(n.key), { children: A, ...V } = t, x = t.hasChildItems || l.collection.getItem(n.lastChildKey)?.type !== "cell", K = x && l.expandedKeys.has(n.key), D = re({
    ...V,
    id: void 0,
    defaultClassName: "react-aria-Row",
    defaultStyle: {
      // @ts-ignore
      "--table-row-level": n.level + 1
    },
    values: {
      ...h,
      state: l,
      isHovered: E,
      isFocused: p,
      isFocusVisible: b,
      selectionMode: l.selectionManager.selectionMode,
      selectionBehavior: l.selectionManager.selectionBehavior,
      isDragging: O,
      isDropTarget: C?.isDropTarget,
      isFocusVisibleWithin: y,
      id: n.key,
      hasChildItems: x,
      isExpanded: K,
      level: n.level + 1
    }
  }), F = Y(t, {
    global: !0
  });
  return delete F.id, delete F.onClick, /* @__PURE__ */ m.createElement(m.Fragment, null, C && !C.isHidden && /* @__PURE__ */ m.createElement(Ln, {
    role: "row",
    style: {
      height: 0
    }
  }, /* @__PURE__ */ m.createElement(zn, {
    role: "gridcell",
    colSpan: l.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ m.createElement("div", {
    role: "button",
    ...I,
    ...C.dropIndicatorProps,
    ref: R
  }))), /* @__PURE__ */ m.createElement(Ln, {
    ...L(F, D, d, g, v, w?.dragProps, $),
    ref: r,
    "data-disabled": h.isDisabled || void 0,
    "data-selected": h.isSelected || void 0,
    "data-hovered": E || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": b || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-dragging": O || void 0,
    "data-drop-target": C?.isDropTarget || void 0,
    "data-selection-mode": l.selectionManager.selectionMode === "none" ? void 0 : l.selectionManager.selectionMode,
    "data-focus-visible-within": y || void 0,
    "data-expanded": K || void 0,
    "data-has-child-items": x || void 0,
    "data-level": n.level + 1
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Yi,
        {
          slots: {
            [rt]: {},
            selection: S
          }
        }
      ],
      [
        Tc,
        {
          slots: {
            [rt]: {},
            selection: S
          }
        }
      ],
      [
        st,
        {
          slots: {
            [rt]: {},
            chevron: f,
            drag: {
              ...w?.dragButtonProps,
              ref: N,
              style: {
                pointerEvents: "none"
              }
            }
          }
        }
      ],
      [
        mn,
        {
          isSelected: h.isSelected
        }
      ],
      [
        m3,
        {
          isFocusVisibleWithinRow: y
        }
      ]
    ]
  }, /* @__PURE__ */ m.createElement(c, {
    collection: l.collection,
    parent: n
  }))));
}, (t) => {
  if (t.id == null && typeof t.children == "function") throw new Error("No id detected for the Row element. The Row element requires a id to be provided to it when the cells are rendered dynamically.");
  let e = [
    t.value
  ].concat(t.dependencies);
  return /* @__PURE__ */ m.createElement(At, {
    dependencies: e,
    items: t.columns,
    idScope: t.id
  }, t.children);
}), Oa = class Oa extends Ze {
};
Oa.type = "cell";
let Ii = Oa, zn = /* @__PURE__ */ te(function(e, n) {
  let { isVirtualized: r } = z(me);
  return r ? /* @__PURE__ */ m.createElement(X.div, {
    ...e,
    ref: n
  }) : /* @__PURE__ */ m.createElement(X.td, {
    ...e,
    ref: n
  });
});
const ix = /* @__PURE__ */ ot(Ii, (t, e, n) => {
  let r = ge(e), l = z(Dt), { dragState: i } = z(Ct), { isVirtualized: a } = z(me);
  n.column = l.collection.columns[n.index];
  let { gridCellProps: o, isPressed: u } = D5({
    node: n,
    shouldSelectOnPressUp: !!i,
    isVirtualized: a
  }, l, r), { isFocused: c, isFocusVisible: s, focusProps: d } = $e(), { hoverProps: f, isHovered: h } = ve({}), { isFocusVisibleWithinRow: p } = z(m3), b = n.parentKey != null ? l.selectionManager.isSelected(n.parentKey) : !1, g = n.colIndex || n.index, y = l.collection.getItem(n.parentKey), $ = y.props.hasChildItems || l.collection.getItem(y.lastChildKey)?.type !== "cell", v = $ && l.expandedKeys.has(n.parentKey), E = l.selectionManager.isDisabled(n.parentKey), S = re({
    ...t,
    id: void 0,
    defaultClassName: "react-aria-Cell",
    values: {
      isFocused: c,
      isFocusVisible: s,
      isFocusVisibleWithinRow: p,
      isPressed: u,
      isHovered: h,
      isSelected: b,
      id: n.key,
      columnIndex: g,
      hasChildItems: $,
      isExpanded: v,
      isDisabled: E,
      level: y.level + 1,
      isTreeColumn: n.column.key === l.treeColumn
    }
  }), w = Y(t, {
    global: !0
  });
  return delete w.id, /* @__PURE__ */ m.createElement(zn, {
    ...L(w, S, o, d, f),
    ref: r,
    "data-focused": c || void 0,
    "data-focus-visible": s || void 0,
    "data-focus-visible-within-row": p || void 0,
    "data-pressed": u || void 0,
    "data-selected": b || void 0,
    "data-column-index": g,
    "data-expanded": v || void 0,
    "data-has-child-items": $ || void 0,
    "data-level": y.level + 1,
    "data-tree-column": n.column.key === l.treeColumn || void 0,
    "data-disabled": E || void 0
  }, /* @__PURE__ */ m.createElement(me.Provider, {
    value: Er
  }, S.children));
});
function O5(t, e) {
  e = ge(e);
  let { dragAndDropHooks: n, dropState: r } = z(Ct), l = B(null), { dropIndicatorProps: i, isHidden: a, isDropTarget: o } = n.useDropIndicator(t, r, l);
  if (a) return null;
  let u = r && t.target.type === "item" ? (r.collection.getItem(t.target.key)?.level || 0) + 1 : 1;
  return /* @__PURE__ */ m.createElement(j5, {
    ...t,
    dropIndicatorProps: i,
    isDropTarget: o,
    buttonRef: l,
    level: u,
    ref: e
  });
}
let H5 = /* @__PURE__ */ te(function(e, n) {
  let { isVirtualized: r } = z(me);
  return r ? /* @__PURE__ */ m.createElement(X.div, {
    ...e,
    ref: n
  }) : /* @__PURE__ */ m.createElement(X.tr, {
    ...e,
    ref: n
  });
}), _5 = /* @__PURE__ */ te(function(e, n) {
  let { isVirtualized: r } = z(me);
  return r ? /* @__PURE__ */ m.createElement(X.div, {
    ...e,
    ref: n
  }) : /* @__PURE__ */ m.createElement(X.td, {
    ...e,
    ref: n
  });
});
function W5(t, e) {
  let { dropIndicatorProps: n, isDropTarget: r, buttonRef: l, level: i, ...a } = t, o = z(Dt), { visuallyHiddenProps: u } = qt(), c = re({
    ...a,
    defaultClassName: "react-aria-DropIndicator",
    defaultStyle: {
      // @ts-ignore
      "--table-row-level": i + 1
    },
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ m.createElement(H5, {
    ...Y(t, {
      global: !0
    }),
    ...c,
    role: "row",
    ref: e,
    "data-drop-target": r || void 0,
    "aria-level": i
  }, /* @__PURE__ */ m.createElement(_5, {
    role: "gridcell",
    colSpan: o.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ m.createElement("div", {
    ...u,
    role: "button",
    ...n,
    ref: l
  }), c.children));
}
const j5 = /* @__PURE__ */ te(W5);
function U5() {
  let t = z(Dt), { dragAndDropHooks: e, dropState: n } = z(Ct), r = B(null), { dropIndicatorProps: l } = e.useDropIndicator({
    target: {
      type: "root"
    }
  }, n, r), i = n.isDropTarget({
    type: "root"
  }), { visuallyHiddenProps: a } = qt();
  return !i && l["aria-hidden"] ? null : /* @__PURE__ */ m.createElement(Ln, {
    role: "row",
    "aria-hidden": l["aria-hidden"],
    style: {
      height: 0
    }
  }, /* @__PURE__ */ m.createElement(zn, {
    role: "gridcell",
    colSpan: t.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ m.createElement("div", {
    role: "button",
    ...a,
    ...l,
    ref: r
  })));
}
ot(Jr, function(e, n, r) {
  let l = z(Dt), { isVirtualized: i } = z(me), { isLoading: a, onLoadMore: o, scrollOffset: u, ...c } = e, s = l.collection.columns.length, d = B(null), f = _(() => ({
    onLoadMore: o,
    collection: l?.collection,
    sentinelRef: d,
    scrollOffset: u
  }), [
    o,
    u,
    l?.collection
  ]);
  gp(f, d);
  let h = re({
    ...c,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-TableLoadingIndicator",
    defaultStyle: {
      // @ts-ignore
      "--table-row-level": r.level + 1
    },
    values: void 0
  }), p = {}, b = {}, g = {};
  return i ? (b["aria-colspan"] = s, g = {
    display: "contents"
  }) : b.colSpan = s, /* @__PURE__ */ m.createElement(m.Fragment, null, /* @__PURE__ */ m.createElement(Ln, {
    style: {
      height: 0
    },
    inert: il(!0)
  }, /* @__PURE__ */ m.createElement(zn, {
    style: {
      padding: 0,
      border: 0
    }
  }, /* @__PURE__ */ m.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: d,
    style: {
      position: "relative",
      height: 1,
      width: 1
    }
  }))), a && h.children && /* @__PURE__ */ m.createElement(Ln, {
    ...L(Y(e, {
      global: !0
    }), p),
    ...h,
    role: "row",
    ref: n,
    "aria-level": r.level + 1,
    "data-level": r.level + 1
  }, /* @__PURE__ */ m.createElement(zn, {
    role: "rowheader",
    ...b,
    style: g
  }, h.children)));
});
class nt {
  constructor(e = 0, n = 0) {
    this.x = e, this.y = n;
  }
  /**
  * Returns a copy of this point.
  */
  copy() {
    return new nt(this.x, this.y);
  }
  /**
  * Checks if two points are equal.
  */
  equals(e) {
    return this.x === e.x && this.y === e.y;
  }
  /**
  * Returns true if this point is the origin.
  */
  isOrigin() {
    return this.x === 0 && this.y === 0;
  }
}
class be {
  constructor(e = 0, n = 0, r = 0, l = 0) {
    this.x = e, this.y = n, this.width = r, this.height = l;
  }
  /**
  * The maximum x-coordinate in the rectangle.
  */
  get maxX() {
    return this.x + this.width;
  }
  /**
  * The maximum y-coordinate in the rectangle.
  */
  get maxY() {
    return this.y + this.height;
  }
  /**
  * The area of the rectangle.
  */
  get area() {
    return this.width * this.height;
  }
  /**
  * The top left corner of the rectangle.
  */
  get topLeft() {
    return new nt(this.x, this.y);
  }
  /**
  * The top right corner of the rectangle.
  */
  get topRight() {
    return new nt(this.maxX, this.y);
  }
  /**
  * The bottom left corner of the rectangle.
  */
  get bottomLeft() {
    return new nt(this.x, this.maxY);
  }
  /**
  * The bottom right corner of the rectangle.
  */
  get bottomRight() {
    return new nt(this.maxX, this.maxY);
  }
  /**
  * Returns whether this rectangle intersects another rectangle.
  *
  * @param rect - The rectangle to check.
  */
  intersects(e) {
    return (process.env.NODE_ENV === "test" && !process.env.VIRT_ON || this.area > 0 && e.area > 0) && this.x <= e.x + e.width && e.x <= this.x + this.width && this.y <= e.y + e.height && e.y <= this.y + this.height;
  }
  /**
  * Returns whether this rectangle fully contains another rectangle.
  *
  * @param rect - The rectangle to check.
  */
  containsRect(e) {
    return this.x <= e.x && this.y <= e.y && this.maxX >= e.maxX && this.maxY >= e.maxY;
  }
  /**
  * Returns whether the rectangle contains the given point.
  *
  * @param point - The point to check.
  */
  containsPoint(e) {
    return this.x <= e.x && this.y <= e.y && this.maxX >= e.x && this.maxY >= e.y;
  }
  /**
  * Returns the first corner of this rectangle (from top to bottom, left to right)
  * that is contained in the given rectangle, or null of the rectangles do not intersect.
  *
  * @param rect - The rectangle to check.
  */
  getCornerInRect(e) {
    for (let n of [
      "topLeft",
      "topRight",
      "bottomLeft",
      "bottomRight"
    ])
      if (e.containsPoint(this[n])) return n;
    return null;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.width === this.width && e.height === this.height;
  }
  pointEquals(e) {
    return this.x === e.x && this.y === e.y;
  }
  sizeEquals(e) {
    return this.width === e.width && this.height === e.height;
  }
  /**
  * Returns the union of this Rect and another.
  */
  union(e) {
    let n = Math.min(this.x, e.x), r = Math.min(this.y, e.y), l = Math.max(this.maxX, e.maxX) - n, i = Math.max(this.maxY, e.maxY) - r;
    return new be(n, r, l, i);
  }
  /**
  * Returns the intersection of this Rect with another.
  * If the rectangles do not intersect, an all zero Rect is returned.
  */
  intersection(e) {
    if (!this.intersects(e)) return new be(0, 0, 0, 0);
    let n = Math.max(this.x, e.x), r = Math.max(this.y, e.y);
    return new be(n, r, Math.min(this.maxX, e.maxX) - n, Math.min(this.maxY, e.maxY) - r);
  }
  /**
  * Returns a copy of this rectangle.
  */
  copy() {
    return new be(this.x, this.y, this.width, this.height);
  }
}
class Le {
  constructor(e = 0, n = 0) {
    this.width = Math.max(e, 0), this.height = Math.max(n, 0);
  }
  /**
  * Returns a copy of this size.
  */
  copy() {
    return new Le(this.width, this.height);
  }
  /**
  * Returns whether this size is equal to another one.
  */
  equals(e) {
    return this.width === e.width && this.height === e.height;
  }
  /**
  * The total area of the Size.
  */
  get area() {
    return this.width * this.height;
  }
}
let G5 = 0;
class g3 {
  constructor(e, n) {
    this.virtualizer = e, this.key = ++G5, this.viewType = n, this.children = /* @__PURE__ */ new Set(), this.reusableViews = /* @__PURE__ */ new Map(), this.layoutInfo = null, this.content = null, this.rendered = null;
  }
  /**
  * Prepares the view for reuse. Called just before the view is removed from the DOM.
  */
  prepareForReuse() {
    this.content = null, this.rendered = null, this.layoutInfo = null;
  }
  getReusableView(e) {
    let n = this.reusableViews.get(e);
    return n && n.length > 0 ? n.shift() : new Y5(this.virtualizer, this, e);
  }
  reuseChild(e) {
    e.prepareForReuse();
    let n = this.reusableViews.get(e.viewType);
    n || (n = [], this.reusableViews.set(e.viewType, n)), n.push(e);
  }
}
class q5 extends g3 {
  constructor(e) {
    super(e, "root");
  }
}
class Y5 extends g3 {
  constructor(e, n, r) {
    super(e, r), this.parent = n;
  }
}
function X5(t, e) {
  if (t === e) return !0;
  if (t.size !== e.size) return !1;
  for (let n of t)
    if (!e.has(n)) return !1;
  return !0;
}
class Z5 {
  setVisibleRect(e) {
    let n = performance.now() - this.startTime;
    n < 500 && (e.x !== this.visibleRect.x && n > 0 && (this.velocity.x = (e.x - this.visibleRect.x) / n), e.y !== this.visibleRect.y && n > 0 && (this.velocity.y = (e.y - this.visibleRect.y) / n)), this.startTime = performance.now(), this.visibleRect = e;
  }
  getOverscannedRect() {
    let e = this.visibleRect.copy(), n = this.visibleRect.height / 3;
    e.height += n, this.velocity.y < 0 && (e.y -= n);
    let r = this.visibleRect.width / 3;
    return e.width += r, this.velocity.x < 0 && (e.x -= r), e;
  }
  constructor() {
    this.startTime = 0, this.velocity = new nt(0, 0), this.visibleRect = new be();
  }
}
class J5 {
  constructor(e) {
    this.delegate = e.delegate, this.collection = e.collection, this.layout = e.layout, this.contentSize = new Le(), this.visibleRect = new be(), this.size = new Le(), this.persistedKeys = /* @__PURE__ */ new Set(), this._visibleViews = /* @__PURE__ */ new Map(), this._renderedContent = /* @__PURE__ */ new WeakMap(), this._rootView = new q5(this), this._isScrolling = !1, this._invalidationContext = {}, this._overscanManager = new Z5();
  }
  /** Returns whether the given key, or an ancestor, is persisted. */
  isPersistedKey(e) {
    if (this.persistedKeys.has(e)) return !0;
    for (let n of this.persistedKeys) for (; n != null; ) {
      let r = this.layout.getLayoutInfo(n);
      if (!r || r.parentKey == null) break;
      if (n = r.parentKey, n === e) return !0;
    }
    return !1;
  }
  getParentView(e) {
    return e.parentKey != null ? this._visibleViews.get(e.parentKey) : this._rootView;
  }
  getReusableView(e) {
    let r = this.getParentView(e).getReusableView(e.type);
    return r.layoutInfo = e, this._renderView(r), r;
  }
  _renderView(e) {
    if (e.layoutInfo) {
      let { type: n, key: r, content: l } = e.layoutInfo;
      e.content = l || this.collection.getItem(r), e.rendered = this._renderContent(n, e.content);
    }
  }
  _renderContent(e, n) {
    let r = n != null ? this._renderedContent.get(n) : null;
    if (r != null) return r;
    let l = this.delegate.renderView(e, n);
    return n && this._renderedContent.set(n, l), l;
  }
  /**
  * Returns the key for the item view currently at the given point.
  */
  keyAtPoint(e) {
    let n = new be(e.x, e.y, 1, 1), r = n.area === 0 ? [] : this.layout.getVisibleLayoutInfos(n);
    for (let l of r)
      if (l.rect.intersects(n)) return l.key;
    return null;
  }
  relayout(e = {}) {
    this.layout.update(e), this.contentSize = this.layout.getContentSize();
    let n = this.visibleRect, r = e.contentChanged ? 0 : n.x, l = e.contentChanged ? 0 : n.y;
    if (r = Math.max(0, Math.min(this.contentSize.width - n.width, r)), l = Math.max(0, Math.min(this.contentSize.height - n.height, l)), r !== n.x || l !== n.y) {
      let i = new be(r, l, n.width, n.height);
      this.delegate.setVisibleRect(i);
    } else this.updateSubviews();
  }
  getVisibleLayoutInfos() {
    let e = process.env.NODE_ENV === "test" && !process.env.VIRT_ON, n = e && typeof HTMLElement < "u" && Object.getOwnPropertyNames(HTMLElement.prototype).includes("clientWidth"), r = e && typeof HTMLElement < "u" && Object.getOwnPropertyNames(HTMLElement.prototype).includes("clientHeight"), l;
    e && !(n && r) ? l = new be(0, 0, this.contentSize.width, this.contentSize.height) : l = this._overscanManager.getOverscannedRect();
    let i = this.layout.getVisibleLayoutInfos(l), a = /* @__PURE__ */ new Map();
    for (let o of i) a.set(o.key, o);
    return a;
  }
  updateSubviews() {
    let e = this.getVisibleLayoutInfos(), n = /* @__PURE__ */ new Set();
    for (let [r, l] of this._visibleViews) {
      let i = e.get(r);
      (!i || l.parent !== this.getParentView(i)) && (this._visibleViews.delete(r), l.parent.reuseChild(l), n.add(l));
    }
    for (let [r, l] of e) {
      let i = this._visibleViews.get(r);
      if (!i)
        i = this.getReusableView(l), i.parent.children.add(i), this._visibleViews.set(r, i), n.delete(i);
      else {
        i.layoutInfo = l;
        let a = this.collection.getItem(l.key);
        i.content !== a && (i.content != null && this._renderedContent.delete(i.content), this._renderView(i));
      }
    }
    for (let r of n)
      r.parent.children.delete(r), r.parent.reusableViews.clear();
    if (!this._isScrolling)
      for (let r of e.keys()) {
        let l = this._visibleViews.get(r);
        l.parent.children.delete(l), l.parent.children.add(l);
      }
  }
  /** Performs layout and updates visible views as needed. */
  render(e) {
    let n = this, r = !1, l = !1, i = !1, a = !1, o = !1, u = !1;
    if (e.collection !== this.collection && (n.collection = e.collection, r = !0), (e.layout !== this.layout || this.layout.virtualizer !== this) && (this.layout && (this.layout.virtualizer = null), e.layout.virtualizer = this, n.layout = e.layout, r = !0), e.persistedKeys && !X5(e.persistedKeys, this.persistedKeys) && (n.persistedKeys = e.persistedKeys, u = !0), !this.visibleRect.equals(e.visibleRect) || !this.size.equals(e.size)) {
      this._overscanManager.setVisibleRect(e.visibleRect);
      let c = new be(this.visibleRect.x, this.visibleRect.y, this.size.width, this.size.height), s = new be(e.visibleRect.x, e.visibleRect.y, e.size.width, e.size.height);
      this.layout.shouldInvalidate(s, c) ? (l = !e.visibleRect.pointEquals(this.visibleRect), i = !this.size.equals(e.size), r = !0) : u = !0, n.visibleRect = e.visibleRect, n.size = e.size;
    }
    return e.invalidationContext !== this._invalidationContext && (e.invalidationContext && (i ||= e.invalidationContext.sizeChanged || !1, l ||= e.invalidationContext.offsetChanged || !1, a ||= e.invalidationContext.itemSizeChanged || !1, o ||= e.invalidationContext.layoutOptions != null && this._invalidationContext.layoutOptions != null && e.invalidationContext.layoutOptions !== this._invalidationContext.layoutOptions && this.layout.shouldInvalidateLayoutOptions(e.invalidationContext.layoutOptions, this._invalidationContext.layoutOptions), r ||= a || i || l || o), this._invalidationContext = e.invalidationContext), e.isScrolling !== this._isScrolling && (this._isScrolling = e.isScrolling, e.isScrolling || (u = !0)), r ? this.relayout({
      offsetChanged: l,
      sizeChanged: i,
      itemSizeChanged: a,
      layoutOptionsChanged: o,
      layoutOptions: this._invalidationContext.layoutOptions
    }) : u && this.updateSubviews(), Array.from(this._rootView.children);
  }
  getVisibleView(e) {
    return this._visibleViews.get(e);
  }
  invalidate(e) {
    this.delegate.invalidate(e);
  }
  updateItemSize(e, n) {
    if (!this.layout.updateItemSize) return;
    this.layout.updateItemSize(e, n) && this.invalidate({
      itemSizeChanged: !0
    });
  }
}
const Q5 = typeof document < "u" ? m.useLayoutEffect : () => {
};
function e2(t) {
  let [e, n] = q(new be(0, 0, 0, 0)), [r, l] = q(new Le()), [i, a] = q(!1), [o, u] = q({}), c = B(!1), [s] = q(() => new J5({
    collection: t.collection,
    layout: t.layout,
    delegate: {
      setVisibleRect(y) {
        n(y), c.current = !0;
      },
      // TODO: should changing these invalidate the entire cache?
      renderView: t.renderView,
      invalidate: u
    }
  }));
  Q5(() => {
    c.current && (c.current = !1, t.onVisibleRectChange(e));
  });
  let d = _(() => t.layoutOptions != null ? {
    ...o,
    layoutOptions: t.layoutOptions
  } : o, [
    o,
    t.layoutOptions
  ]), f = s.render({
    layout: t.layout,
    collection: t.collection,
    persistedKeys: t.persistedKeys,
    layoutOptions: t.layoutOptions,
    visibleRect: e,
    size: t.allowsWindowScrolling ? r : e,
    invalidationContext: d,
    isScrolling: i
  }), h = s.contentSize, p = G(() => {
    a(!0);
  }, []), b = G(() => {
    a(!1);
  }, []);
  return _(() => ({
    virtualizer: s,
    visibleViews: f,
    setVisibleRect: n,
    size: r,
    setSize: l,
    contentSize: h,
    isScrolling: i,
    startScrolling: p,
    endScrolling: b
  }), [
    s,
    f,
    n,
    r,
    l,
    h,
    i,
    p,
    b
  ]);
}
class t2 {
  /**
  * Returns whether the layout should invalidate in response to
  * visible rectangle changes. By default, it only invalidates
  * when the virtualizer's size changes. Return true always
  * to make the layout invalidate while scrolling (e.g. sticky headers).
  */
  shouldInvalidate(e, n) {
    return e.width !== n.width || e.height !== n.height;
  }
  /**
  * Returns whether the layout should invalidate when the layout options change.
  * By default it invalidates when the object identity changes. Override this
  * method to optimize layout updates based on specific option changes.
  */
  shouldInvalidateLayoutOptions(e, n) {
    return e !== n;
  }
  /**
  * This method allows the layout to perform any pre-computation
  * it needs to in order to prepare LayoutInfos for retrieval.
  * Called by the virtualizer before `getVisibleLayoutInfos`
  * or `getLayoutInfo` are called.
  */
  update(e) {
  }
  /** @private */
  getItemRect(e) {
    return this.getLayoutInfo(e)?.rect ?? null;
  }
  /** @private */
  getVisibleRect() {
    return this.virtualizer.visibleRect;
  }
  constructor() {
    this.virtualizer = null;
  }
}
class an {
  /**
  * @param type The type of element represented by this LayoutInfo. Should match the `type` of the
  *   corresponding collection node.
  * @param key A unique key for this LayoutInfo. Should match the `key` of the corresponding
  *   collection node.
  * @param rect The rectangle describing the size and position of this element.
  */
  constructor(e, n, r) {
    this.type = e, this.key = n, this.parentKey = null, this.content = null, this.rect = r, this.estimatedSize = !1, this.isSticky = !1, this.opacity = 1, this.transform = null, this.zIndex = 0, this.allowOverflow = !1;
  }
  /**
  * Returns a copy of the LayoutInfo.
  */
  copy() {
    let e = new an(this.type, this.key, this.rect.copy());
    return e.estimatedSize = this.estimatedSize, e.opacity = this.opacity, e.transform = this.transform, e.parentKey = this.parentKey, e.content = this.content, e.isSticky = this.isSticky, e.zIndex = this.zIndex, e.allowOverflow = this.allowOverflow, e;
  }
}
const tn = 48;
class ax extends t2 {
  /**
  * Creates a new ListLayout with options. See the list of properties below for a description
  * of the options that can be provided.
  */
  constructor(e = {}) {
    super(), this.rowSize = e?.rowSize ?? e?.rowHeight ?? null, this.orientation = e.orientation ?? "vertical", this.estimatedRowSize = e?.estimatedRowSize ?? e?.estimatedRowHeight ?? null, this.headingSize = e?.headingSize ?? e?.headingHeight ?? null, this.estimatedHeadingSize = e?.estimatedHeadingSize ?? e?.estimatedHeadingHeight ?? null, this.loaderSize = e?.loaderSize ?? e?.loaderHeight ?? null, this.dropIndicatorThickness = e.dropIndicatorThickness || 2, this.gap = e.gap || 0, this.padding = e.padding || 0, this.layoutNodes = /* @__PURE__ */ new Map(), this.rootNodes = [], this.lastCollection = null, this.invalidateEverything = !1, this.validRect = new be(), this.requestedRect = new be(), this.contentSize = new Le();
  }
  // Backward compatibility for subclassing.
  get collection() {
    return this.virtualizer.collection;
  }
  /** @deprecated Use `rowSize` instead. */
  get rowHeight() {
    return this.rowSize;
  }
  /** @deprecated Use `estimatedRowSize` instead. */
  get estimatedRowHeight() {
    return this.estimatedRowSize;
  }
  /** @deprecated Use `headingSize` instead. */
  get headingHeight() {
    return this.headingSize;
  }
  /** @deprecated Use `estimatedHeadingSize` instead. */
  get estimatedHeadingHeight() {
    return this.estimatedHeadingSize;
  }
  /** @deprecated Use `loaderSize` instead. */
  get loaderHeight() {
    return this.loaderSize;
  }
  getLayoutInfo(e) {
    return this.ensureLayoutInfo(e), this.layoutNodes.get(e)?.layoutInfo || null;
  }
  getVisibleLayoutInfos(e) {
    let n = this.orientation === "horizontal" ? "x" : "y", r = this.orientation === "horizontal" ? "width" : "height";
    if (e[r] > 1) {
      let a = (this.rowSize ?? this.estimatedRowSize ?? tn) + this.gap;
      e = e.copy();
      let o = Math.floor(e[n] / a) * a, u = e[r] + e[n] - o;
      e[n] = o, e[r] = Math.ceil(u / a) * a;
    }
    this.layoutIfNeeded(e);
    let l = [], i = (a) => {
      for (let o of a) this.isVisible(o, e) && (l.push(o.layoutInfo), o.children && i(o.children));
    };
    return i(this.rootNodes), l;
  }
  layoutIfNeeded(e) {
    if (this.lastCollection) {
      this.requestedRect.containsRect(e) || (this.requestedRect = this.requestedRect.union(e), this.rootNodes = this.buildCollection());
      for (let n of this.virtualizer.persistedKeys)
        if (this.ensureLayoutInfo(n)) return;
    }
  }
  ensureLayoutInfo(e) {
    return !this.layoutNodes.has(e) && this.requestedRect.area < this.contentSize.area && this.lastCollection ? (this.requestedRect = new be(0, 0, 1 / 0, 1 / 0), this.rootNodes = this.buildCollection(), this.requestedRect = new be(0, 0, this.contentSize.width, this.contentSize.height), !0) : !1;
  }
  isVisible(e, n) {
    return e.layoutInfo.rect.intersects(n) || e.layoutInfo.isSticky || e.layoutInfo.type === "header" || e.layoutInfo.type === "loader" || this.virtualizer.isPersistedKey(e.layoutInfo.key);
  }
  shouldInvalidateEverything(e) {
    let n = e.layoutOptions;
    return e.sizeChanged || this.rowSize !== (n?.rowSize ?? n?.rowHeight ?? this.rowSize) || this.orientation !== (n?.orientation ?? this.orientation) || this.headingSize !== (n?.headingSize ?? n?.headingHeight ?? this.headingSize) || this.loaderSize !== (n?.loaderSize ?? n?.loaderHeight ?? this.loaderSize) || this.gap !== (n?.gap ?? this.gap) || this.padding !== (n?.padding ?? this.padding);
  }
  shouldInvalidateLayoutOptions(e, n) {
    return (e?.rowSize ?? e?.rowHeight) !== (n?.rowSize ?? n?.rowHeight) || e.orientation !== n.orientation || (e?.estimatedRowSize ?? e?.estimatedRowHeight) !== (n?.estimatedRowSize ?? n?.estimatedRowHeight) || (e?.headingSize ?? e?.headingHeight) !== (n?.headingSize ?? n?.headingHeight) || (e?.estimatedHeadingSize ?? e?.estimatedHeadingHeight) !== (n?.estimatedHeadingSize ?? n?.estimatedHeadingHeight) || (e?.loaderSize ?? e?.loaderHeight) !== (n?.loaderSize ?? n?.loaderHeight) || e.dropIndicatorThickness !== n.dropIndicatorThickness || e.gap !== n.gap || e.padding !== n.padding;
  }
  update(e) {
    let n = this.virtualizer.collection;
    this.invalidateEverything = this.shouldInvalidateEverything(e), this.invalidateEverything && (this.requestedRect = this.virtualizer.visibleRect.copy(), this.layoutNodes.clear());
    let r = e.layoutOptions;
    if (this.rowSize = r?.rowSize ?? r?.rowHeight ?? this.rowSize, this.orientation = r?.orientation ?? this.orientation, this.estimatedRowSize = r?.estimatedRowSize ?? r?.estimatedRowHeight ?? this.estimatedRowSize, this.headingSize = r?.headingSize ?? r?.headingHeight ?? this.headingSize, this.estimatedHeadingSize = r?.estimatedHeadingSize ?? r?.estimatedHeadingHeight ?? this.estimatedHeadingSize, this.loaderSize = r?.loaderSize ?? r?.loaderHeight ?? this.loaderSize, this.dropIndicatorThickness = r?.dropIndicatorThickness ?? this.dropIndicatorThickness, this.gap = r?.gap ?? this.gap, this.padding = r?.padding ?? this.padding, this.rootNodes = this.buildCollection(), this.lastCollection && n !== this.lastCollection)
      for (let l of this.lastCollection.getKeys()) n.getItem(l) || this.layoutNodes.get(l) && this.layoutNodes.delete(l);
    this.lastCollection = n, this.invalidateEverything = !1, this.validRect = this.requestedRect.copy();
  }
  buildCollection(e = this.padding) {
    let n = this.virtualizer.collection, r = this.orientation === "horizontal" ? "x" : "y", l = this.orientation === "horizontal" ? "maxX" : "maxY", i = n2(n, (c) => c.type !== "content"), a = i.filter((c) => c.type === "loader"), o = [], u = n?.size === 0;
    u && (e = 0);
    for (let c of i) {
      let s = (this.rowSize ?? this.estimatedRowSize ?? tn) + this.gap;
      if (c.type === "item" && e + s < this.requestedRect[r] && !this.isValid(c, e)) {
        e += s;
        continue;
      }
      let d = this.orientation === "horizontal" ? this.buildChild(c, e, this.padding, null) : this.buildChild(c, this.padding, e, null);
      if (e = d.layoutInfo.rect[l] + this.gap, o.push(d), c.type === "loader") {
        let f = a.indexOf(c);
        a.splice(f, 1);
      }
      if ((c.type === "item" || c.type === "loader") && e > this.requestedRect[l]) {
        let f = i.indexOf(c);
        for (let h of a) {
          let p = i.indexOf(h);
          e += (p - f - 1) * s;
          let b = this.orientation === "horizontal" ? this.buildChild(h, e, this.padding, null) : this.buildChild(h, this.padding, e, null);
          o.push(b), e = b.layoutInfo.rect[l], f = p;
        }
        e += (i.length - f - 1) * s;
        break;
      }
    }
    return e = Math.max(e - this.gap, 0), e += u ? 0 : this.padding, this.contentSize = this.orientation === "horizontal" ? new Le(e, this.virtualizer.size.height) : new Le(this.virtualizer.size.width, e), o;
  }
  isValid(e, n) {
    let r = this.layoutNodes.get(e.key), l = this.orientation === "horizontal" ? "x" : "y";
    return !this.invalidateEverything && !!r && r.node === e && n === r.layoutInfo.rect[l] && r.layoutInfo.rect.intersects(this.validRect) && r.validRect.containsRect(r.layoutInfo.rect.intersection(this.requestedRect));
  }
  buildChild(e, n, r, l) {
    if (this.isValid(e, this.orientation === "horizontal" ? n : r)) return this.layoutNodes.get(e.key);
    let i = this.buildNode(e, n, r);
    return i.layoutInfo.parentKey = l ?? null, i.layoutInfo.allowOverflow = !0, this.layoutNodes.set(e.key, i), i;
  }
  buildNode(e, n, r) {
    switch (e.type) {
      case "section":
        return this.buildSection(e, n, r);
      case "item":
        return this.buildItem(e, n, r);
      case "header":
        return this.buildSectionHeader(e, n, r);
      case "loader":
        return this.buildLoader(e, n, r);
      case "separator":
        return this.buildItem(e, n, r);
      default:
        throw new Error("Unsupported node type: " + e.type);
    }
  }
  buildLoader(e, n, r) {
    let l = new be(n, r, this.padding, 0), i = new an(e.type, e.key, l);
    return this.orientation === "horizontal" ? (l.height = this.virtualizer.contentSize.height - this.padding - r, l.width = e.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? tn : 0) : (l.width = this.virtualizer.contentSize.width - this.padding - n, l.height = e.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? tn : 0), {
      layoutInfo: i,
      validRect: l.intersection(this.requestedRect)
    };
  }
  buildSection(e, n, r) {
    let l = this.virtualizer.collection, i = this.virtualizer.size.width - this.padding - n, a = this.virtualizer.size.height - this.padding - r, o = this.orientation === "horizontal" ? new be(n, r, 0, a) : new be(n, r, i, 0), u = new an(e.type, e.key, o), c = this.orientation === "horizontal" ? n : r, s = this.orientation === "horizontal" ? "x" : "y", d = this.orientation === "horizontal" ? "maxX" : "maxY", f = this.orientation === "horizontal" ? "width" : "height", h = 0, p = [];
    for (let b of Te(e, l)) {
      if (b.type === "content") continue;
      let g = (this.rowSize ?? this.estimatedRowSize ?? tn) + this.gap;
      if (c + g < this.requestedRect[s] && !this.isValid(e, c)) {
        c += g, h++;
        continue;
      }
      let y = this.orientation === "horizontal" ? this.buildChild(b, c, r, u.key) : this.buildChild(b, n, c, u.key);
      if (c = y.layoutInfo.rect[d] + this.gap, p.push(y), c > this.requestedRect[d]) {
        c += ([
          ...Te(e, l)
        ].length - (p.length + h)) * g;
        break;
      }
    }
    return c -= this.gap, o[f] = c - (this.orientation === "horizontal" ? n : r), {
      layoutInfo: u,
      children: p,
      validRect: u.rect.intersection(this.requestedRect),
      node: e
    };
  }
  buildSectionHeader(e, n, r) {
    let l = this.orientation === "horizontal" ? "height" : "width", i = this.orientation === "horizontal" ? "width" : "height", a = this.virtualizer.size[l] - this.padding - (this.orientation === "horizontal" ? r : n), o = this.headingSize, u = !1;
    if (o == null) {
      let d = this.layoutNodes.get(e.key), f = d?.layoutInfo;
      if (f) {
        let h = this.virtualizer.collection.getItem(e.key), p = this.lastCollection ? this.lastCollection.getItem(e.key) : null;
        o = d.layoutInfo.rect[i], u = a !== f.rect[l] || h !== p || f.estimatedSize;
      } else
        o = e.rendered ? this.estimatedHeadingSize : 0, u = !0;
    }
    o == null && (o = tn);
    let c = this.orientation === "horizontal" ? new be(n, r, o, a - r) : new be(n, r, a - n, o), s = new an("header", e.key, c);
    return s.estimatedSize = u, {
      layoutInfo: s,
      children: [],
      validRect: s.rect.intersection(this.requestedRect),
      node: e
    };
  }
  buildItem(e, n, r) {
    let l = this.orientation === "horizontal" ? "height" : "width", i = this.orientation === "horizontal" ? "width" : "height", a = this.virtualizer.size[l] - this.padding - (this.orientation === "horizontal" ? r : n), o = this.rowSize, u = !1;
    if (o == null) {
      let d = this.layoutNodes.get(e.key);
      d ? (o = d.layoutInfo.rect[i], u = a !== d.layoutInfo.rect[l] || e !== d.node || d.layoutInfo.estimatedSize) : (o = this.estimatedRowSize, u = !0);
    }
    o == null && (o = tn);
    let c = this.orientation === "horizontal" ? new be(n, r, o, a) : new be(n, r, a, o), s = new an(e.type, e.key, c);
    return s.estimatedSize = u, {
      layoutInfo: s,
      children: [],
      validRect: s.rect.intersection(this.requestedRect),
      node: e
    };
  }
  updateItemSize(e, n) {
    let r = this.layoutNodes.get(e);
    if (!r) return !1;
    let l = this.virtualizer.collection, i = r.layoutInfo, a = this.orientation === "horizontal" ? "x" : "y", o = this.orientation === "horizontal" ? "width" : "height";
    if (i.estimatedSize = !1, i.rect[o] !== n[o]) {
      let u = i.copy();
      u.rect[o] = n[o], r.layoutInfo = u, this.validRect[o] = Math.min(this.validRect[o], i.rect[a] - this.validRect[a]), r.node?.type === "item" && (this.requestedRect[o] += u.rect[o] - i.rect[o]), this.updateLayoutNode(e, i, u);
      let c = i.parentKey != null ? l.getItem(i.parentKey) : null;
      for (; c; )
        this.updateLayoutNode(c.key, i, u), c = c.parentKey != null ? l.getItem(c.parentKey) : null;
      return !0;
    }
    return !1;
  }
  updateLayoutNode(e, n, r) {
    let l = this.layoutNodes.get(e);
    l && (l.validRect = l.validRect.intersection(this.validRect), l.layoutInfo === n && (l.layoutInfo = r));
  }
  getContentSize() {
    return this.contentSize;
  }
  getDropTargetFromPoint(e, n, r) {
    e += this.virtualizer.visibleRect.x, n += this.virtualizer.visibleRect.y;
    let l = new be(e, Math.max(0, n - this.gap), 1, Math.max(1, this.gap * 2)), i = this.getVisibleLayoutInfos(l), a = null, o = 1 / 0;
    for (let d of i) {
      if (!d.rect.intersects(l)) continue;
      let f = Math.abs(d.rect.y - n), h = Math.abs(d.rect.maxY - n), p = Math.min(f, h);
      p < o && (o = p, a = d.key);
    }
    if (a == null || this.virtualizer.collection.size === 0) return {
      type: "root"
    };
    let u = this.getLayoutInfo(a);
    if (!u) return null;
    let c = u.rect, s = {
      type: "item",
      key: u.key,
      dropPosition: "on"
    };
    return r(s) ? n <= c.y + 10 && r({
      ...s,
      dropPosition: "before"
    }) ? s.dropPosition = "before" : n >= c.maxY - 10 && r({
      ...s,
      dropPosition: "after"
    }) && (s.dropPosition = "after") : n <= c.y + c.height / 2 && r({
      ...s,
      dropPosition: "before"
    }) ? s.dropPosition = "before" : r({
      ...s,
      dropPosition: "after"
    }) && (s.dropPosition = "after"), s;
  }
  getDropTargetLayoutInfo(e) {
    let n = this.getLayoutInfo(e.key), r;
    if (e.dropPosition === "before") r = this.orientation === "horizontal" ? new be(Math.max(0, n.rect.x - this.dropIndicatorThickness / 2), n.rect.y, this.dropIndicatorThickness, n.rect.height) : new be(n.rect.x, Math.max(0, n.rect.y - this.dropIndicatorThickness / 2), n.rect.width, this.dropIndicatorThickness);
    else if (e.dropPosition === "after") {
      let l = this.collection.getItem(e.key);
      if (l) {
        let i = l.level ?? 0, a = this.collection.getKeyAfter(e.key);
        for (; a != null; ) {
          let o = this.collection.getItem(a);
          if (!o || o.level <= i) break;
          n = this.getLayoutInfo(a) || n, a = this.collection.getKeyAfter(a);
        }
      }
      r = this.orientation === "horizontal" ? new be(n.rect.maxX - this.dropIndicatorThickness / 2, n.rect.y, this.dropIndicatorThickness, n.rect.height) : new be(n.rect.x, n.rect.maxY - this.dropIndicatorThickness / 2, n.rect.width, this.dropIndicatorThickness);
    } else r = n.rect;
    return new an("dropIndicator", e.key + ":" + e.dropPosition, r);
  }
}
function n2(t, e) {
  const n = [];
  for (const r of t) e(r) && n.push(r);
  return n;
}
const y3 = /* @__PURE__ */ new WeakMap();
function cl(t, e, n) {
  if (!t)
    return "";
  typeof e == "string" && (e = e.replace(/\s+/g, ""));
  let r = y3.get(t);
  return process.env.NODE_ENV !== "production" && !r && console.error("There is no tab id, please check if you have rendered the tab panel before the tab list."), `${r}-${n}-${e}`;
}
function r2(t, e, n) {
  let { key: r, isDisabled: l, shouldSelectOnPressUp: i } = t, { selectionManager: a, selectedKey: o } = e, u = r === o, c = l || e.isDisabled || e.selectionManager.isDisabled(r), s = e.collection.getItem(r), { itemProps: d, isPressed: f } = Un({
    selectionManager: a,
    key: r,
    ref: n,
    isDisabled: c,
    // Link tabs should behave like native anchors (navigate on press up)
    // This avoids reopening beforeunload dialogs when browsers replay
    // queued pointer enter/leave events after cancellation.
    shouldSelectOnPressUp: i ?? s?.props.href != null,
    linkBehavior: "selection"
  }), h = cl(e, r, "tab"), p = cl(e, r, "tabpanel"), { tabIndex: b } = d, g = Y(s?.props, {
    labelable: !0
  });
  delete g.id;
  let y = fl(s?.props), { focusableProps: $ } = Je({
    ...s?.props,
    isDisabled: c
  }, n);
  return {
    tabProps: L(g, $, y, d, {
      id: h,
      "aria-selected": u,
      "aria-disabled": c || void 0,
      "aria-controls": u ? p : void 0,
      tabIndex: c ? void 0 : b,
      role: "tab"
    }),
    isSelected: u,
    isDisabled: c,
    isPressed: f
  };
}
function l2(t, e, n) {
  let r = ga(n) ? void 0 : 0;
  const l = cl(e, t.id ?? e?.selectedKey, "tabpanel"), i = kt({
    ...t,
    id: l,
    "aria-labelledby": cl(e, e?.selectedKey, "tab")
  });
  return {
    tabPanelProps: L(i, {
      tabIndex: r,
      role: "tabpanel",
      "aria-describedby": t["aria-describedby"],
      "aria-details": t["aria-details"]
    })
  };
}
class i2 {
  constructor(e, n, r, l = /* @__PURE__ */ new Set()) {
    this.collection = e, this.flipDirection = n === "rtl" && r === "horizontal", this.disabledKeys = l, this.tabDirection = r === "horizontal";
  }
  getKeyLeftOf(e) {
    return this.flipDirection ? this.getNextKey(e) : this.getPreviousKey(e);
  }
  getKeyRightOf(e) {
    return this.flipDirection ? this.getPreviousKey(e) : this.getNextKey(e);
  }
  isDisabled(e) {
    return this.disabledKeys.has(e) || !!this.collection.getItem(e)?.props?.isDisabled;
  }
  getFirstKey() {
    let e = this.collection.getFirstKey();
    return e != null && this.isDisabled(e) && (e = this.getNextKey(e)), e;
  }
  getLastKey() {
    let e = this.collection.getLastKey();
    return e != null && this.isDisabled(e) && (e = this.getPreviousKey(e)), e;
  }
  getKeyAbove(e) {
    return this.tabDirection ? null : this.getPreviousKey(e);
  }
  getKeyBelow(e) {
    return this.tabDirection ? null : this.getNextKey(e);
  }
  getNextKey(e) {
    let n = e;
    do
      n = this.collection.getKeyAfter(n), n == null && (n = this.collection.getFirstKey());
    while (n != null && this.isDisabled(n) && n !== e);
    return n;
  }
  getPreviousKey(e) {
    let n = e;
    do
      n = this.collection.getKeyBefore(n), n == null && (n = this.collection.getLastKey());
    while (n != null && this.isDisabled(n) && n !== e);
    return n;
  }
}
function a2(t, e, n) {
  let { orientation: r = "horizontal", keyboardActivation: l = "automatic" } = t, { collection: i, selectionManager: a, disabledKeys: o } = e, { direction: u } = pe(), c = _(() => new i2(i, u, r, o), [
    i,
    o,
    r,
    u
  ]), { collectionProps: s } = sa({
    ref: n,
    selectionManager: a,
    keyboardDelegate: c,
    selectOnFocus: l === "automatic",
    disallowEmptySelection: !0,
    scrollRef: n,
    linkBehavior: "selection"
  }), d = ce();
  y3.set(e, d);
  let f = kt({
    ...t,
    id: d
  });
  return {
    tabListProps: {
      ...L(s, f),
      role: "tablist",
      "aria-orientation": r,
      tabIndex: void 0
    }
  };
}
function o2(t) {
  let [e, n] = Be(t.selectedKey, t.defaultSelectedKey ?? null, t.onSelectionChange), r = _(() => e != null ? [
    e
  ] : [], [
    e
  ]), { collection: l, disabledKeys: i, selectionManager: a } = xl({
    ...t,
    selectionMode: "single",
    disallowEmptySelection: !0,
    allowDuplicateSelectionEvents: !0,
    selectedKeys: r,
    onSelectionChange: (u) => {
      if (u === "all") return;
      let c = u.values().next().value ?? null;
      c === e && t.onSelectionChange && t.onSelectionChange(c), n(c);
    }
  }), o = e != null ? l.getItem(e) : null;
  return {
    collection: l,
    disabledKeys: i,
    selectionManager: a,
    selectedKey: e,
    setSelectedKey: n,
    selectedItem: o
  };
}
function u2(t) {
  let e = o2({
    ...t,
    onSelectionChange: t.onSelectionChange ? (a) => {
      a != null && t.onSelectionChange?.(a);
    } : void 0,
    suppressTextValueWarning: !0,
    defaultSelectedKey: t.defaultSelectedKey ?? mu(t.collection, t.disabledKeys ? new Set(t.disabledKeys) : /* @__PURE__ */ new Set()) ?? void 0
  }), { selectionManager: n, collection: r, selectedKey: l } = e, i = B(l);
  return Q(() => {
    let a = l;
    t.selectedKey == null && (n.isEmpty || a == null || !r.getItem(a)) && (a = mu(r, e.disabledKeys), a != null && n.setSelectedKeys([
      a
    ])), (a != null && n.focusedKey == null || !n.isFocused && a !== i.current) && n.setFocusedKey(a), i.current = a;
  }), {
    ...e,
    isDisabled: t.isDisabled || !1
  };
}
function mu(t, e) {
  let n = null;
  if (t) {
    for (n = t.getFirstKey(); n != null && (e.has(n) || t.getItem(n)?.props?.isDisabled) && n !== t.getLastKey(); ) n = t.getKeyAfter(n);
    n != null && (e.has(n) || t.getItem(n)?.props?.isDisabled) && n === t.getLastKey() && (n = t.getFirstKey());
  }
  return n;
}
const wl = /* @__PURE__ */ j(null), Ut = /* @__PURE__ */ j(null), ox = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, wl);
  let { children: r, orientation: l = "horizontal" } = e;
  return r = _(() => typeof r == "function" ? r({
    orientation: l,
    defaultChildren: null
  }) : r, [
    r,
    l
  ]), /* @__PURE__ */ m.createElement(hn, {
    content: r
  }, (i) => /* @__PURE__ */ m.createElement(s2, {
    props: e,
    collection: i,
    tabsRef: n
  }));
});
function s2({ props: t, tabsRef: e, collection: n }) {
  let { orientation: r = "horizontal" } = t, l = u2({
    ...t,
    collection: n,
    children: void 0
  }), { focusProps: i, isFocused: a, isFocusVisible: o } = $e({
    within: !0
  }), u = _(() => ({
    orientation: r,
    isFocusWithin: a,
    isFocusVisible: o
  }), [
    r,
    a,
    o
  ]), c = re({
    ...t,
    defaultClassName: "react-aria-Tabs",
    values: u
  }), s = Y(t, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(s, c, i),
    ref: e,
    slot: t.slot || void 0,
    "data-focused": a || void 0,
    "data-orientation": r,
    "data-focus-visible": o || void 0,
    "data-disabled": l.isDisabled || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        wl,
        t
      ],
      [
        Ut,
        l
      ]
    ]
  }, c.children));
}
const ux = /* @__PURE__ */ te(function(e, n) {
  return z(Ut) ? /* @__PURE__ */ m.createElement(c2, {
    props: e,
    forwardedRef: n
  }) : /* @__PURE__ */ m.createElement(At, e);
});
function c2({ props: t, forwardedRef: e }) {
  let n = z(Ut), { CollectionRoot: r } = z(me), { orientation: l = "horizontal", keyboardActivation: i = "automatic" } = We(wl), a = ge(e), { tabListProps: o } = a2({
    ...t,
    orientation: l,
    keyboardActivation: i
  }, n, a), u = re({
    ...t,
    children: null,
    defaultClassName: "react-aria-TabList",
    values: {
      orientation: l,
      state: n
    }
  }), c = Y(t, {
    global: !0
  });
  return delete c.id, /* @__PURE__ */ m.createElement(X.div, {
    ...L(c, u, o),
    ref: a,
    "data-orientation": l || void 0
  }, /* @__PURE__ */ m.createElement(bn, null, /* @__PURE__ */ m.createElement(r, {
    collection: n.collection,
    persistedKeys: Gi(n.selectionManager.focusedKey)
  })));
}
const Ha = class Ha extends Ze {
};
Ha.type = "item";
let Ki = Ha;
const sx = /* @__PURE__ */ ot(Ki, (t, e, n) => {
  let r = z(Ut), l = ge(e), { tabProps: i, isSelected: a, isDisabled: o, isPressed: u } = r2({
    key: n.key,
    ...t
  }, r, l), { focusProps: c, isFocused: s, isFocusVisible: d } = $e(), { hoverProps: f, isHovered: h } = ve({
    isDisabled: o,
    onHoverStart: t.onHoverStart,
    onHoverEnd: t.onHoverEnd,
    onHoverChange: t.onHoverChange
  }), p = re({
    ...t,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Tab",
    values: {
      isSelected: a,
      isDisabled: o,
      isFocused: s,
      isFocusVisible: d,
      isPressed: u,
      isHovered: h
    }
  }), b = n.props.href ? X.a : X.div, g = Y(t, {
    global: !0
  });
  return delete g.id, delete g.onClick, /* @__PURE__ */ m.createElement(b, {
    ...L(g, p, i, c, f),
    ref: l,
    "data-selected": a || void 0,
    "data-disabled": o || void 0,
    "data-focused": s || void 0,
    "data-focus-visible": d || void 0,
    "data-pressed": u || void 0,
    "data-hovered": h || void 0
  }, /* @__PURE__ */ m.createElement(mn.Provider, {
    value: {
      isSelected: a
    }
  }, p.children));
}), cx = /* @__PURE__ */ Gt(function(e, n) {
  let r = z(Ut), l = ge(n), i = B(r.selectedKey), a = B(null), o = B(null);
  le(() => {
    let c = l.current;
    if (c) {
      if (o.current == null && (o.current = /width|height|block-size|inline-size|all/.test(window.getComputedStyle(c).transition)), o.current && i.current != null && i.current !== r.selectedKey) {
        c.style.setProperty("--tab-panel-width", "auto"), c.style.setProperty("--tab-panel-height", "auto");
        let { width: s, height: d } = c.getBoundingClientRect();
        a.current && (a.current.width !== s || a.current.height !== d) && (c.style.setProperty("--tab-panel-width", a.current.width + "px"), c.style.setProperty("--tab-panel-height", a.current.height + "px"), window.getComputedStyle(c).height, c.style.setProperty("--tab-panel-width", s + "px"), c.style.setProperty("--tab-panel-height", d + "px"), Promise.all(c.getAnimations().map((f) => f.finished)).then(() => {
          c.style.setProperty("--tab-panel-width", "auto"), c.style.setProperty("--tab-panel-height", "auto");
        }).catch(() => {
        }));
      }
      i.current = r.selectedKey;
    }
  }, [
    l,
    r.selectedKey
  ]), r.selectedKey != null && // eslint-disable-next-line rsp-rules/pure-render
  r.selectedKey !== i.current && l.current && // eslint-disable-next-line rsp-rules/pure-render
  o.current && (a.current = l.current.getBoundingClientRect());
  let u = Y(e, {
    labelable: !0,
    global: !0
  });
  return delete u.id, /* @__PURE__ */ m.createElement(X.div, {
    render: e.render,
    ...u,
    ref: l,
    style: e.style,
    className: e.className || "react-aria-TabPanels"
  }, /* @__PURE__ */ m.createElement(At, e));
}), dx = /* @__PURE__ */ Gt(function(e, n) {
  const r = z(Ut);
  let l = ge(n), i = r.selectedKey === e.id, [a, o] = q(r.selectedKey != null ? i : null);
  a == null && r.selectedKey != null ? o(i) : !i && a && o(!1);
  let u = yr(l, i);
  return !i && !e.shouldForceMount && !u ? null : /* @__PURE__ */ m.createElement(d2, {
    ...e,
    tabPanelRef: l,
    isInitiallySelected: a || !1,
    isExiting: u
  });
});
function d2(t) {
  let e = z(Ut), { id: n, tabPanelRef: r, isInitiallySelected: l, isExiting: i, ...a } = t, { tabPanelProps: o } = l2(t, e, r), { focusProps: u, isFocused: c, isFocusVisible: s } = $e(), d = e.selectedKey === t.id, f = Br(r) && !l, h = re({
    ...t,
    defaultClassName: "react-aria-TabPanel",
    values: {
      isFocused: c,
      isFocusVisible: s,
      // @ts-ignore - compatibility with React < 19
      isInert: il(!d),
      isEntering: f,
      isExiting: i,
      state: e
    }
  }), p = Y(a, {
    global: !0
  });
  delete p.id;
  let b = d ? L(p, o, u, h) : L(p, h);
  return /* @__PURE__ */ m.createElement(X.div, {
    ...b,
    ref: r,
    "data-focused": c || void 0,
    "data-focus-visible": s || void 0,
    // @ts-ignore
    inert: il(!d || t.inert),
    "data-inert": d ? void 0 : "true",
    "data-entering": f || void 0,
    "data-exiting": i || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        wl,
        null
      ],
      [
        Ut,
        null
      ]
    ]
  }, /* @__PURE__ */ m.createElement(me.Provider, {
    value: Er
  }, h.children)));
}
const $3 = /* @__PURE__ */ new WeakMap();
function f2(t, e, n) {
  let { direction: r } = pe(), l = t.keyboardDelegate || new Pr({
    collection: e.collection,
    ref: n,
    orientation: "horizontal",
    direction: r,
    disabledKeys: e.disabledKeys,
    disabledBehavior: e.selectionManager.disabledBehavior
  }), { labelProps: i, fieldProps: a, descriptionProps: o, errorMessageProps: u } = gl({
    ...t,
    labelElementType: "span"
  }), { gridProps: c } = g1({
    ...t,
    ...a,
    keyboardDelegate: l,
    shouldFocusWrap: !0,
    linkBehavior: "override",
    keyboardNavigationBehavior: "tab"
  }, e, n), [s, d] = q(!1), { focusWithinProps: f } = Et({
    onFocusWithinChange: d
  }), h = Y(t), p = B(e.collection.size);
  return Q(() => {
    n.current && p.current > 0 && e.collection.size === 0 && s && n.current.focus(), p.current = e.collection.size;
  }, [
    e.collection.size,
    s,
    n
  ]), $3.set(e, {
    onRemove: t.onRemove
  }), {
    gridProps: L(c, h, {
      role: e.collection.size ? "grid" : "group",
      "aria-atomic": !1,
      "aria-relevant": "additions",
      "aria-live": s ? "polite" : "off",
      ...f,
      ...a
    }),
    labelProps: i,
    descriptionProps: o,
    errorMessageProps: u
  };
}
var v3 = {};
v3 = {
  removeButtonLabel: "إزالة",
  removeDescription: "اضغط على مفتاح DELETE لإزالة علامة."
};
var x3 = {};
x3 = {
  removeButtonLabel: "Премахване",
  removeDescription: "Натиснете Delete, за да премахнете маркера."
};
var E3 = {};
E3 = {
  removeButtonLabel: "Odebrat",
  removeDescription: "Stisknutím klávesy Delete odeberete značku."
};
var C3 = {};
C3 = {
  removeButtonLabel: "Fjern",
  removeDescription: "Tryk på Slet for at fjerne tag."
};
var D3 = {};
D3 = {
  removeButtonLabel: "Entfernen",
  removeDescription: "Auf „Löschen“ drücken, um das Tag zu entfernen."
};
var w3 = {};
w3 = {
  removeButtonLabel: "Κατάργηση",
  removeDescription: "Πατήστε Διαγραφή για να καταργήσετε την ετικέτα."
};
var P3 = {};
P3 = {
  removeDescription: "Press Delete to remove tag.",
  removeButtonLabel: "Remove"
};
var S3 = {};
S3 = {
  removeButtonLabel: "Quitar",
  removeDescription: "Pulse Eliminar para quitar la etiqueta."
};
var k3 = {};
k3 = {
  removeButtonLabel: "Eemalda",
  removeDescription: "Sildi eemaldamiseks vajutage kustutusklahvi Delete."
};
var B3 = {};
B3 = {
  removeButtonLabel: "Poista",
  removeDescription: "Poista tunniste painamalla Poista-painiketta."
};
var F3 = {};
F3 = {
  removeButtonLabel: "Supprimer",
  removeDescription: "Appuyez sur Supprimer pour supprimer l’étiquette."
};
var T3 = {};
T3 = {
  removeButtonLabel: "הסר",
  removeDescription: "לחץ על מחק כדי להסיר תג."
};
var A3 = {};
A3 = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Delete za uklanjanje oznake."
};
var I3 = {};
I3 = {
  removeButtonLabel: "Eltávolítás",
  removeDescription: "Nyomja meg a Delete billentyűt a címke eltávolításához."
};
var K3 = {};
K3 = {
  removeButtonLabel: "Rimuovi",
  removeDescription: "Premi Elimina per rimuovere il tag."
};
var R3 = {};
R3 = {
  removeButtonLabel: "削除",
  removeDescription: "タグを削除するには、Delete キーを押します。"
};
var N3 = {};
N3 = {
  removeButtonLabel: "제거",
  removeDescription: "태그를 제거하려면 Delete 키를 누르십시오."
};
var M3 = {};
M3 = {
  removeButtonLabel: "Pašalinti",
  removeDescription: "Norėdami pašalinti žymą, paspauskite „Delete“ klavišą."
};
var L3 = {};
L3 = {
  removeButtonLabel: "Noņemt",
  removeDescription: "Nospiediet Delete [Dzēst], lai noņemtu tagu."
};
var z3 = {};
z3 = {
  removeButtonLabel: "Fjern",
  removeDescription: "Trykk på Slett for å fjerne taggen."
};
var V3 = {};
V3 = {
  removeButtonLabel: "Verwijderen",
  removeDescription: "Druk op Verwijderen om de tag te verwijderen."
};
var O3 = {};
O3 = {
  removeButtonLabel: "Usuń",
  removeDescription: "Naciśnij Usuń, aby usunąć znacznik."
};
var H3 = {};
H3 = {
  removeButtonLabel: "Remover",
  removeDescription: "Pressione Delete para remover a tag."
};
var _3 = {};
_3 = {
  removeButtonLabel: "Eliminar",
  removeDescription: "Prima Delete para eliminar a tag."
};
var W3 = {};
W3 = {
  removeButtonLabel: "Îndepărtaţi",
  removeDescription: "Apăsați pe Delete (Ștergere) pentru a elimina eticheta."
};
var j3 = {};
j3 = {
  removeButtonLabel: "Удалить",
  removeDescription: "Нажмите DELETE, чтобы удалить тег."
};
var U3 = {};
U3 = {
  removeButtonLabel: "Odstrániť",
  removeDescription: "Ak chcete odstrániť značku, stlačte kláves Delete."
};
var G3 = {};
G3 = {
  removeButtonLabel: "Odstrani",
  removeDescription: "Pritisnite Delete, da odstranite oznako."
};
var q3 = {};
q3 = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Obriši da biste uklonili oznaku."
};
var Y3 = {};
Y3 = {
  removeButtonLabel: "Ta bort",
  removeDescription: "Tryck på Radera för att ta bort taggen."
};
var X3 = {};
X3 = {
  removeButtonLabel: "Kaldır",
  removeDescription: "Etiketi kaldırmak için Sil tuşuna basın."
};
var Z3 = {};
Z3 = {
  removeButtonLabel: "Вилучити",
  removeDescription: "Натисніть Delete, щоб вилучити тег."
};
var J3 = {};
J3 = {
  removeButtonLabel: "删除",
  removeDescription: "按下“删除”以删除标记。"
};
var Q3 = {};
Q3 = {
  removeButtonLabel: "移除",
  removeDescription: "按 Delete 鍵以移除標記。"
};
var eg = {};
eg = {
  "ar-AE": v3,
  "bg-BG": x3,
  "cs-CZ": E3,
  "da-DK": C3,
  "de-DE": D3,
  "el-GR": w3,
  "en-US": P3,
  "es-ES": S3,
  "et-EE": k3,
  "fi-FI": B3,
  "fr-FR": F3,
  "he-IL": T3,
  "hr-HR": A3,
  "hu-HU": I3,
  "it-IT": K3,
  "ja-JP": R3,
  "ko-KR": N3,
  "lt-LT": M3,
  "lv-LV": L3,
  "nb-NO": z3,
  "nl-NL": V3,
  "pl-PL": O3,
  "pt-BR": H3,
  "pt-PT": _3,
  "ro-RO": W3,
  "ru-RU": j3,
  "sk-SK": U3,
  "sl-SI": G3,
  "sr-SP": q3,
  "sv-SE": Y3,
  "tr-TR": X3,
  "uk-UA": Z3,
  "zh-CN": J3,
  "zh-TW": Q3
};
function h2(t) {
  return t && t.__esModule ? t.default : t;
}
function p2(t, e, n) {
  let { item: r } = t, l = ke(h2(eg), "@react-aria/tag"), i = ce(), { onRemove: a } = $3.get(e) || {}, { rowProps: o, gridCellProps: u, ...c } = y1({
    node: r
  }, e, n), { descriptionProps: s, ...d } = c, f = e.disabledKeys.has(r.key) || r.props.isDisabled, h = (C) => {
    if (C.key === "Delete" || C.key === "Backspace") {
      if (f) return;
      C.preventDefault(), e.selectionManager.isSelected(r.key) ? a?.(new Set(e.selectionManager.selectedKeys)) : a?.(/* @__PURE__ */ new Set([
        r.key
      ]));
    }
  }, p = pl();
  p === "virtual" && typeof window < "u" && "ontouchstart" in window && (p = "pointer");
  let b = a && (p === "keyboard" || p === "virtual") ? l.format("removeDescription") : "", g = _n(b), y = r.key === e.selectionManager.focusedKey, $ = e.selectionManager.focusedKey != null, v = -1;
  !f && (y || !$) && (v = 0);
  let E = Y(r.props), S = _i(r.props), { focusableProps: w } = Je({
    ...r.props,
    isDisabled: f
  }, n);
  return {
    removeButtonProps: {
      "aria-label": l.format("removeButtonLabel"),
      "aria-labelledby": `${i} ${o.id}`,
      isDisabled: f,
      id: i,
      onPress: () => a ? a(/* @__PURE__ */ new Set([
        r.key
      ])) : null
    },
    rowProps: L(w, o, E, S, {
      tabIndex: v,
      onKeyDown: a ? h : void 0,
      "aria-describedby": g["aria-describedby"]
    }),
    gridCellProps: L(u, {
      "aria-errormessage": t["aria-errormessage"],
      "aria-label": t["aria-label"]
    }),
    ...d,
    allowsRemoving: !!a
  };
}
const b2 = /* @__PURE__ */ j(null), tg = /* @__PURE__ */ j(null), fx = /* @__PURE__ */ te(function(e, n) {
  return [e, n] = ie(e, n, b2), /* @__PURE__ */ m.createElement(ct.Provider, {
    value: null
  }, /* @__PURE__ */ m.createElement(hn, {
    content: e.children
  }, (r) => /* @__PURE__ */ m.createElement(m2, {
    props: e,
    forwardedRef: n,
    collection: r
  })));
});
function m2({ props: t, forwardedRef: e, collection: n }) {
  let r = B(null), { id: l, ...i } = t;
  [i, r] = ie(i, r, dn);
  let { filter: a, shouldUseVirtualFocus: o, ...u } = i, [c, s] = Xe(!t["aria-label"] && !t["aria-labelledby"]), d = xl({
    ...u,
    children: void 0,
    collection: n
  }), f = bp(d, a), h = Y(i, {
    global: !0
  }), p = Object.fromEntries(Object.entries(h).map(([v, E]) => [
    v,
    v === "id" ? E : void 0
  ])), { gridProps: b, labelProps: g, descriptionProps: y, errorMessageProps: $ } = f2({
    ...u,
    ...p,
    label: s
  }, f, r);
  return /* @__PURE__ */ m.createElement(X.div, {
    render: t.render,
    ...h,
    id: l,
    ref: e,
    slot: t.slot || void 0,
    className: t.className ?? "react-aria-TagGroup",
    style: t.style
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        ut,
        {
          ...g,
          elementType: "span",
          ref: c
        }
      ],
      [
        tg,
        {
          ...b,
          ref: r
        }
      ],
      [
        ct,
        f
      ],
      [
        Qe,
        {
          slots: {
            description: y,
            errorMessage: $
          }
        }
      ]
    ]
  }, t.children));
}
const hx = /* @__PURE__ */ te(function(e, n) {
  return z(ct) ? /* @__PURE__ */ m.createElement(g2, {
    props: e,
    forwardedRef: n
  }) : /* @__PURE__ */ m.createElement(At, e);
});
function g2({ props: t, forwardedRef: e }) {
  let n = z(ct), { CollectionRoot: r } = z(me), [l, i] = ie({}, e, tg), { focusProps: a, isFocused: o, isFocusVisible: u } = $e(), c = {
    isEmpty: n.collection.size === 0,
    isFocused: o,
    isFocusVisible: u,
    state: n
  }, s = re({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-TagList",
    values: c
  }), d = Gi(n.selectionManager.focusedKey), f = Y(t, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(f, s, l, a),
    ref: i,
    "data-empty": n.collection.size === 0 || void 0,
    "data-focused": o || void 0,
    "data-focus-visible": u || void 0
  }, /* @__PURE__ */ m.createElement(bn, null, n.collection.size === 0 && t.renderEmptyState ? t.renderEmptyState(c) : /* @__PURE__ */ m.createElement(r, {
    collection: n.collection,
    persistedKeys: d
  })));
}
const px = /* @__PURE__ */ ot(cr, (t, e, n) => {
  let r = z(ct), l = ge(e), { focusProps: i, isFocusVisible: a } = $e({
    within: !1
  }), { rowProps: o, gridCellProps: u, removeButtonProps: c, ...s } = p2({
    item: n
  }, r, l), { hoverProps: d, isHovered: f } = ve({
    isDisabled: !s.allowsSelection && !s.hasAction,
    onHoverStart: n.props.onHoverStart,
    onHoverChange: n.props.onHoverChange,
    onHoverEnd: n.props.onHoverEnd
  }), h = re({
    ...t,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Tag",
    values: {
      ...s,
      isFocusVisible: a,
      isHovered: f,
      selectionMode: r.selectionManager.selectionMode,
      selectionBehavior: r.selectionManager.selectionBehavior
    }
  });
  Q(() => {
    !n.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <Tag> elements with non-plain text children for accessibility.");
  }, [
    n.textValue
  ]);
  let p = Y(t, {
    global: !0
  });
  return delete p.id, delete p.onClick, /* @__PURE__ */ m.createElement(X.div, {
    ref: l,
    ...L(p, h, o, i, d),
    "data-selected": s.isSelected || void 0,
    "data-disabled": s.isDisabled || void 0,
    "data-hovered": f || void 0,
    "data-focused": s.isFocused || void 0,
    "data-focus-visible": a || void 0,
    "data-pressed": s.isPressed || void 0,
    "data-allows-removing": s.allowsRemoving || void 0,
    "data-selection-mode": r.selectionManager.selectionMode === "none" ? void 0 : r.selectionManager.selectionMode
  }, /* @__PURE__ */ m.createElement("div", {
    ...u,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        st,
        {
          slots: {
            remove: c
          }
        }
      ],
      [
        me,
        Er
      ],
      [
        mn,
        {
          isSelected: s.isSelected
        }
      ]
    ]
  }, h.children)));
}), ng = /* @__PURE__ */ j({});
let y2 = (t) => {
  let { onHoverStart: e, onHoverChange: n, onHoverEnd: r, ...l } = t;
  return l;
};
const bx = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, ng);
  let { hoverProps: r, isHovered: l } = ve(e), { isFocused: i, isFocusVisible: a, focusProps: o } = $e({
    isTextInput: !0,
    autoFocus: e.autoFocus
  }), u = !!e["aria-invalid"] && e["aria-invalid"] !== "false", c = re({
    ...e,
    values: {
      isHovered: l,
      isFocused: i,
      isFocusVisible: a,
      isDisabled: e.disabled || !1,
      isInvalid: u
    },
    defaultClassName: "react-aria-TextArea"
  });
  return /* @__PURE__ */ m.createElement(X.textarea, {
    ...L(y2(e), o, r),
    ...c,
    ref: n,
    "data-focused": i || void 0,
    "data-disabled": e.disabled || void 0,
    "data-hovered": l || void 0,
    "data-focus-visible": a || void 0,
    "data-invalid": u || void 0
  });
}), $2 = /* @__PURE__ */ j(null), mx = /* @__PURE__ */ Gt(function(e, n) {
  [e, n] = ie(e, n, $2);
  let { validationBehavior: r } = We(Wn) || {}, l = e.validationBehavior ?? r ?? "native", i = B(null);
  [e, i] = ie(e, i, vr);
  let [a, o] = Xe(!e["aria-label"] && !e["aria-labelledby"]), [u, c] = q("input"), { labelProps: s, inputProps: d, descriptionProps: f, errorMessageProps: h, ...p } = Qi({
    ...xt(e),
    inputElementType: u,
    label: o,
    validationBehavior: l
  }, i), b = G(($) => {
    i.current = $, $ && c($ instanceof HTMLTextAreaElement ? "textarea" : "input");
  }, [
    i
  ]), g = re({
    ...e,
    values: {
      isDisabled: e.isDisabled || !1,
      isInvalid: p.isInvalid,
      isReadOnly: e.isReadOnly || !1,
      isRequired: e.isRequired || !1
    },
    defaultClassName: "react-aria-TextField"
  }), y = Y(e, {
    global: !0
  });
  return delete y.id, /* @__PURE__ */ m.createElement(X.div, {
    ...y,
    ...g,
    ref: n,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": p.isInvalid || void 0,
    "data-readonly": e.isReadOnly || void 0,
    "data-required": e.isRequired || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        ut,
        {
          ...s,
          ref: a
        }
      ],
      [
        wr,
        {
          ...d,
          ref: b
        }
      ],
      [
        ng,
        {
          ...d,
          ref: b
        }
      ],
      [
        Dr,
        {
          role: "presentation",
          isInvalid: p.isInvalid,
          isDisabled: e.isDisabled || !1
        }
      ],
      [
        Qe,
        {
          slots: {
            description: f,
            errorMessage: h
          }
        }
      ],
      [
        Yt,
        p
      ]
    ]
  }, g.children));
});
var rg = {};
rg = {
  close: "إغلاق",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} إشعار`,
    other: () => `${e.number(t.count)} إشعارات`
  })}.`
};
var lg = {};
lg = {
  close: "Затвори",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} известие`,
    other: () => `${e.number(t.count)} известия`
  })}.`
};
var ig = {};
ig = {
  close: "Zavřít",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} oznámení`,
    other: () => `${e.number(t.count)} oznámení`
  })}.`
};
var ag = {};
ag = {
  close: "Luk",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} besked`,
    other: () => `${e.number(t.count)} beskeder`
  })}.`
};
var og = {};
og = {
  close: "Schließen",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} Benachrichtigung`,
    other: () => `${e.number(t.count)} Benachrichtigungen`
  })}.`
};
var ug = {};
ug = {
  close: "Κλείσιμο",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} ειδοποίηση`,
    other: () => `${e.number(t.count)} ειδοποιήσεις`
  })}.`
};
var sg = {};
sg = {
  close: "Close",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} notification`,
    other: () => `${e.number(t.count)} notifications`
  })}.`
};
var cg = {};
cg = {
  close: "Cerrar",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} notificación`,
    other: () => `${e.number(t.count)} notificaciones`
  })}.`
};
var dg = {};
dg = {
  close: "Sule",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} teatis`,
    other: () => `${e.number(t.count)} teatist`
  })}.`
};
var fg = {};
fg = {
  close: "Sulje",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} ilmoitus`,
    other: () => `${e.number(t.count)} ilmoitusta`
  })}.`
};
var hg = {};
hg = {
  close: "Fermer",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} notification`,
    other: () => `${e.number(t.count)} notifications`
  })}.`
};
var pg = {};
pg = {
  close: "סגור",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} התראה`,
    other: () => `${e.number(t.count)} התראות`
  })}.`
};
var bg = {};
bg = {
  close: "Zatvori",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} obavijest`,
    other: () => `${e.number(t.count)} obavijesti`
  })}.`
};
var mg = {};
mg = {
  close: "Bezárás",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} értesítés`,
    other: () => `${e.number(t.count)} értesítés`
  })}.`
};
var gg = {};
gg = {
  close: "Chiudi",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} notifica`,
    other: () => `${e.number(t.count)} notifiche`
  })}.`
};
var yg = {};
yg = {
  close: "閉じる",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} 個の通知`,
    other: () => `${e.number(t.count)} 個の通知`
  })}。`
};
var $g = {};
$g = {
  close: "닫기",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)}개 알림`,
    other: () => `${e.number(t.count)}개 알림`
  })}.`
};
var vg = {};
vg = {
  close: "Uždaryti",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} pranešimas`,
    other: () => `${e.number(t.count)} pranešimai`
  })}.`
};
var xg = {};
xg = {
  close: "Aizvērt",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} paziņojums`,
    other: () => `${e.number(t.count)} paziņojumi`
  })}.`
};
var Eg = {};
Eg = {
  close: "Lukk",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} varsling`,
    other: () => `${e.number(t.count)} varsler`
  })}.`
};
var Cg = {};
Cg = {
  close: "Sluiten",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} melding`,
    other: () => `${e.number(t.count)} meldingen`
  })}.`
};
var Dg = {};
Dg = {
  close: "Zamknij",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} powiadomienie`,
    few: () => `${e.number(t.count)} powiadomienia`,
    many: () => `${e.number(t.count)} powiadomień`,
    other: () => `${e.number(t.count)} powiadomienia`
  })}.`
};
var wg = {};
wg = {
  close: "Fechar",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} notificação`,
    other: () => `${e.number(t.count)} notificações`
  })}.`
};
var Pg = {};
Pg = {
  close: "Fechar",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} notificação`,
    other: () => `${e.number(t.count)} notificações`
  })}.`
};
var Sg = {};
Sg = {
  close: "Închideţi",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} notificare`,
    other: () => `${e.number(t.count)} notificări`
  })}.`
};
var kg = {};
kg = {
  close: "Закрыть",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} уведомление`,
    other: () => `${e.number(t.count)} уведомления`
  })}.`
};
var Bg = {};
Bg = {
  close: "Zatvoriť",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} oznámenie`,
    few: () => `${e.number(t.count)} oznámenia`,
    other: () => `${e.number(t.count)} oznámení`
  })}.`
};
var Fg = {};
Fg = {
  close: "Zapri",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} obvestilo`,
    two: () => `${e.number(t.count)} obvestili`,
    few: () => `${e.number(t.count)} obvestila`,
    other: () => `${e.number(t.count)} obvestil`
  })}.`
};
var Tg = {};
Tg = {
  close: "Zatvori",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} obaveštenje`,
    other: () => `${e.number(t.count)} obaveštenja`
  })}.`
};
var Ag = {};
Ag = {
  close: "Stäng",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} meddelande`,
    other: () => `${e.number(t.count)} meddelanden`
  })}.`
};
var Ig = {};
Ig = {
  close: "Kapat",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} bildirim`,
    other: () => `${e.number(t.count)} bildirim`
  })}.`
};
var Kg = {};
Kg = {
  close: "Закрити",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} сповіщення`,
    other: () => `${e.number(t.count)} сповіщення`
  })}.`
};
var Rg = {};
Rg = {
  close: "关闭",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} 个通知`,
    other: () => `${e.number(t.count)} 个通知`
  })}。`
};
var Ng = {};
Ng = {
  close: "關閉",
  notifications: (t, e) => `${e.plural(t.count, {
    one: () => `${e.number(t.count)} 個通知`,
    other: () => `${e.number(t.count)} 個通知`
  })}。`
};
var Pa = {};
Pa = {
  "ar-AE": rg,
  "bg-BG": lg,
  "cs-CZ": ig,
  "da-DK": ag,
  "de-DE": og,
  "el-GR": ug,
  "en-US": sg,
  "es-ES": cg,
  "et-EE": dg,
  "fi-FI": fg,
  "fr-FR": hg,
  "he-IL": pg,
  "hr-HR": bg,
  "hu-HU": mg,
  "it-IT": gg,
  "ja-JP": yg,
  "ko-KR": $g,
  "lt-LT": vg,
  "lv-LV": xg,
  "nb-NO": Eg,
  "nl-NL": Cg,
  "pl-PL": Dg,
  "pt-BR": wg,
  "pt-PT": Pg,
  "ro-RO": Sg,
  "ru-RU": kg,
  "sk-SK": Bg,
  "sl-SI": Fg,
  "sr-SP": Tg,
  "sv-SE": Ag,
  "tr-TR": Ig,
  "uk-UA": Kg,
  "zh-CN": Rg,
  "zh-TW": Ng
};
function v2(t) {
  return t && t.__esModule ? t.default : t;
}
function x2(t, e, n) {
  let { key: r, timer: l, timeout: i } = t.toast;
  Q(() => {
    if (!(l == null || i == null))
      return l.reset(i), () => {
        l.pause();
      };
  }, [
    l,
    i
  ]);
  let a = ce(), o = mt(), u = ke(v2(Pa), "@react-aria/toast"), [c, s] = q(!1);
  return le(() => {
    s(!0);
  }, []), {
    toastProps: {
      ...Y(t, {
        labelable: !0
      }),
      role: "alertdialog",
      "aria-modal": "false",
      "aria-labelledby": t["aria-labelledby"] || a,
      "aria-describedby": t["aria-describedby"] || o,
      tabIndex: 0
    },
    contentProps: {
      role: "alert",
      "aria-atomic": "true",
      "aria-hidden": c ? void 0 : "true"
    },
    titleProps: {
      id: a
    },
    descriptionProps: {
      id: o
    },
    closeButtonProps: {
      "aria-label": u.format("close"),
      onPress: () => e.close(r)
    }
  };
}
const Mg = 1, Zl = /* @__PURE__ */ Symbol.for("react-aria-landmark-manager");
function E2(t) {
  return document.addEventListener("react-aria-landmark-manager-change", t), () => document.removeEventListener("react-aria-landmark-manager-change", t);
}
function gu() {
  if (typeof document > "u") return null;
  let t = document[Zl];
  return t && t.version >= Mg ? t : (document[Zl] = new D2(), document.dispatchEvent(new CustomEvent("react-aria-landmark-manager-change")), document[Zl]);
}
function C2() {
  return Ui.useSyncExternalStore(E2, gu, gu);
}
class D2 {
  constructor() {
    this.landmarks = [], this.isListening = !1, this.refCount = 0, this.version = Mg, this.f6Handler = this.f6Handler.bind(this), this.focusinHandler = this.focusinHandler.bind(this), this.focusoutHandler = this.focusoutHandler.bind(this);
  }
  setupIfNeeded() {
    this.isListening || (document.addEventListener("keydown", this.f6Handler, {
      capture: !0
    }), document.addEventListener("focusin", this.focusinHandler, {
      capture: !0
    }), document.addEventListener("focusout", this.focusoutHandler, {
      capture: !0
    }), this.isListening = !0);
  }
  teardownIfNeeded() {
    !this.isListening || this.landmarks.length > 0 || this.refCount > 0 || (document.removeEventListener("keydown", this.f6Handler, {
      capture: !0
    }), document.removeEventListener("focusin", this.focusinHandler, {
      capture: !0
    }), document.removeEventListener("focusout", this.focusoutHandler, {
      capture: !0
    }), this.isListening = !1);
  }
  focusLandmark(e, n) {
    this.landmarks.find((r) => r.ref.current === e)?.focus?.(n);
  }
  /**
  * Return set of landmarks with a specific role.
  */
  getLandmarksByRole(e) {
    return new Set(this.landmarks.filter((n) => n.role === e));
  }
  /**
  * Return first landmark with a specific role.
  */
  getLandmarkByRole(e) {
    return this.landmarks.find((n) => n.role === e);
  }
  addLandmark(e) {
    if (this.setupIfNeeded(), this.landmarks.find((l) => l.ref === e.ref) || !e.ref.current) return;
    if (this.landmarks.filter((l) => l.role === "main").length > 1 && process.env.NODE_ENV !== "production" && console.error('Page can contain no more than one landmark with the role "main".'), this.landmarks.length === 0) {
      this.landmarks = [
        e
      ], this.checkLabels(e.role);
      return;
    }
    let n = 0, r = this.landmarks.length - 1;
    for (; n <= r; ) {
      let l = Math.floor((n + r) / 2), i = e.ref.current.compareDocumentPosition(this.landmarks[l].ref.current);
      !!(i & Node.DOCUMENT_POSITION_PRECEDING || i & Node.DOCUMENT_POSITION_CONTAINS) ? n = l + 1 : r = l - 1;
    }
    this.landmarks.splice(n, 0, e), this.checkLabels(e.role);
  }
  updateLandmark(e) {
    let n = this.landmarks.findIndex((r) => r.ref === e.ref);
    n >= 0 && (this.landmarks[n] = {
      ...this.landmarks[n],
      ...e
    }, this.checkLabels(this.landmarks[n].role));
  }
  removeLandmark(e) {
    this.landmarks = this.landmarks.filter((n) => n.ref !== e), this.teardownIfNeeded();
  }
  /**
  * Warn if there are 2+ landmarks with the same role but no label.
  * Labels for landmarks with the same role must also be unique.
  *
  * See https://www.w3.org/WAI/ARIA/apg/practices/landmark-regions/.
  */
  checkLabels(e) {
    let n = this.getLandmarksByRole(e);
    if (n.size > 1) {
      let r = [
        ...n
      ].filter((l) => !l.label);
      if (r.length > 0 && process.env.NODE_ENV !== "production") console.warn(`Page contains more than one landmark with the '${e}' role. If two or more landmarks on a page share the same role, all must be labeled with an aria-label or aria-labelledby attribute: `, r.map((l) => l.ref.current));
      else if (process.env.NODE_ENV !== "production") {
        let l = [
          ...n
        ].map((a) => a.label);
        l.filter((a, o) => l.indexOf(a) !== o).forEach((a) => {
          console.warn(`Page contains more than one landmark with the '${e}' role and '${a}' label. If two or more landmarks on a page share the same role, they must have unique labels: `, [
            ...n
          ].filter((o) => o.label === a).map((o) => o.ref.current));
        });
      }
    }
  }
  /**
  * Get the landmark that is the closest parent in the DOM.
  * Returns undefined if no parent is a landmark.
  */
  closestLandmark(e) {
    let n = new Map(this.landmarks.map((l) => [
      l.ref.current,
      l
    ])), r = e;
    for (; r && !n.has(r) && r !== document.body && r.parentElement; ) r = r.parentElement;
    return n.get(r);
  }
  /**
  * Gets the next landmark, in DOM focus order, or previous if backwards is specified.
  * If last landmark, next should be the first landmark.
  * If not inside a landmark, will return first landmark.
  * Returns undefined if there are no landmarks.
  */
  getNextLandmark(e, { backward: n }) {
    let r = this.closestLandmark(e), l = n ? this.landmarks.length - 1 : 0;
    r && (l = this.landmarks.indexOf(r) + (n ? -1 : 1));
    let i = () => {
      if (l < 0) {
        if (!e.dispatchEvent(new CustomEvent("react-aria-landmark-navigation", {
          detail: {
            direction: "backward"
          },
          bubbles: !0,
          cancelable: !0
        }))) return !0;
        l = this.landmarks.length - 1;
      } else if (l >= this.landmarks.length) {
        if (!e.dispatchEvent(new CustomEvent("react-aria-landmark-navigation", {
          detail: {
            direction: "forward"
          },
          bubbles: !0,
          cancelable: !0
        }))) return !0;
        l = 0;
      }
      return l < 0 || l >= this.landmarks.length;
    };
    if (i()) return;
    let a = l;
    for (; this.landmarks[l].ref.current?.closest("[aria-hidden=true]"); ) {
      if (l += n ? -1 : 1, i()) return;
      if (l === a) break;
    }
    return this.landmarks[l];
  }
  /**
  * Look at next landmark. If an element was previously focused inside, restore focus there.
  * If not, focus the landmark itself.
  * If no landmarks at all, or none with focusable elements, don't move focus.
  */
  f6Handler(e) {
    e.key === "F6" && (e.altKey ? this.focusMain() : this.navigate(H(e), e.shiftKey)) && (e.preventDefault(), e.stopPropagation());
  }
  focusMain() {
    let e = this.getLandmarkByRole("main");
    return e && e.ref.current && e.ref.current.isConnected ? (this.focusLandmark(e.ref.current, "forward"), !0) : !1;
  }
  navigate(e, n) {
    let r = this.getNextLandmark(e, {
      backward: n
    });
    if (!r) return !1;
    if (r.lastFocused) {
      let l = r.lastFocused;
      if (ne(document.body, l))
        return l.focus(), !0;
    }
    return r.ref.current && r.ref.current.isConnected ? (this.focusLandmark(r.ref.current, n ? "backward" : "forward"), !0) : !1;
  }
  /**
  * Sets lastFocused for a landmark, if focus is moved within that landmark.
  * Lets the last focused landmark know it was blurred if something else is focused.
  */
  focusinHandler(e) {
    let n = this.closestLandmark(H(e));
    n && n.ref.current !== H(e) && this.updateLandmark({
      ref: n.ref,
      lastFocused: H(e)
    });
    let r = e.relatedTarget;
    if (r) {
      let l = this.closestLandmark(r);
      l && l.ref.current === r && l.blur();
    }
  }
  /**
  * Track if the focus is lost to the body. If it is, do cleanup on the landmark that last had
  * focus.
  */
  focusoutHandler(e) {
    let n = H(e), r = e.relatedTarget;
    if (!r || r === document) {
      let l = this.closestLandmark(n);
      l && l.ref.current === n && l.blur();
    }
  }
  createLandmarkController() {
    let e = this;
    return e.refCount++, e.setupIfNeeded(), {
      navigate(n, r) {
        let l = r?.from || document.activeElement;
        return e.navigate(l, n === "backward");
      },
      focusNext(n) {
        let r = n?.from || document.activeElement;
        return e.navigate(r, !1);
      },
      focusPrevious(n) {
        let r = n?.from || document.activeElement;
        return e.navigate(r, !0);
      },
      focusMain() {
        return e.focusMain();
      },
      dispose() {
        e && (e.refCount--, e.teardownIfNeeded(), e = null);
      }
    };
  }
  registerLandmark(e) {
    return this.landmarks.find((n) => n.ref === e.ref) ? this.updateLandmark(e) : this.addLandmark(e), () => this.removeLandmark(e.ref);
  }
}
function w2(t, e) {
  const { role: n, "aria-label": r, "aria-labelledby": l, focus: i } = t;
  let a = C2(), o = r || l, [u, c] = q(!1), s = G(() => {
    c(!0);
  }, [
    c
  ]), d = G(() => {
    c(!1);
  }, [
    c
  ]);
  return le(() => {
    if (a) return a.registerLandmark({
      ref: e,
      label: o,
      role: n,
      focus: i || s,
      blur: d
    });
  }, [
    a,
    o,
    e,
    n,
    i,
    s,
    d
  ]), Q(() => {
    u && e.current?.focus();
  }, [
    u,
    e
  ]), {
    landmarkProps: {
      role: n,
      tabIndex: u ? -1 : void 0,
      "aria-label": r,
      "aria-labelledby": l
    }
  };
}
function P2(t) {
  return t && t.__esModule ? t.default : t;
}
function S2(t, e, n) {
  let r = ke(P2(Pa), "@react-aria/toast"), { landmarkProps: l } = w2({
    role: "region",
    "aria-label": t["aria-label"] || r.format("notifications", {
      count: e.visibleToasts.length
    })
  }, n), i = B(!1), a = B(!1), o = G(() => {
    i.current || a.current ? e.pauseAll() : e.resumeAll();
  }, [
    e
  ]), { hoverProps: u } = ve({
    onHoverStart: () => {
      i.current = !0, o();
    },
    onHoverEnd: () => {
      i.current = !1, o();
    }
  }), c = B([]), s = B(e.visibleToasts), d = B(null);
  le(() => {
    if (d.current === -1 || e.visibleToasts.length === 0 || !n.current) {
      c.current = [], s.current = e.visibleToasts;
      return;
    }
    if (c.current = [
      ...n.current.querySelectorAll('[role="alertdialog"]')
    ], s.current.length === e.visibleToasts.length && e.visibleToasts.every((g, y) => g.key === s.current[y].key)) {
      s.current = e.visibleToasts;
      return;
    }
    let p = s.current.map((g, y) => ({
      ...g,
      i: y,
      isRemoved: !e.visibleToasts.some(($) => g.key === $.key)
    })), b = p.findIndex((g) => g.i === d.current && g.isRemoved);
    if (b > -1)
      if (gt() === "pointer" && f.current?.isConnected) Pe(f.current);
      else {
        let g = 0, y, $;
        for (; g <= b; )
          p[g].isRemoved || ($ = Math.max(0, g - 1)), g++;
        for (; g < p.length; ) {
          if (!p[g].isRemoved) {
            y = g - 1;
            break;
          }
          g++;
        }
        $ === void 0 && y === void 0 && ($ = 0), $ >= 0 && $ < c.current.length ? Pe(c.current[$]) : y >= 0 && y < c.current.length && Pe(c.current[y]);
      }
    s.current = e.visibleToasts;
  }, [
    e.visibleToasts,
    n
  ]);
  let f = B(null), { focusWithinProps: h } = Et({
    onFocusWithin: (p) => {
      a.current = !0, f.current = p.relatedTarget, o();
    },
    onBlurWithin: () => {
      a.current = !1, f.current = null, o();
    }
  });
  return Q(() => {
    e.visibleToasts.length === 0 && f.current?.isConnected && (gt() === "pointer" ? Pe(f.current) : f.current.focus(), f.current = null);
  }, [
    n,
    e.visibleToasts.length
  ]), Q(() => () => {
    f.current?.isConnected && (gt() === "pointer" ? Pe(f.current) : f.current.focus(), f.current = null);
  }, [
    n
  ]), {
    regionProps: L(l, u, h, {
      tabIndex: -1,
      // Mark the toast region as a "top layer", so that it:
      //   - is not aria-hidden when opening an overlay
      //   - allows focus even outside a containing focus scope
      //   - doesn’t dismiss overlays when clicking on it, even though it is outside
      // @ts-ignore
      "data-react-aria-top-layer": !0,
      // listen to focus events separate from focuswithin because that will only fire once
      // and we need to follow all focus changes
      onFocus: (p) => {
        let b = H(p).closest('[role="alertdialog"]');
        d.current = c.current.findIndex((g) => g === b);
      },
      onBlur: () => {
        d.current = -1;
      }
    })
  };
}
function k2(t) {
  let e = G((l) => t.subscribe(l), [
    t
  ]), n = G(() => t.visibleToasts, [
    t
  ]);
  return {
    visibleToasts: Ui.useSyncExternalStore(e, n, n),
    add: (l, i) => t.add(l, i),
    close: (l) => t.close(l),
    pauseAll: () => t.pauseAll(),
    resumeAll: () => t.resumeAll()
  };
}
class gx {
  constructor(e) {
    this.queue = [], this.subscriptions = /* @__PURE__ */ new Set(), this.visibleToasts = [], this.maxVisibleToasts = e?.maxVisibleToasts ?? 1 / 0, this.wrapUpdate = e?.wrapUpdate;
  }
  runWithWrapUpdate(e, n) {
    this.wrapUpdate ? this.wrapUpdate(e, n) : e();
  }
  /** Subscribes to updates to the visible toasts. */
  subscribe(e) {
    return this.subscriptions.add(e), () => this.subscriptions.delete(e);
  }
  /** Adds a new toast to the queue. */
  add(e, n = {}) {
    let r = "_" + Math.random().toString(36).slice(2), l = {
      ...n,
      content: e,
      key: r,
      timer: n.timeout ? new B2(() => this.close(r), n.timeout) : void 0
    };
    return this.queue.unshift(l), this.updateVisibleToasts("add"), r;
  }
  /**
  * Closes a toast.
  */
  close(e) {
    let n = this.queue.findIndex((r) => r.key === e);
    n >= 0 && (this.queue[n].onClose?.(), this.queue.splice(n, 1)), this.updateVisibleToasts("remove");
  }
  updateVisibleToasts(e) {
    this.visibleToasts = this.queue.slice(0, this.maxVisibleToasts), this.runWithWrapUpdate(() => {
      for (let n of this.subscriptions) n();
    }, e);
  }
  /** Pauses the timers for all visible toasts. */
  pauseAll() {
    for (let e of this.visibleToasts) e.timer && e.timer.pause();
  }
  /** Resumes the timers for all visible toasts. */
  resumeAll() {
    for (let e of this.visibleToasts) e.timer && e.timer.resume();
  }
  clear() {
    this.queue = [], this.updateVisibleToasts("clear");
  }
}
class B2 {
  constructor(e, n) {
    this.startTime = null, this.remaining = n, this.callback = e;
  }
  reset(e) {
    this.remaining = e, this.resume();
  }
  pause() {
    this.timerId != null && (clearTimeout(this.timerId), this.timerId = null, this.remaining -= Date.now() - this.startTime);
  }
  resume() {
    this.remaining <= 0 || (this.startTime = Date.now(), this.timerId = setTimeout(() => {
      this.timerId = null, this.remaining = 0, this.callback();
    }, this.remaining));
  }
}
const Sa = /* @__PURE__ */ j(null), yx = /* @__PURE__ */ te(function(e, n) {
  let r = it(), l = k2(e.queue), i = ge(n), { regionProps: a } = S2(e, l, i), { focusProps: o, isFocused: u, isFocusVisible: c } = $e(), { hoverProps: s, isHovered: d } = ve({}), f = re({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-ToastRegion",
    values: {
      visibleToasts: l.visibleToasts,
      isHovered: d,
      isFocused: u,
      isFocusVisible: c
    }
  }), { direction: h } = pe(), p, { getContainer: b } = ha();
  r || (p = document.body, b && (p = b()));
  let g = Y(e, {
    global: !0
  }), y = /* @__PURE__ */ m.createElement(Sa.Provider, {
    value: l
  }, /* @__PURE__ */ m.createElement(X.div, {
    ...L(g, f, a, o, s),
    dir: h,
    ref: i,
    "data-hovered": d || void 0,
    "data-focused": u || void 0,
    "data-focus-visible": c || void 0
  }, typeof e.children == "function" ? /* @__PURE__ */ m.createElement(F2, {
    ...e,
    render: void 0,
    className: void 0,
    style: {
      display: "contents"
    }
  }, e.children) : e.children));
  return l.visibleToasts.length > 0 && p ? /* @__PURE__ */ Eu(y, p) : null;
}), F2 = /* @__PURE__ */ te(function(e, n) {
  let r = z(Sa), { hoverProps: l, isHovered: i } = ve({}), a = re({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-ToastList",
    values: {
      visibleToasts: r.visibleToasts,
      isFocused: !1,
      isFocusVisible: !1,
      isHovered: i
    }
  });
  return /* @__PURE__ */ m.createElement(X.ol, {
    ...l,
    ...a,
    ref: n
  }, r.visibleToasts.map((o) => /* @__PURE__ */ m.createElement("li", {
    key: o.key,
    style: {
      display: "contents"
    }
  }, e.children({
    toast: o
  }))));
}), $x = /* @__PURE__ */ te(function(e, n) {
  let r = z(Sa), l = ge(n), { toastProps: i, contentProps: a, titleProps: o, descriptionProps: u, closeButtonProps: c } = x2(e, r, l), { focusProps: s, isFocused: d, isFocusVisible: f } = $e(), h = re({
    ...e,
    defaultClassName: "react-aria-Toast",
    values: {
      toast: e.toast,
      isFocused: d,
      isFocusVisible: f
    }
  }), p = Y(e, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(p, h, i, s),
    ref: l,
    "data-focused": d || void 0,
    "data-focus-visible": f || void 0
  }, /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        Lg,
        a
      ],
      [
        Qe,
        {
          slots: {
            [rt]: {},
            title: o,
            description: u
          }
        }
      ],
      [
        st,
        {
          slots: {
            [rt]: {},
            close: c
          }
        }
      ]
    ]
  }, h.children));
}), Lg = /* @__PURE__ */ j({}), vx = /* @__PURE__ */ te(function(e, n) {
  return [e, n] = ie(e, n, Lg), /* @__PURE__ */ m.createElement(X.div, {
    render: e.render,
    className: "react-aria-ToastContent",
    ...e,
    ref: n
  }, e.children);
});
function zg(t, e, n) {
  const { isSelected: r } = e, { isPressed: l, buttonProps: i } = Dc({
    ...t,
    onPress: Ye(e.toggle, t.onPress)
  }, n);
  return {
    isPressed: l,
    isSelected: r,
    isDisabled: t.isDisabled || !1,
    buttonProps: L(i, {
      "aria-pressed": r
    })
  };
}
function Vg(t, e) {
  const { "aria-label": n, "aria-labelledby": r, orientation: l = "horizontal" } = t;
  let [i, a] = q(!1);
  le(() => {
    a(!!(e.current && e.current.parentElement?.closest('[role="toolbar"]')));
  });
  const { direction: o } = pe(), u = o === "rtl" && l === "horizontal";
  let c = r0(e);
  const s = (p) => {
    if (ne(p.currentTarget, H(p))) {
      if (l === "horizontal" && p.key === "ArrowRight" || l === "vertical" && p.key === "ArrowDown")
        u ? c.focusPrevious() : c.focusNext();
      else if (l === "horizontal" && p.key === "ArrowLeft" || l === "vertical" && p.key === "ArrowUp")
        u ? c.focusNext() : c.focusPrevious();
      else if (p.key === "Tab") {
        d.current = oe(), p.shiftKey ? c.focusFirst() : c.focusLast();
        return;
      } else
        return;
      p.stopPropagation(), p.preventDefault();
    }
  }, d = B(null), f = (p) => {
    !ne(p.currentTarget, p.relatedTarget) && !d.current && (d.current = H(p));
  }, h = (p) => {
    d.current && !ne(p.currentTarget, p.relatedTarget) && ne(e.current, H(p)) && (d.current?.focus(), d.current = null);
  };
  return {
    toolbarProps: {
      ...Y(t, {
        labelable: !0
      }),
      role: i ? "group" : "toolbar",
      "aria-orientation": l,
      "aria-label": n,
      "aria-labelledby": n == null ? r : void 0,
      onKeyDownCapture: i ? void 0 : s,
      onFocusCapture: i ? void 0 : h,
      onBlurCapture: i ? void 0 : f
    }
  };
}
function T2(t, e, n) {
  let { isDisabled: r } = t, { toolbarProps: l } = Vg(t, n);
  return {
    groupProps: {
      ...l,
      role: e.selectionMode === "single" ? "radiogroup" : l.role,
      "aria-disabled": r
    }
  };
}
function A2(t, e, n) {
  let r = {
    isSelected: e.selectedKeys.has(t.id),
    defaultSelected: !1,
    setSelected(u) {
      e.setSelected(t.id, u);
    },
    toggle() {
      e.toggleKey(t.id);
    }
  }, { isPressed: l, isSelected: i, isDisabled: a, buttonProps: o } = zg({
    ...t,
    id: void 0,
    isDisabled: t.isDisabled || e.isDisabled
  }, r, n);
  return e.selectionMode === "single" && (o.role = "radio", o["aria-checked"] = r.isSelected, delete o["aria-pressed"]), {
    isPressed: l,
    isSelected: i,
    isDisabled: a,
    buttonProps: o
  };
}
function I2(t) {
  let { selectionMode: e = "single", disallowEmptySelection: n, isDisabled: r = !1 } = t, [l, i] = Be(_(() => t.selectedKeys ? new Set(t.selectedKeys) : void 0, [
    t.selectedKeys
  ]), _(() => t.defaultSelectedKeys ? new Set(t.defaultSelectedKeys) : /* @__PURE__ */ new Set(), [
    t.defaultSelectedKeys
  ]), t.onSelectionChange);
  return {
    selectionMode: e,
    isDisabled: r,
    selectedKeys: l,
    setSelectedKeys: i,
    toggleKey(a) {
      let o;
      e === "multiple" ? (o = new Set(l), o.has(a) && (!n || o.size > 1) ? o.delete(a) : o.add(a)) : o = new Set(l.has(a) && !n ? [] : [
        a
      ]), i(o);
    },
    setSelected(a, o) {
      o !== l.has(a) && this.toggleKey(a);
    }
  };
}
const K2 = /* @__PURE__ */ j({}), Og = /* @__PURE__ */ j(null), xx = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, K2);
  let r = I2(e), { groupProps: l } = T2(e, r, n), i = re({
    ...e,
    values: {
      orientation: e.orientation || "horizontal",
      isDisabled: r.isDisabled,
      state: r
    },
    defaultClassName: "react-aria-ToggleButtonGroup"
  }), a = Y(e, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(a, i, l),
    ref: n,
    slot: e.slot || void 0,
    "data-orientation": e.orientation || "horizontal",
    "data-disabled": e.isDisabled || void 0
  }, /* @__PURE__ */ m.createElement(Og.Provider, {
    value: r
  }, /* @__PURE__ */ m.createElement(bn, null, i.children)));
}), R2 = /* @__PURE__ */ j({}), Ex = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, R2);
  let r = z(Og), l = $l(r && e.id != null ? {
    isSelected: r.selectedKeys.has(e.id),
    onChange(g) {
      r.setSelected(e.id, g);
    }
  } : e), { buttonProps: i, isPressed: a, isSelected: o, isDisabled: u } = r && e.id != null ? A2({
    ...e,
    id: e.id
  }, r, n) : zg({
    ...e,
    id: e.id != null ? String(e.id) : void 0
  }, l, n), { focusProps: c, isFocused: s, isFocusVisible: d } = $e(e), { hoverProps: f, isHovered: h } = ve({
    ...e,
    isDisabled: u
  }), p = re({
    ...e,
    id: void 0,
    values: {
      isHovered: h,
      isPressed: a,
      isFocused: s,
      isSelected: l.isSelected,
      isFocusVisible: d,
      isDisabled: u,
      state: l
    },
    defaultClassName: "react-aria-ToggleButton"
  }), b = Y(e, {
    global: !0
  });
  return delete b.id, delete b.onClick, /* @__PURE__ */ m.createElement(X.button, {
    ...L(b, p, i, c, f),
    ref: n,
    slot: e.slot || void 0,
    "data-focused": s || void 0,
    "data-disabled": u || void 0,
    "data-pressed": a || void 0,
    "data-selected": o || void 0,
    "data-hovered": h || void 0,
    "data-focus-visible": d || void 0
  }, /* @__PURE__ */ m.createElement(mn.Provider, {
    value: {
      isSelected: o
    }
  }, p.children));
}), N2 = /* @__PURE__ */ j({}), Cx = /* @__PURE__ */ te(function(e, n) {
  [e, n] = ie(e, n, N2);
  let { toolbarProps: r } = Vg(e, n), l = re({
    ...e,
    values: {
      orientation: e.orientation || "horizontal"
    },
    defaultClassName: "react-aria-Toolbar"
  }), i = Y(e, {
    global: !0
  });
  return delete i.id, /* @__PURE__ */ m.createElement(X.div, {
    ...L(i, l, r),
    ref: n,
    slot: e.slot || void 0,
    "data-orientation": e.orientation || "horizontal"
  }, l.children);
}), Ri = /* @__PURE__ */ m.createContext(null);
function M2(t) {
  let { children: e } = t, n = z(Ri), [r, l] = q(0), i = _(() => ({
    parent: n,
    modalCount: r,
    addModal() {
      l((a) => a + 1), n && n.addModal();
    },
    removeModal() {
      l((a) => a - 1), n && n.removeModal();
    }
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ m.createElement(Ri.Provider, {
    value: i
  }, e);
}
function L2() {
  let t = z(Ri);
  return {
    modalProviderProps: {
      "aria-hidden": t && t.modalCount > 0 ? !0 : void 0
    }
  };
}
function z2(t) {
  let { modalProviderProps: e } = L2();
  return /* @__PURE__ */ m.createElement("div", {
    "data-overlay-container": !0,
    ...t,
    ...e
  });
}
function V2(t) {
  return /* @__PURE__ */ m.createElement(M2, null, /* @__PURE__ */ m.createElement(z2, t));
}
function O2(t) {
  let e = it(), { portalContainer: n = e ? null : document.body, ...r } = t, { getContainer: l } = ha();
  if (!t.portalContainer && l && (n = l()), m.useEffect(() => {
    if (n?.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
  }, [
    n
  ]), !n) return null;
  let i = /* @__PURE__ */ m.createElement(V2, r);
  return /* @__PURE__ */ Ni.createPortal(i, n);
}
const H2 = 1500, yu = 500;
let nn = {}, _2 = 0, er = !1, bt = null, rn = null;
function Hg(t = {}) {
  let { delay: e = H2, closeDelay: n = yu } = t, { isOpen: r, open: l, close: i } = kr(t), a = _(() => `${++_2}`, []), o = B(null), u = B(i), c = () => {
    nn[a] = f;
  }, s = () => {
    for (let p in nn) p !== a && (nn[p](!0), delete nn[p]);
  }, d = () => {
    o.current && clearTimeout(o.current), o.current = null, s(), c(), er = !0, l(), bt && (clearTimeout(bt), bt = null), rn && (clearTimeout(rn), rn = null);
  }, f = (p) => {
    p || n <= 0 ? (o.current && clearTimeout(o.current), o.current = null, u.current()) : o.current || (o.current = setTimeout(() => {
      o.current = null, u.current();
    }, n)), bt && (clearTimeout(bt), bt = null), er && (rn && clearTimeout(rn), rn = setTimeout(() => {
      delete nn[a], rn = null, er = !1;
    }, Math.max(yu, n)));
  }, h = () => {
    s(), c(), !r && !er ? (bt && clearTimeout(bt), bt = setTimeout(() => {
      bt = null, er = !0, d();
    }, e)) : r || d();
  };
  return Q(() => {
    u.current = i;
  }, [
    i
  ]), Q(() => () => {
    o.current && clearTimeout(o.current), nn[a] && delete nn[a];
  }, [
    a
  ]), {
    isOpen: r,
    open: (p) => {
      !p && e > 0 && !o.current ? h() : d();
    },
    close: f
  };
}
function W2(t, e) {
  let n = Y(t, {
    labelable: !0
  }), { hoverProps: r } = ve({
    onHoverStart: () => e?.open(!0),
    onHoverEnd: () => e?.close()
  });
  return {
    tooltipProps: L(n, r, {
      role: "tooltip"
    })
  };
}
function j2(t, e, n) {
  let { isDisabled: r, trigger: l, shouldCloseOnPress: i = !0 } = t, a = ce(), o = B(!1), u = B(!1), c = () => {
    (o.current || u.current) && e.open(u.current);
  }, s = ($) => {
    !o.current && !u.current && e.close($);
  };
  Q(() => {
    let $ = (v) => {
      n && n.current && v.key === "Escape" && (v.stopPropagation(), e.close(!0));
    };
    if (e.isOpen)
      return document.addEventListener("keydown", $, !0), () => {
        document.removeEventListener("keydown", $, !0);
      };
  }, [
    n,
    e
  ]);
  let d = () => {
    l !== "focus" && (gt() === "pointer" ? o.current = !0 : o.current = !1, c());
  }, f = () => {
    l !== "focus" && (u.current = !1, o.current = !1, s());
  }, h = () => {
    i && (u.current = !1, o.current = !1, s(!0));
  }, p = () => {
    vt() && (u.current = !0, c());
  }, b = () => {
    u.current = !1, o.current = !1, s(!0);
  }, { hoverProps: g } = ve({
    isDisabled: r,
    onHoverStart: d,
    onHoverEnd: f
  }), { focusableProps: y } = Je({
    isDisabled: r,
    onFocus: p,
    onBlur: b
  }, n);
  return {
    triggerProps: {
      "aria-describedby": e.isOpen ? a : void 0,
      ...L(y, g, {
        onPointerDown: h,
        onKeyDown: h
      }),
      tabIndex: void 0
    },
    tooltipProps: {
      id: a
    }
  };
}
const ka = /* @__PURE__ */ j(null), _g = /* @__PURE__ */ j(null);
function Dx(t) {
  let e = Hg(t), n = B(null), { triggerProps: r, tooltipProps: l } = j2(t, e, n);
  return /* @__PURE__ */ m.createElement(he, {
    values: [
      [
        ka,
        e
      ],
      [
        _g,
        {
          ...l,
          triggerRef: n
        }
      ]
    ]
  }, /* @__PURE__ */ m.createElement(r$, {
    ...r,
    ref: n
  }, t.children));
}
const wx = /* @__PURE__ */ te(function({ UNSTABLE_portalContainer: e, ...n }, r) {
  [n, r] = ie(n, r, _g);
  let l = z(ka), i = Hg(n), a = n.isOpen != null || n.defaultOpen != null || !l ? i : l, o = yr(r, a.isOpen) || n.isExiting || !1;
  return !a.isOpen && !o ? null : /* @__PURE__ */ m.createElement(O2, {
    portalContainer: e
  }, /* @__PURE__ */ m.createElement(U2, {
    ...n,
    tooltipRef: r,
    isExiting: o
  }));
});
function U2(t) {
  let e = z(ka), n = B(null), { overlayProps: r, arrowProps: l, placement: i, triggerAnchorPoint: a } = Pp({
    placement: t.placement || "top",
    targetRef: t.triggerRef,
    overlayRef: t.tooltipRef,
    arrowRef: n,
    offset: t.offset,
    crossOffset: t.crossOffset,
    isOpen: e.isOpen,
    arrowBoundaryOffset: t.arrowBoundaryOffset,
    shouldFlip: t.shouldFlip,
    containerPadding: t.containerPadding,
    onClose: () => e.close(!0)
  }), o = Br(t.tooltipRef, !!i) || t.isEntering || !1, u = re({
    ...t,
    defaultClassName: "react-aria-Tooltip",
    values: {
      placement: i,
      isEntering: o,
      isExiting: t.isExiting,
      state: e
    }
  });
  t = L(t, r);
  let { tooltipProps: c } = W2(t, e), s = Y(t, {
    global: !0
  });
  return /* @__PURE__ */ m.createElement(X.div, {
    ...L(s, u, c),
    ref: t.tooltipRef,
    style: {
      ...r.style,
      "--trigger-anchor-point": a ? `${a.x}px ${a.y}px` : void 0,
      ...u.style
    },
    "data-placement": i ?? void 0,
    "data-entering": o || void 0,
    "data-exiting": t.isExiting || void 0
  }, /* @__PURE__ */ m.createElement(Ep.Provider, {
    value: {
      ...l,
      placement: i,
      ref: n
    }
  }, u.children));
}
let Cn = null;
function G2(t = !1) {
  if (Cn === null || t) {
    const e = document.createElement("div"), n = e.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    const r = document.createElement("div"), l = r.style;
    return l.width = "100px", l.height = "100px", e.appendChild(r), document.body.appendChild(e), e.scrollLeft > 0 ? Cn = "positive-descending" : (e.scrollLeft = 1, e.scrollLeft === 0 ? Cn = "negative" : Cn = "positive-ascending"), document.body.removeChild(e), Cn;
  }
  return Cn;
}
function q2(t, e) {
  let { scrollLeft: n } = t;
  if (e === "rtl") {
    let { scrollWidth: r, clientWidth: l } = t;
    switch (G2()) {
      case "negative":
        n = -n;
        break;
      case "positive-descending":
        n = r - l - n;
        break;
    }
  }
  return n;
}
function Y2(t, e) {
  let { contentSize: n, onVisibleRectChange: r, onSizeChange: l, innerStyle: i, onScrollStart: a, onScrollEnd: o, scrollDirection: u = "both", onScroll: c, allowsWindowScrolling: s, ...d } = t, f = B({
    // Internal scroll position of the scroll view.
    scrollPosition: new nt(),
    // Size of the scroll view.
    size: new Le(),
    // Offset of the scroll view relative to the window viewport.
    viewportOffset: new nt(),
    // Size of the window viewport.
    viewportSize: new Le(),
    scrollEndTime: 0,
    scrollTimeout: null,
    isScrolling: !1,
    lastVisibleRect: new be()
  }).current, { direction: h } = pe(), p = G(() => {
    let N = s ? new be(f.viewportOffset.x + f.scrollPosition.x, f.viewportOffset.y + f.scrollPosition.y, Math.max(0, Math.min(f.size.width - f.viewportOffset.x, f.viewportSize.width)), Math.max(0, Math.min(f.size.height - f.viewportOffset.y, f.viewportSize.height))) : new be(f.scrollPosition.x, f.scrollPosition.y, f.size.width, f.size.height);
    (N.area > 0 || f.lastVisibleRect.area > 0) && (r(N), f.lastVisibleRect = N);
  }, [
    f,
    s,
    r
  ]), [b, g] = q(!1), y = G((N) => {
    let O = H(N);
    if (ne(O, e.current)) {
      if (c && O === e.current && c(N), O !== e.current) {
        let A = e.current.getBoundingClientRect(), V = A.x < 0 ? -A.x : 0, x = A.y < 0 ? -A.y : 0;
        if (V === f.viewportOffset.x && x === f.viewportOffset.y) return;
        f.viewportOffset = new nt(V, x);
      } else {
        let A = O.scrollTop, V = q2(O, h);
        f.scrollPosition = new nt(Math.max(0, Math.min(V, n.width - f.size.width)), Math.max(0, Math.min(A, n.height - f.size.height)));
      }
      Ge(() => {
        p(), f.isScrolling || (f.isScrolling = !0, g(!0), window.dispatchEvent(new Event("tk.disconnect-observer")), a && a());
        let A = Date.now();
        f.scrollEndTime <= A + 50 && (f.scrollEndTime = A + 300, f.scrollTimeout != null && clearTimeout(f.scrollTimeout), f.scrollTimeout = setTimeout(() => {
          f.isScrolling = !1, g(!1), f.scrollTimeout = null, window.dispatchEvent(new Event("tk.connect-observer")), o && o();
        }, 300));
      });
    }
  }, [
    c,
    e,
    h,
    f,
    n,
    p,
    a,
    o
  ]);
  Q(() => (document.addEventListener("scroll", y, !0), () => document.removeEventListener("scroll", y, !0)), [
    y
  ]), Q(() => () => {
    f.scrollTimeout != null && clearTimeout(f.scrollTimeout), f.isScrolling && window.dispatchEvent(new Event("tk.connect-observer"));
  }, []);
  let $ = B(!1), v = G((N) => {
    let O = e.current;
    if (!O || $.current) return;
    $.current = !0;
    let A = process.env.NODE_ENV === "test" && !process.env.VIRT_ON, V = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes("clientWidth"), x = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes("clientHeight"), K = O.clientWidth, D = O.clientHeight, F = A && !V ? 1 / 0 : K, M = A && !x ? 1 / 0 : D, P = window.innerWidth, T = window.innerHeight, W = f.viewportSize.width !== P || f.viewportSize.height !== T;
    W && (f.viewportSize = new Le(P, T)), (f.size.width !== F || f.size.height !== M || W) && (f.size = new Le(F, M), N(() => {
      p(), l?.(f.size);
    }), (!A && K !== O.clientWidth || D !== O.clientHeight) && (f.size = new Le(O.clientWidth, O.clientHeight), N(() => {
      p(), l?.(f.size);
    }))), $.current = !1;
  }, [
    e,
    f,
    p,
    l
  ]), E = ye(v);
  le(() => {
    f.viewportSize = new Le(window.innerWidth, window.innerHeight);
    let N = () => {
      E(Ge);
    };
    return window.addEventListener("resize", N), () => window.removeEventListener("resize", N);
  }, [
    f
  ]);
  let S = B(null), [w, C] = q({});
  le(() => {
    if (!$.current && (S.current == null || !n.equals(S.current)))
      if (
        // @ts-ignore
        typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u"
      ) {
        C({}), S.current = n;
        return;
      } else queueMicrotask(() => E(Ge));
    S.current = n;
  }), le(() => {
    E((N) => N());
  }, [
    w
  ]);
  let R = G(() => {
    v(Ge);
  }, [
    v
  ]);
  Nn({
    ref: e,
    box: "border-box",
    onResize: R
  });
  let I = {
    // Reset padding so that relative positioning works correctly. Padding will be done in JS layout.
    padding: 0,
    ...d.style
  };
  return u === "horizontal" ? (I.overflowX = "auto", I.overflowY = "hidden") : u === "vertical" || n.width === f.size.width ? (I.overflowY = "auto", I.overflowX = "hidden") : I.overflow = "auto", i = {
    width: Number.isFinite(n.width) ? n.width : void 0,
    height: Number.isFinite(n.height) ? n.height : void 0,
    pointerEvents: b ? "none" : "auto",
    position: "relative",
    ...i
  }, {
    isScrolling: b,
    scrollViewProps: {
      ...d,
      style: I
    },
    contentProps: {
      role: "presentation",
      style: i
    }
  };
}
function X2(t) {
  let { layoutInfo: e, virtualizer: n, ref: r } = t, l = e?.key, i = G(() => {
    if (l != null && r.current) {
      let a = Z2(r.current);
      n.updateItemSize(l, a);
    }
  }, [
    n,
    l,
    r
  ]);
  return le(() => {
    e?.estimatedSize && i();
  }), {
    updateSize: i
  };
}
function Z2(t) {
  let e = t.style.height;
  t.style.height = "";
  let n = new Le(t.scrollWidth, t.scrollHeight);
  return t.style.height = e, n;
}
function Wg(t) {
  let { style: e, className: n, layoutInfo: r, virtualizer: l, parent: i, children: a } = t, { direction: o } = pe(), u = B(null);
  return X2({
    layoutInfo: r,
    virtualizer: l,
    ref: u
  }), /* @__PURE__ */ m.createElement("div", {
    role: "presentation",
    ref: u,
    className: n,
    style: {
      ...J2(r, o, i),
      ...e
    }
  }, a);
}
let $u = /* @__PURE__ */ new WeakMap();
function J2(t, e, n) {
  let r = e === "rtl" ? "right" : "left", l = $u.get(t);
  if (l && l[r] != null) {
    if (!n) return l;
    let o = t.rect.y - n.rect.y, u = t.rect.x - n.rect.x;
    if (l.top === o && l[r] === u) return l;
  }
  let i = {
    // TODO: For layoutInfos that are sticky that have parents with overflow visible, their "top" will be relative to the to the nearest scrolling container
    // which WON'T be the parent since the parent has overflow visible. This means we shouldn't offset the height by the parent's position
    // Not 100% about this change here since it is quite ambigious what the scrolling container maybe and how its top is positioned with respect to the
    // calculated layoutInfo.y here
    top: t.rect.y - (n && !(n.allowOverflow && t.isSticky) ? n.rect.y : 0),
    [r]: t.rect.x - (n && !(n.allowOverflow && t.isSticky) ? n.rect.x : 0),
    width: t.rect.width,
    height: t.rect.height
  };
  Object.entries(i).forEach(([o, u]) => {
    Number.isFinite(u) || (i[o] = void 0);
  });
  let a = {
    position: t.isSticky ? "sticky" : "absolute",
    // Sticky elements are positioned in normal document flow. Display inline-block so that they don't push other sticky columns onto the following rows.
    display: t.isSticky ? "inline-block" : void 0,
    overflow: t.allowOverflow ? "visible" : "hidden",
    opacity: t.opacity,
    zIndex: t.zIndex,
    transform: t.transform ?? void 0,
    contain: "size layout style",
    ...i
  };
  return $u.set(t, a), a;
}
const jg = /* @__PURE__ */ j(null), Ug = /* @__PURE__ */ j(null);
function Px(t) {
  let { children: e, layout: n, layoutOptions: r } = t, l = _(() => typeof n == "function" ? new n() : n, [
    n
  ]), i = _(() => ({
    isVirtualized: !0,
    layoutDelegate: l,
    dropTargetDelegate: l.getDropTargetFromPoint ? l : void 0,
    CollectionRoot: Q2,
    CollectionBranch: e6
  }), [
    l
  ]);
  return /* @__PURE__ */ m.createElement(me.Provider, {
    value: i
  }, /* @__PURE__ */ m.createElement(Ug.Provider, {
    value: {
      layout: l,
      layoutOptions: r
    }
  }, e));
}
function Q2({ collection: t, persistedKeys: e, scrollRef: n, renderDropIndicator: r }) {
  let { layout: l, layoutOptions: i } = z(Ug), a = l.useLayoutOptions?.(), o = e2({
    allowsWindowScrolling: !0,
    layout: l,
    collection: t,
    renderView: (c, s) => s?.render?.(s),
    onVisibleRectChange(c) {
      let s = n?.current;
      s && (s.scrollLeft = c.x, s.scrollTop = c.y);
    },
    persistedKeys: e,
    layoutOptions: _(() => i && a ? {
      ...i,
      ...a
    } : i || a, [
      i,
      a
    ])
  }), { contentProps: u } = Y2({
    onVisibleRectChange: o.setVisibleRect,
    onSizeChange: o.setSize,
    contentSize: o.contentSize,
    onScrollStart: o.startScrolling,
    onScrollEnd: o.endScrolling,
    allowsWindowScrolling: !0
  }, n);
  return /* @__PURE__ */ m.createElement("div", u, /* @__PURE__ */ m.createElement(jg.Provider, {
    value: o
  }, Gg(null, o.visibleViews, r)));
}
function e6({ parent: t, renderDropIndicator: e }) {
  let r = z(jg).virtualizer.getVisibleView(t.key);
  return Gg(r, Array.from(r.children), e);
}
function Gg(t, e, n) {
  return e.map((r) => t6(t, r, n));
}
function t6(t, e, n) {
  let r = /* @__PURE__ */ m.createElement(Wg, {
    key: e.key,
    layoutInfo: e.layoutInfo,
    virtualizer: e.virtualizer,
    parent: t?.layoutInfo
  }, e.rendered), { collection: l, layout: i } = e.virtualizer, a = e.content;
  return a?.type === "item" && n && i.getDropTargetLayoutInfo && (r = /* @__PURE__ */ m.createElement(m.Fragment, {
    key: e.key
  }, vu(t, e, {
    type: "item",
    key: e.content.key,
    dropPosition: "before"
  }, n), r, Rs(l, a, (o) => vu(t, e, o, n)))), r;
}
function vu(t, e, n, r) {
  let l = r(n);
  if (l) {
    let i = e.virtualizer.layout.getDropTargetLayoutInfo(n);
    l = /* @__PURE__ */ m.createElement(Wg, {
      layoutInfo: i,
      virtualizer: e.virtualizer,
      parent: t?.layoutInfo
    }, l);
  }
  return l;
}
export {
  qt as $,
  fx as A,
  hx as B,
  rx as C,
  ix as D,
  tx as E,
  nx as F,
  Q6 as G,
  ex as H,
  At as I,
  hi as J,
  lx as K,
  Z6 as L,
  J6 as M,
  Cx as N,
  le as O,
  Nn as P,
  p6 as Q,
  pe as R,
  px as S,
  ce as T,
  a6 as U,
  at as V,
  o6 as W,
  d6 as X,
  u6 as Y,
  s6 as Z,
  l6 as _,
  Be as a,
  wx as a0,
  Dx as a1,
  ge as a2,
  m6 as a3,
  v6 as a4,
  P1 as a5,
  W6 as a6,
  z6 as a7,
  A6 as a8,
  h6 as a9,
  cy as aA,
  cx as aB,
  dx as aC,
  P6 as aD,
  ng as aE,
  bx as aF,
  mx as aG,
  yx as aH,
  gx as aI,
  $x as aJ,
  vx as aK,
  Ex as aL,
  xx as aM,
  V6 as aN,
  jn as aO,
  H6 as aa,
  _6 as ab,
  O6 as ac,
  R6 as ad,
  w6 as ae,
  V$ as af,
  N6 as ag,
  S6 as ah,
  b6 as ai,
  ie as aj,
  ut as ak,
  j6 as al,
  U6 as am,
  G6 as an,
  q6 as ao,
  k6 as ap,
  i6 as aq,
  g0 as ar,
  p0 as as,
  Px as at,
  ax as au,
  Y6 as av,
  X6 as aw,
  ox as ax,
  ux as ay,
  sx as az,
  x6 as b,
  c6 as c,
  sy as d,
  B6 as e,
  F6 as f,
  D6 as g,
  g6 as h,
  _e as i,
  f6 as j,
  T6 as k,
  y6 as l,
  C6 as m,
  E6 as n,
  L6 as o,
  $e as p,
  mr as q,
  L as r,
  M6 as s,
  Cy as t,
  I6 as u,
  K6 as v,
  G1 as w,
  ve as x,
  lt as y,
  $6 as z
};
